// export const oldPersonas = [
//   {
//     nome_socio: 'BIO ASSETS ATIVOS AMBIENTAIS LTDA',
//     tipo: 'empresa',
//     id_socios: '3557460000103',
//     rol: 'Sócio',
//     id_empresa: '05.086.970/0001-75',
//     nombre_empresa: 'Ecomapuá Conservação Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR1094VER'],
//   },
//   {
//     nome_socio: 'CHAN LAP TAK',
//     tipo: 'pessoa',
//     id_socios: '***201238**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '05.086.970/0001-75',
//     nombre_empresa: 'Ecomapuá Conservação Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR1094VER'],
//   },
//   {
//     nome_socio: 'RAPHAEL PALMIERI SALOMAO',
//     tipo: 'pessoa',
//     id_socios: '***056298**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'CRISTIANNE SACCAB ZARZUR CHACCUR',
//     tipo: 'pessoa',
//     id_socios: '***458478**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'JOSE ALEXANDRE BUAIZ NETO',
//     tipo: 'pessoa',
//     id_socios: '***583201**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'RAPHAEL DE CUNTO',
//     tipo: 'pessoa',
//     id_socios: '***312668**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'LUIS CLAUDIO FURTADO FARIA',
//     tipo: 'pessoa',
//     id_socios: '***528997**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'VICENTE COELHO ARAUJO',
//     tipo: 'pessoa',
//     id_socios: '***485621**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'LEONARDO BAPTISTA RODRIGUES CRUZ',
//     tipo: 'pessoa',
//     id_socios: '***657518**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'CARLOS AUGUSTO VILHENA DE MAGALHAES CUNHA FILHO',
//     tipo: 'pessoa',
//     id_socios: '***758741**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'THIAGO BRAGA JUNQUEIRA',
//     tipo: 'pessoa',
//     id_socios: '***137676**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'DIOGENES MENDES GONCALVES NETO',
//     tipo: 'pessoa',
//     id_socios: '***515128**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'TIAGO MOREIRA VIEIRA ROCHA',
//     tipo: 'pessoa',
//     id_socios: '***696248**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'ALVARO SILAS ULIANI MARTINS DOS SANTOS',
//     tipo: 'pessoa',
//     id_socios: '***170258**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'VANIA MARQUES RIBEIRO',
//     tipo: 'pessoa',
//     id_socios: '***956416**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'WERNER GRAU NETO',
//     tipo: 'pessoa',
//     id_socios: '***415998**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'EDUARDO HENRIQUE PAOLIELLO JUNIOR',
//     tipo: 'pessoa',
//     id_socios: '***937038**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'YUKA ONO',
//     tipo: 'pessoa',
//     id_socios: '***513848**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'EDUARDO CARVALHO CAIUBY',
//     tipo: 'pessoa',
//     id_socios: '***773268**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'CELSO CINTRA MORI',
//     tipo: 'pessoa',
//     id_socios: '***295228**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'GUILHERME SAMPAIO MONTEIRO',
//     tipo: 'pessoa',
//     id_socios: '***312198**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'MIGUEL TORNOVSKY',
//     tipo: 'pessoa',
//     id_socios: '***842227**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'HENRY SERGIO SZTUTMAN',
//     tipo: 'pessoa',
//     id_socios: '***313888**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'ANGELA FAN CHI KUNG',
//     tipo: 'pessoa',
//     id_socios: '***524188**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'RENATO HENRIQUE CAUMO',
//     tipo: 'pessoa',
//     id_socios: '***879538**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'RICARDO SIMOES RUSSO',
//     tipo: 'pessoa',
//     id_socios: '***379308**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'THIAGO JOSE DA SILVA',
//     tipo: 'pessoa',
//     id_socios: '***260578**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'FERNANDO SANTIAGO DOS SANTOS ZORZO',
//     tipo: 'pessoa',
//     id_socios: '***245988**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'ROBERTA STETTINGER ROSSI BILOTTI DEMANGE',
//     tipo: 'pessoa',
//     id_socios: '***100458**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'THAIS GALO',
//     tipo: 'pessoa',
//     id_socios: '***940708**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'RODRIGO PERSONE PRESTES DE CAMARGO',
//     tipo: 'pessoa',
//     id_socios: '***167198**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'ALEXANDRE BERTOLDI',
//     tipo: 'pessoa',
//     id_socios: '***031318**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'GILBERTO GIUSTI',
//     tipo: 'pessoa',
//     id_socios: '***888338**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'LUIZ FERNANDO VALENTE DE PAIVA',
//     tipo: 'pessoa',
//     id_socios: '***497278**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'MARCOS DE VICQ DE CUMPTICH',
//     tipo: 'pessoa',
//     id_socios: '***933297**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'HENRIQUE DA SILVA GORDO LANG',
//     tipo: 'pessoa',
//     id_socios: '***206158**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'JOSE CARLOS JUNQUEIRA SAMPAIO MEIRELLES',
//     tipo: 'pessoa',
//     id_socios: '***330768**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'JOAMIR MULLER ROMITI ALVES',
//     tipo: 'pessoa',
//     id_socios: '***176128**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'VINICIUS PIMENTA SEIXAS PEREIRA',
//     tipo: 'pessoa',
//     id_socios: '***258908**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'LARISSA MARIA GALIMBERTI AFONSO',
//     tipo: 'pessoa',
//     id_socios: '***491558**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'MARCELO MARQUES RONCAGLIA',
//     tipo: 'pessoa',
//     id_socios: '***369218**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'TATIANA MELLO GUAZZELLI',
//     tipo: 'pessoa',
//     id_socios: '***075438**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'JOSE MAURO DECOUSSAU MACHADO',
//     tipo: 'pessoa',
//     id_socios: '***254588**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'CARLOS EDUARDO GAZINEU DE AZEVEDO',
//     tipo: 'pessoa',
//     id_socios: '***727048**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'JULIO CESAR BUENO',
//     tipo: 'pessoa',
//     id_socios: '***433706**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'MARIANA MONTE ALEGRE DE PAIVA',
//     tipo: 'pessoa',
//     id_socios: '***345928**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'TIAGO ARAUJO DIAS THEMUDO LESSA',
//     tipo: 'pessoa',
//     id_socios: '***521399**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'FERNANDO RUIZ DE ALMEIDA PRADO',
//     tipo: 'pessoa',
//     id_socios: '***258028**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'FERNANDO MIRANDEZ DEL NERO GOMES',
//     tipo: 'pessoa',
//     id_socios: '***507648**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'TERCIO CHIAVASSA',
//     tipo: 'pessoa',
//     id_socios: '***210278**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'FABIO ROCHA PINTO E SILVA',
//     tipo: 'pessoa',
//     id_socios: '***296518**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'ANDRE VERTULLO BERNINI',
//     tipo: 'pessoa',
//     id_socios: '***789178**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'RODRIGO CORREA MARTONE',
//     tipo: 'pessoa',
//     id_socios: '***879558**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'GIULIANO COLOMBO',
//     tipo: 'pessoa',
//     id_socios: '***926648**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'ENRICO JUCA BENTIVEGNA',
//     tipo: 'pessoa',
//     id_socios: '***115788**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'MARCELLO ALFREDO BERNARDES',
//     tipo: 'pessoa',
//     id_socios: '***778207**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'CAMILA CARVALHO GOMES',
//     tipo: 'pessoa',
//     id_socios: '***061068**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'ANDRE ZONARO GIACCHETTA',
//     tipo: 'pessoa',
//     id_socios: '***805378**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'MAURO BERENHOLC',
//     tipo: 'pessoa',
//     id_socios: '***546858**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'FRANCISCO WERNECK DE ALBUQUERQUE MARANHAO',
//     tipo: 'pessoa',
//     id_socios: '***945917**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'LUCIANA ROSANOVA GALHARDO',
//     tipo: 'pessoa',
//     id_socios: '***112088**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'LUIS ANTONIO FERRAZ MENDES',
//     tipo: 'pessoa',
//     id_socios: '***801798**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'BIANCA PUMAR COELHO',
//     tipo: 'pessoa',
//     id_socios: '***009287**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'FRANCO MUSETTI GROTTI',
//     tipo: 'pessoa',
//     id_socios: '***951138**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'FERNANDO ALVES MEIRA',
//     tipo: 'pessoa',
//     id_socios: '***166928**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'BRUNO BALDUCCINI',
//     tipo: 'pessoa',
//     id_socios: '***438088**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'MAXIMILIAN FIERRO PASCHOAL',
//     tipo: 'pessoa',
//     id_socios: '***936358**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'CARLOS ALBERTO MOREIRA LIMA JUNIOR',
//     tipo: 'pessoa',
//     id_socios: '***383938**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'RAFAEL JOSE LOPES GASPAR',
//     tipo: 'pessoa',
//     id_socios: '***725098**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'PAULA SUSANNA AMARAL MELLO',
//     tipo: 'pessoa',
//     id_socios: '***664108**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'EIDER AVELINO SILVA',
//     tipo: 'pessoa',
//     id_socios: '***308926**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'CAROLINE GUAZZELLI QUEIROZ GOMES',
//     tipo: 'pessoa',
//     id_socios: '***342228**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'CAUE REZENDE MYANAKI',
//     tipo: 'pessoa',
//     id_socios: '***498738**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'JORGE NEY DE FIGUEIREDO LOPES JUNIOR',
//     tipo: 'pessoa',
//     id_socios: '***732628**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'THERA VAN SWAAY DE MARCHI',
//     tipo: 'pessoa',
//     id_socios: '***979808**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'SERGIO PINHEIRO MARCAL',
//     tipo: 'pessoa',
//     id_socios: '***062448**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'MARCELO VIVEIROS DE MOURA',
//     tipo: 'pessoa',
//     id_socios: '***026677**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'PYTHAGORAS LOPES DE CARVALHO NETO',
//     tipo: 'pessoa',
//     id_socios: '***472768**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'MAURICIO JOSE GUILHERME FROES GUIDI CELINI GIUBILEI',
//     tipo: 'pessoa',
//     id_socios: '***974146**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'ANDRE MORAES MARQUES',
//     tipo: 'pessoa',
//     id_socios: '***811118**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'ANTONIO JOSE MATTOS MORELLO',
//     tipo: 'pessoa',
//     id_socios: '***258138**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'EMIR NUNES DE OLIVEIRA NETO',
//     tipo: 'pessoa',
//     id_socios: '***459167**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'MARCELLO PORTES DA SILVEIRA LOBO',
//     tipo: 'pessoa',
//     id_socios: '***439427**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'GIANCARLO CHAMMA MATARAZZO',
//     tipo: 'pessoa',
//     id_socios: '***715628**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'CRISTIANE IANAGUI MATSUMOTO',
//     tipo: 'pessoa',
//     id_socios: '***050458**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'RICARDO PAGLIARI LEVY',
//     tipo: 'pessoa',
//     id_socios: '***906228**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'LEONARDO PERES DA ROCHA E SILVA',
//     tipo: 'pessoa',
//     id_socios: '***696421**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'LUCIANO GARCIA ROSSI',
//     tipo: 'pessoa',
//     id_socios: '***150638**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'LUCAS PINTO SIMAO',
//     tipo: 'pessoa',
//     id_socios: '***002508**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'FLAVIO VEITZMAN',
//     tipo: 'pessoa',
//     id_socios: '***562208**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'MARIO PANSERI FERREIRA',
//     tipo: 'pessoa',
//     id_socios: '***951998**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'ANDRE VIVAN DE SOUZA',
//     tipo: 'pessoa',
//     id_socios: '***419238**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'RAPHAEL MORAES PACIELLO',
//     tipo: 'pessoa',
//     id_socios: '***657307**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'DANIEL COSTA REBELLO',
//     tipo: 'pessoa',
//     id_socios: '***585701**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'ANA CAROLINA FERNANDES CARPINETTI',
//     tipo: 'pessoa',
//     id_socios: '***593738**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'RODRIGO DE MAGALHAES CARNEIRO DE OLIVEIRA',
//     tipo: 'pessoa',
//     id_socios: '***455118**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'TIAGO ELER SILVA',
//     tipo: 'pessoa',
//     id_socios: '***017886**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'JOAO MARCELO GONCALVES PACHECO',
//     tipo: 'pessoa',
//     id_socios: '***031608**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'JOSE LUIZ HOMEM DE MELLO',
//     tipo: 'pessoa',
//     id_socios: '***791188**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'ALEXANDRE OUTEDA JORGE',
//     tipo: 'pessoa',
//     id_socios: '***356338**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'RICARDO GLAESSNER BINNIE',
//     tipo: 'pessoa',
//     id_socios: '***396548**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'JOSE ROBERTO OLIVA JUNIOR',
//     tipo: 'pessoa',
//     id_socios: '***947796**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'LUIS CELSO CECILIO LEITE RIBEIRO',
//     tipo: 'pessoa',
//     id_socios: '***226498**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'PEDRO PAULO BARRADAS BARATA',
//     tipo: 'pessoa',
//     id_socios: '***295378**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'GUILHERME FELICISSIMO DE ALMEIDA LEITE',
//     tipo: 'pessoa',
//     id_socios: '***370848**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'CAIO CARLOS CRUZ FERREIRA SILVA',
//     tipo: 'pessoa',
//     id_socios: '***213297**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'CAMILA MARTINO PARISE',
//     tipo: 'pessoa',
//     id_socios: '***695058**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'RENE GUILHERME DA SILVA MEDRADO',
//     tipo: 'pessoa',
//     id_socios: '***196028**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'CARLOS HENRIQUE TRANJAN BECHARA',
//     tipo: 'pessoa',
//     id_socios: '***076297**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'LUIZ ROBERTO PEROBA BARBOSA',
//     tipo: 'pessoa',
//     id_socios: '***276118**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'FERNANDO JOSE PRADO FERREIRA',
//     tipo: 'pessoa',
//     id_socios: '***642888**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'DIEGO CALDAS RIVAS DE SIMONE',
//     tipo: 'pessoa',
//     id_socios: '***607578**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'CIRO TORRES FREITAS',
//     tipo: 'pessoa',
//     id_socios: '***855898**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'RENATO STEPHAN GRION',
//     tipo: 'pessoa',
//     id_socios: '***457108**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'RICARDO EMMANUEL VIEIRA COELHO',
//     tipo: 'pessoa',
//     id_socios: '***066017**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'NATALIA GENINA LUGERO DE ALMEIDA',
//     tipo: 'pessoa',
//     id_socios: '***865938**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'ANDREA MASCITTO',
//     tipo: 'pessoa',
//     id_socios: '***882918**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'JOAO RAFAEL LAVANDEIRA GANDARA DE CARVALHO',
//     tipo: 'pessoa',
//     id_socios: '***031487**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'MARCOS CHAVES LADEIRA',
//     tipo: 'pessoa',
//     id_socios: '***289588**',
//     rol: 'Sócio com Capital',
//     id_empresa: '60.613.478/0001-19',
//     nombre_empresa: 'Pinheiro Neto Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'DIVALDO JOSE DA COSTA REZENDE',
//     tipo: 'pessoa',
//     id_socios: '***539846**',
//     rol: 'Sócio',
//     id_empresa: '02.405.151/0002-36',
//     nombre_empresa: 'Ecológica Assessoria LTDA.',
//     pais: 'Brasil',
//     id_proyecto: [
//       'BR3304VER',
//       'BR3152VER',
//       'BR2980VER',
//       'BR2870VER',
//       'BR2871VER',
//       'BR2709VER',
//       'BR2558VER',
//       'BR2482VER',
//       'BR2373VER',
//       'BR1686VER',
//     ],
//   },
//   {
//     nome_socio: 'STEFANO MERLIN',
//     tipo: 'pessoa',
//     id_socios: '***121341**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '02.405.151/0002-36',
//     nombre_empresa: 'Ecológica Assessoria LTDA.',
//     pais: 'Brasil',
//     id_proyecto: [
//       'BR3304VER',
//       'BR3152VER',
//       'BR2980VER',
//       'BR2870VER',
//       'BR2871VER',
//       'BR2709VER',
//       'BR2558VER',
//       'BR2482VER',
//       'BR2373VER',
//       'BR1686VER',
//     ],
//   },
//   {
//     nome_socio: 'ROBERTO TAIAR ARBEX',
//     tipo: 'pessoa',
//     id_socios: '***100548**',
//     rol: 'Diretor',
//     id_empresa: '09.448.003/0001-67',
//     nombre_empresa: 'ZX Participações S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR3306VER'],
//   },
//   {
//     nome_socio: 'MARCOS PASTORE DAVID',
//     tipo: 'pessoa',
//     id_socios: '***729608**',
//     rol: 'Conselheiro de Administração',
//     id_empresa: '09.448.003/0001-67',
//     nombre_empresa: 'ZX Participações S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR3306VER'],
//   },
//   {
//     nome_socio: 'MARCELO TAIAR ARBEX',
//     tipo: 'pessoa',
//     id_socios: '***643338**',
//     rol: 'Diretor',
//     id_empresa: '09.448.003/0001-67',
//     nombre_empresa: 'ZX Participações S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR3306VER'],
//   },
//   {
//     nome_socio: 'NATAL FERREIRA VASCONCELOS',
//     tipo: 'pessoa',
//     id_socios: '***680196**',
//     rol: 'Administrador',
//     id_empresa: '68.773.597/0001-40',
//     nombre_empresa: 'RINA S.p.A (RINA)/RINA BRASIL SERVICOS TECNICOS LTDA.',
//     pais: 'Brasil',
//     id_proyecto: [
//       'BR1811VER',
//       'BR4461VER',
//       'BR4082VER',
//       'BR4042VER',
//       'BR3631VER',
//       'BR3601VER',
//       'BR3451VER',
//       'BR3141VER',
//       'BR2878VER',
//       'BR2558VER',
//       'BR2551VER',
//       'BR2539VER',
//       'BR2508VER',
//       'BR2373VER',
//       'BR1686VER',
//       'BR1115VER',
//       'BR1503VER',
//     ],
//   },
//   {
//     nome_socio: 'JOSE SALVADOR DA SILVA FILHO',
//     tipo: 'pessoa',
//     id_socios: '***608528**',
//     rol: 'Administrador',
//     id_empresa: '68.773.597/0001-40',
//     nombre_empresa: 'RINA S.p.A (RINA)/RINA BRASIL SERVICOS TECNICOS LTDA.',
//     pais: 'Brasil',
//     id_proyecto: [
//       'BR1811VER',
//       'BR4461VER',
//       'BR4082VER',
//       'BR4042VER',
//       'BR3631VER',
//       'BR3601VER',
//       'BR3451VER',
//       'BR3141VER',
//       'BR2878VER',
//       'BR2558VER',
//       'BR2551VER',
//       'BR2539VER',
//       'BR2508VER',
//       'BR2373VER',
//       'BR1686VER',
//       'BR1115VER',
//       'BR1503VER',
//     ],
//   },
//   {
//     nome_socio: 'RINA INTERNATIONAL BV',
//     tipo: 'empresa',
//     id_socios: '11391040000128',
//     rol: 'Sócio Pessoa Jurídica Domiciliado no Exterior',
//     id_empresa: '68.773.597/0001-40',
//     nombre_empresa: 'RINA S.p.A (RINA)/RINA BRASIL SERVICOS TECNICOS LTDA.',
//     pais: 'Brasil',
//     id_proyecto: [
//       'BR1811VER',
//       'BR4461VER',
//       'BR4082VER',
//       'BR4042VER',
//       'BR3631VER',
//       'BR3601VER',
//       'BR3451VER',
//       'BR3141VER',
//       'BR2878VER',
//       'BR2558VER',
//       'BR2551VER',
//       'BR2539VER',
//       'BR2508VER',
//       'BR2373VER',
//       'BR1686VER',
//       'BR1115VER',
//       'BR1503VER',
//     ],
//   },
//   {
//     nome_socio: 'RINA SERVICES S.P.A.',
//     tipo: 'empresa',
//     id_socios: '9243232000145',
//     rol: 'Sócio Pessoa Jurídica Domiciliado no Exterior',
//     id_empresa: '68.773.597/0001-40',
//     nombre_empresa: 'RINA S.p.A (RINA)/RINA BRASIL SERVICOS TECNICOS LTDA.',
//     pais: 'Brasil',
//     id_proyecto: ['BR1811VER'],
//     '': 'BR1503VER',
//   },
//   {
//     nome_socio: 'REGINALDO BISPO DE SOUZA',
//     tipo: 'pessoa',
//     id_socios: '***025532**',
//     rol: 'Sócio',
//     id_empresa: '46.590.622/0001-18',
//     nombre_empresa: 'Incorporadora Manicoré LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4850VER'],
//   },
//   {
//     nome_socio: 'LUIZ ROGERIO DE OLIVEIRA',
//     tipo: 'pessoa',
//     id_socios: '***232952**',
//     rol: 'Administrador',
//     id_empresa: '46.590.622/0001-18',
//     nombre_empresa: 'Incorporadora Manicoré LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4850VER'],
//   },
//   {
//     nome_socio: 'JOERCIO PAULINO DA COSTA',
//     tipo: 'pessoa',
//     id_socios: '***070922**',
//     rol: 'Administrador',
//     id_empresa: '46.590.622/0001-18',
//     nombre_empresa: 'Incorporadora Manicoré LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4850VER'],
//   },
//   {
//     nome_socio: 'GABRIEL BERTONI SEBASTIAO',
//     tipo: 'pessoa',
//     id_socios: '***926188**',
//     rol: 'Sócio',
//     id_empresa: '46.590.622/0001-18',
//     nombre_empresa: 'Incorporadora Manicoré LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4850VER'],
//   },
//   {
//     nome_socio: 'RJC2 ASSETS ADMINISTRATION PARTICIPACOES LTDA',
//     tipo: 'empresa',
//     id_socios: '48064917000186',
//     rol: 'Sócio',
//     id_empresa: '46.590.622/0001-18',
//     nombre_empresa: 'Incorporadora Manicoré LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4850VER'],
//   },
//   {
//     nome_socio: 'BERNARD GUSTAVE PIERRE CASSAGNE',
//     tipo: 'pessoa',
//     id_socios: '***543362**',
//     rol: 'Sócio Pessoa Física Residente no Exterior',
//     id_empresa: '09.502.811/0001-65',
//     nombre_empresa:
//       'Florestal Recursos Manejo Brasil Consultoria e Assessoria Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR1811VER'],
//   },
//   {
//     nome_socio: 'NICOLAS PIERRE BAYOL',
//     tipo: 'pessoa',
//     id_socios: '***543282**',
//     rol: 'Sócio Pessoa Física Residente no Exterior',
//     id_empresa: '09.502.811/0001-65',
//     nombre_empresa:
//       'Florestal Recursos Manejo Brasil Consultoria e Assessoria Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR1811VER'],
//   },
//   {
//     nome_socio: 'FORET RESSOURCES MANAGEMENT',
//     tipo: 'empresa',
//     id_socios: '9312168000107',
//     rol: 'Sócio Pessoa Jurídica Domiciliado no Exterior',
//     id_empresa: '09.502.811/0001-65',
//     nombre_empresa:
//       'Florestal Recursos Manejo Brasil Consultoria e Assessoria Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR1811VER'],
//   },
//   {
//     nome_socio: 'ARLEI RODRIGUES FONTOURA',
//     tipo: 'pessoa',
//     id_socios: '***997180**',
//     rol: 'Administrador',
//     id_empresa: '09.502.811/0001-65',
//     nombre_empresa:
//       'Florestal Recursos Manejo Brasil Consultoria e Assessoria Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR1811VER'],
//   },
//   {
//     nome_socio: 'JEAN FRANCOIS PAUL FERNAND CHEVALIER',
//     tipo: 'pessoa',
//     id_socios: '***543102**',
//     rol: 'Sócio Pessoa Física Residente no Exterior',
//     id_empresa: '09.502.811/0001-65',
//     nombre_empresa:
//       'Florestal Recursos Manejo Brasil Consultoria e Assessoria Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR1811VER'],
//   },
//   {
//     nome_socio: 'SERGIO ANTONIO GARCIA AMOROSO',
//     tipo: 'pessoa',
//     id_socios: '***086608**',
//     rol: 'Presidente',
//     id_empresa: '17.919.786/0001-48',
//     nombre_empresa: 'GRUPO JARI S.A EM RECUPERACAO JUDICIAL',
//     pais: 'Brasil',
//     id_proyecto: ['BR4615VER'],
//   },
//   {
//     nome_socio: 'JORGE FRANCISCO HENRIQUES',
//     tipo: 'pessoa',
//     id_socios: '***806808**',
//     rol: 'Diretor',
//     id_empresa: '17.919.786/0001-48',
//     nombre_empresa: 'GRUPO JARI S.A EM RECUPERACAO JUDICIAL',
//     pais: 'Brasil',
//     id_proyecto: ['BR4615VER'],
//   },
//   {
//     nome_socio: 'VICTOR DAVI PATINI BORLENGHI',
//     tipo: 'pessoa',
//     id_socios: '***276578**',
//     rol: 'Conselheiro de Administração',
//     id_empresa: '09.720.550/0001-50',
//     nombre_empresa: 'Biofílica Ambipar Environment Investments',
//     pais: 'Brasil',
//     id_proyecto: [
//       'BR4747VER',
//       'BR4687VER',
//       'BR4689VER',
//       'BR4615VER',
//       'BR1811VER',
//       'BR4034VER',
//       'BR3590VER',
//       'BR3430VER',
//       'BR1571VER',
//       'BR1115VER',
//       'BR1503VER',
//       'BR1329VER',
//     ],
//   },
//   {
//     nome_socio: 'FABRICIO RESENDE FONSECA',
//     tipo: 'pessoa',
//     id_socios: '***870167**',
//     rol: 'Conselheiro de Administração',
//     id_empresa: '09.720.550/0001-50',
//     nombre_empresa: 'Biofílica Ambipar Environment Investments',
//     pais: 'Brasil',
//     id_proyecto: [
//       'BR4747VER',
//       'BR4687VER',
//       'BR4689VER',
//       'BR4615VER',
//       'BR1811VER',
//       'BR4034VER',
//       'BR3590VER',
//       'BR3430VER',
//       'BR1571VER',
//       'BR1115VER',
//       'BR1503VER',
//       'BR1329VER',
//     ],
//   },
//   {
//     nome_socio: 'PLINIO PAGNONCELLI AGUIAR RIBEIRO',
//     tipo: 'pessoa',
//     id_socios: '***333201**',
//     rol: 'Presidente',
//     id_empresa: '09.720.550/0001-50',
//     nombre_empresa: 'Biofílica Ambipar Environment Investments',
//     pais: 'Brasil',
//     id_proyecto: [
//       'BR4747VER',
//       'BR4687VER',
//       'BR4689VER',
//       'BR4615VER',
//       'BR1811VER',
//       'BR4034VER',
//       'BR3590VER',
//       'BR3430VER',
//       'BR1571VER',
//       'BR1115VER',
//       'BR1503VER',
//       'BR1329VER',
//     ],
//   },
//   {
//     nome_socio: 'PAULO ROBERTO BELLOTTI',
//     tipo: 'pessoa',
//     id_socios: '***013908**',
//     rol: 'Conselheiro de Administração',
//     id_empresa: '09.720.550/0001-50',
//     nombre_empresa: 'Biofílica Ambipar Environment Investments',
//     pais: 'Brasil',
//     id_proyecto: [
//       'BR4747VER',
//       'BR4687VER',
//       'BR4689VER',
//       'BR4615VER',
//       'BR1811VER',
//       'BR4034VER',
//       'BR3590VER',
//       'BR3430VER',
//       'BR1571VER',
//       'BR1115VER',
//       'BR1503VER',
//       'BR1329VER',
//     ],
//   },
//   {
//     nome_socio: 'ALESSANDRA BESSA ALVES DE MELO',
//     tipo: 'pessoa',
//     id_socios: '***259048**',
//     rol: 'Conselheiro de Administração',
//     id_empresa: '09.720.550/0001-50',
//     nombre_empresa: 'Biofílica Ambipar Environment Investments',
//     pais: 'Brasil',
//     id_proyecto: [
//       'BR4747VER',
//       'BR4687VER',
//       'BR4689VER',
//       'BR4615VER',
//       'BR1811VER',
//       'BR4034VER',
//       'BR3590VER',
//       'BR3430VER',
//       'BR1571VER',
//       'BR1115VER',
//       'BR1503VER',
//       'BR1329VER',
//     ],
//   },
//   {
//     nome_socio: 'EDUARDO GOMES DE ALMEIDA',
//     tipo: 'pessoa',
//     id_socios: '***930137**',
//     rol: 'Conselheiro de Administração',
//     id_empresa: '09.720.550/0001-50',
//     nombre_empresa: 'Biofílica Ambipar Environment Investments',
//     pais: 'Brasil',
//     id_proyecto: [
//       'BR4747VER',
//       'BR4687VER',
//       'BR4689VER',
//       'BR4615VER',
//       'BR1811VER',
//       'BR4034VER',
//       'BR3590VER',
//       'BR3430VER',
//       'BR1571VER',
//       'BR1115VER',
//       'BR1503VER',
//       'BR1329VER',
//     ],
//   },
//   {
//     nome_socio: 'GUILHERME PATINI BORLENGHI',
//     tipo: 'pessoa',
//     id_socios: '***104768**',
//     rol: 'Diretor',
//     id_empresa: '09.720.550/0001-50',
//     nombre_empresa: 'Biofílica Ambipar Environment Investments',
//     pais: 'Brasil',
//     id_proyecto: [
//       'BR4747VER',
//       'BR4687VER',
//       'BR4689VER',
//       'BR4615VER',
//       'BR1811VER',
//       'BR4034VER',
//       'BR3590VER',
//       'BR3430VER',
//       'BR1571VER',
//       'BR1115VER',
//       'BR1503VER',
//       'BR1329VER',
//     ],
//   },
//   {
//     nome_socio: 'JUSCELINO FERNANDES MARTINS',
//     tipo: 'pessoa',
//     id_socios: '***406806**',
//     rol: 'Conselheiro de Administração',
//     id_empresa: '09.720.550/0001-50',
//     nombre_empresa: 'Biofílica Ambipar Environment Investments',
//     pais: 'Brasil',
//     id_proyecto: [
//       'BR4747VER',
//       'BR4687VER',
//       'BR4689VER',
//       'BR4615VER',
//       'BR1811VER',
//       'BR4034VER',
//       'BR3590VER',
//       'BR3430VER',
//       'BR1571VER',
//       'BR1115VER',
//       'BR1503VER',
//       'BR1329VER',
//     ],
//   },
//   {
//     nome_socio: 'LUCIANA FREIRE BARCA NASCIMENTO',
//     tipo: 'pessoa',
//     id_socios: '***428758**',
//     rol: 'Diretor',
//     id_empresa: '09.720.550/0001-50',
//     nombre_empresa: 'Biofílica Ambipar Environment Investments',
//     pais: 'Brasil',
//     id_proyecto: [
//       'BR4747VER',
//       'BR4687VER',
//       'BR4689VER',
//       'BR4615VER',
//       'BR1811VER',
//       'BR4034VER',
//       'BR3590VER',
//       'BR3430VER',
//       'BR1571VER',
//       'BR1115VER',
//       'BR1503VER',
//       'BR1329VER',
//     ],
//   },
//   {
//     nome_socio: 'THIAGO DA COSTA SILVA',
//     tipo: 'pessoa',
//     id_socios: '***653698**',
//     rol: 'Diretor',
//     id_empresa: '09.720.550/0001-50',
//     nombre_empresa: 'Biofílica Ambipar Environment Investments',
//     pais: 'Brasil',
//     id_proyecto: [
//       'BR4747VER',
//       'BR4687VER',
//       'BR4689VER',
//       'BR4615VER',
//       'BR1811VER',
//       'BR4034VER',
//       'BR3590VER',
//       'BR3430VER',
//       'BR1571VER',
//       'BR1115VER',
//       'BR1503VER',
//       'BR1329VER',
//     ],
//   },
//   {
//     nome_socio: 'FERNANDA HOEBEL MUNHOZ BUENO',
//     tipo: 'pessoa',
//     id_socios: '***138879**',
//     rol: 'Sócio',
//     id_empresa: '45.424.948/0001-02',
//     nombre_empresa: 'Guanabara Ambiental LTDA.',
//     pais: 'Brasil',
//     id_proyecto: ['BR3631VER'],
//   },
//   {
//     nome_socio: 'IANA HOEBEL MUNHOZ',
//     tipo: 'pessoa',
//     id_socios: '***138859**',
//     rol: 'Sócio',
//     id_empresa: '45.424.948/0001-02',
//     nombre_empresa: 'Guanabara Ambiental LTDA.',
//     pais: 'Brasil',
//     id_proyecto: ['BR3631VER'],
//   },
//   {
//     nome_socio: 'ROSANA MARIA HOEBEL',
//     tipo: 'pessoa',
//     id_socios: '***543249**',
//     rol: 'Sócio',
//     id_empresa: '45.424.948/0001-02',
//     nombre_empresa: 'Guanabara Ambiental LTDA.',
//     pais: 'Brasil',
//     id_proyecto: ['BR3631VER'],
//   },
//   {
//     nome_socio: 'DIEGO HOEBEL MUNHOZ',
//     tipo: 'pessoa',
//     id_socios: '***072969**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '45.424.948/0001-02',
//     nombre_empresa: 'Guanabara Ambiental LTDA.',
//     pais: 'Brasil',
//     id_proyecto: ['BR3631VER'],
//   },
//   {
//     nome_socio: 'JOSE FERNANDO MAZUCA FILHO',
//     tipo: 'pessoa',
//     id_socios: '***051488**',
//     rol: 'Presidente',
//     id_empresa: '15.009.178/0001-70',
//     nombre_empresa: 'Usinas Itamarati S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4141VER'],
//   },
//   {
//     nome_socio: 'MARCO AURELIO MENDONCA SERAPHIM',
//     tipo: 'pessoa',
//     id_socios: '***242506**',
//     rol: 'Diretor',
//     id_empresa: '15.009.178/0001-70',
//     nombre_empresa: 'Usinas Itamarati S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4141VER'],
//   },
//   {
//     nome_socio: 'ANDERSON ANGELO DE SOUZA',
//     tipo: 'pessoa',
//     id_socios: '***177605**',
//     rol: 'Diretor',
//     id_empresa: '15.009.178/0001-70',
//     nombre_empresa: 'Usinas Itamarati S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4141VER'],
//   },
//   {
//     nome_socio: 'VITOR MONTENEGRO WANDERLEY JUNIOR',
//     tipo: 'pessoa',
//     id_socios: '***955054**',
//     rol: 'Conselheiro de Administração',
//     id_empresa: '15.009.178/0001-70',
//     nombre_empresa: 'Usinas Itamarati S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4141VER'],
//   },
//   {
//     nome_socio: 'RODRIGO RIBEIRO GONCALVES',
//     tipo: 'pessoa',
//     id_socios: '***871628**',
//     rol: 'Diretor',
//     id_empresa: '15.009.178/0001-70',
//     nombre_empresa: 'Usinas Itamarati S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4141VER'],
//   },
//   {
//     nome_socio: 'PAULO PIRATINY ABBOTT CALDEIRA',
//     tipo: 'pessoa',
//     id_socios: '***795780**',
//     rol: 'Conselheiro de Administração',
//     id_empresa: '15.009.178/0001-70',
//     nombre_empresa: 'Usinas Itamarati S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4141VER'],
//   },
//   {
//     nome_socio: 'SERGIO SPINELLI SILVA JUNIOR',
//     tipo: 'pessoa',
//     id_socios: '***888088**',
//     rol: 'Conselheiro de Administração',
//     id_empresa: '15.009.178/0001-70',
//     nombre_empresa: 'Usinas Itamarati S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4141VER'],
//   },
//   {
//     nome_socio: 'JACYR DA SILVA COSTA FILHO',
//     tipo: 'pessoa',
//     id_socios: '***252758**',
//     rol: 'Conselheiro de Administração',
//     id_empresa: '15.009.178/0001-70',
//     nombre_empresa: 'Usinas Itamarati S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4141VER'],
//   },
//   {
//     nome_socio: 'PAULO CESAR LEITE',
//     tipo: 'pessoa',
//     id_socios: '***827888**',
//     rol: 'Diretor',
//     id_empresa: '15.009.178/0001-70',
//     nombre_empresa: 'Usinas Itamarati S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4141VER'],
//   },
//   {
//     nome_socio: 'JOSE ARIMATEA DE ANGELO CALSAVERINI',
//     tipo: 'pessoa',
//     id_socios: '***264808**',
//     rol: 'Conselheiro de Administração',
//     id_empresa: '15.009.178/0001-70',
//     nombre_empresa: 'Usinas Itamarati S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4141VER'],
//   },
//   {
//     nome_socio: 'JARI DE SOUZA',
//     tipo: 'pessoa',
//     id_socios: '***167991**',
//     rol: 'Diretor',
//     id_empresa: '15.009.178/0001-70',
//     nombre_empresa: 'Usinas Itamarati S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4141VER'],
//   },
//   {
//     nome_socio: 'MARCELO RESCHINI ABUD',
//     tipo: 'pessoa',
//     id_socios: '***694888**',
//     rol: 'Conselheiro de Administração',
//     id_empresa: '15.009.178/0001-70',
//     nombre_empresa: 'Usinas Itamarati S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4141VER'],
//   },
//   {
//     nome_socio: 'JOSE ROBERTO MENDONCA DE BARROS',
//     tipo: 'pessoa',
//     id_socios: '***761408**',
//     rol: 'Conselheiro de Administração',
//     id_empresa: '15.009.178/0001-70',
//     nombre_empresa: 'Usinas Itamarati S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4141VER'],
//   },
//   {
//     nome_socio: 'BERNARDO PARNES',
//     tipo: 'pessoa',
//     id_socios: '***102448**',
//     rol: 'Conselheiro de Administração',
//     id_empresa: '15.009.178/0001-70',
//     nombre_empresa: 'Usinas Itamarati S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4141VER'],
//   },
//   {
//     nome_socio: 'FAUSTO SCAPINI',
//     tipo: 'pessoa',
//     id_socios: '***285639**',
//     rol: 'Sócio',
//     id_empresa: '22.694.956/0001-73',
//     nombre_empresa: 'GEOMASTER GEOTECNOLOGIA AMBIENTAL LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4681VER'],
//   },
//   {
//     nome_socio: 'FABIO ROBERTO NIEDERMEIER',
//     tipo: 'pessoa',
//     id_socios: '***104560**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '22.694.956/0001-73',
//     nombre_empresa: 'GEOMASTER GEOTECNOLOGIA AMBIENTAL LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4681VER'],
//   },
//   {
//     nome_socio: 'ELISA VIEIRA LEONEL',
//     tipo: 'pessoa',
//     id_socios: '***460676**',
//     rol: 'Conselheiro de Administração',
//     id_empresa: '00.000.000/0001-91',
//     nombre_empresa: 'Banco do Brasil S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4221VER', 'BR4165VER'],
//   },
//   {
//     nome_socio: 'FRANCISCO AUGUSTO LASSALVIA',
//     tipo: 'pessoa',
//     id_socios: '***355918**',
//     rol: 'Diretor',
//     id_empresa: '00.000.000/0001-91',
//     nombre_empresa: 'Banco do Brasil S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4221VER', 'BR4165VER'],
//   },
//   {
//     nome_socio: 'MARCO GEOVANNE TOBIAS DA SILVA',
//     tipo: 'pessoa',
//     id_socios: '***225791**',
//     rol: 'Diretor',
//     id_empresa: '00.000.000/0001-91',
//     nombre_empresa: 'Banco do Brasil S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4221VER', 'BR4165VER'],
//   },
//   {
//     nome_socio: 'JOAO FRANCISCO FRUET JUNIOR',
//     tipo: 'pessoa',
//     id_socios: '***344060**',
//     rol: 'Diretor',
//     id_empresa: '00.000.000/0001-91',
//     nombre_empresa: 'Banco do Brasil S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4221VER', 'BR4165VER'],
//   },
//   {
//     nome_socio: 'RAFAEL MACHADO GIOVANELLA',
//     tipo: 'pessoa',
//     id_socios: '***211719**',
//     rol: 'Diretor',
//     id_empresa: '00.000.000/0001-91',
//     nombre_empresa: 'Banco do Brasil S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4221VER', 'BR4165VER'],
//   },
//   {
//     nome_socio: 'PAULA SAYAO CARVALHO ARAUJO',
//     tipo: 'pessoa',
//     id_socios: '***989951**',
//     rol: 'Diretor',
//     id_empresa: '00.000.000/0001-91',
//     nombre_empresa: 'Banco do Brasil S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4221VER', 'BR4165VER'],
//   },
//   {
//     nome_socio: 'JULIO CESAR VEZZARO',
//     tipo: 'pessoa',
//     id_socios: '***058029**',
//     rol: 'Diretor',
//     id_empresa: '00.000.000/0001-91',
//     nombre_empresa: 'Banco do Brasil S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4221VER', 'BR4165VER'],
//   },
//   {
//     nome_socio: 'MARISA REGHINI FERREIRA MATTOS',
//     tipo: 'pessoa',
//     id_socios: '***301948**',
//     rol: 'Diretor',
//     id_empresa: '00.000.000/0001-91',
//     nombre_empresa: 'Banco do Brasil S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4221VER', 'BR4165VER'],
//   },
//   {
//     nome_socio: 'MARCELO GASPARINO DA SILVA',
//     tipo: 'pessoa',
//     id_socios: '***383469**',
//     rol: 'Conselheiro de Administração',
//     id_empresa: '00.000.000/0001-91',
//     nombre_empresa: 'Banco do Brasil S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4221VER', 'BR4165VER'],
//   },
//   {
//     nome_socio: 'CARLOS EDUARDO GUEDES PINTO',
//     tipo: 'pessoa',
//     id_socios: '***464088**',
//     rol: 'Diretor',
//     id_empresa: '00.000.000/0001-91',
//     nombre_empresa: 'Banco do Brasil S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4221VER', 'BR4165VER'],
//   },
//   {
//     nome_socio: 'NEUDSON PERES DE FREITAS',
//     tipo: 'pessoa',
//     id_socios: '***631536**',
//     rol: 'Diretor',
//     id_empresa: '00.000.000/0001-91',
//     nombre_empresa: 'Banco do Brasil S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4221VER', 'BR4165VER'],
//   },
//   {
//     nome_socio: 'LUIZ GUSTAVO BRAZ LAGE',
//     tipo: 'pessoa',
//     id_socios: '***132426**',
//     rol: 'Diretor',
//     id_empresa: '00.000.000/0001-91',
//     nombre_empresa: 'Banco do Brasil S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4221VER', 'BR4165VER'],
//   },
//   {
//     nome_socio: 'LARISSA DA SILVA NOVAIS VIEIRA',
//     tipo: 'pessoa',
//     id_socios: '***038787**',
//     rol: 'Diretor',
//     id_empresa: '00.000.000/0001-91',
//     nombre_empresa: 'Banco do Brasil S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4221VER', 'BR4165VER'],
//   },
//   {
//     nome_socio: 'DARIO CARNEVALLI DURIGAN',
//     tipo: 'pessoa',
//     id_socios: '***672408**',
//     rol: 'Conselheiro de Administração',
//     id_empresa: '00.000.000/0001-91',
//     nombre_empresa: 'Banco do Brasil S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4221VER', 'BR4165VER'],
//   },
//   {
//     nome_socio: 'FELIPE GUIMARAES GEISSLER PRINCE',
//     tipo: 'pessoa',
//     id_socios: '***345856**',
//     rol: 'Diretor',
//     id_empresa: '00.000.000/0001-91',
//     nombre_empresa: 'Banco do Brasil S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4221VER', 'BR4165VER'],
//   },
//   {
//     nome_socio: 'ROBERT JUENEMANN',
//     tipo: 'pessoa',
//     id_socios: '***077100**',
//     rol: 'Conselheiro de Administração',
//     id_empresa: '00.000.000/0001-91',
//     nombre_empresa: 'Banco do Brasil S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4221VER', 'BR4165VER'],
//   },
//   {
//     nome_socio: 'RODRIGO MULINARI',
//     tipo: 'pessoa',
//     id_socios: '***599070**',
//     rol: 'Diretor',
//     id_empresa: '00.000.000/0001-91',
//     nombre_empresa: 'Banco do Brasil S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4221VER', 'BR4165VER'],
//   },
//   {
//     nome_socio: 'TARCIANA PAULA GOMES MEDEIROS',
//     tipo: 'pessoa',
//     id_socios: '***128734**',
//     rol: 'Presidente',
//     id_empresa: '00.000.000/0001-91',
//     nombre_empresa: 'Banco do Brasil S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4221VER', 'BR4165VER'],
//   },
//   {
//     nome_socio: 'ANELIZE LENZI RUAS DE ALMEIDA',
//     tipo: 'pessoa',
//     id_socios: '***195641**',
//     rol: 'Conselheiro de Administração',
//     id_empresa: '00.000.000/0001-91',
//     nombre_empresa: 'Banco do Brasil S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4221VER', 'BR4165VER'],
//   },
//   {
//     nome_socio: 'PAULO ROBERTO SIMAO BIJOS',
//     tipo: 'pessoa',
//     id_socios: '***914748**',
//     rol: 'Conselheiro de Administração',
//     id_empresa: '00.000.000/0001-91',
//     nombre_empresa: 'Banco do Brasil S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4221VER', 'BR4165VER'],
//   },
//   {
//     nome_socio: 'ANTONIO CARLOS WAGNER CHIARELLO',
//     tipo: 'pessoa',
//     id_socios: '***263100**',
//     rol: 'Diretor',
//     id_empresa: '00.000.000/0001-91',
//     nombre_empresa: 'Banco do Brasil S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4221VER', 'BR4165VER'],
//   },
//   {
//     nome_socio: 'EULER ANTONIO LUZ MATHIAS',
//     tipo: 'pessoa',
//     id_socios: '***344088**',
//     rol: 'Diretor',
//     id_empresa: '00.000.000/0001-91',
//     nombre_empresa: 'Banco do Brasil S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4221VER', 'BR4165VER'],
//   },
//   {
//     nome_socio: 'LUCIANO MATARAZZO REGNO',
//     tipo: 'pessoa',
//     id_socios: '***210718**',
//     rol: 'Diretor',
//     id_empresa: '00.000.000/0001-91',
//     nombre_empresa: 'Banco do Brasil S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4221VER', 'BR4165VER'],
//   },
//   {
//     nome_socio: 'ALBERTO MARTINHAGO VIEIRA',
//     tipo: 'pessoa',
//     id_socios: '***842999**',
//     rol: 'Diretor',
//     id_empresa: '00.000.000/0001-91',
//     nombre_empresa: 'Banco do Brasil S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4221VER', 'BR4165VER'],
//   },
//   {
//     nome_socio: 'ROSIANE BARBOSA LAVIOLA',
//     tipo: 'pessoa',
//     id_socios: '***181471**',
//     rol: 'Diretor',
//     id_empresa: '00.000.000/0001-91',
//     nombre_empresa: 'Banco do Brasil S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4221VER', 'BR4165VER'],
//   },
//   {
//     nome_socio: 'RODRIGO COSTA VASCONCELOS',
//     tipo: 'pessoa',
//     id_socios: '***561061**',
//     rol: 'Diretor',
//     id_empresa: '00.000.000/0001-91',
//     nombre_empresa: 'Banco do Brasil S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4221VER', 'BR4165VER'],
//   },
//   {
//     nome_socio: 'CARLA NESI',
//     tipo: 'pessoa',
//     id_socios: '***295868**',
//     rol: 'Diretor',
//     id_empresa: '00.000.000/0001-91',
//     nombre_empresa: 'Banco do Brasil S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4221VER', 'BR4165VER'],
//   },
//   {
//     nome_socio: 'KELLY TATIANE MARTINS QUIRINO',
//     tipo: 'pessoa',
//     id_socios: '***783438**',
//     rol: 'Conselheiro de Administração',
//     id_empresa: '00.000.000/0001-91',
//     nombre_empresa: 'Banco do Brasil S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4221VER', 'BR4165VER'],
//   },
//   {
//     nome_socio: 'ALAN CARLOS GUEDES DE OLIVEIRA',
//     tipo: 'pessoa',
//     id_socios: '***550179**',
//     rol: 'Diretor',
//     id_empresa: '00.000.000/0001-91',
//     nombre_empresa: 'Banco do Brasil S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4221VER', 'BR4165VER'],
//   },
//   {
//     nome_socio: 'GABRIEL MURICCA GALIPOLO',
//     tipo: 'pessoa',
//     id_socios: '***827438**',
//     rol: 'Conselheiro de Administração',
//     id_empresa: '00.000.000/0001-91',
//     nombre_empresa: 'Banco do Brasil S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4221VER', 'BR4165VER'],
//   },
//   {
//     nome_socio: 'KAMILLO TONONI OLIVEIRA SILVA',
//     tipo: 'pessoa',
//     id_socios: '***027514**',
//     rol: 'Diretor',
//     id_empresa: '00.000.000/0001-91',
//     nombre_empresa: 'Banco do Brasil S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4221VER', 'BR4165VER'],
//   },
//   {
//     nome_socio: 'PEDRO BRAMONT',
//     tipo: 'pessoa',
//     id_socios: '***472469**',
//     rol: 'Diretor',
//     id_empresa: '00.000.000/0001-91',
//     nombre_empresa: 'Banco do Brasil S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4221VER', 'BR4165VER'],
//   },
//   {
//     nome_socio: 'EDUARDO CESAR PASA',
//     tipo: 'pessoa',
//     id_socios: '***035920**',
//     rol: 'Diretor',
//     id_empresa: '00.000.000/0001-91',
//     nombre_empresa: 'Banco do Brasil S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4221VER', 'BR4165VER'],
//   },
//   {
//     nome_socio: 'JOSE RICARDO SASSERON',
//     tipo: 'pessoa',
//     id_socios: '***404558**',
//     rol: 'Diretor',
//     id_empresa: '00.000.000/0001-91',
//     nombre_empresa: 'Banco do Brasil S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4221VER', 'BR4165VER'],
//   },
//   {
//     nome_socio: 'MARIANA PIRES DIAS',
//     tipo: 'pessoa',
//     id_socios: '***147908**',
//     rol: 'Diretor',
//     id_empresa: '00.000.000/0001-91',
//     nombre_empresa: 'Banco do Brasil S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4221VER', 'BR4165VER'],
//   },
//   {
//     nome_socio: 'THIAGO AFFONSO BORSARI',
//     tipo: 'pessoa',
//     id_socios: '***759718**',
//     rol: 'Diretor',
//     id_empresa: '00.000.000/0001-91',
//     nombre_empresa: 'Banco do Brasil S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4221VER', 'BR4165VER'],
//   },
//   {
//     nome_socio: 'ANA CRISTINA ROSA GARCIA',
//     tipo: 'pessoa',
//     id_socios: '***443671**',
//     rol: 'Diretor',
//     id_empresa: '00.000.000/0001-91',
//     nombre_empresa: 'Banco do Brasil S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4221VER', 'BR4165VER'],
//   },
//   {
//     nome_socio: 'EVERTON LUIS KAPFENBERGER',
//     tipo: 'pessoa',
//     id_socios: '***224319**',
//     rol: 'Diretor',
//     id_empresa: '00.000.000/0001-91',
//     nombre_empresa: 'Banco do Brasil S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4221VER', 'BR4165VER'],
//   },
//   {
//     nome_socio: 'JOAO VAGNES DE MOURA SILVA',
//     tipo: 'pessoa',
//     id_socios: '***043411**',
//     rol: 'Diretor',
//     id_empresa: '00.000.000/0001-91',
//     nombre_empresa: 'Banco do Brasil S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4221VER', 'BR4165VER'],
//   },
//   {
//     nome_socio: 'LUCINEIA POSSAR',
//     tipo: 'pessoa',
//     id_socios: '***309199**',
//     rol: 'Diretor',
//     id_empresa: '00.000.000/0001-91',
//     nombre_empresa: 'Banco do Brasil S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4221VER', 'BR4165VER'],
//   },
//   {
//     nome_socio: 'MARIANO COLINI CENAMO',
//     tipo: 'pessoa',
//     id_socios: '***318518**',
//     rol: 'Sócio',
//     id_empresa: '33.837.198/0001-11',
//     nombre_empresa:
//       'Amazonia Agroflorestal Comercializacao de Produtos Agroflorestais Ltda',
//     pais: 'Brasil',
//     id_proyecto: ['BR4265VER'],
//   },
//   {
//     nome_socio: 'JONATAS MACHADO IBERNON',
//     tipo: 'pessoa',
//     id_socios: '***143122**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '33.837.198/0001-11',
//     nombre_empresa:
//       'Amazonia Agroflorestal Comercializacao de Produtos Agroflorestais Ltda',
//     pais: 'Brasil',
//     id_proyecto: ['BR4265VER'],
//   },
//   {
//     nome_socio: 'NICIA DE ALMEIDA COUTINHO',
//     tipo: 'pessoa',
//     id_socios: '***607842**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '20.454.046/0001-98',
//     nombre_empresa: 'Harmonia Socioambiental',
//     pais: 'Brasil',
//     id_proyecto: ['BR1811VER'],
//   },
//   {
//     nome_socio: 'NICIA DE ALMEIDA COUTINHO',
//     tipo: 'pessoa',
//     id_socios: '***607842**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '20.454.046/0001-98',
//     nombre_empresa: 'Harmonia Consultoria LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR3141VER'],
//   },
//   {
//     nome_socio: 'MARY LUCY DA COSTA SANTANA',
//     tipo: 'pessoa',
//     id_socios: '***290448**',
//     rol: 'Sócio',
//     id_empresa: '20.454.046/0001-98',
//     nombre_empresa: 'Harmonia Socioambiental',
//     pais: 'Brasil',
//     id_proyecto: ['BR1811VER'],
//   },
//   {
//     nome_socio: 'MARY LUCY DA COSTA SANTANA',
//     tipo: 'pessoa',
//     id_socios: '***290448**',
//     rol: 'Sócio',
//     id_empresa: '20.454.046/0001-98',
//     nombre_empresa: 'Harmonia Consultoria LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR3141VER'],
//   },
//   {
//     nome_socio: 'JOSE AUGUSTO DE SOUSA JUNIOR',
//     tipo: 'pessoa',
//     id_socios: '***261198**',
//     rol: 'Conselheiro de Administração',
//     id_empresa: '11.090.267/0001-33',
//     nombre_empresa: 'Mata Nativa BR',
//     pais: 'Brasil',
//     id_proyecto: ['BR4461VER'],
//   },
//   {
//     nome_socio: 'JOSE AUGUSTO DE SOUSA JUNIOR',
//     tipo: 'pessoa',
//     id_socios: '***261198**',
//     rol: 'Conselheiro de Administração',
//     id_empresa: '11.090.267/0001-33',
//     nombre_empresa:
//       'MATA NATIVA DO BRASIL ASSESSORIA E CONSULTORIA AMBIENTAL LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR3281VER'],
//   },
//   {
//     nome_socio: 'RICARDO METZNER GOMES',
//     tipo: 'pessoa',
//     id_socios: '***859658**',
//     rol: 'Sócio',
//     id_empresa: '11.090.267/0001-33',
//     nombre_empresa: 'Mata Nativa BR',
//     pais: 'Brasil',
//     id_proyecto: ['BR4461VER'],
//   },
//   {
//     nome_socio: 'RICARDO METZNER GOMES',
//     tipo: 'pessoa',
//     id_socios: '***859658**',
//     rol: 'Sócio',
//     id_empresa: '11.090.267/0001-33',
//     nombre_empresa:
//       'MATA NATIVA DO BRASIL ASSESSORIA E CONSULTORIA AMBIENTAL LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR3281VER'],
//   },
//   {
//     nome_socio: 'JEFFERSON LUIZ MATIOLI',
//     tipo: 'pessoa',
//     id_socios: '***390338**',
//     rol: 'Sócio',
//     id_empresa: '11.090.267/0001-33',
//     nombre_empresa: 'Mata Nativa BR',
//     pais: 'Brasil',
//     id_proyecto: ['BR4461VER'],
//   },
//   {
//     nome_socio: 'JEFFERSON LUIZ MATIOLI',
//     tipo: 'pessoa',
//     id_socios: '***390338**',
//     rol: 'Sócio',
//     id_empresa: '11.090.267/0001-33',
//     nombre_empresa:
//       'MATA NATIVA DO BRASIL ASSESSORIA E CONSULTORIA AMBIENTAL LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR3281VER'],
//   },
//   {
//     nome_socio: 'ANDREZA KELLY DELBON DE SOUSA',
//     tipo: 'pessoa',
//     id_socios: '***788628**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '11.090.267/0001-33',
//     nombre_empresa: 'Mata Nativa BR',
//     pais: 'Brasil',
//     id_proyecto: ['BR4461VER'],
//   },
//   {
//     nome_socio: 'ANDREZA KELLY DELBON DE SOUSA',
//     tipo: 'pessoa',
//     id_socios: '***788628**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '11.090.267/0001-33',
//     nombre_empresa:
//       'MATA NATIVA DO BRASIL ASSESSORIA E CONSULTORIA AMBIENTAL LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR3281VER'],
//   },
//   {
//     nome_socio: 'ERLON SILVA HONORATO',
//     tipo: 'pessoa',
//     id_socios: '***866508**',
//     rol: 'Sócio',
//     id_empresa: '11.090.267/0001-33',
//     nombre_empresa: 'Mata Nativa BR',
//     pais: 'Brasil',
//     id_proyecto: ['BR4461VER'],
//   },
//   {
//     nome_socio: 'ERLON SILVA HONORATO',
//     tipo: 'pessoa',
//     id_socios: '***866508**',
//     rol: 'Sócio',
//     id_empresa: '11.090.267/0001-33',
//     nombre_empresa:
//       'MATA NATIVA DO BRASIL ASSESSORIA E CONSULTORIA AMBIENTAL LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR3281VER'],
//   },
//   {
//     nome_socio: 'FRANCILENE COLFERAI JACOB',
//     tipo: 'pessoa',
//     id_socios: '***714829**',
//     rol: 'Administrador',
//     id_empresa: '32.224.430/0001-83',
//     nombre_empresa: 'Jacob & Jacob Consultoria Agrícola Ltda',
//     pais: 'Brasil',
//     id_proyecto: ['BR3304VER'],
//   },
//   {
//     nome_socio: 'JAMIL COLFERAI JACOB',
//     tipo: 'pessoa',
//     id_socios: '***259339**',
//     rol: 'Sócio Menor (Assistido/Representado)',
//     id_empresa: '32.224.430/0001-83',
//     nombre_empresa: 'Jacob & Jacob Consultoria Agrícola Ltda',
//     pais: 'Brasil',
//     id_proyecto: ['BR3304VER'],
//   },
//   {
//     nome_socio: 'FERNANDO GUSTAVO JACOB',
//     tipo: 'pessoa',
//     id_socios: '***929509**',
//     rol: 'Administrador',
//     id_empresa: '32.224.430/0001-83',
//     nombre_empresa: 'Jacob & Jacob Consultoria Agrícola Ltda',
//     pais: 'Brasil',
//     id_proyecto: ['BR3304VER'],
//   },
//   {
//     nome_socio: 'VICENTE COLFERAI JACOB',
//     tipo: 'pessoa',
//     id_socios: '***269459**',
//     rol: 'Sócio Menor (Assistido/Representado)',
//     id_empresa: '32.224.430/0001-83',
//     nombre_empresa: 'Jacob & Jacob Consultoria Agrícola Ltda',
//     pais: 'Brasil',
//     id_proyecto: ['BR3304VER'],
//   },
//   {
//     nome_socio: 'SERGIO AUGUSTO MALACRIDA JUNIOR',
//     tipo: 'pessoa',
//     id_socios: '***532868**',
//     rol: 'Administrador',
//     id_empresa: '01.991.834/0001-79',
//     nombre_empresa: 'FAZENDA BODOQUENA LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4117VER'],
//   },
//   {
//     nome_socio: 'MAURO RIBEIRO NETO',
//     tipo: 'pessoa',
//     id_socios: '***002066**',
//     rol: 'Administrador',
//     id_empresa: '01.991.834/0001-79',
//     nombre_empresa: 'FAZENDA BODOQUENA LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4117VER'],
//   },
//   {
//     nome_socio: 'VOTORANTIM S.A.',
//     tipo: 'empresa',
//     id_socios: '3407049000151',
//     rol: 'Sócio',
//     id_empresa: '01.991.834/0001-79',
//     nombre_empresa: 'FAZENDA BODOQUENA LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4117VER'],
//   },
//   {
//     nome_socio: 'ADRIANO SARACENI BANDEIRA',
//     tipo: 'pessoa',
//     id_socios: '***487208**',
//     rol: 'Administrador',
//     id_empresa: '01.991.834/0001-79',
//     nombre_empresa: 'FAZENDA BODOQUENA LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4117VER'],
//   },
//   {
//     nome_socio: 'LUIZ APARECIDO CARUSO NETO',
//     tipo: 'pessoa',
//     id_socios: '***667778**',
//     rol: 'Administrador',
//     id_empresa: '01.991.834/0001-79',
//     nombre_empresa: 'FAZENDA BODOQUENA LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4117VER'],
//   },
//   {
//     nome_socio: 'VP GESTAO LTDA.',
//     tipo: 'empresa',
//     id_socios: '26547288000102',
//     rol: 'Sócio',
//     id_empresa: '01.991.834/0001-79',
//     nombre_empresa: 'FAZENDA BODOQUENA LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4117VER'],
//   },
//   {
//     nome_socio: 'MONICA CRISTINA CABELLO DE BRITO',
//     tipo: 'pessoa',
//     id_socios: '***877464**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '28.542.812/0001-88',
//     nombre_empresa: 'Casa da Floresta Ambiental Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR3590VER'],
//   },
//   {
//     nome_socio: 'KLAUS DUARTE BARRETTO',
//     tipo: 'pessoa',
//     id_socios: '***601978**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '28.542.812/0001-88',
//     nombre_empresa: 'Casa da Floresta Ambiental Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR3590VER'],
//   },
//   {
//     nome_socio: 'RUDIBERT RUECKERT',
//     tipo: 'pessoa',
//     id_socios: '***428319**',
//     rol: 'Administrador',
//     id_empresa: '04.193.033/0001-56',
//     nombre_empresa: 'Mil Madeiras Preciosas LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4542VER'],
//   },
//   {
//     nome_socio: 'JOAO DA CRUZ RODRIGUES',
//     tipo: 'pessoa',
//     id_socios: '***512723**',
//     rol: 'Administrador',
//     id_empresa: '04.193.033/0001-56',
//     nombre_empresa: 'Mil Madeiras Preciosas LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4542VER'],
//   },
//   {
//     nome_socio: 'PRECIOUS WOODS HOLDING LTD.',
//     tipo: 'empresa',
//     id_socios: '5569852000118',
//     rol: 'Sócio',
//     id_empresa: '04.193.033/0001-56',
//     nombre_empresa: 'Mil Madeiras Preciosas LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4542VER'],
//   },
//   {
//     nome_socio: 'JAMES CASTRO CAMELI',
//     tipo: 'pessoa',
//     id_socios: '***942272**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '02.257.256/0001-04',
//     nombre_empresa: 'Amazônia Agroindústria EIRELI',
//     pais: 'Brasil',
//     id_proyecto: ['BR3430VER'],
//   },
//   {
//     nome_socio: 'CARLOS SERGIO THOMAZI',
//     tipo: 'pessoa',
//     id_socios: '***535769**',
//     rol: 'Administrador',
//     id_empresa: '07.615.618/0001-05',
//     nombre_empresa: 'FSV PROJETOS AMBIENTAIS LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4069VER'],
//   },
//   {
//     nome_socio: 'JORGE LUIS URIARTE',
//     tipo: 'pessoa',
//     id_socios: '***056260**',
//     rol: 'Administrador',
//     id_empresa: '07.615.618/0001-05',
//     nombre_empresa: 'FSV PROJETOS AMBIENTAIS LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4069VER'],
//   },
//   {
//     nome_socio: 'JAIR ROVER',
//     tipo: 'pessoa',
//     id_socios: '***921912**',
//     rol: 'Administrador',
//     id_empresa: '07.615.618/0001-05',
//     nombre_empresa: 'FSV PROJETOS AMBIENTAIS LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4069VER'],
//   },
//   {
//     nome_socio: 'JJ ADMINISTRADORA DE BENS LTDA',
//     tipo: 'empresa',
//     id_socios: '30570275000121',
//     rol: 'Sócio',
//     id_empresa: '07.615.618/0001-05',
//     nombre_empresa: 'FSV PROJETOS AMBIENTAIS LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4069VER'],
//   },
//   {
//     nome_socio: 'HUMBERTO ANTONIO ROVER',
//     tipo: 'pessoa',
//     id_socios: '***788449**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '07.615.618/0001-05',
//     nombre_empresa: 'FSV PROJETOS AMBIENTAIS LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4069VER'],
//   },
//   {
//     nome_socio: 'JORGE LUIZ PORTO MUNARI',
//     tipo: 'pessoa',
//     id_socios: '***822859**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '07.615.618/0001-05',
//     nombre_empresa: 'FSV PROJETOS AMBIENTAIS LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4069VER'],
//   },
//   {
//     nome_socio: 'EJV PARTICIPACAO SOCIETARIA LTDA',
//     tipo: 'empresa',
//     id_socios: '34100287000143',
//     rol: 'Sócio',
//     id_empresa: '07.615.618/0001-05',
//     nombre_empresa: 'FSV PROJETOS AMBIENTAIS LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4069VER'],
//   },
//   {
//     nome_socio: 'JUCELINO ANTONIO SALLA',
//     tipo: 'pessoa',
//     id_socios: '***902900**',
//     rol: 'Administrador',
//     id_empresa: '07.615.618/0001-05',
//     nombre_empresa: 'FSV PROJETOS AMBIENTAIS LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4069VER'],
//   },
//   {
//     nome_socio: 'DN PARTICIPACOES LTDA',
//     tipo: 'empresa',
//     id_socios: '17416571000104',
//     rol: 'Sócio',
//     id_empresa: '07.615.618/0001-05',
//     nombre_empresa: 'FSV PROJETOS AMBIENTAIS LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4069VER'],
//   },
//   {
//     nome_socio: 'CJC PARTICIPACOES LTDA',
//     tipo: 'empresa',
//     id_socios: '50486543000139',
//     rol: 'Sócio',
//     id_empresa: '07.615.618/0001-05',
//     nombre_empresa: 'FSV PROJETOS AMBIENTAIS LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4069VER'],
//   },
//   {
//     nome_socio: 'SILMAR LAGEMANN',
//     tipo: 'pessoa',
//     id_socios: '***591460**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '07.615.618/0001-05',
//     nombre_empresa: 'FSV PROJETOS AMBIENTAIS LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4069VER'],
//   },
//   {
//     nome_socio: 'MARLI BERTOTTI DACKO',
//     tipo: 'pessoa',
//     id_socios: '***260000**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '02.609.742/0001-44',
//     nombre_empresa: 'Grupo Dacko',
//     pais: 'Brasil',
//     id_proyecto: ['BR1953VER'],
//   },
//   {
//     nome_socio: 'ALCIMAR DACKO',
//     tipo: 'pessoa',
//     id_socios: '***168880**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '02.609.742/0001-44',
//     nombre_empresa: 'Grupo Dacko',
//     pais: 'Brasil',
//     id_proyecto: ['BR1953VER'],
//   },
//   {
//     nome_socio:
//       'STADIE & FISCHA PARTICIPACOES, INCORPORACOES E ADMINISTRACAO DE BENS LTDA',
//     tipo: 'empresa',
//     id_socios: '19442704000142',
//     rol: 'Sócio',
//     id_empresa: '19.942.166/0003-17',
//     nombre_empresa: 'NRD Desenvolvimento de Recursos Naturais Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR2482VER'],
//   },
//   {
//     nome_socio: 'VALDEMAR CANDIDO DA SILVA',
//     tipo: 'pessoa',
//     id_socios: '***898379**',
//     rol: 'Administrador',
//     id_empresa: '19.942.166/0003-17',
//     nombre_empresa: 'NRD Desenvolvimento de Recursos Naturais Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR2482VER'],
//   },
//   {
//     nome_socio:
//       'MANFREDINI PARTICIPACOES, INCORPORACOES & ADMINISTRACAO DE BENS LTDA',
//     tipo: 'empresa',
//     id_socios: '10807509000102',
//     rol: 'Sócio',
//     id_empresa: '19.942.166/0003-17',
//     nombre_empresa: 'NRD Desenvolvimento de Recursos Naturais Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR2482VER'],
//   },
//   {
//     nome_socio: 'VCS PARTICIPACOES LTDA',
//     tipo: 'empresa',
//     id_socios: '46176324000186',
//     rol: 'Sócio',
//     id_empresa: '19.942.166/0003-17',
//     nombre_empresa: 'NRD Desenvolvimento de Recursos Naturais Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR2482VER'],
//   },
//   {
//     nome_socio: 'NATURAL RESOURCES DEVELOPMENT AG',
//     tipo: 'empresa',
//     id_socios: '13076885000154',
//     rol: 'Sócio',
//     id_empresa: '19.942.166/0003-17',
//     nombre_empresa: 'NRD Desenvolvimento de Recursos Naturais Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR2482VER'],
//   },
//   {
//     nome_socio: 'ANDRE ROBERTO DOS SANTOS MANFREDINI',
//     tipo: 'pessoa',
//     id_socios: '***357479**',
//     rol: 'Administrador',
//     id_empresa: '19.942.166/0003-17',
//     nombre_empresa: 'NRD Desenvolvimento de Recursos Naturais Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR2482VER'],
//   },
//   {
//     nome_socio: 'DERYCK PANTOJA MARTINS',
//     tipo: 'pessoa',
//     id_socios: '***869052**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '10.658.609/0001-06',
//     nombre_empresa:
//       'STA Soluções Técnicas e Serviços de Engenharia Ambiental Ltda',
//     pais: 'Brasil',
//     id_proyecto: ['BR4747VER', 'BR4687VER', 'BR3590VER'],
//   },
//   {
//     nome_socio: 'RANIERY VALE NERI BRANCO',
//     tipo: 'pessoa',
//     id_socios: '***987262**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '10.658.609/0001-06',
//     nombre_empresa:
//       'STA Soluções Técnicas e Serviços de Engenharia Ambiental Ltda',
//     pais: 'Brasil',
//     id_proyecto: ['BR4747VER', 'BR4687VER', 'BR3590VER'],
//   },
//   {
//     nome_socio: 'HEBERTON HENRIQUE DIMAS DE BARROS',
//     tipo: 'pessoa',
//     id_socios: '***200468**',
//     rol: 'Sócio',
//     id_empresa: '39.693.526/0001-30',
//     nombre_empresa: 'BRCarbon Serviços Ambientais LTDA',
//     pais: 'Brasil',
//     id_proyecto: [
//       'BR4850VER',
//       'BR4552VER',
//       'BR4542VER',
//       'BR4042VER',
//       'BR2551VER',
//     ],
//   },
//   {
//     nome_socio: 'DIEGO MACHADO CARRION SERRANO',
//     tipo: 'pessoa',
//     id_socios: '***277458**',
//     rol: 'Sócio',
//     id_empresa: '39.693.526/0001-30',
//     nombre_empresa: 'BRCarbon Serviços Ambientais LTDA',
//     pais: 'Brasil',
//     id_proyecto: [
//       'BR4850VER',
//       'BR4552VER',
//       'BR4542VER',
//       'BR4042VER',
//       'BR2551VER',
//     ],
//   },
//   {
//     nome_socio: 'BRUNO MELO DA MATTA',
//     tipo: 'pessoa',
//     id_socios: '***369088**',
//     rol: 'Sócio',
//     id_empresa: '39.693.526/0001-30',
//     nombre_empresa: 'BRCarbon Serviços Ambientais LTDA',
//     pais: 'Brasil',
//     id_proyecto: [
//       'BR4850VER',
//       'BR4552VER',
//       'BR4542VER',
//       'BR4042VER',
//       'BR2551VER',
//     ],
//   },
//   {
//     nome_socio: 'TMNH PARTICIPACOES LTDA',
//     tipo: 'empresa',
//     id_socios: '35725203000120',
//     rol: 'Sócio',
//     id_empresa: '39.693.526/0001-30',
//     nombre_empresa: 'BRCarbon Serviços Ambientais LTDA',
//     pais: 'Brasil',
//     id_proyecto: [
//       'BR4850VER',
//       'BR4552VER',
//       'BR4542VER',
//       'BR4042VER',
//       'BR2551VER',
//     ],
//   },
//   {
//     nome_socio: 'DAVID ESCAQUETE',
//     tipo: 'pessoa',
//     id_socios: '***023018**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '39.693.526/0001-30',
//     nombre_empresa: 'BRCarbon Serviços Ambientais LTDA',
//     pais: 'Brasil',
//     id_proyecto: [
//       'BR4850VER',
//       'BR4552VER',
//       'BR4542VER',
//       'BR4042VER',
//       'BR2551VER',
//     ],
//   },
//   {
//     nome_socio: 'RENAN AKIO KAMIMURA',
//     tipo: 'pessoa',
//     id_socios: '***056616**',
//     rol: 'Sócio',
//     id_empresa: '39.693.526/0001-30',
//     nombre_empresa: 'BRCarbon Serviços Ambientais LTDA',
//     pais: 'Brasil',
//     id_proyecto: [
//       'BR4850VER',
//       'BR4552VER',
//       'BR4542VER',
//       'BR4042VER',
//       'BR2551VER',
//     ],
//   },
//   {
//     nome_socio: 'BRUNO BRAZIL DE SOUZA',
//     tipo: 'pessoa',
//     id_socios: '***986868**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '39.693.526/0001-30',
//     nombre_empresa: 'BRCarbon Serviços Ambientais LTDA',
//     pais: 'Brasil',
//     id_proyecto: [
//       'BR4850VER',
//       'BR4552VER',
//       'BR4542VER',
//       'BR4042VER',
//       'BR2551VER',
//     ],
//   },
//   {
//     nome_socio: 'RUBENS BATISTA JUNIOR',
//     tipo: 'pessoa',
//     id_socios: '***518796**',
//     rol: 'Representante Legal',
//     id_empresa: '43.214.055/0001-07',
//     nombre_empresa: 'ARMAZENS MARTINS',
//     pais: 'Brasil',
//     id_proyecto: ['BR3590VER'],
//   },
//   {
//     nome_socio: 'MARCO ANTONIO VILELA TANNUS FILHO',
//     tipo: 'pessoa',
//     id_socios: '***628546**',
//     rol: 'Diretor',
//     id_empresa: '43.214.055/0001-07',
//     nombre_empresa: 'ARMAZENS MARTINS',
//     pais: 'Brasil',
//     id_proyecto: ['BR3590VER'],
//   },
//   {
//     nome_socio: 'AVENOR TEIXEIRA DE CARVALHO NETO',
//     tipo: 'pessoa',
//     id_socios: '***146346**',
//     rol: 'Diretor',
//     id_empresa: '43.214.055/0001-07',
//     nombre_empresa: 'ARMAZENS MARTINS',
//     pais: 'Brasil',
//     id_proyecto: ['BR3590VER'],
//   },
//   {
//     nome_socio: 'ARTHUR CHIAROTTO PENTEADO',
//     tipo: 'pessoa',
//     id_socios: '***456578**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '44.947.794/0001-70',
//     nombre_empresa: 'FAZENDA CONTINENTAL LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4671VER'],
//   },
//   {
//     nome_socio: 'GRAZIELLA VICENTE BISQUOLO PENTEADO',
//     tipo: 'pessoa',
//     id_socios: '***690498**',
//     rol: 'Sócio',
//     id_empresa: '44.947.794/0001-70',
//     nombre_empresa: 'FAZENDA CONTINENTAL LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4671VER'],
//   },
//   {
//     nome_socio: 'FLAVIA CHIAROTTO PENTEADO',
//     tipo: 'pessoa',
//     id_socios: '***651418**',
//     rol: 'Produtor Rural',
//     id_empresa: '08.430.917/0001-38',
//     nombre_empresa: 'Arthur Junqueira Ferreira Penteado',
//     pais: 'Brasil',
//     id_proyecto: ['BR4671VER'],
//   },
//   {
//     nome_socio: 'ARTHUR CHIAROTTO PENTEADO',
//     tipo: 'pessoa',
//     id_socios: '***456578**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '08.430.917/0001-38',
//     nombre_empresa: 'Arthur Junqueira Ferreira Penteado',
//     pais: 'Brasil',
//     id_proyecto: ['BR4671VER'],
//   },
//   {
//     nome_socio: 'ARTHUR JUNQUEIRA FERREIRA PENTEADO',
//     tipo: 'pessoa',
//     id_socios: '***150158**',
//     rol: 'Produtor Rural',
//     id_empresa: '08.430.917/0001-38',
//     nombre_empresa: 'Arthur Junqueira Ferreira Penteado',
//     pais: 'Brasil',
//     id_proyecto: ['BR4671VER'],
//   },
//   {
//     nome_socio: 'PINNACLE GLOBAL PARTNERS',
//     tipo: 'empresa',
//     id_socios: '27506365000149',
//     rol: 'Sócio Pessoa Jurídica Domiciliado no Exterior',
//     id_empresa: '19.235.736/0001-77',
//     nombre_empresa: 'Global Serviços de Engenharia',
//     pais: 'Brasil',
//     id_proyecto: ['BR1561VER'],
//   },
//   {
//     nome_socio: 'ALLAN MORGADO GUERRA',
//     tipo: 'pessoa',
//     id_socios: '***677107**',
//     rol: 'Administrador',
//     id_empresa: '19.235.736/0001-77',
//     nombre_empresa: 'Global Serviços de Engenharia',
//     pais: 'Brasil',
//     id_proyecto: ['BR1561VER'],
//   },
//   {
//     nome_socio: 'PAULO SILVA CESARIO ROSA',
//     tipo: 'pessoa',
//     id_socios: '***351442**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '10.758.301/0001-32',
//     nombre_empresa: 'Moura e Rosa Empreendimentos Imobiliários LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR963VER'],
//   },
//   {
//     nome_socio: 'FELIPE MOURA SALES',
//     tipo: 'pessoa',
//     id_socios: '***586582**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '10.758.301/0001-32',
//     nombre_empresa: 'Moura e Rosa Empreendimentos Imobiliários LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR963VER'],
//   },
//   {
//     nome_socio: 'JULIANA PEREZ ALONSO CORREA',
//     tipo: 'pessoa',
//     id_socios: '***701207**',
//     rol: 'Diretor',
//     id_empresa: '07.336.695/0001-26',
//     nombre_empresa: 'AgroSB Agropecuária S.A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4689VER'],
//   },
//   {
//     nome_socio: 'JULIANA PEREZ ALONSO CORREA',
//     tipo: 'pessoa',
//     id_socios: '***701207**',
//     rol: 'Diretor',
//     id_empresa: '07.336.695/0001-26',
//     nombre_empresa: 'AGROSB AGROPECUÁRIA S.A.',
//     pais: 'Brasil',
//     id_proyecto: ['BR4142VER'],
//   },
//   {
//     nome_socio: 'DANIEL MOREIRA FLORENCE',
//     tipo: 'pessoa',
//     id_socios: '***499317**',
//     rol: 'Diretor',
//     id_empresa: '07.336.695/0001-26',
//     nombre_empresa: 'AgroSB Agropecuária S.A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4689VER'],
//   },
//   {
//     nome_socio: 'DANIEL MOREIRA FLORENCE',
//     tipo: 'pessoa',
//     id_socios: '***499317**',
//     rol: 'Diretor',
//     id_empresa: '07.336.695/0001-26',
//     nombre_empresa: 'AGROSB AGROPECUÁRIA S.A.',
//     pais: 'Brasil',
//     id_proyecto: ['BR4142VER'],
//   },
//   {
//     nome_socio: 'EDUARDO DE BRITTO PEREIRA AZEVEDO',
//     tipo: 'pessoa',
//     id_socios: '***208487**',
//     rol: 'Conselheiro de Administração',
//     id_empresa: '07.336.695/0001-26',
//     nombre_empresa: 'AgroSB Agropecuária S.A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4689VER'],
//   },
//   {
//     nome_socio: 'EDUARDO DE BRITTO PEREIRA AZEVEDO',
//     tipo: 'pessoa',
//     id_socios: '***208487**',
//     rol: 'Conselheiro de Administração',
//     id_empresa: '07.336.695/0001-26',
//     nombre_empresa: 'AGROSB AGROPECUÁRIA S.A.',
//     pais: 'Brasil',
//     id_proyecto: ['BR4142VER'],
//   },
//   {
//     nome_socio: 'MARCIO JOSE FERREIRA',
//     tipo: 'pessoa',
//     id_socios: '***569628**',
//     rol: 'Diretor',
//     id_empresa: '07.336.695/0001-26',
//     nombre_empresa: 'AgroSB Agropecuária S.A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4689VER'],
//   },
//   {
//     nome_socio: 'MARCIO JOSE FERREIRA',
//     tipo: 'pessoa',
//     id_socios: '***569628**',
//     rol: 'Diretor',
//     id_empresa: '07.336.695/0001-26',
//     nombre_empresa: 'AGROSB AGROPECUÁRIA S.A.',
//     pais: 'Brasil',
//     id_proyecto: ['BR4142VER'],
//   },
//   {
//     nome_socio: 'ARLINDO DE AZEVEDO MOURA',
//     tipo: 'pessoa',
//     id_socios: '***459100**',
//     rol: 'Conselheiro de Administração',
//     id_empresa: '07.336.695/0001-26',
//     nombre_empresa: 'AgroSB Agropecuária S.A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4689VER'],
//   },
//   {
//     nome_socio: 'ARLINDO DE AZEVEDO MOURA',
//     tipo: 'pessoa',
//     id_socios: '***459100**',
//     rol: 'Conselheiro de Administração',
//     id_empresa: '07.336.695/0001-26',
//     nombre_empresa: 'AGROSB AGROPECUÁRIA S.A.',
//     pais: 'Brasil',
//     id_proyecto: ['BR4142VER'],
//   },
//   {
//     nome_socio: 'CRISTIANO SOARES RODRIGUES',
//     tipo: 'pessoa',
//     id_socios: '***919117**',
//     rol: 'Presidente',
//     id_empresa: '07.336.695/0001-26',
//     nombre_empresa: 'AgroSB Agropecuária S.A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4689VER'],
//   },
//   {
//     nome_socio: 'CRISTIANO SOARES RODRIGUES',
//     tipo: 'pessoa',
//     id_socios: '***919117**',
//     rol: 'Presidente',
//     id_empresa: '07.336.695/0001-26',
//     nombre_empresa: 'AGROSB AGROPECUÁRIA S.A.',
//     pais: 'Brasil',
//     id_proyecto: ['BR4142VER'],
//   },
//   {
//     nome_socio: 'ALMIR NARAYAMOGA SURUI',
//     tipo: 'pessoa',
//     id_socios: '***366972**',
//     rol: 'Presidente',
//     id_empresa: '22.858.310/0001-84',
//     nombre_empresa: 'Metareilá do Povo Indígena Suruí',
//     pais: 'Brasil',
//     id_proyecto: ['BR1118VER'],
//   },
//   {
//     nome_socio: 'FELIPE BITTENCOURT DE CARVALHO',
//     tipo: 'pessoa',
//     id_socios: '***799467**',
//     rol: 'Presidente',
//     id_empresa: '01.380.468/0001-11',
//     nombre_empresa: 'Arca S/A Agropecuaria',
//     pais: 'Brasil',
//     id_proyecto: ['BR2871VER'],
//   },
//   {
//     nome_socio: 'PAULO CESAR BITTENCOURT DE CARVALHO',
//     tipo: 'pessoa',
//     id_socios: '***699067**',
//     rol: 'Diretor',
//     id_empresa: '01.380.468/0001-11',
//     nombre_empresa: 'Arca S/A Agropecuaria',
//     pais: 'Brasil',
//     id_proyecto: ['BR2871VER'],
//   },
//   {
//     nome_socio: 'SEBASTIAO ERNANES RANGEL',
//     tipo: 'pessoa',
//     id_socios: '***626417**',
//     rol: 'Diretor',
//     id_empresa: '01.380.468/0001-11',
//     nombre_empresa: 'Arca S/A Agropecuaria',
//     pais: 'Brasil',
//     id_proyecto: ['BR2871VER'],
//   },
//   {
//     nome_socio: 'AIGLE CAVALCA KNACK',
//     tipo: 'pessoa',
//     id_socios: '***138519**',
//     rol: 'Administrador',
//     id_empresa: '24.727.505/0001-10',
//     nombre_empresa: 'AGROPECUARIA CAVALCA MT LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4867VER'],
//   },
//   {
//     nome_socio: 'ALCIDES CAVALCA NETO',
//     tipo: 'pessoa',
//     id_socios: '***708829**',
//     rol: 'Administrador',
//     id_empresa: '24.727.505/0001-10',
//     nombre_empresa: 'AGROPECUARIA CAVALCA MT LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4867VER'],
//   },
//   {
//     nome_socio: 'A A CAVALCA ADMINISTRACAO DE BENS PROPRIOS E PARTICIPACOES LTDA.',
//     tipo: 'empresa',
//     id_socios: '1569232000128',
//     rol: 'Sócio',
//     id_empresa: '24.727.505/0001-10',
//     nombre_empresa: 'AGROPECUARIA CAVALCA MT LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4867VER'],
//   },
//   {
//     nome_socio: 'CVL PARTICIPACOES SOCIETARIAS LTDA.',
//     tipo: 'empresa',
//     id_socios: '9474443000199',
//     rol: 'Sócio',
//     id_empresa: '24.727.505/0001-10',
//     nombre_empresa: 'AGROPECUARIA CAVALCA MT LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4867VER'],
//   },
//   {
//     nome_socio: 'ACK PARTICIPACOES SOCIETARIAS LTDA',
//     tipo: 'empresa',
//     id_socios: '29122221000114',
//     rol: 'Sócio',
//     id_empresa: '24.727.505/0001-10',
//     nombre_empresa: 'AGROPECUARIA CAVALCA MT LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4867VER'],
//   },
//   {
//     nome_socio: 'MEDIO NORTE PARTICIPACOES SOCIETARIAS LTDA.',
//     tipo: 'empresa',
//     id_socios: '10466676000129',
//     rol: 'Sócio',
//     id_empresa: '24.727.505/0001-10',
//     nombre_empresa: 'AGROPECUARIA CAVALCA MT LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4867VER'],
//   },
//   {
//     nome_socio: 'AFAR PARTICIPACOES SOCIETARIAS LTDA',
//     tipo: 'empresa',
//     id_socios: '21974561000161',
//     rol: 'Sócio',
//     id_empresa: '24.727.505/0001-10',
//     nombre_empresa: 'AGROPECUARIA CAVALCA MT LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4867VER'],
//   },
//   {
//     nome_socio: 'CELIA REGINA DANCIERI MARTINELLI',
//     tipo: 'pessoa',
//     id_socios: '***620648**',
//     rol: 'Sócio',
//     id_empresa: '45.034.188/0001-27',
//     nombre_empresa: 'COIMMA INCORPORAÇÕES IMOBILIÁRIAS LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4117VER'],
//   },
//   {
//     nome_socio: 'MARIA SANTINA DANSIERI',
//     tipo: 'pessoa',
//     id_socios: '***412308**',
//     rol: 'Sócio',
//     id_empresa: '45.034.188/0001-27',
//     nombre_empresa: 'COIMMA INCORPORAÇÕES IMOBILIÁRIAS LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4117VER'],
//   },
//   {
//     nome_socio: 'LUIZ CARLOS DANSIERI',
//     tipo: 'pessoa',
//     id_socios: '***455318**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '45.034.188/0001-27',
//     nombre_empresa: 'COIMMA INCORPORAÇÕES IMOBILIÁRIAS LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4117VER'],
//   },
//   {
//     nome_socio: 'PAULO CESAR DANCIERI',
//     tipo: 'pessoa',
//     id_socios: '***469618**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '45.034.188/0001-27',
//     nombre_empresa: 'COIMMA INCORPORAÇÕES IMOBILIÁRIAS LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4117VER'],
//   },
//   {
//     nome_socio: 'ISABEL CRISTINA DANCIERI SILVEIRA',
//     tipo: 'pessoa',
//     id_socios: '***078958**',
//     rol: 'Sócio',
//     id_empresa: '45.034.188/0001-27',
//     nombre_empresa: 'COIMMA INCORPORAÇÕES IMOBILIÁRIAS LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4117VER'],
//   },
//   {
//     nome_socio: 'FATIMA PERFEITO CAMPOS DANSIERI',
//     tipo: 'pessoa',
//     id_socios: '***437858**',
//     rol: 'Sócio',
//     id_empresa: '45.034.188/0001-27',
//     nombre_empresa: 'COIMMA INCORPORAÇÕES IMOBILIÁRIAS LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4117VER'],
//   },
//   {
//     nome_socio: 'DANIELA DE CAMPOS DANSIERI E ALMEIDA PRADO',
//     tipo: 'pessoa',
//     id_socios: '***064708**',
//     rol: 'Sócio',
//     id_empresa: '45.034.188/0001-27',
//     nombre_empresa: 'COIMMA INCORPORAÇÕES IMOBILIÁRIAS LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4117VER'],
//   },
//   {
//     nome_socio: 'VIRGILIO MAURICIO VIANA',
//     tipo: 'pessoa',
//     id_socios: '***280696**',
//     rol: 'Diretor',
//     id_empresa: '09.351.359/0001-88',
//     nombre_empresa: 'Fundação Amazonas Sustentável - FAS',
//     pais: 'Brasil',
//     id_proyecto: ['BR1596VER'],
//   },
//   {
//     nome_socio: 'MARIA DO SOCORRO CORDEIRO SIQUEIRA',
//     tipo: 'pessoa',
//     id_socios: '***065552**',
//     rol: 'Diretor',
//     id_empresa: '09.351.359/0001-88',
//     nombre_empresa: 'Fundação Amazonas Sustentável - FAS',
//     pais: 'Brasil',
//     id_proyecto: ['BR1596VER'],
//   },
//   {
//     nome_socio: 'JOSE VILLELA DE ANDRADE NETO',
//     tipo: 'pessoa',
//     id_socios: '***809518**',
//     rol: 'Presidente',
//     id_empresa: '03.472.750/0001-54',
//     nombre_empresa: 'AGROPECUARIA CHAPADA DOS GUIMARAES S A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4867VER'],
//   },
//   {
//     nome_socio: 'JOAO VILLELA DE ANDRADE',
//     tipo: 'pessoa',
//     id_socios: '***845878**',
//     rol: 'Diretor',
//     id_empresa: '03.472.750/0001-54',
//     nombre_empresa: 'AGROPECUARIA CHAPADA DOS GUIMARAES S A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4867VER'],
//   },
//   {
//     nome_socio: 'JOSE ULPIANO PINTO DE SOUZA FILHO',
//     tipo: 'pessoa',
//     id_socios: '***205518**',
//     rol: 'Diretor',
//     id_empresa: '03.472.750/0001-54',
//     nombre_empresa: 'AGROPECUARIA CHAPADA DOS GUIMARAES S A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4867VER'],
//   },
//   {
//     nome_socio: 'MANUELA CARVALHO FARIAS',
//     tipo: 'pessoa',
//     id_socios: '***503702**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '36.634.796/0001-81',
//     nombre_empresa: 'LAVRADO SOLUÇÕES AMBIENTAIS',
//     pais: 'Brasil',
//     id_proyecto: ['BR3430VER'],
//   },
//   {
//     nome_socio: 'MAOLA MONIQUE FARIA',
//     tipo: 'pessoa',
//     id_socios: '***744176**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '36.634.796/0001-81',
//     nombre_empresa: 'LAVRADO SOLUÇÕES AMBIENTAIS',
//     pais: 'Brasil',
//     id_proyecto: ['BR3430VER'],
//   },
//   {
//     nome_socio: 'FABIO IZIDORO DE FARIAS',
//     tipo: 'pessoa',
//     id_socios: '***979372**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '36.634.796/0001-81',
//     nombre_empresa: 'LAVRADO SOLUÇÕES AMBIENTAIS',
//     pais: 'Brasil',
//     id_proyecto: ['BR3430VER'],
//   },
//   {
//     nome_socio: 'RODRIGO SOUSA PEREIRA',
//     tipo: 'pessoa',
//     id_socios: '***817048**',
//     rol: 'Sócio com Capital',
//     id_empresa: '10.245.529/0001-29',
//     nombre_empresa: 'Monteiro de Barros Sociedade de Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR4747VER'],
//   },
//   {
//     nome_socio: 'PAULA DE LARA E SILVA',
//     tipo: 'pessoa',
//     id_socios: '***511028**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '10.245.529/0001-29',
//     nombre_empresa: 'Monteiro de Barros Sociedade de Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR4747VER'],
//   },
//   {
//     nome_socio: 'SORAIA DE SOUZA PIRES',
//     tipo: 'pessoa',
//     id_socios: '***019978**',
//     rol: 'Sócio sem Capital',
//     id_empresa: '10.245.529/0001-29',
//     nombre_empresa: 'Monteiro de Barros Sociedade de Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR4747VER'],
//   },
//   {
//     nome_socio: 'THEOTONIO MAURICIO MONTEIRO DE BARROS',
//     tipo: 'pessoa',
//     id_socios: '***551938**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '10.245.529/0001-29',
//     nombre_empresa: 'Monteiro de Barros Sociedade de Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR4747VER'],
//   },
//   {
//     nome_socio: 'PAOLO ARDENGHI DI CICCO',
//     tipo: 'pessoa',
//     id_socios: '***000788**',
//     rol: 'Sócio sem Capital',
//     id_empresa: '10.245.529/0001-29',
//     nombre_empresa: 'Monteiro de Barros Sociedade de Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR4747VER'],
//   },
//   {
//     nome_socio: 'EDSON ANASTACIO FILHO',
//     tipo: 'pessoa',
//     id_socios: '***834308**',
//     rol: 'Sócio sem Capital',
//     id_empresa: '10.245.529/0001-29',
//     nombre_empresa: 'Monteiro de Barros Sociedade de Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR4747VER'],
//   },
//   {
//     nome_socio: 'THIAGO ARMANDO SPINA',
//     tipo: 'pessoa',
//     id_socios: '***454938**',
//     rol: 'Sócio sem Capital',
//     id_empresa: '10.245.529/0001-29',
//     nombre_empresa: 'Monteiro de Barros Sociedade de Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR4747VER'],
//   },
//   {
//     nome_socio: 'ALEX SANDRO DA SILVA',
//     tipo: 'pessoa',
//     id_socios: '***605588**',
//     rol: 'Sócio com Capital',
//     id_empresa: '10.245.529/0001-29',
//     nombre_empresa: 'Monteiro de Barros Sociedade de Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR4747VER'],
//   },
//   {
//     nome_socio: 'LILIAN KEIKO MOTOOKA',
//     tipo: 'pessoa',
//     id_socios: '***890308**',
//     rol: 'Sócio com Capital',
//     id_empresa: '10.245.529/0001-29',
//     nombre_empresa: 'Monteiro de Barros Sociedade de Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR4747VER'],
//   },
//   {
//     nome_socio: 'RAPHAELLA MARIA CHAGAS FERNANDES GONCALVES',
//     tipo: 'pessoa',
//     id_socios: '***600328**',
//     rol: 'Sócio sem Capital',
//     id_empresa: '10.245.529/0001-29',
//     nombre_empresa: 'Monteiro de Barros Sociedade de Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR4747VER'],
//   },
//   {
//     nome_socio: 'BARBARA REGE PALOMO PAVAN',
//     tipo: 'pessoa',
//     id_socios: '***209098**',
//     rol: 'Sócio sem Capital',
//     id_empresa: '10.245.529/0001-29',
//     nombre_empresa: 'Monteiro de Barros Sociedade de Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR4747VER'],
//   },
//   {
//     nome_socio: 'FABIANA MACIEL DA COSTA',
//     tipo: 'pessoa',
//     id_socios: '***699973**',
//     rol: 'Sócio sem Capital',
//     id_empresa: '10.245.529/0001-29',
//     nombre_empresa: 'Monteiro de Barros Sociedade de Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR4747VER'],
//   },
//   {
//     nome_socio: 'NADIA DE SOUZA BANCOFF',
//     tipo: 'pessoa',
//     id_socios: '***243128**',
//     rol: 'Sócio sem Capital',
//     id_empresa: '10.245.529/0001-29',
//     nombre_empresa: 'Monteiro de Barros Sociedade de Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR4747VER'],
//   },
//   {
//     nome_socio: 'PATRICIA DE LUCA LIMA GREFF',
//     tipo: 'pessoa',
//     id_socios: '***751649**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '20.277.095/0001-00',
//     nombre_empresa: 'NEO GREEN CONSULTORIA AMBIENTAL LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR3050VER', 'BR2950VER'],
//   },
//   {
//     nome_socio: 'FABIO GALINDO SILVESTRE',
//     tipo: 'pessoa',
//     id_socios: '***417038**',
//     rol: 'Diretor',
//     id_empresa: '43.688.286/0001-52',
//     nombre_empresa: 'Future Carbon Holding S.A.',
//     pais: 'Brasil',
//     id_proyecto: [
//       'BR4263VER',
//       'BR4141VER',
//       'BR4142VER',
//       'BR4143VER',
//       'BR4094VER',
//       'BR4095VER',
//       'BR4082VER',
//       'BR4084VER',
//       'BR4089VER',
//       'BR4068VER',
//       'BR4069VER',
//       'BR3666VER',
//       'BR3451VER',
//       'BR3306VER',
//       'BR3049VER',
//       'BR2878VER',
//     ],
//   },
//   {
//     nome_socio: 'MARCIO ARTIN ARAKELIAN',
//     tipo: 'pessoa',
//     id_socios: '***883488**',
//     rol: 'Diretor',
//     id_empresa: '43.688.286/0001-52',
//     nombre_empresa: 'Future Carbon Holding S.A.',
//     pais: 'Brasil',
//     id_proyecto: [
//       'BR4263VER',
//       'BR4141VER',
//       'BR4142VER',
//       'BR4143VER',
//       'BR4094VER',
//       'BR4095VER',
//       'BR4082VER',
//       'BR4084VER',
//       'BR4089VER',
//       'BR4068VER',
//       'BR4069VER',
//       'BR3666VER',
//       'BR3451VER',
//       'BR3306VER',
//       'BR3049VER',
//       'BR2878VER',
//     ],
//   },
//   {
//     nome_socio: 'RODRIGO GOMES DE OLIVEIRA',
//     tipo: 'pessoa',
//     id_socios: '***451969**',
//     rol: 'Administrador',
//     id_empresa: '40.968.597/0001-87',
//     nombre_empresa: 'Roma Participações S/S LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR3631VER'],
//   },
//   {
//     nome_socio: 'RG CLINICA MEDICA SS LTDA',
//     tipo: 'empresa',
//     id_socios: '39876042000126',
//     rol: 'Sócio',
//     id_empresa: '40.968.597/0001-87',
//     nombre_empresa: 'Roma Participações S/S LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR3631VER'],
//   },
//   {
//     nome_socio: 'VITORIO SUFREDINI NETO',
//     tipo: 'pessoa',
//     id_socios: '***133913**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '09.256.139/0001-75',
//     nombre_empresa: 'Floraplac MDF LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4042VER'],
//   },
//   {
//     nome_socio: 'ADRIANO D AGNOLUZZO',
//     tipo: 'pessoa',
//     id_socios: '***215749**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '09.256.139/0001-75',
//     nombre_empresa: 'Floraplac MDF LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4042VER'],
//   },
//   {
//     nome_socio: 'SILVANO D AGNOLUZZO',
//     tipo: 'pessoa',
//     id_socios: '***196092**',
//     rol: 'Sócio',
//     id_empresa: '09.256.139/0001-75',
//     nombre_empresa: 'Floraplac MDF LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4042VER'],
//   },
//   {
//     nome_socio: 'RADCE CONSULTORIA E PARTICIPACOES LTDA',
//     tipo: 'empresa',
//     id_socios: '24271394000180',
//     rol: 'Sócio',
//     id_empresa: '47.457.033/0001-29',
//     nombre_empresa: 'Infrapar Sustainability Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR4497VER', 'BR4394VER'],
//   },
//   {
//     nome_socio: 'MARIANA NAOUM MENDONCA COROA',
//     tipo: 'pessoa',
//     id_socios: '***654587**',
//     rol: 'Administrador',
//     id_empresa: '47.457.033/0001-29',
//     nombre_empresa: 'Infrapar Sustainability Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR4497VER', 'BR4394VER'],
//   },
//   {
//     nome_socio: 'NAOUM AMBIENTAL LTDA',
//     tipo: 'empresa',
//     id_socios: '44109954000102',
//     rol: 'Sócio',
//     id_empresa: '47.457.033/0001-29',
//     nombre_empresa: 'Infrapar Sustainability Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR4497VER', 'BR4394VER'],
//   },
//   {
//     nome_socio: 'IVISIX VENTURES, CONSULTORIA, PROJETOS E PARTICIPACOES LTDA',
//     tipo: 'empresa',
//     id_socios: '18546015000115',
//     rol: 'Sócio',
//     id_empresa: '47.457.033/0001-29',
//     nombre_empresa: 'Infrapar Sustainability Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR4497VER', 'BR4394VER'],
//   },
//   {
//     nome_socio: 'MARCO ANTONIO FUJIHARA',
//     tipo: 'pessoa',
//     id_socios: '***916318**',
//     rol: 'Administrador',
//     id_empresa: '47.457.033/0001-29',
//     nombre_empresa: 'Infrapar Sustainability Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR4497VER', 'BR4394VER'],
//   },
//   {
//     nome_socio: 'VICTOR NAOUM MENDONCA COROA',
//     tipo: 'pessoa',
//     id_socios: '***655237**',
//     rol: 'Administrador',
//     id_empresa: '47.457.033/0001-29',
//     nombre_empresa: 'Infrapar Sustainability Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR4497VER', 'BR4394VER'],
//   },
//   {
//     nome_socio: 'JULIANA DIAS FIGUEIREDO',
//     tipo: 'pessoa',
//     id_socios: '***150267**',
//     rol: 'Administrador',
//     id_empresa: '47.457.033/0001-29',
//     nombre_empresa: 'Infrapar Sustainability Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR4497VER', 'BR4394VER'],
//   },
//   {
//     nome_socio: 'MN CONSULTORIA E PARTICIPACOES LTDA',
//     tipo: 'pessoa',
//     id_socios: '48890355000120',
//     rol: 'Sócio',
//     id_empresa: '47.457.033/0001-29',
//     nombre_empresa: 'Infrapar Sustainability Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR4497VER', 'BR4394VER'],
//   },
//   {
//     nome_socio: 'BRENO PINTO FIGUEIREDO',
//     tipo: 'pessoa',
//     id_socios: '***316027**',
//     rol: 'Administrador',
//     id_empresa: '47.457.033/0001-29',
//     nombre_empresa: 'Infrapar Sustainability Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR4497VER', 'BR4394VER'],
//   },
//   {
//     nome_socio: 'SANTA ADELIA EMPREENDIMENTOS E PARTICIPACOES S/A',
//     tipo: 'empresa',
//     id_socios: '24118220000182',
//     rol: 'Sócio',
//     id_empresa: '00.309.708/0001-29',
//     nombre_empresa: 'KPM Empreendimentos e Participações Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR3152VER'],
//   },
//   {
//     nome_socio: 'MORRO AZUL EMPREENDIMENTOS E PARTICIPACOES S/A',
//     tipo: 'empresa',
//     id_socios: '7697230000109',
//     rol: 'Sócio',
//     id_empresa: '00.309.708/0001-29',
//     nombre_empresa: 'KPM Empreendimentos e Participações Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR3152VER'],
//   },
//   {
//     nome_socio: 'NOSSA SENHORA APARECIDA EMPREENDIMENTOS E PARTICIPACOES S/A',
//     tipo: 'empresa',
//     id_socios: '13610970000150',
//     rol: 'Sócio',
//     id_empresa: '00.309.708/0001-29',
//     nombre_empresa: 'KPM Empreendimentos e Participações Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR3152VER'],
//   },
//   {
//     nome_socio: 'EDSON KELLER',
//     tipo: 'pessoa',
//     id_socios: '***975608**',
//     rol: 'Administrador',
//     id_empresa: '00.309.708/0001-29',
//     nombre_empresa: 'KPM Empreendimentos e Participações Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR3152VER'],
//   },
//   {
//     nome_socio: 'IARA NUNES DE OLIVEIRA',
//     tipo: 'pessoa',
//     id_socios: '***664001**',
//     rol: 'Administrador',
//     id_empresa: '00.309.708/0001-29',
//     nombre_empresa: 'KPM Empreendimentos e Participações Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR3152VER'],
//   },
//   {
//     nome_socio: 'SATURNO INVESTIMENTOS E PARTICIPACOES S/A',
//     tipo: 'empresa',
//     id_socios: '7640115000190',
//     rol: 'Sócio',
//     id_empresa: '00.309.708/0001-29',
//     nombre_empresa: 'KPM Empreendimentos e Participações Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR3152VER'],
//   },
//   {
//     nome_socio: 'RIO XINGU PARTICIPACOES LTDA',
//     tipo: 'empresa',
//     id_socios: '7826181000159',
//     rol: 'Sócio',
//     id_empresa: '00.309.708/0001-29',
//     nombre_empresa: 'KPM Empreendimentos e Participações Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR3152VER'],
//   },
//   {
//     nome_socio: 'LUIZ PICCININ',
//     tipo: 'pessoa',
//     id_socios: '***215738**',
//     rol: 'Administrador',
//     id_empresa: '00.309.708/0001-29',
//     nombre_empresa: 'KPM Empreendimentos e Participações Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR3152VER'],
//   },
//   {
//     nome_socio: 'ROBERTO MOTTA',
//     tipo: 'pessoa',
//     id_socios: '***684718**',
//     rol: 'Administrador',
//     id_empresa: '00.309.708/0001-29',
//     nombre_empresa: 'KPM Empreendimentos e Participações Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR3152VER'],
//   },
//   {
//     nome_socio: 'RODRIGO DE SOUZA GOMES',
//     tipo: 'pessoa',
//     id_socios: '***820842**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '38.384.085/0001-21',
//     nombre_empresa: 'Catraia Soluções Ambientais LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR3631VER'],
//   },
//   {
//     nome_socio: 'RAIR DE SOUSA VERDE',
//     tipo: 'pessoa',
//     id_socios: '***950202**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '38.384.085/0001-21',
//     nombre_empresa: 'Catraia Soluções Ambientais LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR3631VER'],
//   },
//   {
//     nome_socio: 'GUILHERME ROSSETTO NUNES DE OLIVEIRA',
//     tipo: 'pessoa',
//     id_socios: '***141088**',
//     rol: 'Administrador',
//     id_empresa: '17.610.393/0001-58',
//     nombre_empresa: 'Terra Vista Gestora de Recursos Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR4394VER', 'BR3816VER'],
//   },
//   {
//     nome_socio: 'GUILHERME ROSSETTO NUNES DE OLIVEIRA',
//     tipo: 'pessoa',
//     id_socios: '***141088**',
//     rol: 'Administrador',
//     id_empresa: '17.610.393/0001-58',
//     nombre_empresa: 'Terra Vista Gestora de Recursos Ltd',
//     pais: 'Brasil',
//     id_proyecto: ['BR4221VER', 'BR4165VER'],
//   },
//   {
//     nome_socio: 'LIRDES S.A.',
//     tipo: 'empresa',
//     id_socios: '40054245000116',
//     rol: 'Sócio Pessoa Jurídica Domiciliado no Exterior',
//     id_empresa: '17.610.393/0001-58',
//     nombre_empresa: 'Terra Vista Gestora de Recursos Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR4394VER', 'BR3816VER'],
//   },
//   {
//     nome_socio: 'LIRDES S.A.',
//     tipo: 'empresa',
//     id_socios: '40054245000116',
//     rol: 'Sócio Pessoa Jurídica Domiciliado no Exterior',
//     id_empresa: '17.610.393/0001-58',
//     nombre_empresa: 'Terra Vista Gestora de Recursos Ltd',
//     pais: 'Brasil',
//     id_proyecto: ['BR4221VER', 'BR4165VER'],
//   },
//   {
//     nome_socio: 'ROBERTO FIGUEIREDO STRUMPF',
//     tipo: 'pessoa',
//     id_socios: '***860408**',
//     rol: 'Administrador',
//     id_empresa: '11.388.008/0001-93',
//     nombre_empresa: 'Radicle',
//     pais: 'Brasil',
//     id_proyecto: ['BR2586VER', 'BR2587VER'],
//   },
//   {
//     nome_socio: 'CARBON CREDIT SOLUTIONS INC',
//     tipo: 'empresa',
//     id_socios: '34490801000102',
//     rol: 'Sócio Pessoa Jurídica Domiciliado no Exterior',
//     id_empresa: '11.388.008/0001-93',
//     nombre_empresa: 'Radicle',
//     pais: 'Brasil',
//     id_proyecto: ['BR2586VER', 'BR2587VER'],
//   },
//   {
//     nome_socio: 'UBIRACI BENUTE JAIME',
//     tipo: 'pessoa',
//     id_socios: '***651398**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '48.258.048/0001-20',
//     nombre_empresa: 'Seringal São Miguel SPE Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR4394VER'],
//   },
//   {
//     nome_socio: 'JOSE CARLOS KALIL',
//     tipo: 'pessoa',
//     id_socios: '***504478**',
//     rol: 'Sócio',
//     id_empresa: '48.258.048/0001-20',
//     nombre_empresa: 'Seringal São Miguel SPE Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR4394VER'],
//   },
//   {
//     nome_socio: 'ERNANDO PEREIRA DA SILVA',
//     tipo: 'pessoa',
//     id_socios: '***794918**',
//     rol: 'Sócio',
//     id_empresa: '48.258.048/0001-20',
//     nombre_empresa: 'Seringal São Miguel SPE Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR4394VER'],
//   },
//   {
//     nome_socio: 'JEFFERSON RUBENS FERREIRA',
//     tipo: 'pessoa',
//     id_socios: '***859788**',
//     rol: 'Sócio',
//     id_empresa: '48.258.048/0001-20',
//     nombre_empresa: 'Seringal São Miguel SPE Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR4394VER'],
//   },
//   {
//     nome_socio: 'CRISTIANI SILVESTRE',
//     tipo: 'pessoa',
//     id_socios: '***150228**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '24.535.210/0001-42',
//     nombre_empresa: 'Nigrum Capital Assessoria e Gestão de Negócios LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR3304VER', 'BR2980VER'],
//   },
//   {
//     nome_socio: 'MARCOS GUILHERME ALVES PRETO',
//     tipo: 'pessoa',
//     id_socios: '***830858**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '24.535.210/0001-42',
//     nombre_empresa: 'Nigrum Capital Assessoria e Gestão de Negócios LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR3304VER', 'BR2980VER'],
//   },
//   {
//     nome_socio: 'JORGE FRANCISCO HENRIQUES',
//     tipo: 'pessoa',
//     id_socios: '***806808**',
//     rol: 'Diretor',
//     id_empresa: '04.815.734/0001-80',
//     nombre_empresa: 'Jari Celulose S.A.',
//     pais: 'Brasil',
//     id_proyecto: ['BR1811VER', 'BR1115VER'],
//   },
//   {
//     nome_socio: 'SERGIO ANTONIO GARCIA AMOROSO',
//     tipo: 'pessoa',
//     id_socios: '***086608**',
//     rol: 'Presidente',
//     id_empresa: '04.815.734/0001-80',
//     nombre_empresa: 'Jari Celulose S.A.',
//     pais: 'Brasil',
//     id_proyecto: ['BR1811VER', 'BR1115VER'],
//   },
//   {
//     nome_socio: 'ANDRE LUIZ PINTO LISBOA PINHEIRO',
//     tipo: 'pessoa',
//     id_socios: '***759702**',
//     rol: 'Presidente',
//     id_empresa: '04.138.913/0001-20',
//     nombre_empresa: 'Maísa-Moju Agroindustrial Ltda',
//     pais: 'Brasil',
//     id_proyecto: ['BR1329VER'],
//   },
//   {
//     nome_socio: 'MARCIO ROBERTO PINTO LISBOA PINHEIRO',
//     tipo: 'pessoa',
//     id_socios: '***099482**',
//     rol: 'Diretor',
//     id_empresa: '04.138.913/0001-20',
//     nombre_empresa: 'Maísa-Moju Agroindustrial Ltda',
//     pais: 'Brasil',
//     id_proyecto: ['BR1329VER'],
//   },
//   {
//     nome_socio: 'MOACIR ELOY CROCETTA BATISTA',
//     tipo: 'pessoa',
//     id_socios: '***705129**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '22.839.815/0001-00',
//     nombre_empresa: 'BATISTA E CIA LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR2551VER'],
//   },
//   {
//     nome_socio: 'IRACI GALVANE BATISTA',
//     tipo: 'pessoa',
//     id_socios: '***509359**',
//     rol: 'Sócio',
//     id_empresa: '22.839.815/0001-00',
//     nombre_empresa: 'BATISTA E CIA LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR2551VER'],
//   },
//   {
//     nome_socio: 'RAFAEL BEMERGUY SEFER',
//     tipo: 'pessoa',
//     id_socios: '***017792**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '43.608.949/0001-81',
//     nombre_empresa: 'SANTA MARIA PECUARIA E AGRONEGOCIO LTDA.',
//     pais: 'Brasil',
//     id_proyecto: ['BR3738VER'],
//   },
//   {
//     nome_socio: 'CHRISTIANA SOARES CABRAL FLECHA',
//     tipo: 'pessoa',
//     id_socios: '***148736**',
//     rol: 'Administrador',
//     id_empresa: '12.028.178/0001-20',
//     nombre_empresa: 'Carbonext Tecnologia em Soluções Ambientais LTDA',
//     pais: 'Brasil',
//     id_proyecto: [
//       'BR4886VER',
//       'BR4876VER',
//       'BR4865VER',
//       'BR4867VER',
//       'BR4857VER',
//       'BR4681VER',
//       'BR4671VER',
//       'BR3601VER',
//       'BR3324VER',
//       'BR3055VER',
//       'BR3002VER',
//       'BR2539VER',
//       'BR2508VER',
//       'BR1686VER',
//     ],
//   },
//   {
//     nome_socio: 'FELIPE VIANA LIMA',
//     tipo: 'pessoa',
//     id_socios: '***925228**',
//     rol: 'Administrador',
//     id_empresa: '12.028.178/0001-20',
//     nombre_empresa: 'Carbonext Tecnologia em Soluções Ambientais LTDA',
//     pais: 'Brasil',
//     id_proyecto: [
//       'BR4886VER',
//       'BR4876VER',
//       'BR4865VER',
//       'BR4867VER',
//       'BR4857VER',
//       'BR4681VER',
//       'BR4671VER',
//       'BR3601VER',
//       'BR3324VER',
//       'BR3055VER',
//       'BR3002VER',
//       'BR2539VER',
//       'BR2508VER',
//       'BR1686VER',
//     ],
//   },
//   {
//     nome_socio: 'LUIZ FERNANDO DE MOURA',
//     tipo: 'pessoa',
//     id_socios: '***671088**',
//     rol: 'Administrador',
//     id_empresa: '12.028.178/0001-20',
//     nombre_empresa: 'Carbonext Tecnologia em Soluções Ambientais LTDA',
//     pais: 'Brasil',
//     id_proyecto: [
//       'BR4886VER',
//       'BR4876VER',
//       'BR4865VER',
//       'BR4867VER',
//       'BR4857VER',
//       'BR4681VER',
//       'BR4671VER',
//       'BR3601VER',
//       'BR3324VER',
//       'BR3055VER',
//       'BR3002VER',
//       'BR2539VER',
//       'BR2508VER',
//       'BR1686VER',
//     ],
//   },
//   {
//     nome_socio: 'FRANCIELE SALVADOR',
//     tipo: 'pessoa',
//     id_socios: '***648179**',
//     rol: 'Administrador',
//     id_empresa: '12.028.178/0001-20',
//     nombre_empresa: 'Carbonext Tecnologia em Soluções Ambientais LTDA',
//     pais: 'Brasil',
//     id_proyecto: [
//       'BR4886VER',
//       'BR4876VER',
//       'BR4865VER',
//       'BR4867VER',
//       'BR4857VER',
//       'BR4681VER',
//       'BR4671VER',
//       'BR3601VER',
//       'BR3324VER',
//       'BR3055VER',
//       'BR3002VER',
//       'BR2539VER',
//       'BR2508VER',
//       'BR1686VER',
//     ],
//   },
//   {
//     nome_socio: 'CARBONEXT HOLDING S.A',
//     tipo: 'empresa',
//     id_socios: '41643197000164',
//     rol: 'Sócio',
//     id_empresa: '12.028.178/0001-20',
//     nombre_empresa: 'Carbonext Tecnologia em Soluções Ambientais LTDA',
//     pais: 'Brasil',
//     id_proyecto: [
//       'BR4886VER',
//       'BR4876VER',
//       'BR4865VER',
//       'BR4867VER',
//       'BR4857VER',
//       'BR4681VER',
//       'BR4671VER',
//       'BR3601VER',
//       'BR3324VER',
//       'BR3055VER',
//       'BR3002VER',
//       'BR2539VER',
//       'BR2508VER',
//       'BR1686VER',
//     ],
//   },
//   {
//     nome_socio: 'LUCIANO ROBERTO CORREA DA FONSECA FILHO',
//     tipo: 'pessoa',
//     id_socios: '***039828**',
//     rol: 'Administrador',
//     id_empresa: '12.028.178/0001-20',
//     nombre_empresa: 'Carbonext Tecnologia em Soluções Ambientais LTDA',
//     pais: 'Brasil',
//     id_proyecto: [
//       'BR4886VER',
//       'BR4876VER',
//       'BR4865VER',
//       'BR4867VER',
//       'BR4857VER',
//       'BR4681VER',
//       'BR4671VER',
//       'BR3601VER',
//       'BR3324VER',
//       'BR3055VER',
//       'BR3002VER',
//       'BR2539VER',
//       'BR2508VER',
//       'BR1686VER',
//     ],
//   },
//   {
//     nome_socio: 'HUGO SOUZA DOS SANTOS',
//     tipo: 'pessoa',
//     id_socios: '***050378**',
//     rol: 'Administrador',
//     id_empresa: '12.028.178/0001-20',
//     nombre_empresa: 'Carbonext Tecnologia em Soluções Ambientais LTDA',
//     pais: 'Brasil',
//     id_proyecto: [
//       'BR4886VER',
//       'BR4876VER',
//       'BR4865VER',
//       'BR4867VER',
//       'BR4857VER',
//       'BR4681VER',
//       'BR4671VER',
//       'BR3601VER',
//       'BR3324VER',
//       'BR3055VER',
//       'BR3002VER',
//       'BR2539VER',
//       'BR2508VER',
//       'BR1686VER',
//     ],
//   },
//   {
//     nome_socio: 'JANAINA CORREA DA FONSECA DALLAN',
//     tipo: 'pessoa',
//     id_socios: '***713338**',
//     rol: 'Administrador',
//     id_empresa: '12.028.178/0001-20',
//     nombre_empresa: 'Carbonext Tecnologia em Soluções Ambientais LTDA',
//     pais: 'Brasil',
//     id_proyecto: [
//       'BR4886VER',
//       'BR4876VER',
//       'BR4865VER',
//       'BR4867VER',
//       'BR4857VER',
//       'BR4681VER',
//       'BR4671VER',
//       'BR3601VER',
//       'BR3324VER',
//       'BR3055VER',
//       'BR3002VER',
//       'BR2539VER',
//       'BR2508VER',
//       'BR1686VER',
//     ],
//   },
//   {
//     nome_socio: 'VICTOR SOUZA DE MATTOS',
//     tipo: 'pessoa',
//     id_socios: '***005528**',
//     rol: 'Administrador',
//     id_empresa: '12.028.178/0001-20',
//     nombre_empresa: 'Carbonext Tecnologia em Soluções Ambientais LTDA',
//     pais: 'Brasil',
//     id_proyecto: [
//       'BR4886VER',
//       'BR4876VER',
//       'BR4865VER',
//       'BR4867VER',
//       'BR4857VER',
//       'BR4681VER',
//       'BR4671VER',
//       'BR3601VER',
//       'BR3324VER',
//       'BR3055VER',
//       'BR3002VER',
//       'BR2539VER',
//       'BR2508VER',
//       'BR1686VER',
//     ],
//   },
//   {
//     nome_socio: 'MARCOS FRANCISCO DE LA CRUZ COSTA',
//     tipo: 'pessoa',
//     id_socios: '***390358**',
//     rol: 'Diretor',
//     id_empresa: '04.102.265/0001-51',
//     nombre_empresa: 'AGROPALMA S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4034VER'],
//   },
//   {
//     nome_socio: 'LUIZ HENRIQUE OLIVEIRA MARQUES',
//     tipo: 'pessoa',
//     id_socios: '***347041**',
//     rol: 'Diretor',
//     id_empresa: '04.102.265/0001-51',
//     nombre_empresa: 'AGROPALMA S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4034VER'],
//   },
//   {
//     nome_socio: 'MARCELLA CATARINA NOVAES DE ARAUJO',
//     tipo: 'pessoa',
//     id_socios: '***350162**',
//     rol: 'Diretor',
//     id_empresa: '04.102.265/0001-51',
//     nombre_empresa: 'AGROPALMA S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4034VER'],
//   },
//   {
//     nome_socio: 'TULIO DIAS BRITO',
//     tipo: 'pessoa',
//     id_socios: '***945538**',
//     rol: 'Diretor',
//     id_empresa: '04.102.265/0001-51',
//     nombre_empresa: 'AGROPALMA S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4034VER'],
//   },
//   {
//     nome_socio: 'BENY FITERMAN',
//     tipo: 'pessoa',
//     id_socios: '***861438**',
//     rol: 'Diretor',
//     id_empresa: '04.102.265/0001-51',
//     nombre_empresa: 'AGROPALMA S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4034VER'],
//   },
//   {
//     nome_socio: 'ANDRE NOGUEIRA BORBA',
//     tipo: 'pessoa',
//     id_socios: '***681646**',
//     rol: 'Diretor',
//     id_empresa: '04.102.265/0001-51',
//     nombre_empresa: 'AGROPALMA S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4034VER'],
//   },
//   {
//     nome_socio: 'GILVAN GUIDIN',
//     tipo: 'pessoa',
//     id_socios: '***783861**',
//     rol: 'Presidente',
//     id_empresa: '17.855.575/0001-99',
//     nombre_empresa: 'Grupo Rovema',
//     pais: 'Brasil',
//     id_proyecto: ['BR2878VER'],
//   },
//   {
//     nome_socio: 'LEDIANA GHEDIN LOPES',
//     tipo: 'pessoa',
//     id_socios: '***265402**',
//     rol: 'Diretor',
//     id_empresa: '17.855.575/0001-99',
//     nombre_empresa: 'Grupo Rovema',
//     pais: 'Brasil',
//     id_proyecto: ['BR2878VER'],
//   },
//   {
//     nome_socio: 'CAIO MARIO CALDEIRA BRANT RIBEIRO',
//     tipo: 'pessoa',
//     id_socios: '***735306**',
//     rol: 'Sócio',
//     id_empresa: '09.047.829/0001-14',
//     nombre_empresa: 'Tifla Empreendimentos E Participaçoes Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR4143VER'],
//   },
//   {
//     nome_socio: 'MARCELO MUZZI DE QUEIROZ',
//     tipo: 'pessoa',
//     id_socios: '***209306**',
//     rol: 'Administrador',
//     id_empresa: '09.047.829/0001-14',
//     nombre_empresa: 'Tifla Empreendimentos E Participaçoes Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR4143VER'],
//   },
//   {
//     nome_socio: 'FLAVIA CALDEIRA BRANT RIBEIRO DE FIGUEIREDO',
//     tipo: 'pessoa',
//     id_socios: '***245466**',
//     rol: 'Sócio',
//     id_empresa: '09.047.829/0001-14',
//     nombre_empresa: 'Tifla Empreendimentos E Participaçoes Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR4143VER'],
//   },
//   {
//     nome_socio: 'ANA BEATRIZ RIBEIRO DE QUEIROZ',
//     tipo: 'pessoa',
//     id_socios: '***739806**',
//     rol: 'Sócio',
//     id_empresa: '09.047.829/0001-14',
//     nombre_empresa: 'Tifla Empreendimentos E Participaçoes Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR4143VER'],
//   },
//   {
//     nome_socio: 'JOSE GILVAN DE OLIVEIRA MATOGROSSO COSTA',
//     tipo: 'pessoa',
//     id_socios: '***053122**',
//     rol: 'Sócio',
//     id_empresa: '18.311.727/0001-55',
//     nombre_empresa: 'Dunorte Agroflorestal Ltda',
//     pais: 'Brasil',
//     id_proyecto: ['BR3601VER'],
//   },
//   {
//     nome_socio: 'JOSMAR GILSON DE OLIVEIRA MATOGROSSO COSTA',
//     tipo: 'pessoa',
//     id_socios: '***110512**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '18.311.727/0001-55',
//     nombre_empresa: 'Dunorte Agroflorestal Ltda',
//     pais: 'Brasil',
//     id_proyecto: ['BR3601VER'],
//   },
//   {
//     nome_socio: 'MARCIO ROBERTO PINTO LISBOA PINHEIRO',
//     tipo: 'pessoa',
//     id_socios: '***099482**',
//     rol: 'Diretor',
//     id_empresa: '04.363.966/0001-44',
//     nombre_empresa: 'Sipasa-Seringa Industrial do Pará S.A.',
//     pais: 'Brasil',
//     id_proyecto: ['BR1329VER'],
//   },
//   {
//     nome_socio: 'ANDRE LUIZ PINTO LISBOA PINHEIRO',
//     tipo: 'pessoa',
//     id_socios: '***759702**',
//     rol: 'Presidente',
//     id_empresa: '04.363.966/0001-44',
//     nombre_empresa: 'Sipasa-Seringa Industrial do Pará S.A.',
//     pais: 'Brasil',
//     id_proyecto: ['BR1329VER'],
//   },
//   {
//     nome_socio: 'EDISON TICLE DE ANDRADE MELO E SOUZA FILHO',
//     tipo: 'pessoa',
//     id_socios: '***300688**',
//     rol: 'Administrador',
//     id_empresa: '42.475.587/0001-35',
//     nombre_empresa: 'MYCARBON3 LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4461VER'],
//   },
//   {
//     nome_socio: 'FERNANDO GALLETTI DE QUEIROZ',
//     tipo: 'pessoa',
//     id_socios: '***418418**',
//     rol: 'Administrador',
//     id_empresa: '42.475.587/0001-35',
//     nombre_empresa: 'MYCARBON3 LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4461VER'],
//   },
//   {
//     nome_socio: 'JOAO DE ALMEIDA SAMPAIO FILHO',
//     tipo: 'pessoa',
//     id_socios: '***526218**',
//     rol: 'Administrador',
//     id_empresa: '42.475.587/0001-35',
//     nombre_empresa: 'MYCARBON3 LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4461VER'],
//   },
//   {
//     nome_socio: 'NATHAN DE MELLO FORTUNATO FREIRE',
//     tipo: 'pessoa',
//     id_socios: '***421118**',
//     rol: 'Administrador',
//     id_empresa: '42.475.587/0001-35',
//     nombre_empresa: 'MYCARBON3 LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4461VER'],
//   },
//   {
//     nome_socio: 'MINERVA DAWN FARMS INDUSTRIA E COMERCIO DE PROTEINAS S/A',
//     tipo: 'empresa',
//     id_socios: '9104182000115',
//     rol: 'Sócio',
//     id_empresa: '42.475.587/0001-35',
//     nombre_empresa: 'MYCARBON3 LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4461VER'],
//   },
//   {
//     nome_socio: 'MINERVA S.A.',
//     tipo: 'empresa',
//     id_socios: '67620377000114',
//     rol: 'Sócio',
//     id_empresa: '42.475.587/0001-35',
//     nombre_empresa: 'MYCARBON3 LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4461VER'],
//   },
//   {
//     nome_socio: 'ANDRE LUIS DOS SANTOS RIBEIRO',
//     tipo: 'pessoa',
//     id_socios: '***424298**',
//     rol: 'Diretor',
//     id_empresa: '20.722.575/0001-25',
//     nombre_empresa: 'ABC Agropecuária Brasil Norte S.A.',
//     pais: 'Brasil',
//     id_proyecto: ['BR2558VER'],
//   },
//   {
//     nome_socio: 'MARLOS FERREIRA ALVES',
//     tipo: 'pessoa',
//     id_socios: '***163976**',
//     rol: 'Presidente',
//     id_empresa: '20.722.575/0001-25',
//     nombre_empresa: 'ABC Agropecuária Brasil Norte S.A.',
//     pais: 'Brasil',
//     id_proyecto: ['BR2558VER'],
//   },
//   {
//     nome_socio: 'MAXIMIR DIAS DE FRANCA',
//     tipo: 'pessoa',
//     id_socios: '***916941**',
//     rol: 'Diretor',
//     id_empresa: '20.722.575/0001-25',
//     nombre_empresa: 'ABC Agropecuária Brasil Norte S.A.',
//     pais: 'Brasil',
//     id_proyecto: ['BR2558VER'],
//   },
//   {
//     nome_socio: 'MARCIO ARTIN ARAKELIAN',
//     tipo: 'pessoa',
//     id_socios: '***883488**',
//     rol: 'Diretor',
//     id_empresa: '44.120.168/0001-06',
//     nombre_empresa:
//       'Carbon Asset (Carbon Asset Management Projetos Ambientais LTDA)',
//     pais: 'Brasil',
//     id_proyecto: ['BR3451VER', 'BR3049VER'],
//   },
//   {
//     nome_socio: 'FUTURE CARBON HOLDING S.A.',
//     tipo: 'empresa',
//     id_socios: '43688286000152',
//     rol: 'Sócio',
//     id_empresa: '44.120.168/0001-06',
//     nombre_empresa:
//       'Carbon Asset (Carbon Asset Management Projetos Ambientais LTDA)',
//     pais: 'Brasil',
//     id_proyecto: ['BR3451VER', 'BR3049VER'],
//   },
//   {
//     nome_socio: 'PEDRO IVO GALINDO SILVESTRE',
//     tipo: 'pessoa',
//     id_socios: '***807498**',
//     rol: 'Administrador',
//     id_empresa: '44.120.168/0001-06',
//     nombre_empresa:
//       'Carbon Asset (Carbon Asset Management Projetos Ambientais LTDA)',
//     pais: 'Brasil',
//     id_proyecto: ['BR3451VER', 'BR3049VER'],
//   },
//   {
//     nome_socio: 'ROSANA DELLA MEA SUTTON',
//     tipo: 'pessoa',
//     id_socios: '***889270**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '14.436.003/0001-87',
//     nombre_empresa: 'CO2X Conservação de Florestas Ltda',
//     pais: 'Brasil',
//     id_proyecto: ['BR1147VER'],
//   },
//   {
//     nome_socio: 'AMAZONIA SOLUCOES PARA A SUSTENTABILIDADE LTDA.',
//     tipo: 'empresa',
//     id_socios: '10577464000119',
//     rol: 'Sócio',
//     id_empresa: '14.436.003/0001-87',
//     nombre_empresa: 'CO2X Conservação de Florestas Ltda',
//     pais: 'Brasil',
//     id_proyecto: ['BR1147VER'],
//   },
//   {
//     nome_socio: 'ILVANIO MARTINS',
//     tipo: 'pessoa',
//     id_socios: '***666196**',
//     rol: 'Presidente',
//     id_empresa: '32.983.785/0001-56',
//     nombre_empresa: 'ECOTRÓPICA - FUNDAÇÃO DE APOIO A VIDA NOS TRÓPICOS',
//     pais: 'Brasil',
//     id_proyecto: ['BR2566VER'],
//   },
//   {
//     nome_socio: 'NELITON MARQUES DA SILVA',
//     tipo: 'pessoa',
//     id_socios: '***830862**',
//     rol: 'Presidente',
//     id_empresa: '07.339.438/0001-48',
//     nombre_empresa: 'IDESAM',
//     pais: 'Brasil',
//     id_proyecto: ['BR4265VER'],
//   },
//   {
//     nome_socio: 'PAOLA PACHECO BLEICKER',
//     tipo: 'pessoa',
//     id_socios: '***769900**',
//     rol: 'Administrador',
//     id_empresa: '07.339.438/0001-48',
//     nombre_empresa: 'IDESAM',
//     pais: 'Brasil',
//     id_proyecto: ['BR4265VER'],
//   },
//   {
//     nome_socio: 'CILL CONSULTORIA E ASSESSORIA EMPRESARIAL LTDA',
//     tipo: 'empresa',
//     id_socios: '3542670000128',
//     rol: 'Sócio',
//     id_empresa: '03.501.232/0004-64',
//     nombre_empresa: 'CKVB Florestal Ltda',
//     pais: 'Brasil',
//     id_proyecto: ['BR832VER'],
//   },
//   {
//     nome_socio: 'PIQUIA HOLDING LTDA',
//     tipo: 'empresa',
//     id_socios: '3025229000179',
//     rol: 'Sócio',
//     id_empresa: '03.501.232/0004-64',
//     nombre_empresa: 'CKVB Florestal Ltda',
//     pais: 'Brasil',
//     id_proyecto: ['BR832VER'],
//   },
//   {
//     nome_socio: 'CELIA MARIA MARINHO DE ARAUJO MELO',
//     tipo: 'pessoa',
//     id_socios: '***306553**',
//     rol: 'Administrador',
//     id_empresa: '03.501.232/0004-64',
//     nombre_empresa: 'CKVB Florestal Ltda',
//     pais: 'Brasil',
//     id_proyecto: ['BR832VER'],
//   },
//   {
//     nome_socio: 'MARIA LUCILENE FERREIRA',
//     tipo: 'pessoa',
//     id_socios: '***743652**',
//     rol: 'Administrador',
//     id_empresa: '03.501.232/0004-64',
//     nombre_empresa: 'CKVB Florestal Ltda',
//     pais: 'Brasil',
//     id_proyecto: ['BR832VER'],
//   },
//   {
//     nome_socio: 'MARIA CECILIA FIORDOLIVA FERRONATO',
//     tipo: 'pessoa',
//     id_socios: '***928328**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '20.481.986/0001-76',
//     nombre_empresa: 'ECCON Soluções Ambientais',
//     pais: 'Brasil',
//     id_proyecto: ['BR4117VER'],
//   },
//   {
//     nome_socio: 'MARCELO DE CASTRO CHAVES STABILE',
//     tipo: 'pessoa',
//     id_socios: '***210858**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '20.481.986/0001-76',
//     nombre_empresa: 'ECCON Soluções Ambientais',
//     pais: 'Brasil',
//     id_proyecto: ['BR4117VER'],
//   },
//   {
//     nome_socio: 'YURI RUGAI MARINHO',
//     tipo: 'pessoa',
//     id_socios: '***980998**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '20.481.986/0001-76',
//     nombre_empresa: 'ECCON Soluções Ambientais',
//     pais: 'Brasil',
//     id_proyecto: ['BR4117VER'],
//   },
//   {
//     nome_socio: 'FERNANDO MONTANARI',
//     tipo: 'pessoa',
//     id_socios: '***231909**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '20.481.986/0001-76',
//     nombre_empresa: 'ECCON Soluções Ambientais',
//     pais: 'Brasil',
//     id_proyecto: ['BR4117VER'],
//   },
//   {
//     nome_socio: 'SELMA LUCIA LIRA BELTRAO',
//     tipo: 'pessoa',
//     id_socios: '***945164**',
//     rol: 'Diretor',
//     id_empresa: '00.348.003/0068-28',
//     nombre_empresa: 'EMBRAPA - ACRE',
//     pais: 'Brasil',
//     id_proyecto: ['BR963VER'],
//   },
//   {
//     nome_socio: 'SILVIA MARIA FONSECA SILVEIRA MASSRUHA',
//     tipo: 'pessoa',
//     id_socios: '***083228**',
//     rol: 'Presidente',
//     id_empresa: '00.348.003/0068-28',
//     nombre_empresa: 'EMBRAPA - ACRE',
//     pais: 'Brasil',
//     id_proyecto: ['BR963VER'],
//   },
//   {
//     nome_socio: 'ANA MARGARIDA CASTRO EULER',
//     tipo: 'pessoa',
//     id_socios: '***716557**',
//     rol: 'Diretor',
//     id_empresa: '00.348.003/0068-28',
//     nombre_empresa: 'EMBRAPA - ACRE',
//     pais: 'Brasil',
//     id_proyecto: ['BR963VER'],
//   },
//   {
//     nome_socio: 'CLENIO NAILTO PILLON',
//     tipo: 'pessoa',
//     id_socios: '***639420**',
//     rol: 'Diretor',
//     id_empresa: '00.348.003/0068-28',
//     nombre_empresa: 'EMBRAPA - ACRE',
//     pais: 'Brasil',
//     id_proyecto: ['BR963VER'],
//   },
//   {
//     nome_socio: 'ALDERI EMIDIO DE ARAUJO',
//     tipo: 'pessoa',
//     id_socios: '***860108**',
//     rol: 'Diretor',
//     id_empresa: '00.348.003/0068-28',
//     nombre_empresa: 'EMBRAPA - ACRE',
//     pais: 'Brasil',
//     id_proyecto: ['BR963VER'],
//   },
//   {
//     nome_socio: 'GILBERTO DO CARMO LOPES SIQUEIRA',
//     tipo: 'pessoa',
//     id_socios: '***749801**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '13.331.592/0001-76',
//     nombre_empresa: 'GESTAO E RESULTADOS CONSULTORES ASSOCIADOS',
//     pais: 'Brasil',
//     id_proyecto: ['BR3430VER'],
//   },
//   {
//     nome_socio: 'RENAN OLIVEIRA SILVA',
//     tipo: 'pessoa',
//     id_socios: '***045233**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '13.331.592/0001-76',
//     nombre_empresa: 'GESTAO E RESULTADOS CONSULTORES ASSOCIADOS',
//     pais: 'Brasil',
//     id_proyecto: ['BR3430VER'],
//   },
//   {
//     nome_socio: 'PARA REDD PROJECTS LIMITED',
//     tipo: 'empresa',
//     id_socios: '43500617000189',
//     rol: 'Sócio',
//     id_empresa: '43.192.338/0001-03',
//     nombre_empresa: 'REDDA Projetos Ambientais Sociedade Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR3334VER'],
//   },
//   {
//     nome_socio: 'BRUNO TAVARES DA SILVA',
//     tipo: 'pessoa',
//     id_socios: '***073528**',
//     rol: 'Administrador',
//     id_empresa: '43.192.338/0001-03',
//     nombre_empresa: 'REDDA Projetos Ambientais Sociedade Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR3334VER'],
//   },
//   {
//     nome_socio: 'TAV COMPANY PARTICIPACOES  SOCIEDADE UNIPESSOAL LIMITADA',
//     tipo: 'empresa',
//     id_socios: '42834280000183',
//     rol: 'Sócio',
//     id_empresa: '43.192.338/0001-03',
//     nombre_empresa: 'REDDA Projetos Ambientais Sociedade Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR3334VER'],
//   },
//   {
//     nome_socio: 'DIEGO MACHADO CARRION SERRANO',
//     tipo: 'pessoa',
//     id_socios: '***277458**',
//     rol: 'Sócio',
//     id_empresa: '11.453.128/0001-27',
//     nombre_empresa: 'C3-Floresta, Meio Ambiente & Energia ',
//     pais: 'Brasil',
//     id_proyecto: ['BR1596VER'],
//   },
//   {
//     nome_socio: 'PAULA MARIA BIRAL',
//     tipo: 'pessoa',
//     id_socios: '***909298**',
//     rol: 'Sócio',
//     id_empresa: '11.453.128/0001-27',
//     nombre_empresa: 'C3-Floresta, Meio Ambiente & Energia ',
//     pais: 'Brasil',
//     id_proyecto: ['BR1596VER'],
//   },
//   {
//     nome_socio: 'FLAVIA GALINDO SILVESTRE SILVA',
//     tipo: 'pessoa',
//     id_socios: '***934628**',
//     rol: 'Presidente',
//     id_empresa: '27.899.023/0001-36',
//     nombre_empresa: 'Sparta Participações Societárias S.A.',
//     pais: 'Brasil',
//     id_proyecto: ['BR3049VER'],
//   },
//   {
//     nome_socio: 'ADALVA MARIA GALINDO',
//     tipo: 'pessoa',
//     id_socios: '***024608**',
//     rol: 'Diretor',
//     id_empresa: '27.899.023/0001-36',
//     nombre_empresa: 'Sparta Participações Societárias S.A.',
//     pais: 'Brasil',
//     id_proyecto: ['BR3049VER'],
//   },
//   {
//     nome_socio: 'MUNIR YOUNES SOARES',
//     tipo: 'pessoa',
//     id_socios: '***894178**',
//     rol: 'Diretor',
//     id_empresa: '22.524.415/0001-05',
//     nombre_empresa: 'Systemica (MYS E JLFL TREINAMENTO GERENCIAL LTDA)',
//     pais: 'Brasil',
//     id_proyecto: ['BR4016VER', 'BR3738VER'],
//   },
//   {
//     nome_socio: 'TIAGO GONCALVES DE OLIVEIRA RICCI',
//     tipo: 'pessoa',
//     id_socios: '***802751**',
//     rol: 'Conselheiro de Administração',
//     id_empresa: '22.524.415/0001-05',
//     nombre_empresa: 'Systemica (MYS E JLFL TREINAMENTO GERENCIAL LTDA)',
//     pais: 'Brasil',
//     id_proyecto: ['BR4016VER', 'BR3738VER'],
//   },
//   {
//     nome_socio: 'FRANCISCO UMBERTO PRADO COUTO',
//     tipo: 'pessoa',
//     id_socios: '***797238**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '11.313.775/0001-33',
//     nombre_empresa: 'JR AGROPECUARIA E EMPREENDIMENTOS LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR1382VER'],
//   },
//   {
//     nome_socio: 'CAMILLA SCHINDLER',
//     tipo: 'pessoa',
//     id_socios: '***693189**',
//     rol: 'Presidente',
//     id_empresa: '51.840.317/0001-77',
//     nombre_empresa: 'Associação Aliança 5P',
//     pais: 'Brasil',
//     id_proyecto: ['BR4747VER'],
//   },
//   {
//     nome_socio: 'MICHEL ALEXANDRE ROY',
//     tipo: 'pessoa',
//     id_socios: '***895478**',
//     rol: 'Diretor',
//     id_empresa: '51.840.317/0001-77',
//     nombre_empresa: 'Associação Aliança 5P',
//     pais: 'Brasil',
//     id_proyecto: ['BR4747VER'],
//   },
//   {
//     nome_socio: 'LILIAN MARQUES ESTEVES',
//     tipo: 'pessoa',
//     id_socios: '***941527**',
//     rol: 'Diretor',
//     id_empresa: '51.840.317/0001-77',
//     nombre_empresa: 'Associação Aliança 5P',
//     pais: 'Brasil',
//     id_proyecto: ['BR4747VER'],
//   },
//   {
//     nome_socio: 'MONICA CRISTINA CABELLO DE BRITO',
//     tipo: 'pessoa',
//     id_socios: '***877464**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '03.491.393/0001-71',
//     nombre_empresa: 'CASA DA FLORESTA AMBIENTAL LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR1811VER'],
//   },
//   {
//     nome_socio: 'KLAUS DUARTE BARRETTO',
//     tipo: 'pessoa',
//     id_socios: '***601978**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '03.491.393/0001-71',
//     nombre_empresa: 'CASA DA FLORESTA AMBIENTAL LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR1811VER'],
//   },
//   {
//     nome_socio: 'RODOLPHO OLIVEIRA SANTOS',
//     tipo: 'pessoa',
//     id_socios: '***909928**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '29.225.906/0001-96',
//     nombre_empresa: 'Ricci e Santos Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR4016VER', 'BR3738VER'],
//   },
//   {
//     nome_socio: 'KARINE TAVARES DA CRUZ',
//     tipo: 'pessoa',
//     id_socios: '***028818**',
//     rol: 'Sócio sem Capital',
//     id_empresa: '29.225.906/0001-96',
//     nombre_empresa: 'Ricci e Santos Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR4016VER', 'BR3738VER'],
//   },
//   {
//     nome_socio: 'DANIEL DAYEH ROCHA',
//     tipo: 'pessoa',
//     id_socios: '***932718**',
//     rol: 'Sócio sem Capital',
//     id_empresa: '29.225.906/0001-96',
//     nombre_empresa: 'Ricci e Santos Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR4016VER', 'BR3738VER'],
//   },
//   {
//     nome_socio: 'TIAGO GONCALVES DE OLIVEIRA RICCI',
//     tipo: 'pessoa',
//     id_socios: '***802751**',
//     rol: 'Conselheiro de Administração',
//     id_empresa: '29.225.906/0001-96',
//     nombre_empresa: 'Ricci e Santos Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR4016VER', 'BR3738VER'],
//   },
//   {
//     nome_socio: 'FELIPE GOMES DORNELAS ALVARES',
//     tipo: 'pessoa',
//     id_socios: '***602898**',
//     rol: 'Sócio sem Capital',
//     id_empresa: '29.225.906/0001-96',
//     nombre_empresa: 'Ricci e Santos Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR4016VER', 'BR3738VER'],
//   },
//   {
//     nome_socio: 'MATEUS LEMOS FRANCO DA SILVA',
//     tipo: 'pessoa',
//     id_socios: '***568086**',
//     rol: 'Sócio sem Capital',
//     id_empresa: '29.225.906/0001-96',
//     nombre_empresa: 'Ricci e Santos Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR4016VER', 'BR3738VER'],
//   },
//   {
//     nome_socio: 'SIMONE POLINI DE MARCHI',
//     tipo: 'pessoa',
//     id_socios: '***820511**',
//     rol: 'Sócio sem Capital',
//     id_empresa: '29.225.906/0001-96',
//     nombre_empresa: 'Ricci e Santos Advogados',
//     pais: 'Brasil',
//     id_proyecto: ['BR4016VER', 'BR3738VER'],
//   },
//   {
//     nome_socio: 'ALEXANDRE DA ROSA',
//     tipo: 'pessoa',
//     id_socios: '***060148**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '21.838.332/0001-10',
//     nombre_empresa: 'WMF Energy S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR1561VER'],
//   },
//   {
//     nome_socio: 'NICOLAS GUTIERREZ LONDONO',
//     tipo: 'pessoa',
//     id_socios: '***246717**',
//     rol: 'Diretor',
//     id_empresa: '41.131.748/0001-00',
//     nombre_empresa: 'Samaúma Empreendimentos Imobiliários S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4461VER'],
//   },
//   {
//     nome_socio: 'JOSE AUGUSTO DE SOUSA JUNIOR',
//     tipo: 'pessoa',
//     id_socios: '***261198**',
//     rol: 'Conselheiro de Administração',
//     id_empresa: '41.131.748/0001-00',
//     nombre_empresa: 'Samaúma Empreendimentos Imobiliários S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4461VER'],
//   },
//   {
//     nome_socio: 'FERNANDO FERREIRA MEIRELLES',
//     tipo: 'pessoa',
//     id_socios: '***890178**',
//     rol: 'Conselheiro de Administração',
//     id_empresa: '41.131.748/0001-00',
//     nombre_empresa: 'Samaúma Empreendimentos Imobiliários S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4461VER'],
//   },
//   {
//     nome_socio: 'LUIZ HENRIQUE GREIN MONIZ DE ARAGAO',
//     tipo: 'pessoa',
//     id_socios: '***379229**',
//     rol: 'Diretor',
//     id_empresa: '41.131.748/0001-00',
//     nombre_empresa: 'Samaúma Empreendimentos Imobiliários S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4461VER'],
//   },
//   {
//     nome_socio: 'RODRIGO BRANDAO DE ALMEIDA',
//     tipo: 'pessoa',
//     id_socios: '***671237**',
//     rol: 'Diretor',
//     id_empresa: '41.131.748/0001-00',
//     nombre_empresa: 'Samaúma Empreendimentos Imobiliários S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4461VER'],
//   },
//   {
//     nome_socio: 'FABIO ROBERTO NIEDERMEIER',
//     tipo: 'pessoa',
//     id_socios: '***104560**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '42.161.900/0001-60',
//     nombre_empresa:
//       'Campo Verde Agência de Negócios Imobiliários e Serviços Ambientais LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4857VER'],
//   },
//   {
//     nome_socio: 'FABIO ROBERTO NIEDERMEIER',
//     tipo: 'pessoa',
//     id_socios: '***104560**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '42.161.900/0001-60',
//     nombre_empresa:
//       'Campo Verde Agência de Negócios Imobiliários e Serviços Ambientais Ltda',
//     pais: 'Brasil',
//     id_proyecto: ['BR4681VER'],
//   },
//   {
//     nome_socio: 'ESTELA NEVES DE SOUZA ALBUQUERQUE',
//     tipo: 'pessoa',
//     id_socios: '***995382**',
//     rol: 'Sócio',
//     id_empresa: '42.161.900/0001-60',
//     nombre_empresa:
//       'Campo Verde Agência de Negócios Imobiliários e Serviços Ambientais LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4857VER'],
//   },
//   {
//     nome_socio: 'ESTELA NEVES DE SOUZA ALBUQUERQUE',
//     tipo: 'pessoa',
//     id_socios: '***995382**',
//     rol: 'Sócio',
//     id_empresa: '42.161.900/0001-60',
//     nombre_empresa:
//       'Campo Verde Agência de Negócios Imobiliários e Serviços Ambientais Ltda',
//     pais: 'Brasil',
//     id_proyecto: ['BR4681VER'],
//   },
//   {
//     nome_socio: 'EDGARD MARIO DE MEDEIROS JUNIOR',
//     tipo: 'pessoa',
//     id_socios: '***986482**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '42.161.900/0001-60',
//     nombre_empresa:
//       'Campo Verde Agência de Negócios Imobiliários e Serviços Ambientais LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4857VER'],
//   },
//   {
//     nome_socio: 'EDGARD MARIO DE MEDEIROS JUNIOR',
//     tipo: 'pessoa',
//     id_socios: '***986482**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '42.161.900/0001-60',
//     nombre_empresa:
//       'Campo Verde Agência de Negócios Imobiliários e Serviços Ambientais Ltda',
//     pais: 'Brasil',
//     id_proyecto: ['BR4681VER'],
//   },
//   {
//     nome_socio: 'JUSTINIANO DE QUEIROZ NETTO',
//     tipo: 'pessoa',
//     id_socios: '***230652**',
//     rol: 'Sócio',
//     id_empresa: '42.161.900/0001-60',
//     nombre_empresa:
//       'Campo Verde Agência de Negócios Imobiliários e Serviços Ambientais LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4857VER'],
//   },
//   {
//     nome_socio: 'JUSTINIANO DE QUEIROZ NETTO',
//     tipo: 'pessoa',
//     id_socios: '***230652**',
//     rol: 'Sócio',
//     id_empresa: '42.161.900/0001-60',
//     nombre_empresa:
//       'Campo Verde Agência de Negócios Imobiliários e Serviços Ambientais Ltda',
//     pais: 'Brasil',
//     id_proyecto: ['BR4681VER'],
//   },
//   {
//     nome_socio: 'OSMAR SCARAMUSSA',
//     tipo: 'pessoa',
//     id_socios: '***917247**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '42.161.900/0001-60',
//     nombre_empresa:
//       'Campo Verde Agência de Negócios Imobiliários e Serviços Ambientais LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4857VER'],
//   },
//   {
//     nome_socio: 'OSMAR SCARAMUSSA',
//     tipo: 'pessoa',
//     id_socios: '***917247**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '42.161.900/0001-60',
//     nombre_empresa:
//       'Campo Verde Agência de Negócios Imobiliários e Serviços Ambientais Ltda',
//     pais: 'Brasil',
//     id_proyecto: ['BR4681VER'],
//   },
//   {
//     nome_socio: 'ADNAN DEMACHKI',
//     tipo: 'pessoa',
//     id_socios: '***781292**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '42.161.900/0001-60',
//     nombre_empresa:
//       'Campo Verde Agência de Negócios Imobiliários e Serviços Ambientais LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4857VER'],
//   },
//   {
//     nome_socio: 'ADNAN DEMACHKI',
//     tipo: 'pessoa',
//     id_socios: '***781292**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '42.161.900/0001-60',
//     nombre_empresa:
//       'Campo Verde Agência de Negócios Imobiliários e Serviços Ambientais Ltda',
//     pais: 'Brasil',
//     id_proyecto: ['BR4681VER'],
//   },
//   {
//     nome_socio: 'ARTHUR CHIAROTTO PENTEADO',
//     tipo: 'pessoa',
//     id_socios: '***456578**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '10.203.779/0001-04',
//     nombre_empresa: 'Arthur Chiarotto Penteado',
//     pais: 'Brasil',
//     id_proyecto: ['BR4671VER'],
//   },
//   {
//     nome_socio: 'FLAVIA CHIAROTTO PENTEADO',
//     tipo: 'pessoa',
//     id_socios: '***651418**',
//     rol: 'Produtor Rural',
//     id_empresa: '10.203.779/0001-04',
//     nombre_empresa: 'Arthur Chiarotto Penteado',
//     pais: 'Brasil',
//     id_proyecto: ['BR4671VER'],
//   },
//   {
//     nome_socio: 'ALVARO LUIZ DILLI GONCALVES',
//     tipo: 'pessoa',
//     id_socios: '***062441**',
//     rol: 'Diretor',
//     id_empresa: '13.046.954/0001-87',
//     nombre_empresa: 'SLC Landco Empreendimentos Agricolas S.A.',
//     pais: 'Brasil',
//     id_proyecto: ['BR4886VER'],
//   },
//   {
//     nome_socio: 'AURELIO PAVINATO',
//     tipo: 'pessoa',
//     id_socios: '***973590**',
//     rol: 'Administrador',
//     id_empresa: '13.046.954/0001-87',
//     nombre_empresa: 'SLC Landco Empreendimentos Agricolas S.A.',
//     pais: 'Brasil',
//     id_proyecto: ['BR4886VER'],
//   },
//   {
//     nome_socio: 'RENATO CASSIM CAVALINI',
//     tipo: 'pessoa',
//     id_socios: '***658628**',
//     rol: 'Conselheiro de Administração',
//     id_empresa: '13.046.954/0001-87',
//     nombre_empresa: 'SLC Landco Empreendimentos Agricolas S.A.',
//     pais: 'Brasil',
//     id_proyecto: ['BR4886VER'],
//   },
//   {
//     nome_socio: 'VERNER TIEDE',
//     tipo: 'pessoa',
//     id_socios: '***795000**',
//     rol: 'Conselheiro de Administração',
//     id_empresa: '13.046.954/0001-87',
//     nombre_empresa: 'SLC Landco Empreendimentos Agricolas S.A.',
//     pais: 'Brasil',
//     id_proyecto: ['BR4886VER'],
//   },
//   {
//     nome_socio: 'JAN MARK ANGELE PENSAERT',
//     tipo: 'pessoa',
//     id_socios: '***342010**',
//     rol: 'Conselheiro de Administração',
//     id_empresa: '13.046.954/0001-87',
//     nombre_empresa: 'SLC Landco Empreendimentos Agricolas S.A.',
//     pais: 'Brasil',
//     id_proyecto: ['BR4886VER'],
//   },
//   {
//     nome_socio: 'EDUARDO SILVA LOGEMANN',
//     tipo: 'pessoa',
//     id_socios: '***844760**',
//     rol: 'Conselheiro de Administração',
//     id_empresa: '13.046.954/0001-87',
//     nombre_empresa: 'SLC Landco Empreendimentos Agricolas S.A.',
//     pais: 'Brasil',
//     id_proyecto: ['BR4886VER'],
//   },
//   {
//     nome_socio: 'DOUGLAS ANTONIO GRANEMANN DE SOUZA',
//     tipo: 'pessoa',
//     id_socios: '***464009**',
//     rol: 'Administrador',
//     id_empresa: '84.639.632/0001-90',
//     nombre_empresa: 'Manoa Sustentável, Exploração e Serviços Florestais Ltda ',
//     pais: 'Brasil',
//     id_proyecto: ['BR1571VER'],
//   },
//   {
//     nome_socio: 'CARLOS ALBERTO BARBOSA PORSCH',
//     tipo: 'pessoa',
//     id_socios: '***439179**',
//     rol: 'Administrador',
//     id_empresa: '84.639.632/0001-90',
//     nombre_empresa: 'Manoa Sustentável, Exploração e Serviços Florestais Ltda ',
//     pais: 'Brasil',
//     id_proyecto: ['BR1571VER'],
//   },
//   {
//     nome_socio: 'REALE LTDA',
//     tipo: 'empresa',
//     id_socios: '33904379000113',
//     rol: 'Sócio',
//     id_empresa: '84.639.632/0001-90',
//     nombre_empresa: 'Manoa Sustentável, Exploração e Serviços Florestais Ltda ',
//     pais: 'Brasil',
//     id_proyecto: ['BR1571VER'],
//   },
//   {
//     nome_socio: 'AGROCORTEX FLORESTAS TROPICAIS PARTICIPACOES LTDA.',
//     tipo: 'empresa',
//     id_socios: '19846881000194',
//     rol: 'Sócio',
//     id_empresa: '19.848.073/0001-66',
//     nombre_empresa: 'Agrocortex Madeiras do Acre Agroflorestal Ltda',
//     pais: 'Brasil',
//     id_proyecto: ['BR1686VER'],
//   },
//   {
//     nome_socio: 'AGROCORTEX FLORESTAS DO BRASIL PARTICIPACOES S.A.',
//     tipo: 'empresa',
//     id_socios: '19374422000155',
//     rol: 'Sócio',
//     id_empresa: '19.848.073/0001-66',
//     nombre_empresa: 'Agrocortex Madeiras do Acre Agroflorestal Ltda',
//     pais: 'Brasil',
//     id_proyecto: ['BR1686VER'],
//   },
//   {
//     nome_socio: 'MARIA CRISTINA RODRIGUEZ RODRIGUEZ',
//     tipo: 'pessoa',
//     id_socios: '***340996**',
//     rol: 'Administrador',
//     id_empresa: '19.848.073/0001-66',
//     nombre_empresa: 'Agrocortex Madeiras do Acre Agroflorestal Ltda',
//     pais: 'Brasil',
//     id_proyecto: ['BR1686VER'],
//   },
//   {
//     nome_socio: 'MARCOS GUILHERME ALVES PRETO',
//     tipo: 'pessoa',
//     id_socios: '***830858**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '19.848.073/0001-66',
//     nombre_empresa: 'Agrocortex Madeiras do Acre Agroflorestal Ltda',
//     pais: 'Brasil',
//     id_proyecto: ['BR1686VER'],
//   },
//   {
//     nome_socio: 'DIEGO HOEBEL MUNHOZ',
//     tipo: 'pessoa',
//     id_socios: '***072969**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '46.443.235/0001-59',
//     nombre_empresa: 'IACO AMBIENTAL LTDA.',
//     pais: 'Brasil',
//     id_proyecto: ['BR3631VER'],
//   },
//   {
//     nome_socio: 'ROMA PARTICIPACOES S/S LTDA',
//     tipo: 'empresa',
//     id_socios: '46014709000147',
//     rol: 'Sócio',
//     id_empresa: '46.443.235/0001-59',
//     nombre_empresa: 'IACO AMBIENTAL LTDA.',
//     pais: 'Brasil',
//     id_proyecto: ['BR3631VER'],
//   },
//   {
//     nome_socio: 'GUANABARA AMBIENTAL LTDA',
//     tipo: 'empresa',
//     id_socios: '45424948000102',
//     rol: 'Sócio',
//     id_empresa: '46.443.235/0001-59',
//     nombre_empresa: 'IACO AMBIENTAL LTDA.',
//     pais: 'Brasil',
//     id_proyecto: ['BR3631VER'],
//   },
//   {
//     nome_socio: 'CRISTIANO SOARES RODRIGUES',
//     tipo: 'pessoa',
//     id_socios: '***919117**',
//     rol: 'Presidente',
//     id_empresa: '03.587.881/0001-87',
//     nombre_empresa: 'VALE VERDE PROPRIEDADES AGRÍCOLAS S.A.',
//     pais: 'Brasil',
//     id_proyecto: ['BR4142VER'],
//   },
//   {
//     nome_socio: 'JULIANA PEREZ ALONSO CORREA',
//     tipo: 'pessoa',
//     id_socios: '***701207**',
//     rol: 'Diretor',
//     id_empresa: '03.587.881/0001-87',
//     nombre_empresa: 'VALE VERDE PROPRIEDADES AGRÍCOLAS S.A.',
//     pais: 'Brasil',
//     id_proyecto: ['BR4142VER'],
//   },
//   {
//     nome_socio: 'ADRIANO D AGNOLUZZO',
//     tipo: 'pessoa',
//     id_socios: '***215749**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '34.597.658/0001-44',
//     nombre_empresa: 'FLORAPLAC INDUSTRIAL LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4042VER'],
//   },
//   {
//     nome_socio: 'SILVANO D AGNOLUZZO',
//     tipo: 'pessoa',
//     id_socios: '***196092**',
//     rol: 'Sócio',
//     id_empresa: '34.597.658/0001-44',
//     nombre_empresa: 'FLORAPLAC INDUSTRIAL LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4042VER'],
//   },
//   {
//     nome_socio: 'VITORIO SUFREDINI NETO',
//     tipo: 'pessoa',
//     id_socios: '***133913**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '34.597.658/0001-44',
//     nombre_empresa: 'FLORAPLAC INDUSTRIAL LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4042VER'],
//   },
//   {
//     nome_socio: 'CLEMENTE SOARES HAMOY',
//     tipo: 'pessoa',
//     id_socios: '***928602**',
//     rol: 'Diretor',
//     id_empresa: '04.737.144/0001-86',
//     nombre_empresa: 'Brascomp Compensados do Brasil S.A.',
//     pais: 'Brasil',
//     id_proyecto: ['BR4687VER'],
//   },
//   {
//     nome_socio: 'ARI ZUGMAN',
//     tipo: 'pessoa',
//     id_socios: '***806279**',
//     rol: 'Presidente',
//     id_empresa: '04.737.144/0001-86',
//     nombre_empresa: 'Brascomp Compensados do Brasil S.A.',
//     pais: 'Brasil',
//     id_proyecto: ['BR4687VER'],
//   },
//   {
//     nome_socio: 'AGRO MARIPA - PARTICIPACOES, EMPREENDIMENTOS E ADMINISTRACAO LTDA',
//     tipo: 'empresa',
//     id_socios: '1240653000100',
//     rol: 'Sócio',
//     id_empresa: '04.975.356/0001-00',
//     nombre_empresa: 'Gairova Agropecus Ltda',
//     pais: 'Brasil',
//     id_proyecto: ['BR2870VER'],
//   },
//   {
//     nome_socio: 'MARCELO BAPTISTA DE OLIVEIRA',
//     tipo: 'pessoa',
//     id_socios: '***801626**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '04.975.356/0001-00',
//     nombre_empresa: 'Gairova Agropecus Ltda',
//     pais: 'Brasil',
//     id_proyecto: ['BR2870VER'],
//   },
//   {
//     nome_socio: 'JOAO ANTONIO VILLARES STOPPE',
//     tipo: 'pessoa',
//     id_socios: '***619068**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '23.831.247/0001-55',
//     nombre_empresa: 'Ituxi Administração e Participação LTDA',
//     pais: 'Brasil',
//     id_proyecto: [
//       'BR4825VER',
//       'BR4633VER',
//       'BR3816VER',
//       'BR2539VER',
//       'BR2508VER',
//     ],
//   },
//   {
//     nome_socio: 'RICARDO VILLARES LOT STOPPE',
//     tipo: 'pessoa',
//     id_socios: '***184878**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '23.831.247/0001-55',
//     nombre_empresa: 'Ituxi Administração e Participação LTDA',
//     pais: 'Brasil',
//     id_proyecto: [
//       'BR4825VER',
//       'BR4633VER',
//       'BR3816VER',
//       'BR2539VER',
//       'BR2508VER',
//     ],
//   },
//   {
//     nome_socio: 'CATARINA VILLARES STOPPE',
//     tipo: 'pessoa',
//     id_socios: '***184868**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '23.831.247/0001-55',
//     nombre_empresa: 'Ituxi Administração e Participação LTDA',
//     pais: 'Brasil',
//     id_proyecto: [
//       'BR4825VER',
//       'BR4633VER',
//       'BR3816VER',
//       'BR2539VER',
//       'BR2508VER',
//     ],
//   },
//   {
//     nome_socio: 'PAULA ISLA MARTINS',
//     tipo: 'pessoa',
//     id_socios: '***705191**',
//     rol: 'Sócio',
//     id_empresa: '44.181.146/0001-56',
//     nombre_empresa: 'Restaura Consultoria Ambiental e Treinamentos LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4747VER'],
//   },
//   {
//     nome_socio: 'LETICIA KOUTCHIN DOS REIS',
//     tipo: 'pessoa',
//     id_socios: '***507441**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '44.181.146/0001-56',
//     nombre_empresa: 'Restaura Consultoria Ambiental e Treinamentos LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4747VER'],
//   },
//   {
//     nome_socio: 'MICHAEL EDWARD GREENE',
//     tipo: 'pessoa',
//     id_socios: '***159561**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '26.396.649/0001-67',
//     nombre_empresa: 'Brazil Agfor LLC',
//     pais: 'Brasil',
//     id_proyecto: ['BR2252VER'],
//   },
//   {
//     nome_socio: 'BRAZIL AGFOR, LLC',
//     tipo: 'empresa',
//     id_socios: '25314742000112',
//     rol: 'Sócio',
//     id_empresa: '26.396.649/0001-67',
//     nombre_empresa: 'Brazil Agfor LLC',
//     pais: 'Brasil',
//     id_proyecto: ['BR2252VER'],
//   },
//   {
//     nome_socio: 'GIUSEPPE PINELLI',
//     tipo: 'pessoa',
//     id_socios: '***594661**',
//     rol: 'Presidente',
//     id_empresa: '04.310.918/0001-98',
//     nombre_empresa: 'BR ARBO Gestão Florestal',
//     pais: 'Brasil',
//     id_proyecto: ['BR4485VER'],
//   },
//   {
//     nome_socio: 'RICARDO LUIZ LUDKE',
//     tipo: 'pessoa',
//     id_socios: '***479461**',
//     rol: 'Diretor',
//     id_empresa: '04.310.918/0001-98',
//     nombre_empresa: 'BR ARBO Gestão Florestal',
//     pais: 'Brasil',
//     id_proyecto: ['BR4485VER'],
//   },
//   {
//     nome_socio: 'CARLOS ROBERTO CANABARRO GOMES',
//     tipo: 'pessoa',
//     id_socios: '***553600**',
//     rol: 'Diretor',
//     id_empresa: '04.310.918/0001-98',
//     nombre_empresa: 'BR ARBO Gestão Florestal',
//     pais: 'Brasil',
//     id_proyecto: ['BR4485VER'],
//   },
//   {
//     nome_socio: 'GIRLEI COSTA DA CUNHA',
//     tipo: 'pessoa',
//     id_socios: '***054540**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '03.705.896/0001-00',
//     nombre_empresa: 'Biodendro Consultoria Florestal LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4689VER', 'BR4034VER'],
//   },
//   {
//     nome_socio: 'EDUARDO GUSSON',
//     tipo: 'pessoa',
//     id_socios: '***909988**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '03.705.896/0001-00',
//     nombre_empresa: 'Biodendro Consultoria Florestal LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4689VER', 'BR4034VER'],
//   },
//   {
//     nome_socio: 'FREDERICO TOMAS DE SOUZA E MIRANDA',
//     tipo: 'pessoa',
//     id_socios: '***716718**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '03.705.896/0001-00',
//     nombre_empresa: 'Biodendro Consultoria Florestal LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4689VER', 'BR4034VER'],
//   },
//   {
//     nome_socio: 'WARWICK DO AMARAL MANFRINATO',
//     tipo: 'pessoa',
//     id_socios: '***267028**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '05.321.358/0001-30',
//     nombre_empresa: 'PLANT Inteligência Ambiental Ltda',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'SLC INVESTIMENTOS AGRICOLAS LTDA',
//     tipo: 'empresa',
//     id_socios: '19765592000160',
//     rol: 'Sócio',
//     id_empresa: '19.763.569/0001-37',
//     nombre_empresa: 'SLC Perdizes Empreendimentos Agricolas LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4886VER'],
//   },
//   {
//     nome_socio: 'SLC AGRICOLA S.A.',
//     tipo: 'empresa',
//     id_socios: '89096457000155',
//     rol: 'Sócio',
//     id_empresa: '19.763.569/0001-37',
//     nombre_empresa: 'SLC Perdizes Empreendimentos Agricolas LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4886VER'],
//   },
//   {
//     nome_socio: 'GUSTAVO MACEDO LUNARDI',
//     tipo: 'pessoa',
//     id_socios: '***748920**',
//     rol: 'Administrador',
//     id_empresa: '19.763.569/0001-37',
//     nombre_empresa: 'SLC Perdizes Empreendimentos Agricolas LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4886VER'],
//   },
//   {
//     nome_socio: 'AURELIO PAVINATO',
//     tipo: 'pessoa',
//     id_socios: '***973590**',
//     rol: 'Administrador',
//     id_empresa: '19.763.569/0001-37',
//     nombre_empresa: 'SLC Perdizes Empreendimentos Agricolas LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4886VER'],
//   },
//   {
//     nome_socio: 'ALDO ROBERTO TISOTT',
//     tipo: 'pessoa',
//     id_socios: '***009870**',
//     rol: 'Administrador',
//     id_empresa: '19.763.569/0001-37',
//     nombre_empresa: 'SLC Perdizes Empreendimentos Agricolas LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4886VER'],
//   },
//   {
//     nome_socio: 'IVO MARCON BRUM',
//     tipo: 'pessoa',
//     id_socios: '***420770**',
//     rol: 'Administrador',
//     id_empresa: '19.763.569/0001-37',
//     nombre_empresa: 'SLC Perdizes Empreendimentos Agricolas LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4886VER'],
//   },
//   {
//     nome_socio: 'CRISTIANO SOARES RODRIGUES',
//     tipo: 'pessoa',
//     id_socios: '***919117**',
//     rol: 'Presidente',
//     id_empresa: '03.676.931/0001-00',
//     nombre_empresa: 'VALE SERENO PROPRIEDADES AGRÍCOLAS S.A.',
//     pais: 'Brasil',
//     id_proyecto: ['BR4142VER'],
//   },
//   {
//     nome_socio: 'EDUARDO DE BRITTO PEREIRA AZEVEDO',
//     tipo: 'pessoa',
//     id_socios: '***208487**',
//     rol: 'Conselheiro de Administração',
//     id_empresa: '03.676.931/0001-00',
//     nombre_empresa: 'VALE SERENO PROPRIEDADES AGRÍCOLAS S.A.',
//     pais: 'Brasil',
//     id_proyecto: ['BR4142VER'],
//   },
//   {
//     nome_socio: 'ADRIANO D AGNOLUZZO',
//     tipo: 'pessoa',
//     id_socios: '***215749**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '04.345.294/0001-44',
//     nombre_empresa: 'RIO CONCREM INDUSTRIAL LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4042VER'],
//   },
//   {
//     nome_socio: 'VITORIO SUFREDINI NETO',
//     tipo: 'pessoa',
//     id_socios: '***133913**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '04.345.294/0001-44',
//     nombre_empresa: 'RIO CONCREM INDUSTRIAL LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4042VER'],
//   },
//   {
//     nome_socio: 'SILVANO D AGNOLUZZO',
//     tipo: 'pessoa',
//     id_socios: '***196092**',
//     rol: 'Sócio',
//     id_empresa: '04.345.294/0001-44',
//     nombre_empresa: 'RIO CONCREM INDUSTRIAL LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4042VER'],
//   },
//   {
//     nome_socio: 'CESAR EDUARDO ISAACSON BUFFARA',
//     tipo: 'pessoa',
//     id_socios: '***017689**',
//     rol: 'Presidente',
//     id_empresa: '75.045.120/0001-04',
//     nombre_empresa: 'Limeira Indústria e Comércio S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR2950VER'],
//   },
//   {
//     nome_socio: 'CRISTIANE BLEY KESTERKE CLAUSEN',
//     tipo: 'pessoa',
//     id_socios: '***408519**',
//     rol: 'Diretor',
//     id_empresa: '75.045.120/0001-04',
//     nombre_empresa: 'Limeira Indústria e Comércio S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR2950VER'],
//   },
//   {
//     nome_socio: 'JORGE CRISTIANO MELLO',
//     tipo: 'pessoa',
//     id_socios: '***846328**',
//     rol: 'Diretor',
//     id_empresa: '75.045.120/0001-04',
//     nombre_empresa: 'Limeira Indústria e Comércio S/A',
//     pais: 'Brasil',
//     id_proyecto: ['BR2950VER'],
//   },
//   {
//     nome_socio: 'CLAUDIO UEZU',
//     tipo: 'pessoa',
//     id_socios: '***574778**',
//     rol: 'Sócio',
//     id_empresa: '20.949.082/0001-22',
//     nombre_empresa: 'Uezu Planejamento Ambiental S/S LTDA',
//     pais: 'Brasil',
//     id_proyecto: [
//       'BR2980VER',
//       'BR2870VER',
//       'BR2709VER',
//       'BR2558VER',
//       'BR2482VER',
//       'BR2373VER',
//     ],
//   },
//   {
//     nome_socio: 'ALEXANDRE UEZU',
//     tipo: 'pessoa',
//     id_socios: '***977958**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '20.949.082/0001-22',
//     nombre_empresa: 'Uezu Planejamento Ambiental S/S LTDA',
//     pais: 'Brasil',
//     id_proyecto: [
//       'BR2980VER',
//       'BR2870VER',
//       'BR2709VER',
//       'BR2558VER',
//       'BR2482VER',
//       'BR2373VER',
//     ],
//   },
//   {
//     nome_socio: 'ADRIANO D AGNOLUZZO',
//     tipo: 'pessoa',
//     id_socios: '***215749**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '83.277.400/0001-76',
//     nombre_empresa: 'EXPAMA EXPORTADORA PARAGOMINAS DE MADEIRAS LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4042VER'],
//   },
//   {
//     nome_socio: 'SILVANO D AGNOLUZZO',
//     tipo: 'pessoa',
//     id_socios: '***196092**',
//     rol: 'Sócio',
//     id_empresa: '83.277.400/0001-76',
//     nombre_empresa: 'EXPAMA EXPORTADORA PARAGOMINAS DE MADEIRAS LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4042VER'],
//   },
//   {
//     nome_socio: 'VITORIO SUFREDINI NETO',
//     tipo: 'pessoa',
//     id_socios: '***133913**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '83.277.400/0001-76',
//     nombre_empresa: 'EXPAMA EXPORTADORA PARAGOMINAS DE MADEIRAS LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4042VER'],
//   },
//   {
//     nome_socio: 'IRENE ELIZABETH LENCI',
//     tipo: 'pessoa',
//     id_socios: '***194608**',
//     rol: 'Administrador',
//     id_empresa: '06.066.768/0001-44',
//     nombre_empresa: 'Florestal Santa Maria',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'FSM PARTICIPACOES LTDA',
//     tipo: 'empresa',
//     id_socios: '7804142000150',
//     rol: 'Sócio',
//     id_empresa: '06.066.768/0001-44',
//     nombre_empresa: 'Florestal Santa Maria',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'RUBENS FORBES ALVES DE LIMA',
//     tipo: 'pessoa',
//     id_socios: '***508538**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '06.066.768/0001-44',
//     nombre_empresa: 'Florestal Santa Maria',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'LUIZ ANTONIO MEDEIROS TAVARES',
//     tipo: 'pessoa',
//     id_socios: '***959912**',
//     rol: 'Presidente',
//     id_empresa: '21.774.398/0001-93',
//     nombre_empresa: 'Instituto Manguezal',
//     pais: 'Brasil',
//     id_proyecto: ['BR3601VER'],
//   },
//   {
//     nome_socio: 'ANTONIO FERNANDO DE GASPARI',
//     tipo: 'pessoa',
//     id_socios: '***264308**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '01.852.356/0001-16',
//     nombre_empresa: 'Ambiens Soluções Ambientais',
//     pais: 'Brasil',
//     id_proyecto: ['BR4689VER', 'BR4034VER'],
//   },
//   {
//     nome_socio: 'ROQUE LAZARO DE GASPARI JUNIOR',
//     tipo: 'pessoa',
//     id_socios: '***264808**',
//     rol: 'Conselheiro de Administração',
//     id_empresa: '01.852.356/0001-16',
//     nombre_empresa: 'Ambiens Soluções Ambientais',
//     pais: 'Brasil',
//     id_proyecto: ['BR4689VER', 'BR4034VER'],
//   },
//   {
//     nome_socio: 'VALDENOR CAMPOS DA COSTA JUNIOR',
//     tipo: 'pessoa',
//     id_socios: '***429112**',
//     rol: 'Diretor',
//     id_empresa: '12.132.277/0001-57',
//     nombre_empresa: 'Empresa Brasileira de Conservação de Florestas S.A.',
//     pais: 'Brasil',
//     id_proyecto: ['BR1147VER'],
//   },
//   {
//     nome_socio: 'FERNANDO O REILLY CABRAL BARRIONUEVO',
//     tipo: 'pessoa',
//     id_socios: '***732119**',
//     rol: 'Diretor',
//     id_empresa: '12.132.277/0001-57',
//     nombre_empresa: 'Empresa Brasileira de Conservação de Florestas S.A.',
//     pais: 'Brasil',
//     id_proyecto: ['BR1147VER'],
//   },
//   {
//     nome_socio: 'EDUARDO O REILLY CABRAL COVAS BARRIONUEVO',
//     tipo: 'pessoa',
//     id_socios: '***055259**',
//     rol: 'Diretor',
//     id_empresa: '12.132.277/0001-57',
//     nombre_empresa: 'Empresa Brasileira de Conservação de Florestas S.A.',
//     pais: 'Brasil',
//     id_proyecto: ['BR1147VER'],
//   },
//   {
//     nome_socio: 'LEONARDO O REILLY CABRAL BARRIONUEVO',
//     tipo: 'pessoa',
//     id_socios: '***859059**',
//     rol: 'Presidente',
//     id_empresa: '12.132.277/0001-57',
//     nombre_empresa: 'Empresa Brasileira de Conservação de Florestas S.A.',
//     pais: 'Brasil',
//     id_proyecto: ['BR1147VER'],
//   },
//   {
//     nome_socio: 'HILDEGARD GUTZ HORTA',
//     tipo: 'pessoa',
//     id_socios: '***642258**',
//     rol: 'Administrador',
//     id_empresa: '07.712.535/0001-34',
//     nombre_empresa: 'BUNGE ALIMENTOS PARTICIPACOES LTDA.',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'BUNGE HOLDINGS B.V.',
//     tipo: 'empresa',
//     id_socios: '6051621000180',
//     rol: 'Sócio Pessoa Jurídica Domiciliado no Exterior',
//     id_empresa: '07.712.535/0001-34',
//     nombre_empresa: 'BUNGE ALIMENTOS PARTICIPACOES LTDA.',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'BUNGE BRASIL HOLDINGS BV',
//     tipo: 'empresa',
//     id_socios: '6051618000167',
//     rol: 'Sócio Pessoa Jurídica Domiciliado no Exterior',
//     id_empresa: '07.712.535/0001-34',
//     nombre_empresa: 'BUNGE ALIMENTOS PARTICIPACOES LTDA.',
//     pais: 'Brasil',
//     id_proyecto: ['BR875VER'],
//   },
//   {
//     nome_socio: 'JOSMAR GILSON DE OLIVEIRA MATOGROSSO COSTA',
//     tipo: 'pessoa',
//     id_socios: '***110512**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '06.161.839/0001-98',
//     nombre_empresa:
//       'Mesmos sócios da Matogrosso Participações Ltda. É possível que sejam os donos das fazendas, mas esta informação não está clara no projeto. ',
//     pais: 'Brasil',
//     id_proyecto: ['BR3601VER'],
//   },
//   {
//     nome_socio: 'MARIA MATOGROSSO COSTA',
//     tipo: 'pessoa',
//     id_socios: '***526042**',
//     rol: 'Sócio',
//     id_empresa: '06.161.839/0001-98',
//     nombre_empresa:
//       'Mesmos sócios da Matogrosso Participações Ltda. É possível que sejam os donos das fazendas, mas esta informação não está clara no projeto. ',
//     pais: 'Brasil',
//     id_proyecto: ['BR3601VER'],
//   },
//   {
//     nome_socio: 'JOSE GILVAN DE OLIVEIRA MATOGROSSO COSTA',
//     tipo: 'pessoa',
//     id_socios: '***053122**',
//     rol: 'Sócio',
//     id_empresa: '06.161.839/0001-98',
//     nombre_empresa:
//       'Mesmos sócios da Matogrosso Participações Ltda. É possível que sejam os donos das fazendas, mas esta informação não está clara no projeto. ',
//     pais: 'Brasil',
//     id_proyecto: ['BR3601VER'],
//   },
//   {
//     nome_socio: 'ANTONIO JOSE LUDOVINO LOPES',
//     tipo: 'pessoa',
//     id_socios: '***734848**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '07.746.411/0001-70',
//     nombre_empresa: 'CARBONO FÁCIL — PROJETOS E SISTEMAS DE CERTIFICAÇÃO',
//     pais: 'Brasil',
//     id_proyecto: ['BR3430VER'],
//   },
//   {
//     nome_socio: 'MOACIR ELOY CROCETTA BATISTA',
//     tipo: 'pessoa',
//     id_socios: '***705129**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '46.831.892/0001-73',
//     nombre_empresa: 'Yaco2 Gestão e Comércio de Carbono LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4552VER'],
//   },
//   {
//     nome_socio: 'JUNIOR GALVANE BATISTA',
//     tipo: 'pessoa',
//     id_socios: '***211559**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '46.831.892/0001-73',
//     nombre_empresa: 'Yaco2 Gestão e Comércio de Carbono LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4552VER'],
//   },
//   {
//     nome_socio: 'GUILHERME GALVANE BATISTA',
//     tipo: 'pessoa',
//     id_socios: '***391002**',
//     rol: 'Sócio',
//     id_empresa: '46.831.892/0001-73',
//     nombre_empresa: 'Yaco2 Gestão e Comércio de Carbono LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4552VER'],
//   },
//   {
//     nome_socio: 'RJC2 ASSETS ADMINISTRATION PARTICIPACOES LTDA',
//     tipo: 'empresa',
//     id_socios: '48064917000186',
//     rol: 'Sócio',
//     id_empresa: '46.831.892/0001-73',
//     nombre_empresa: 'Yaco2 Gestão e Comércio de Carbono LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4552VER'],
//   },
//   {
//     nome_socio: 'BATISTA & CIA LTDA',
//     tipo: 'empresa',
//     id_socios: '22839815000100',
//     rol: 'Sócio',
//     id_empresa: '46.831.892/0001-73',
//     nombre_empresa: 'Yaco2 Gestão e Comércio de Carbono LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4552VER'],
//   },
//   {
//     nome_socio: 'MARCELO CORSINI AFONSO',
//     tipo: 'pessoa',
//     id_socios: '***467978**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '19.666.030/0001-60',
//     nombre_empresa: 'PACER INOVACAO LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4876VER'],
//   },
//   {
//     nome_socio: 'HILEIA PARTICIPACOES E INVESTIMENTOS S/A',
//     tipo: 'empresa',
//     id_socios: '48950782000156',
//     rol: 'Sócio',
//     id_empresa: '19.666.030/0001-60',
//     nombre_empresa: 'PACER INOVACAO LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR4876VER'],
//   },
//   {
//     nome_socio: 'FABIO THAINES',
//     tipo: 'pessoa',
//     id_socios: '***602511**',
//     rol: 'Sócio',
//     id_empresa: '04.199.086/0001-84',
//     nombre_empresa: 'TECMAN',
//     pais: 'Brasil',
//     id_proyecto: ['BR963VER', 'BR1382VER'],
//   },
//   {
//     nome_socio: 'IGOR AGAPEJEV DE ANDRADE',
//     tipo: 'pessoa',
//     id_socios: '***979048**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '04.199.086/0001-84',
//     nombre_empresa: 'TECMAN',
//     pais: 'Brasil',
//     id_proyecto: ['BR963VER', 'BR1382VER'],
//   },
//   {
//     nome_socio: 'FERNANDO FROSINI DE BARROS FERRAZ',
//     tipo: 'pessoa',
//     id_socios: '***903948**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '16.434.241/0001-89',
//     nombre_empresa: 'Avix Engenharia e Estudos Técnicos Ltd.',
//     pais: 'Brasil',
//     id_proyecto: ['BR3816VER', 'BR2539VER', 'BR2508VER', 'BR875VER'],
//   },
//   {
//     nome_socio: 'RENAN CUNHA FANTINI',
//     tipo: 'pessoa',
//     id_socios: '***564918**',
//     rol: 'Sócio',
//     id_empresa: '16.434.241/0001-89',
//     nombre_empresa: 'Avix Engenharia e Estudos Técnicos Ltd.',
//     pais: 'Brasil',
//     id_proyecto: ['BR3816VER', 'BR2539VER', 'BR2508VER', 'BR875VER'],
//   },
//   {
//     nome_socio: 'SERGIO ANTONIO GARCIA AMOROSO',
//     tipo: 'pessoa',
//     id_socios: '***086608**',
//     rol: 'Presidente',
//     id_empresa: '74.502.550/0001-45',
//     nombre_empresa: 'Fundação Jari',
//     pais: 'Brasil',
//     id_proyecto: ['BR4615VER'],
//   },
//   {
//     nome_socio: 'FRANCISCO RODRIGUES DE MELO',
//     tipo: 'pessoa',
//     id_socios: '***932952**',
//     rol: 'Presidente',
//     id_empresa: '08.885.776/0001-48',
//     nombre_empresa:
//       'ATAGROCAMP - Associação dos trabalhadores agroextrativistas do Alto Camarapí',
//     pais: 'Brasil',
//     id_proyecto: ['BR3334VER'],
//   },
//   {
//     nome_socio: 'FRANCISCO RODRIGUES CALIXTO NETO',
//     tipo: 'pessoa',
//     id_socios: '***430722**',
//     rol: 'Presidente',
//     id_empresa: '07.472.782/0001-00',
//     nombre_empresa:
//       'ATAIG-PA – Associação dos trabalhadores agroextrativistas da Ilha Grande do Pacajaí Assentamento Pai do Governo Federal',
//     pais: 'Brasil',
//     id_proyecto: ['BR3334VER'],
//   },
//   {
//     nome_socio: 'GUSTAVO HENRIQUE BATISTA',
//     tipo: 'pessoa',
//     id_socios: '***623546**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '49.460.034/0001-58',
//     nombre_empresa: 'Geowiki Engenharia Ltda',
//     pais: 'Brasil',
//     id_proyecto: ['BR1654VER'],
//   },
//   {
//     nome_socio: 'CAIO MARIO CALDEIRA BRANT RIBEIRO',
//     tipo: 'pessoa',
//     id_socios: '***735306**',
//     rol: 'Sócio',
//     id_empresa: '04.960.233/0001-97',
//     nombre_empresa: 'Urupianga Agro Pecuaria S.A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4143VER'],
//   },
//   {
//     nome_socio: 'MARIO ALVES RIBEIRO',
//     tipo: 'pessoa',
//     id_socios: '***411456**',
//     rol: 'Presidente',
//     id_empresa: '04.960.233/0001-97',
//     nombre_empresa: 'Urupianga Agro Pecuaria S.A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4143VER'],
//   },
//   {
//     nome_socio: 'HELENA CALDEIRA BRANT RIBEIRO',
//     tipo: 'pessoa',
//     id_socios: '***739996**',
//     rol: 'Conselheiro de Administração',
//     id_empresa: '04.960.233/0001-97',
//     nombre_empresa: 'Urupianga Agro Pecuaria S.A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4143VER'],
//   },
//   {
//     nome_socio: 'MARCELO MUZZI DE QUEIROZ',
//     tipo: 'pessoa',
//     id_socios: '***209306**',
//     rol: 'Administrador',
//     id_empresa: '04.960.233/0001-97',
//     nombre_empresa: 'Urupianga Agro Pecuaria S.A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4143VER'],
//   },
//   {
//     nome_socio: 'ANA BEATRIZ RIBEIRO DE QUEIROZ',
//     tipo: 'pessoa',
//     id_socios: '***739806**',
//     rol: 'Sócio',
//     id_empresa: '04.960.233/0001-97',
//     nombre_empresa: 'Urupianga Agro Pecuaria S.A',
//     pais: 'Brasil',
//     id_proyecto: ['BR4143VER'],
//   },
//   {
//     nome_socio: 'CAIO MORALES DEPRA',
//     tipo: 'pessoa',
//     id_socios: '***932452**',
//     rol: 'Diretor',
//     id_empresa: '51.504.594/0001-09',
//     nombre_empresa: 'COOPERCARBON – Cooperativa',
//     pais: 'Brasil',
//     id_proyecto: ['BR4681VER'],
//   },
//   {
//     nome_socio: 'ADERVAL JOSE DALMASO',
//     tipo: 'pessoa',
//     id_socios: '***831842**',
//     rol: 'Diretor',
//     id_empresa: '51.504.594/0001-09',
//     nombre_empresa: 'COOPERCARBON – Cooperativa',
//     pais: 'Brasil',
//     id_proyecto: ['BR4681VER'],
//   },
//   {
//     nome_socio: 'JOAO BOSCO GABRIEL',
//     tipo: 'pessoa',
//     id_socios: '***620187**',
//     rol: 'Presidente',
//     id_empresa: '51.504.594/0001-09',
//     nombre_empresa: 'COOPERCARBON – Cooperativa',
//     pais: 'Brasil',
//     id_proyecto: ['BR4681VER'],
//   },
//   {
//     nome_socio: 'ELENIRA GADELHA BEZERRA MENDES',
//     tipo: 'pessoa',
//     id_socios: '***467282**',
//     rol: 'Presidente',
//     id_empresa: '08.164.340/0001-60',
//     nombre_empresa: 'Instituto Chico Mendes',
//     pais: 'Brasil',
//     id_proyecto: ['BR963VER'],
//   },
//   {
//     nome_socio: 'VALESSA FERNANDES JANUARIO DA SILVEIRA',
//     tipo: 'pessoa',
//     id_socios: '***841349**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '41.764.351/0001-56',
//     nombre_empresa: 'GRUPO SWAT INTERNACIONAL',
//     pais: 'Brasil',
//     id_proyecto: ['BR3601VER'],
//   },
//   {
//     nome_socio: 'CRASSO PAULO BOSCO BREVIGLIERI',
//     tipo: 'pessoa',
//     id_socios: '***511618**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '34.808.431/0001-09',
//     nombre_empresa: 'GUAXINIM Environmental Solutions Ltda.',
//     pais: 'Brasil',
//     id_proyecto: ['BR4394VER'],
//   },
//   {
//     nome_socio: 'ADILSON DO NASCIMENTO ANDRADE',
//     tipo: 'pessoa',
//     id_socios: '***772442**',
//     rol: 'Presidente',
//     id_empresa: '20.150.825/0001-08',
//     nombre_empresa:
//       'ARQUICOSTT - Associação Remanescentes de Quilombos da comunidade São Tomé Tauçú',
//     pais: 'Brasil',
//     id_proyecto: ['BR3334VER'],
//   },
//   {
//     nome_socio: 'YURI NOGUEIRA FERES',
//     tipo: 'pessoa',
//     id_socios: '***597308**',
//     rol: 'Diretor',
//     id_empresa: '27.800.015/0001-90',
//     nombre_empresa: 'Rainforest Alliance, Inc. (RAINFOREST ALLIANCE BRASIL)',
//     pais: 'Brasil',
//     id_proyecto: [
//       'BR1147VER',
//       'BR1118VER',
//       'BR1112VER',
//       'BR1571VER',
//       'BR875VER',
//       'BR832VER',
//       'BR1382VER',
//       'BR1329VER',
//     ],
//   },
//   {
//     nome_socio: 'TERESA CRISTINA CORPA VENDRAMINI',
//     tipo: 'pessoa',
//     id_socios: '***801538**',
//     rol: 'Diretor',
//     id_empresa: '42.551.951/0001-07',
//     nombre_empresa: 'Instituto Taquari Vivo - ITV',
//     pais: 'Brasil',
//     id_proyecto: ['BR4747VER'],
//   },
//   {
//     nome_socio: 'ALAIN JUAN PABLO BELDA FERNANDEZ',
//     tipo: 'pessoa',
//     id_socios: '***686058**',
//     rol: 'Diretor',
//     id_empresa: '42.551.951/0001-07',
//     nombre_empresa: 'Instituto Taquari Vivo - ITV',
//     pais: 'Brasil',
//     id_proyecto: ['BR4747VER'],
//   },
//   {
//     nome_socio: 'TERESA CRISTINA RIBEIRO RALSTON BOTELHO BRACHER',
//     tipo: 'pessoa',
//     id_socios: '***246628**',
//     rol: 'Presidente',
//     id_empresa: '42.551.951/0001-07',
//     nombre_empresa: 'Instituto Taquari Vivo - ITV',
//     pais: 'Brasil',
//     id_proyecto: ['BR4747VER'],
//   },
//   {
//     nome_socio: 'ALEXANDRE ENRICO SILVA FIGLIOLINO',
//     tipo: 'pessoa',
//     id_socios: '***668698**',
//     rol: 'Diretor',
//     id_empresa: '42.551.951/0001-07',
//     nombre_empresa: 'Instituto Taquari Vivo - ITV',
//     pais: 'Brasil',
//     id_proyecto: ['BR4747VER'],
//   },
//   {
//     nome_socio: 'RAFAEL BEMERGUY SEFER',
//     tipo: 'pessoa',
//     id_socios: '***017792**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '46.881.535/0001-10',
//     nombre_empresa: 'BYBLOS AGRONEGÓCIO HOLDING LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR3738VER'],
//   },
//   {
//     nome_socio: 'JOAO CARLOS DE SOUZA MEIRELLES FILHO',
//     tipo: 'pessoa',
//     id_socios: '***833748**',
//     rol: 'Presidente',
//     id_empresa: '02.650.035/0001-00',
//     nombre_empresa: 'Instituto Peabiru',
//     pais: 'Brasil',
//     id_proyecto: ['BR4689VER', 'BR4034VER'],
//   },
//   {
//     nome_socio: 'AMPLEWELL HOLDINGS LIMITED',
//     tipo: 'empresa',
//     id_socios: '10793175000157',
//     rol: 'Sócio Pessoa Jurídica Domiciliado no Exterior',
//     id_empresa: '10.199.645/0005-82',
//     nombre_empresa: 'Universal Timber Resource do Brasil (UTRB)',
//     pais: 'Brasil',
//     id_proyecto: ['BR2980VER'],
//   },
//   {
//     nome_socio: 'GREAT PATH LIMITED',
//     tipo: 'empresa',
//     id_socios: '12822908000160',
//     rol: 'Sócio Pessoa Jurídica Domiciliado no Exterior',
//     id_empresa: '10.199.645/0005-82',
//     nombre_empresa: 'Universal Timber Resource do Brasil (UTRB)',
//     pais: 'Brasil',
//     id_proyecto: ['BR2980VER'],
//   },
//   {
//     nome_socio: 'FABIO LEVI VIDIGAL',
//     tipo: 'pessoa',
//     id_socios: '***062838**',
//     rol: 'Administrador',
//     id_empresa: '10.199.645/0005-82',
//     nombre_empresa: 'Universal Timber Resource do Brasil (UTRB)',
//     pais: 'Brasil',
//     id_proyecto: ['BR2980VER'],
//   },
//   {
//     nome_socio: 'DENISE VIANA BORGES',
//     tipo: 'pessoa',
//     id_socios: '***200532**',
//     rol: 'Presidente',
//     id_empresa: '04.611.106/0001-82',
//     nombre_empresa:
//       'Associação dos Moradores da Reserva Extrativista Rio Preto Jacundá e Riberinhos do Rio Machado – ASMOREX',
//     pais: 'Brasil',
//     id_proyecto: ['BR1503VER'],
//   },
//   {
//     nome_socio: 'FABIANA BARBOSA GOMES',
//     tipo: 'pessoa',
//     id_socios: '***321292**',
//     rol: 'Presidente',
//     id_empresa: '03.721.311/0001-38',
//     nombre_empresa:
//       'CENTRO DE ESTUDOS DA CULTURA E DO MEIO AMBIENTE DA AMAZONIA-RIO TERRA',
//     pais: 'Brasil',
//     id_proyecto: ['BR1503VER'],
//   },
//   {
//     nome_socio: 'MARIA DO SOCORRO COSTA DE ARAUJO',
//     tipo: 'pessoa',
//     id_socios: '***182292**',
//     rol: 'Sócio',
//     id_empresa: '22.417.044/0001-54',
//     nombre_empresa: 'AMBIENTAL AMAZÔNIA',
//     pais: 'Brasil',
//     id_proyecto: ['BR3430VER'],
//   },
//   {
//     nome_socio: 'GUSTAVO COSTA DE ARAUJO',
//     tipo: 'pessoa',
//     id_socios: '***339352**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '22.417.044/0001-54',
//     nombre_empresa: 'AMBIENTAL AMAZÔNIA',
//     pais: 'Brasil',
//     id_proyecto: ['BR3430VER'],
//   },
//   {
//     nome_socio: 'FELIPE RIBEIRO BITTENCOURT',
//     tipo: 'pessoa',
//     id_socios: '***385576**',
//     rol: 'Diretor',
//     id_empresa: '08.294.685/0001-38',
//     nombre_empresa: 'WayCarbon Soluções Ambientais e Projetos de Carbono LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR3631VER'],
//   },
//   {
//     nome_socio: 'PAULO MACHADO DE CARVALHO',
//     tipo: 'pessoa',
//     id_socios: '***868448**',
//     rol: 'Diretor',
//     id_empresa: '08.294.685/0001-38',
//     nombre_empresa: 'WayCarbon Soluções Ambientais e Projetos de Carbono LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR3631VER'],
//   },
//   {
//     nome_socio: 'HENRIQUE DE ALMEIDA PEREIRA',
//     tipo: 'pessoa',
//     id_socios: '***238646**',
//     rol: 'Diretor',
//     id_empresa: '08.294.685/0001-38',
//     nombre_empresa: 'WayCarbon Soluções Ambientais e Projetos de Carbono LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR3631VER'],
//   },
//   {
//     nome_socio: 'CARBON CREDITS CONSULTING S.R.L',
//     tipo: 'empresa',
//     id_socios: '42905382000142',
//     rol: 'Sócio',
//     id_empresa: '44.212.107/0001-79',
//     nombre_empresa: 'Carbon Credits Consulting SRL',
//     pais: 'Brasil',
//     id_proyecto: ['BR3141VER'],
//   },
//   {
//     nome_socio: 'MARIA JOSE DE SANTANA DIAS GUTIERREZ',
//     tipo: 'pessoa',
//     id_socios: '***035078**',
//     rol: 'Administrador',
//     id_empresa: '44.212.107/0001-79',
//     nombre_empresa: 'Carbon Credits Consulting SRL',
//     pais: 'Brasil',
//     id_proyecto: ['BR3141VER'],
//   },
//   {
//     nome_socio: 'RAFAEL NORA TANNUS',
//     tipo: 'pessoa',
//     id_socios: '***020798**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '10.411.029/0001-10',
//     nombre_empresa: 'Tamoios Tecnologia e Consultoria Ltda',
//     pais: 'Brasil',
//     id_proyecto: ['BR1686VER'],
//   },
//   {
//     nome_socio: 'RAFAEL NORA TANNUS',
//     tipo: 'pessoa',
//     id_socios: '***020798**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '10.411.029/0001-10',
//     nombre_empresa: 'Agência Verde',
//     pais: 'Brasil',
//     id_proyecto: ['BR1094VER'],
//   },
//   {
//     nome_socio: 'THIAGO DE AVILA OTHERO',
//     tipo: 'pessoa',
//     id_socios: '***251260**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '12.045.953/0001-55',
//     nombre_empresa: 'T.A.O Consultoria Ambiental Ltda',
//     pais: 'Brasil',
//     id_proyecto: ['BR1686VER'],
//   },
//   {
//     nome_socio: 'GUILHERME LUCAS MEDEIROS PRADO',
//     tipo: 'pessoa',
//     id_socios: '***904058**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '12.045.953/0001-55',
//     nombre_empresa: 'T.A.O Consultoria Ambiental Ltda',
//     pais: 'Brasil',
//     id_proyecto: ['BR1686VER'],
//   },
//   {
//     nome_socio: 'MARCELO HECTOR SABBAGH HADDAD',
//     tipo: 'pessoa',
//     id_socios: '***713058**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '12.045.953/0001-55',
//     nombre_empresa: 'T.A.O Consultoria Ambiental Ltda',
//     pais: 'Brasil',
//     id_proyecto: ['BR1686VER'],
//   },
//   {
//     nome_socio: 'STEFANO MERLIN',
//     tipo: 'pessoa',
//     id_socios: '***121341**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '09.510.073/0001-06',
//     nombre_empresa: 'Sustainable Carbon Projetos Ambientais Ltda',
//     pais: 'Brasil',
//     id_proyecto: [
//       'BR2870VER',
//       'BR2871VER',
//       'BR2709VER',
//       'BR2558VER',
//       'BR2482VER',
//       'BR2373VER',
//       'BR1094VER',
//     ],
//   },
//   {
//     nome_socio: 'AMINTAS DE OLIVEIRA BRANDAO JUNIOR',
//     tipo: 'pessoa',
//     id_socios: '***647222**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '25.227.501/0001-36',
//     nombre_empresa: 'BRGEO SERVICOS DE CONSULTORIA LTDA',
//     pais: 'Brasil',
//     id_proyecto: ['BR1811VER'],
//   },
//   {
//     nome_socio: 'ROMULO PEREIRA DA SILVA ARANTES',
//     tipo: 'pessoa',
//     id_socios: '***675098**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '45.879.260/0001-17',
//     nombre_empresa: 'Pau Brasil Assessoria Florestal',
//     pais: 'Brasil',
//     id_proyecto: ['BR4825VER', 'BR4633VER'],
//   },
//   {
//     nome_socio: 'JOSE LUIZ FELIX DE ANDRADE FILHO',
//     tipo: 'pessoa',
//     id_socios: '***882133**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '41.253.379/0001-29',
//     nombre_empresa: 'OnePlanet Ltda',
//     pais: 'Brasil',
//     id_proyecto: ['BR3050VER'],
//   },
//   {
//     nome_socio: 'MICHAEL EDWARD GREENE',
//     tipo: 'pessoa',
//     id_socios: '***159561**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '39.879.582/0001-63',
//     nombre_empresa: 'Amigos dos Ribeirinhos',
//     pais: 'Brasil',
//     id_proyecto: ['BR2620VER'],
//   },
//   {
//     nome_socio: 'VERONICA OKI IGACIHALAGUTI',
//     tipo: 'pessoa',
//     id_socios: '***177712**',
//     rol: 'Diretor',
//     id_empresa: '34.891.085/0001-67',
//     nombre_empresa: 'IMAZON - Instituto do Homem e Meio Ambiente da Amazônia',
//     pais: 'Brasil',
//     id_proyecto: ['BR3590VER'],
//   },
//   {
//     nome_socio: 'ANGELO PACCELLI CIPRIANO RABELO',
//     tipo: 'pessoa',
//     id_socios: '***644391**',
//     rol: 'Presidente',
//     id_empresa: '16.575.853/0001-91',
//     nombre_empresa: 'Instituto Homem Pantaneiro',
//     pais: 'Brasil',
//     id_proyecto: ['BR2566VER'],
//   },
//   {
//     nome_socio: 'FRANCISCO RAMOS MUNIZ',
//     tipo: 'pessoa',
//     id_socios: '***224252**',
//     rol: 'Presidente',
//     id_empresa: '03.486.071/0001-34',
//     nombre_empresa:
//       'Associação dos Remanescentes de Quilombos de Gurupá - ARQMG',
//     pais: 'Brasil',
//     id_proyecto: ['BR4857VER'],
//   },
//   {
//     nome_socio: 'MARIA SANTANA FERREIRA GONCALVES',
//     tipo: 'pessoa',
//     id_socios: '***157202**',
//     rol: 'Presidente',
//     id_empresa: '26.318.791/0001-96',
//     nombre_empresa:
//       'ASMOGAC - Associação dos moradores agroextrativistas do assentamento PEAEX Acangatá',
//     pais: 'Brasil',
//     id_proyecto: ['BR3334VER'],
//   },
//   {
//     nome_socio: 'RAFAELLA FERRAZ SOUZA',
//     tipo: 'pessoa',
//     id_socios: '***.752.797-**',
//     rol: 'Representante Legal',
//     id_empresa: '07.580.775/0001-22',
//     nombre_empresa: 'Interconexión Eléctrica S.A. E.S.P ISA',
//     pais: '',
//     id_proyecto: ['BR2566VER'],
//   },
//   {
//     nome_socio: 'MARIA ALICE',
//     tipo: 'pessoa',
//     id_socios: '***.572.288-**',
//     rol: 'Representante Legal',
//     id_empresa: '08.510.883/0001-91',
//     nombre_empresa: 'AENOR INTERNACIONAL, S.A.U.',
//     pais: '',
//     id_proyecto: ['BR4867VER', 'BR4857VER'],
//   },
//   {
//     nome_socio: 'BRUNO TAVARES DA SILVA',
//     tipo: 'pessoa',
//     id_socios: '***.073.528-**',
//     rol: 'Representante Legal',
//     id_empresa: '43.500.617/0001-89',
//     nombre_empresa: 'Para REDD Projects Ltd',
//     pais: '',
//     id_proyecto: ['BR3334VER'],
//   },
//   {
//     nome_socio: 'FABRICIO PERES MAZAIA',
//     tipo: 'pessoa',
//     id_socios: '***.382.038-**',
//     rol: 'Diretor',
//     id_empresa: '09.077.252/0001-93',
//     nombre_empresa:
//       'NOVAAGRI INFRA-ESTRUTURA DE ARMAZENAGEM E ESCOAMENTO AGRICOLA S.A',
//     pais: '',
//     id_proyecto: ['BR5044VER'],
//   },
//   {
//     nome_socio: 'SHIGEHARU KATO',
//     tipo: 'pessoa',
//     id_socios: '***.123.811-**',
//     rol: 'Diretor',
//     id_empresa: '09.077.252/0001-93',
//     nombre_empresa:
//       'NOVAAGRI INFRA-ESTRUTURA DE ARMAZENAGEM E ESCOAMENTO AGRICOLA S.A',
//     pais: '',
//     id_proyecto: ['BR5044VER'],
//   },
//   {
//     nome_socio: 'SHOHEI NODA',
//     tipo: 'pessoa',
//     id_socios: '***.363.348-**',
//     rol: 'Diretor',
//     id_empresa: '09.077.252/0001-93',
//     nombre_empresa:
//       'NOVAAGRI INFRA-ESTRUTURA DE ARMAZENAGEM E ESCOAMENTO AGRICOLA S.A',
//     pais: '',
//     id_proyecto: ['BR5044VER'],
//   },
//   {
//     nome_socio: 'CEZAR DA CUNHA MELO SENA',
//     tipo: 'pessoa',
//     id_socios: '***.288.556-**',
//     rol: 'Diretor',
//     id_empresa: '09.077.252/0001-93',
//     nombre_empresa:
//       'NOVAAGRI INFRA-ESTRUTURA DE ARMAZENAGEM E ESCOAMENTO AGRICOLA S.A',
//     pais: '',
//     id_proyecto: ['BR5044VER'],
//   },
//   {
//     nome_socio: 'THIAGO LUIZ GOERCK',
//     tipo: 'pessoa',
//     id_socios: '***.490.328-**',
//     rol: 'Diretor',
//     id_empresa: '09.077.252/0001-93',
//     nombre_empresa:
//       'NOVAAGRI INFRA-ESTRUTURA DE ARMAZENAGEM E ESCOAMENTO AGRICOLA S.A',
//     pais: '',
//     id_proyecto: ['BR5044VER'],
//   },
//   {
//     nome_socio: 'TAKANOBU KODAMA',
//     tipo: 'pessoa',
//     id_socios: '***.859.728-**',
//     rol: 'Diretor',
//     id_empresa: '09.077.252/0001-93',
//     nombre_empresa:
//       'NOVAAGRI INFRA-ESTRUTURA DE ARMAZENAGEM E ESCOAMENTO AGRICOLA S.A',
//     pais: '',
//     id_proyecto: ['BR5044VER'],
//   },
//   {
//     nome_socio: 'NEY NELSON MACHADO DE SOUSA',
//     tipo: 'pessoa',
//     id_socios: '***.174.078-**',
//     rol: 'Diretor',
//     id_empresa: '09.077.252/0001-93',
//     nombre_empresa:
//       'NOVAAGRI INFRA-ESTRUTURA DE ARMAZENAGEM E ESCOAMENTO AGRICOLA S.A',
//     pais: '',
//     id_proyecto: ['BR5044VER'],
//   },
//   {
//     nome_socio: 'YASUYUKI HIDAKA',
//     tipo: 'pessoa',
//     id_socios: '***.774.078-**',
//     rol: 'Diretor',
//     id_empresa: '09.077.252/0001-93',
//     nombre_empresa:
//       'NOVAAGRI INFRA-ESTRUTURA DE ARMAZENAGEM E ESCOAMENTO AGRICOLA S.A',
//     pais: '',
//     id_proyecto: ['BR5044VER'],
//   },
//   {
//     nome_socio: 'MAURO DONISETI SILVERIO RODRIGUES',
//     tipo: 'pessoa',
//     id_socios: '***.051.909-**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '47.858.323/0001-84',
//     nombre_empresa: 'BOCALON AGROPECUARIA LTDA',
//     pais: '',
//     id_proyecto: ['BR5044VER'],
//   },
//   {
//     nome_socio: 'REMY DENECHEAU',
//     tipo: 'pessoa',
//     id_socios: '***.082.547-**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '27.784.327/0001-58',
//     nombre_empresa: 'ORGANICA CONSULTORIA LTDA',
//     pais: '',
//     id_proyecto: ['BR5025VER', 'BR4956VER'],
//   },
//   {
//     nome_socio: 'REMY DENECHEAU',
//     tipo: 'pessoa',
//     id_socios: '***.082.547-**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '44.749.580/0001-90',
//     nombre_empresa: 'Urupolpas ',
//     pais: '',
//     id_proyecto: ['BR4956VER'],
//   },
//   {
//     nome_socio: 'ANA MARIA GOMES MATA',
//     tipo: 'pessoa',
//     id_socios: '***.158.087-**',
//     rol: 'Sócio',
//     id_empresa: '44.749.580/0001-90',
//     nombre_empresa: 'Urupolpas ',
//     pais: '',
//     id_proyecto: ['BR4956VER'],
//   },
//   {
//     nome_socio: 'MANOEL PEDRO BRAGA PAES',
//     tipo: 'pessoa',
//     id_socios: '***.643.672-**',
//     rol: 'Diretor',
//     id_empresa: '04.394.176/0001-26',
//     nombre_empresa: 'AGROFRUT',
//     pais: '',
//     id_proyecto: ['BR4956VER'],
//   },
//   {
//     nome_socio: 'ANTONIO CARLOS MONTEIRO FONSECA',
//     tipo: 'pessoa',
//     id_socios: '***.369.302-**',
//     rol: 'Presidente',
//     id_empresa: '04.394.176/0001-26',
//     nombre_empresa: 'AGROFRUT',
//     pais: '',
//     id_proyecto: ['BR4956VER'],
//   },
//   {
//     nome_socio: 'ADAMOR MACEDO PINTO',
//     tipo: 'pessoa',
//     id_socios: '***.062.202-**',
//     rol: 'Diretor',
//     id_empresa: '04.394.176/0001-26',
//     nombre_empresa: 'AGROFRUT',
//     pais: '',
//     id_proyecto: ['BR4956VER'],
//   },
//   {
//     nome_socio: 'OKRYT KUANTORO',
//     tipo: 'pessoa',
//     id_socios: '***.035.802-**',
//     rol: 'Presidente',
//     id_empresa: '36.411.161/0001-15',
//     nombre_empresa: 'ASSOCIACAO INDIGENA MANTINO',
//     pais: '',
//     id_proyecto: ['BR133ECO'],
//   },
//   {
//     nome_socio: 'ELIMARA PARINTINTIN',
//     tipo: 'pessoa',
//     id_socios: '***.220.952-**',
//     rol: 'Presidente',
//     id_empresa: '01.444.198/0001-65',
//     nombre_empresa: 'ORGANIZACAO DO POVO INDIGENA PARINTINTIN DO AMAZONAS',
//     pais: '',
//     id_proyecto: ['BR144ECO', 'BR125ECO'],
//   },
//   {
//     nome_socio: 'JUAREZ CINTA LARGA',
//     tipo: 'pessoa',
//     id_socios: '***.390.511-**',
//     rol: 'Presidente',
//     id_empresa: '08.916.233/0001-40',
//     nombre_empresa: 'ASSOCIACAO DO POVO INDIGENA CINTA LARGA - ETEREPUYA',
//     pais: '',
//     id_proyecto: ['BR139ECO', 'BR140ECO', 'BR141ECO', 'BR142ECO'],
//   },
//   {
//     nome_socio: 'OITA MATINA CINTA LARGA FILHO SEMANI',
//     tipo: 'pessoa',
//     id_socios: '***.986.872-**',
//     rol: 'Presidente',
//     id_empresa: '09.330.691/0001-66',
//     nombre_empresa:
//       'PATJAMAAJ - COORDENACAO DAS ORGANIZACOES INDIGENAS DO POVO CINTA LARGA',
//     pais: '',
//     id_proyecto: ['BR143ECO'],
//   },
//   {
//     nome_socio: 'FRANCINILDO COSME KABA MUNDURUKU',
//     tipo: 'pessoa',
//     id_socios: '***.599.952-**',
//     rol: 'Presidente',
//     id_empresa: '10.221.125/0001-03',
//     nombre_empresa: 'ASSOCIACAO INDIGENA PUSURU',
//     pais: '',
//     id_proyecto: ['BR130ECO', 'BR131ECO', 'BR128ECO', 'BR129ECO'],
//   },
//   {
//     nome_socio: 'THALIA ASSIRY CINTA LARGA',
//     tipo: 'pessoa',
//     id_socios: '***.091.582-**',
//     rol: 'Presidente',
//     id_empresa: '32.019.169/0001-80',
//     nombre_empresa:
//       'COOPERATIVA DE PRODUCAO E DESENVOLVIMENTO DO POVO INDIGENA CINTA LARGA - RO/MT',
//     pais: '',
//     id_proyecto: ['BR137ECO', 'BR138ECO'],
//   },
//   {
//     nome_socio: 'MARIA SILVA CABRAL',
//     tipo: 'pessoa',
//     id_socios: '***.344.522-**',
//     rol: 'Diretor',
//     id_empresa: '32.019.169/0001-80',
//     nombre_empresa:
//       'COOPERATIVA DE PRODUCAO E DESENVOLVIMENTO DO POVO INDIGENA CINTA LARGA - RO/MT',
//     pais: '',
//     id_proyecto: ['BR137ECO', 'BR138ECO'],
//   },
//   {
//     nome_socio: 'EUMARIA ASSIRI MAKURAP',
//     tipo: 'pessoa',
//     id_socios: '***.200.812-**',
//     rol: 'Diretor',
//     id_empresa: '32.019.169/0001-80',
//     nombre_empresa:
//       'COOPERATIVA DE PRODUCAO E DESENVOLVIMENTO DO POVO INDIGENA CINTA LARGA - RO/MT',
//     pais: '',
//     id_proyecto: ['BR137ECO', 'BR138ECO'],
//   },
//   {
//     nome_socio: 'ALEXIS DE MORAES CANTAUX',
//     tipo: 'pessoa',
//     id_socios: '***.813.938-**',
//     rol: 'Diretor',
//     id_empresa: '35.716.805/0001-10',
//     nombre_empresa: 'Canopée Gestão Ambiental e Florestal S/A,',
//     pais: '',
//     id_proyecto: ['BR189ECO', 'BR172ECO'],
//   },
//   {
//     nome_socio: 'JEAN PIERRE PAUL CANTAUX',
//     tipo: 'pessoa',
//     id_socios: '***.271.438-**',
//     rol: 'Diretor',
//     id_empresa: '35.716.805/0001-10',
//     nombre_empresa: 'Canopée Gestão Ambiental e Florestal S/A,',
//     pais: '',
//     id_proyecto: ['BR189ECO', 'BR172ECO'],
//   },
//   {
//     nome_socio: 'PEDRO RUHS DA SILVA',
//     tipo: 'pessoa',
//     id_socios: '***.339.947-**',
//     rol: 'Representante Legal',
//     id_empresa: '33.568.357/0001-20',
//     nombre_empresa: 'Companhia ASF Brasil',
//     pais: '',
//     id_proyecto: ['BR189ECO'],
//   },
//   {
//     nome_socio: 'SERVIO TULIO PRADO JUNIOR',
//     tipo: 'pessoa',
//     id_socios: '***.875.808-**',
//     rol: 'Representante Legal',
//     id_empresa: '23.628.450/0001-29',
//     nombre_empresa: 'Elio Tecnologia Ltda.',
//     pais: '',
//     id_proyecto: ['BR189ECO', 'BR172ECO'],
//   },
//   {
//     nome_socio: 'DAIL DAE IL SONG',
//     tipo: 'pessoa',
//     id_socios: '***.225.678-**',
//     rol: 'Sócio',
//     id_empresa: '23.628.450/0001-29',
//     nombre_empresa: 'Elio Tecnologia Ltda.',
//     pais: '',
//     id_proyecto: ['BR189ECO', 'BR172ECO'],
//   },
//   {
//     nome_socio: 'RUI PEDRO DE ALMEIDA RIBEIRO',
//     tipo: 'pessoa',
//     id_socios: '***.262.658-**',
//     rol: 'Sócio',
//     id_empresa: '23.628.450/0001-29',
//     nombre_empresa: 'Elio Tecnologia Ltda.',
//     pais: '',
//     id_proyecto: ['BR189ECO', 'BR172ECO'],
//   },
//   {
//     nome_socio: 'YIM KYU LEE',
//     tipo: 'pessoa',
//     id_socios: '***.154.388-**',
//     rol: 'Sócio',
//     id_empresa: '23.628.450/0001-29',
//     nombre_empresa: 'Elio Tecnologia Ltda.',
//     pais: '',
//     id_proyecto: ['BR189ECO', 'BR172ECO'],
//   },
//   {
//     nome_socio: 'GABRIEL KIM',
//     tipo: 'pessoa',
//     id_socios: '***.049.508-**',
//     rol: 'Sócio',
//     id_empresa: '23.628.450/0001-29',
//     nombre_empresa: 'Elio Tecnologia Ltda.',
//     pais: '',
//     id_proyecto: ['BR189ECO', 'BR172ECO'],
//   },
//   {
//     nome_socio: 'LUCIANO DA SILVEIRA ARAUJO',
//     tipo: 'pessoa',
//     id_socios: '***.656.508-**',
//     rol: 'Sócio',
//     id_empresa: '23.628.450/0001-29',
//     nombre_empresa: 'Elio Tecnologia Ltda.',
//     pais: '',
//     id_proyecto: ['BR189ECO', 'BR172ECO'],
//   },
//   {
//     nome_socio: 'CESAR EDUARDO BECHARA ARB CAMARDO',
//     tipo: 'pessoa',
//     id_socios: '***.123.998-**',
//     rol: 'Sócio',
//     id_empresa: '23.628.450/0001-29',
//     nombre_empresa: 'Elio Tecnologia Ltda.',
//     pais: '',
//     id_proyecto: ['BR189ECO', 'BR172ECO'],
//   },
//   {
//     nome_socio: 'MARCELO PEREIRA BINDER',
//     tipo: 'pessoa',
//     id_socios: '***.845.488-**',
//     rol: 'Sócio',
//     id_empresa: '23.628.450/0001-29',
//     nombre_empresa: 'Elio Tecnologia Ltda.',
//     pais: '',
//     id_proyecto: ['BR189ECO', 'BR172ECO'],
//   },
//   {
//     nome_socio: 'SEOK YEON CHANG',
//     tipo: 'pessoa',
//     id_socios: '***.189.278-**',
//     rol: 'Sócio',
//     id_empresa: '23.628.450/0001-29',
//     nombre_empresa: 'Elio Tecnologia Ltda.',
//     pais: '',
//     id_proyecto: ['BR189ECO', 'BR172ECO'],
//   },
//   {
//     nome_socio: 'FERNANDO LOPES ALBERTO',
//     tipo: 'pessoa',
//     id_socios: '***.603.498-**',
//     rol: 'Sócio',
//     id_empresa: '23.628.450/0001-29',
//     nombre_empresa: 'Elio Tecnologia Ltda.',
//     pais: '',
//     id_proyecto: ['BR189ECO', 'BR172ECO'],
//   },
//   {
//     nome_socio: 'JEAN PIERRE PAUL CANTAUX',
//     tipo: 'pessoa',
//     id_socios: '***.271.438-**',
//     rol: 'Sócio-Administrador',
//     id_empresa: ' 06.089.113/0001-91',
//     nombre_empresa: 'Ixtis Informática e Participações Ltda. ',
//     pais: '',
//     id_proyecto: ['BR189ECO', 'BR172ECO'],
//   },
//   {
//     nome_socio: 'PAULO BRAGA',
//     tipo: 'pessoa',
//     id_socios: '***.583.338-**',
//     rol: 'Sócio',
//     id_empresa: ' 06.089.113/0001-91',
//     nombre_empresa: 'Ixtis Informática e Participações Ltda. ',
//     pais: '',
//     id_proyecto: ['BR189ECO', 'BR172ECO'],
//   },
//   {
//     nome_socio: 'JEAN CLAUDE PINTO BARRETO',
//     tipo: 'pessoa',
//     id_socios: '***.795.057-**',
//     rol: 'Sócio',
//     id_empresa: ' 06.089.113/0001-91',
//     nombre_empresa: 'Ixtis Informática e Participações Ltda. ',
//     pais: '',
//     id_proyecto: ['BR189ECO', 'BR172ECO'],
//   },
//   {
//     nome_socio: 'SAID ELIAS VASCONCELOS NOGUEIRA',
//     tipo: 'pessoa',
//     id_socios: '***.084.582-**',
//     rol: 'Sócio-Administrador',
//     id_empresa: '23.799.842/0001-50',
//     nombre_empresa: 'DREAM LTDA. ',
//     pais: '',
//     id_proyecto: ['BR172ECO'],
//   },
//   {
//     nome_socio: 'ANDREIA DE QUEIROZ FREIRE',
//     tipo: 'pessoa',
//     id_socios: '***.027.062-**',
//     rol: 'Sócio',
//     id_empresa: '23.799.842/0001-50',
//     nombre_empresa: 'DREAM LTDA. ',
//     pais: '',
//     id_proyecto: ['BR172ECO'],
//   },
// ]

export interface IPersonas {
  id_empresa?: string
  id_novo_empresa?: string
  id_socio_carbono: string
  id_socio: string
  nome_socio: string
  tipo: string
  relacao_empresa_rol: Array<string>
}

// export const Personas: IPersonas[] = [
//   {
//     nome_socio: 'MARIA JOSE DE SANTANA DIAS GUTIERREZ',
//     tipo: 'persona',
//     id_socio: '***035078**',
//     id_socio_carbono: 'BR0065PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BE0102EM:administrador'],
//   },
//   {
//     nome_socio: 'CARBON CREDITS CONSULTING S.R.L',
//     tipo: 'empresa',
//     id_socio: '4.29054E+13',
//     id_socio_carbono: 'XX0057EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BE0102EM:socio'],
//   },
//   {
//     nome_socio: 'CHRISTIANA SOARES CABRAL FLECHA',
//     tipo: 'persona',
//     id_socio: '***148736**',
//     id_socio_carbono: 'BR0119PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0001EM:administrador'],
//   },
//   {
//     nome_socio: 'FELIPE VIANA LIMA',
//     tipo: 'persona',
//     id_socio: '***925228**',
//     id_socio_carbono: 'BR0493PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0001EM:administrador'],
//   },
//   {
//     nome_socio: 'FRANCIELE SALVADOR',
//     tipo: 'persona',
//     id_socio: '***648179**',
//     id_socio_carbono: 'BR0351PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0001EM:administrador'],
//   },
//   {
//     nome_socio: 'HUGO SOUZA DOS SANTOS',
//     tipo: 'persona',
//     id_socio: '***050378**',
//     id_socio_carbono: 'BR0071PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0001EM:administrador'],
//   },
//   {
//     nome_socio: 'JANAINA CORREA DA FONSECA DALLAN',
//     tipo: 'persona',
//     id_socio: '***713338**',
//     id_socio_carbono: 'BR0387PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0001EM:administrador'],
//   },
//   {
//     nome_socio: 'LUCIANO ROBERTO CORREA DA FONSECA FILHO',
//     tipo: 'persona',
//     id_socio: '***039828**',
//     id_socio_carbono: 'BR0068PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0001EM:administrador'],
//   },
//   {
//     nome_socio: 'LUIZ FERNANDO DE MOURA',
//     tipo: 'persona',
//     id_socio: '***671088**',
//     id_socio_carbono: 'BR0365PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0001EM:administrador'],
//   },
//   {
//     nome_socio: 'VICTOR SOUZA DE MATTOS',
//     tipo: 'persona',
//     id_socio: '***005528**',
//     id_socio_carbono: 'BR0047PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0001EM:administrador'],
//   },
//   {
//     nome_socio: 'CARBONEXT HOLDING S.A',
//     tipo: 'empresa',
//     id_socio: '4.16432E+13',
//     id_socio_carbono: 'XX0045EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0001EM:socio'],
//   },
//   {
//     nome_socio: 'ALDO ROBERTO TISOTT',
//     tipo: 'persona',
//     id_socio: '***009870**',
//     id_socio_carbono: 'BR0049PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0002EM:administrador'],
//   },
//   {
//     nome_socio: 'GUSTAVO MACEDO LUNARDI',
//     tipo: 'persona',
//     id_socio: '***748920**',
//     id_socio_carbono: 'BR0403PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0002EM:administrador'],
//   },
//   {
//     nome_socio: 'IVO MARCON BRUM',
//     tipo: 'persona',
//     id_socio: '***420770**',
//     id_socio_carbono: 'BR0251PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0002EM:administrador'],
//   },
//   {
//     nome_socio: 'SLC AGRICOLA S.A.',
//     tipo: 'empresa',
//     id_socio: '8.90965E+13',
//     id_socio_carbono: 'XX0055EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0002EM:socio'],
//   },
//   {
//     nome_socio: 'SLC INVESTIMENTOS AGRICOLAS LTDA',
//     tipo: 'empresa',
//     id_socio: '1.97656E+13',
//     id_socio_carbono: 'XX0030EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0002EM:socio'],
//   },
//   {
//     nome_socio: 'AURELIO PAVINATO',
//     tipo: 'persona',
//     id_socio: '***973590**',
//     id_socio_carbono: 'BR0520PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0003EM:administrador', 'BR0002EM:administrador'],
//   },
//   {
//     nome_socio: 'EDUARDO SILVA LOGEMANN',
//     tipo: 'persona',
//     id_socio: '***844760**',
//     id_socio_carbono: 'BR0450PER',
//     relacao_com_empresa: 'Conselheiro de Administração',
//     id_rol: 'consejo_adm',
//     relacion_empresas_rol: ['BR0003EM:consejo_adm'],
//   },
//   {
//     nome_socio: 'JAN MARK ANGELE PENSAERT',
//     tipo: 'persona',
//     id_socio: '***342010**',
//     id_socio_carbono: 'BR0217PER',
//     relacao_com_empresa: 'Conselheiro de Administração',
//     id_rol: 'consejo_adm',
//     relacion_empresas_rol: ['BR0003EM:consejo_adm'],
//   },
//   {
//     nome_socio: 'RENATO CASSIM CAVALINI',
//     tipo: 'persona',
//     id_socio: '***658628**',
//     id_socio_carbono: 'BR0359PER',
//     relacao_com_empresa: 'Conselheiro de Administração',
//     id_rol: 'consejo_adm',
//     relacion_empresas_rol: ['BR0003EM:consejo_adm'],
//   },
//   {
//     nome_socio: 'VERNER TIEDE',
//     tipo: 'persona',
//     id_socio: '***795000**',
//     id_socio_carbono: 'BR0422PER',
//     relacao_com_empresa: 'Conselheiro de Administração',
//     id_rol: 'consejo_adm',
//     relacion_empresas_rol: ['BR0003EM:consejo_adm'],
//   },
//   {
//     nome_socio: 'ALVARO LUIZ DILLI GONCALVES',
//     tipo: 'persona',
//     id_socio: '***062441**',
//     id_socio_carbono: 'BR0083PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0003EM:director'],
//   },
//   {
//     nome_socio: 'HILEIA PARTICIPACOES E INVESTIMENTOS S/A',
//     tipo: 'empresa',
//     id_socio: '4.89508E+13',
//     id_socio_carbono: 'XX0053EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0004EM:socio'],
//   },
//   {
//     nome_socio: 'MARCELO CORSINI AFONSO',
//     tipo: 'persona',
//     id_socio: '***467978**',
//     id_socio_carbono: 'BR0277PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0004EM:socio_adm'],
//   },
//   {
//     nome_socio: 'JOAO VILLELA DE ANDRADE',
//     tipo: 'persona',
//     id_socio: '***845878**',
//     id_socio_carbono: 'BR0451PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0006EM:director'],
//   },
//   {
//     nome_socio: 'JOSE ULPIANO PINTO DE SOUZA FILHO',
//     tipo: 'persona',
//     id_socio: '***205518**',
//     id_socio_carbono: 'BR0146PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0006EM:director'],
//   },
//   {
//     nome_socio: 'JOSE VILLELA DE ANDRADE NETO',
//     tipo: 'persona',
//     id_socio: '***809518**',
//     id_socio_carbono: 'BR0434PER',
//     relacao_com_empresa: 'Presidente',
//     id_rol: 'presidente',
//     relacion_empresas_rol: ['BR0006EM:presidente'],
//   },
//   {
//     nome_socio: 'AIGLE CAVALCA KNACK',
//     tipo: 'persona',
//     id_socio: '***138519**',
//     id_socio_carbono: 'BR0112PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0007EM:administrador'],
//   },
//   {
//     nome_socio: 'ALCIDES CAVALCA NETO',
//     tipo: 'persona',
//     id_socio: '***708829**',
//     id_socio_carbono: 'BR0385PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0007EM:administrador'],
//   },
//   {
//     nome_socio: 'A A CAVALCA ADMINISTRACAO DE BENS PROPRIOS E PARTICIPACOES LTDA.',
//     tipo: 'empresa',
//     id_socio: '1.56923E+12',
//     id_socio_carbono: 'XX0002EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0007EM:socio'],
//   },
//   {
//     nome_socio: 'ACK PARTICIPACOES SOCIETARIAS LTDA',
//     tipo: 'empresa',
//     id_socio: '2.91222E+13',
//     id_socio_carbono: 'XX0037EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0007EM:socio'],
//   },
//   {
//     nome_socio: 'AFAR PARTICIPACOES SOCIETARIAS LTDA',
//     tipo: 'empresa',
//     id_socio: '2.19746E+13',
//     id_socio_carbono: 'XX0032EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0007EM:socio'],
//   },
//   {
//     nome_socio: 'CVL PARTICIPACOES SOCIETARIAS LTDA.',
//     tipo: 'empresa',
//     id_socio: '9.47444E+12',
//     id_socio_carbono: 'XX0017EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0007EM:socio'],
//   },
//   {
//     nome_socio: 'MEDIO NORTE PARTICIPACOES SOCIETARIAS LTDA.',
//     tipo: 'empresa',
//     id_socio: '1.04667E+13',
//     id_socio_carbono: 'XX0018EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0007EM:socio'],
//   },
//   {
//     nome_socio: 'FRANCISCO RAMOS MUNIZ',
//     tipo: 'persona',
//     id_socio: '***224252**',
//     id_socio_carbono: 'BR0159PER',
//     relacao_com_empresa: 'Presidente',
//     id_rol: 'presidente',
//     relacion_empresas_rol: ['BR0008EM:presidente'],
//   },
//   {
//     nome_socio: 'ESTELA NEVES DE SOUZA ALBUQUERQUE',
//     tipo: 'persona',
//     id_socio: '***995382**',
//     id_socio_carbono: 'BR0532PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0009EM:socio'],
//   },
//   {
//     nome_socio: 'JUSTINIANO DE QUEIROZ NETTO',
//     tipo: 'persona',
//     id_socio: '***230652**',
//     id_socio_carbono: 'BR0163PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0009EM:socio'],
//   },
//   {
//     nome_socio: 'ADNAN DEMACHKI',
//     tipo: 'persona',
//     id_socio: '***781292**',
//     id_socio_carbono: 'BR0414PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0009EM:socio_adm'],
//   },
//   {
//     nome_socio: 'EDGARD MARIO DE MEDEIROS JUNIOR',
//     tipo: 'persona',
//     id_socio: '***986482**',
//     id_socio_carbono: 'BR0528PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0009EM:socio_adm'],
//   },
//   {
//     nome_socio: 'OSMAR SCARAMUSSA',
//     tipo: 'persona',
//     id_socio: '***917247**',
//     id_socio_carbono: 'BR0490PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0009EM:socio_adm'],
//   },
//   {
//     nome_socio: 'BRUNO MELO DA MATTA',
//     tipo: 'persona',
//     id_socio: '***369088**',
//     id_socio_carbono: 'BR0230PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0010EM:socio'],
//   },
//   {
//     nome_socio: 'DIEGO MACHADO CARRION SERRANO',
//     tipo: 'persona',
//     id_socio: '***277458**',
//     id_socio_carbono: 'BR0193PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0010EM:socio', 'BR0131EM:socio'],
//   },
//   {
//     nome_socio: 'HEBERTON HENRIQUE DIMAS DE BARROS',
//     tipo: 'persona',
//     id_socio: '***200468**',
//     id_socio_carbono: 'BR0143PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0010EM:socio'],
//   },
//   {
//     nome_socio: 'RENAN AKIO KAMIMURA',
//     tipo: 'persona',
//     id_socio: '***056616**',
//     id_socio_carbono: 'BR0079PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0010EM:socio'],
//   },
//   {
//     nome_socio: 'TMNH PARTICIPACOES LTDA',
//     tipo: 'empresa',
//     id_socio: '3.57252E+13',
//     id_socio_carbono: 'XX0042EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0010EM:socio'],
//   },
//   {
//     nome_socio: 'BRUNO BRAZIL DE SOUZA',
//     tipo: 'persona',
//     id_socio: '***986868**',
//     id_socio_carbono: 'BR0529PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0010EM:socio_adm'],
//   },
//   {
//     nome_socio: 'DAVID ESCAQUETE',
//     tipo: 'persona',
//     id_socio: '***023018**',
//     id_socio_carbono: 'BR0056PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0010EM:socio_adm'],
//   },
//   {
//     nome_socio: 'JOERCIO PAULINO DA COSTA',
//     tipo: 'persona',
//     id_socio: '***070922**',
//     id_socio_carbono: 'BR0089PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0011EM:administrador'],
//   },
//   {
//     nome_socio: 'LUIZ ROGERIO DE OLIVEIRA',
//     tipo: 'persona',
//     id_socio: '***232952**',
//     id_socio_carbono: 'BR0165PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0011EM:administrador'],
//   },
//   {
//     nome_socio: 'GABRIEL BERTONI SEBASTIAO',
//     tipo: 'persona',
//     id_socio: '***926188**',
//     id_socio_carbono: 'BR0494PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0011EM:socio'],
//   },
//   {
//     nome_socio: 'REGINALDO BISPO DE SOUZA',
//     tipo: 'persona',
//     id_socio: '***025532**',
//     id_socio_carbono: 'BR0058PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0011EM:socio'],
//   },
//   {
//     nome_socio: 'RJC2 ASSETS ADMINISTRATION PARTICIPACOES LTDA',
//     tipo: 'persona',
//     id_socio: '4.80649E+13',
//     id_socio_carbono: 'XX0050EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0011EM:socio', 'BR0032EM:socio'],
//   },
//   {
//     nome_socio: 'CATARINA VILLARES STOPPE',
//     tipo: 'persona',
//     id_socio: '***184868**',
//     id_socio_carbono: 'BR0137PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0012EM:socio_adm'],
//   },
//   {
//     nome_socio: 'JOAO ANTONIO VILLARES STOPPE',
//     tipo: 'persona',
//     id_socio: '***619068**',
//     id_socio_carbono: 'BR0338PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0012EM:socio_adm'],
//   },
//   {
//     nome_socio: 'RICARDO VILLARES LOT STOPPE',
//     tipo: 'persona',
//     id_socio: '***184878**',
//     id_socio_carbono: 'BR0138PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0012EM:socio_adm'],
//   },
//   {
//     nome_socio: 'ROMULO PEREIRA DA SILVA ARANTES',
//     tipo: 'persona',
//     id_socio: '***675098**',
//     id_socio_carbono: 'BR0368PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0013EM:socio_adm'],
//   },
//   {
//     nome_socio: 'ALESSANDRA BESSA ALVES DE MELO',
//     tipo: 'persona',
//     id_socio: '***259048**',
//     id_socio_carbono: 'BR0179PER',
//     relacao_com_empresa: 'Conselheiro de Administração',
//     id_rol: 'consejo_adm',
//     relacion_empresas_rol: ['BR0014EM:consejo_adm'],
//   },
//   {
//     nome_socio: 'EDUARDO GOMES DE ALMEIDA',
//     tipo: 'persona',
//     id_socio: '***930137**',
//     id_socio_carbono: 'BR0499PER',
//     relacao_com_empresa: 'Conselheiro de Administração',
//     id_rol: 'consejo_adm',
//     relacion_empresas_rol: ['BR0014EM:consejo_adm'],
//   },
//   {
//     nome_socio: 'FABRICIO RESENDE FONSECA',
//     tipo: 'persona',
//     id_socio: '***870167**',
//     id_socio_carbono: 'BR0464PER',
//     relacao_com_empresa: 'Conselheiro de Administração',
//     id_rol: 'consejo_adm',
//     relacion_empresas_rol: ['BR0014EM:consejo_adm'],
//   },
//   {
//     nome_socio: 'JUSCELINO FERNANDES MARTINS',
//     tipo: 'persona',
//     id_socio: '***406806**',
//     id_socio_carbono: 'BR0243PER',
//     relacao_com_empresa: 'Conselheiro de Administração',
//     id_rol: 'consejo_adm',
//     relacion_empresas_rol: ['BR0014EM:consejo_adm'],
//   },
//   {
//     nome_socio: 'PAULO ROBERTO BELLOTTI',
//     tipo: 'persona',
//     id_socio: '***013908**',
//     id_socio_carbono: 'BR0050PER',
//     relacao_com_empresa: 'Conselheiro de Administração',
//     id_rol: 'consejo_adm',
//     relacion_empresas_rol: ['BR0014EM:consejo_adm'],
//   },
//   {
//     nome_socio: 'VICTOR DAVI PATINI BORLENGHI',
//     tipo: 'persona',
//     id_socio: '***276578**',
//     id_socio_carbono: 'BR0192PER',
//     relacao_com_empresa: 'Conselheiro de Administração',
//     id_rol: 'consejo_adm',
//     relacion_empresas_rol: ['BR0014EM:consejo_adm'],
//   },
//   {
//     nome_socio: 'GUILHERME PATINI BORLENGHI',
//     tipo: 'persona',
//     id_socio: '***104768**',
//     id_socio_carbono: 'BR0103PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0014EM:director'],
//   },
//   {
//     nome_socio: 'LUCIANA FREIRE BARCA NASCIMENTO',
//     tipo: 'persona',
//     id_socio: '***428758**',
//     id_socio_carbono: 'BR0255PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0014EM:director'],
//   },
//   {
//     nome_socio: 'THIAGO DA COSTA SILVA',
//     tipo: 'persona',
//     id_socio: '***653698**',
//     id_socio_carbono: 'BR0354PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0014EM:director'],
//   },
//   {
//     nome_socio: 'PLINIO PAGNONCELLI AGUIAR RIBEIRO',
//     tipo: 'persona',
//     id_socio: '***333201**',
//     id_socio_carbono: 'BR0214PER',
//     relacao_com_empresa: 'Presidente',
//     id_rol: 'presidente',
//     relacion_empresas_rol: ['BR0014EM:presidente'],
//   },
//   {
//     nome_socio: 'ALAIN JUAN PABLO BELDA FERNANDEZ',
//     tipo: 'persona',
//     id_socio: '***686058**',
//     id_socio_carbono: 'BR0373PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0015EM:director'],
//   },
//   {
//     nome_socio: 'ALEXANDRE ENRICO SILVA FIGLIOLINO',
//     tipo: 'persona',
//     id_socio: '***668698**',
//     id_socio_carbono: 'BR0364PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0015EM:director'],
//   },
//   {
//     nome_socio: 'TERESA CRISTINA CORPA VENDRAMINI',
//     tipo: 'persona',
//     id_socio: '***801538**',
//     id_socio_carbono: 'BR0426PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0015EM:director'],
//   },
//   {
//     nome_socio: 'TERESA CRISTINA RIBEIRO RALSTON BOTELHO BRACHER',
//     tipo: 'persona',
//     id_socio: '***246628**',
//     id_socio_carbono: 'BR0171PER',
//     relacao_com_empresa: 'Presidente',
//     id_rol: 'presidente',
//     relacion_empresas_rol: ['BR0015EM:presidente'],
//   },
//   {
//     nome_socio: 'PAULA ISLA MARTINS',
//     tipo: 'persona',
//     id_socio: '***705191**',
//     id_socio_carbono: 'BR0384PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0016EM:socio'],
//   },
//   {
//     nome_socio: 'LETICIA KOUTCHIN DOS REIS',
//     tipo: 'persona',
//     id_socio: '***507441**',
//     id_socio_carbono: 'BR0290PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0016EM:socio_adm'],
//   },
//   {
//     nome_socio: 'DERYCK PANTOJA MARTINS',
//     tipo: 'persona',
//     id_socio: '***869052**',
//     id_socio_carbono: 'BR0463PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0017EM:socio_adm'],
//   },
//   {
//     nome_socio: 'RANIERY VALE NERI BRANCO',
//     tipo: 'persona',
//     id_socio: '***987262**',
//     id_socio_carbono: 'BR0530PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0017EM:socio_adm'],
//   },
//   {
//     nome_socio: 'ALEX SANDRO DA SILVA',
//     tipo: 'persona',
//     id_socio: '***605588**',
//     id_socio_carbono: 'BR0334PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0018EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'LILIAN KEIKO MOTOOKA',
//     tipo: 'persona',
//     id_socio: '***890308**',
//     id_socio_carbono: 'BR0476PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0018EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'RODRIGO SOUSA PEREIRA',
//     tipo: 'persona',
//     id_socio: '***817048**',
//     id_socio_carbono: 'BR0436PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0018EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'BARBARA REGE PALOMO PAVAN',
//     tipo: 'persona',
//     id_socio: '***209098**',
//     id_socio_carbono: 'BR0149PER',
//     relacao_com_empresa: 'Sócio sem Capital',
//     id_rol: 'socio_s_capital',
//     relacion_empresas_rol: ['BR0018EM:socio_s_capital'],
//   },
//   {
//     nome_socio: 'EDSON ANASTACIO FILHO',
//     tipo: 'persona',
//     id_socio: '***834308**',
//     id_socio_carbono: 'BR0446PER',
//     relacao_com_empresa: 'Sócio sem Capital',
//     id_rol: 'socio_s_capital',
//     relacion_empresas_rol: ['BR0018EM:socio_s_capital'],
//   },
//   {
//     nome_socio: 'FABIANA MACIEL DA COSTA',
//     tipo: 'persona',
//     id_socio: '***699973**',
//     id_socio_carbono: 'BR0381PER',
//     relacao_com_empresa: 'Sócio sem Capital',
//     id_rol: 'socio_s_capital',
//     relacion_empresas_rol: ['BR0018EM:socio_s_capital'],
//   },
//   {
//     nome_socio: 'NADIA DE SOUZA BANCOFF',
//     tipo: 'persona',
//     id_socio: '***243128**',
//     id_socio_carbono: 'BR0168PER',
//     relacao_com_empresa: 'Sócio sem Capital',
//     id_rol: 'socio_s_capital',
//     relacion_empresas_rol: ['BR0018EM:socio_s_capital'],
//   },
//   {
//     nome_socio: 'PAOLO ARDENGHI DI CICCO',
//     tipo: 'persona',
//     id_socio: '***000788**',
//     id_socio_carbono: 'BR0044PER',
//     relacao_com_empresa: 'Sócio sem Capital',
//     id_rol: 'socio_s_capital',
//     relacion_empresas_rol: ['BR0018EM:socio_s_capital'],
//   },
//   {
//     nome_socio: 'RAPHAELLA MARIA CHAGAS FERNANDES GONCALVES',
//     tipo: 'persona',
//     id_socio: '***600328**',
//     id_socio_carbono: 'BR0330PER',
//     relacao_com_empresa: 'Sócio sem Capital',
//     id_rol: 'socio_s_capital',
//     relacion_empresas_rol: ['BR0018EM:socio_s_capital'],
//   },
//   {
//     nome_socio: 'SORAIA DE SOUZA PIRES',
//     tipo: 'persona',
//     id_socio: '***019978**',
//     id_socio_carbono: 'BR0054PER',
//     relacao_com_empresa: 'Sócio sem Capital',
//     id_rol: 'socio_s_capital',
//     relacion_empresas_rol: ['BR0018EM:socio_s_capital'],
//   },
//   {
//     nome_socio: 'THIAGO ARMANDO SPINA',
//     tipo: 'persona',
//     id_socio: '***454938**',
//     id_socio_carbono: 'BR0265PER',
//     relacao_com_empresa: 'Sócio sem Capital',
//     id_rol: 'socio_s_capital',
//     relacion_empresas_rol: ['BR0018EM:socio_s_capital'],
//   },
//   {
//     nome_socio: 'PAULA DE LARA E SILVA',
//     tipo: 'persona',
//     id_socio: '***511028**',
//     id_socio_carbono: 'BR0294PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0018EM:socio_adm'],
//   },
//   {
//     nome_socio: 'THEOTONIO MAURICIO MONTEIRO DE BARROS',
//     tipo: 'persona',
//     id_socio: '***551938**',
//     id_socio_carbono: 'BR0314PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0018EM:socio_adm'],
//   },
//   {
//     nome_socio: 'LILIAN MARQUES ESTEVES',
//     tipo: 'persona',
//     id_socio: '***941527**',
//     id_socio_carbono: 'BR0508PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0019EM:director'],
//   },
//   {
//     nome_socio: 'MICHEL ALEXANDRE ROY',
//     tipo: 'persona',
//     id_socio: '***895478**',
//     id_socio_carbono: 'BR0478PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0019EM:director'],
//   },
//   {
//     nome_socio: 'CAMILLA SCHINDLER',
//     tipo: 'persona',
//     id_socio: '***693189**',
//     id_socio_carbono: 'BR0375PER',
//     relacao_com_empresa: 'Presidente',
//     id_rol: 'presidente',
//     relacion_empresas_rol: ['BR0019EM:presidente'],
//   },
//   {
//     nome_socio: 'CLEMENTE SOARES HAMOY',
//     tipo: 'persona',
//     id_socio: '***928602**',
//     id_socio_carbono: 'BR0497PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0020EM:director'],
//   },
//   {
//     nome_socio: 'ARI ZUGMAN',
//     tipo: 'persona',
//     id_socio: '***806279**',
//     id_socio_carbono: 'BR0431PER',
//     relacao_com_empresa: 'Presidente',
//     id_rol: 'presidente',
//     relacion_empresas_rol: ['BR0020EM:presidente'],
//   },
//   {
//     nome_socio: 'ARLINDO DE AZEVEDO MOURA',
//     tipo: 'persona',
//     id_socio: '***459100**',
//     id_socio_carbono: 'BR0271PER',
//     relacao_com_empresa: 'Conselheiro de Administração',
//     id_rol: 'consejo_adm',
//     relacion_empresas_rol: ['BR0021EM:consejo_adm'],
//   },
//   {
//     nome_socio: 'EDUARDO DE BRITTO PEREIRA AZEVEDO',
//     tipo: 'persona',
//     id_socio: '***208487**',
//     id_socio_carbono: 'BR0148PER',
//     relacao_com_empresa: 'Conselheiro de Administração',
//     id_rol: 'consejo_adm',
//     relacion_empresas_rol: ['BR0021EM:consejo_adm', 'BR0055EM:consejo_adm'],
//   },
//   {
//     nome_socio: 'DANIEL MOREIRA FLORENCE',
//     tipo: 'persona',
//     id_socio: '***499317**',
//     id_socio_carbono: 'BR0287PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0021EM:director'],
//   },
//   {
//     nome_socio: 'JULIANA PEREZ ALONSO CORREA',
//     tipo: 'persona',
//     id_socio: '***701207**',
//     id_socio_carbono: 'BR0382PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0021EM:director', 'BR0054EM:director'],
//   },
//   {
//     nome_socio: 'MARCIO JOSE FERREIRA',
//     tipo: 'persona',
//     id_socio: '***569628**',
//     id_socio_carbono: 'BR0320PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0021EM:director'],
//   },
//   {
//     nome_socio: 'CRISTIANO SOARES RODRIGUES',
//     tipo: 'persona',
//     id_socio: '***919117**',
//     id_socio_carbono: 'BR0491PER',
//     relacao_com_empresa: 'Presidente',
//     id_rol: 'presidente',
//     relacion_empresas_rol: [
//       'BR0021EM:presidente',
//       'BR0054EM:presidente',
//       'BR0055EM:presidente',
//     ],
//   },
//   {
//     nome_socio: 'ROQUE LAZARO DE GASPARI JUNIOR',
//     tipo: 'persona',
//     id_socio: '***264808**',
//     id_socio_carbono: 'BR0187PER',
//     relacao_com_empresa: 'Conselheiro de Administração',
//     id_rol: 'consejo_adm',
//     relacion_empresas_rol: ['BR0022EM:consejo_adm'],
//   },
//   {
//     nome_socio: 'ANTONIO FERNANDO DE GASPARI',
//     tipo: 'persona',
//     id_socio: '***264308**',
//     id_socio_carbono: 'BR0185PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0022EM:socio_adm'],
//   },
//   {
//     nome_socio: 'JOAO CARLOS DE SOUZA MEIRELLES FILHO',
//     tipo: 'persona',
//     id_socio: '***833748**',
//     id_socio_carbono: 'BR0445PER',
//     relacao_com_empresa: 'Presidente',
//     id_rol: 'presidente',
//     relacion_empresas_rol: ['BR0023EM:presidente'],
//   },
//   {
//     nome_socio: 'EDUARDO GUSSON',
//     tipo: 'persona',
//     id_socio: '***909988**',
//     id_socio_carbono: 'BR0486PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0024EM:socio_adm'],
//   },
//   {
//     nome_socio: 'FREDERICO TOMAS DE SOUZA E MIRANDA',
//     tipo: 'persona',
//     id_socio: '***716718**',
//     id_socio_carbono: 'BR0391PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0024EM:socio_adm'],
//   },
//   {
//     nome_socio: 'GIRLEI COSTA DA CUNHA',
//     tipo: 'persona',
//     id_socio: '***054540**',
//     id_socio_carbono: 'BR0075PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0024EM:socio_adm'],
//   },
//   {
//     nome_socio: 'ADERVAL JOSE DALMASO',
//     tipo: 'persona',
//     id_socio: '***831842**',
//     id_socio_carbono: 'BR0444PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0025EM:director'],
//   },
//   {
//     nome_socio: 'CAIO MORALES DEPRA',
//     tipo: 'persona',
//     id_socio: '***932452**',
//     id_socio_carbono: 'BR0500PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0025EM:director'],
//   },
//   {
//     nome_socio: 'JOAO BOSCO GABRIEL',
//     tipo: 'persona',
//     id_socio: '***620187**',
//     id_socio_carbono: 'BR0339PER',
//     relacao_com_empresa: 'Presidente',
//     id_rol: 'presidente',
//     relacion_empresas_rol: ['BR0025EM:presidente'],
//   },
//   {
//     nome_socio: 'FAUSTO SCAPINI',
//     tipo: 'persona',
//     id_socio: '***285639**',
//     id_socio_carbono: 'BR0195PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0026EM:socio'],
//   },
//   {
//     nome_socio: 'FABIO ROBERTO NIEDERMEIER',
//     tipo: 'persona',
//     id_socio: '***104560**',
//     id_socio_carbono: 'BR0102PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0026EM:socio_adm', 'BR0009EM:socio_adm'],
//   },
//   {
//     nome_socio: 'ARTHUR JUNQUEIRA FERREIRA PENTEADO',
//     tipo: 'persona',
//     id_socio: '***150158**',
//     id_socio_carbono: 'BR0120PER',
//     relacao_com_empresa: 'Produtor Rural',
//     id_rol: 'produtor_rural',
//     relacion_empresas_rol: ['BR0028EM:produtor_rural'],
//   },
//   {
//     nome_socio: 'FLAVIA CHIAROTTO PENTEADO',
//     tipo: 'persona',
//     id_socio: '***651418**',
//     id_socio_carbono: 'BR0353PER',
//     relacao_com_empresa: 'Produtor Rural',
//     id_rol: 'produtor_rural',
//     relacion_empresas_rol: [
//       'BR0028EM:produtor_rural',
//       'BR0027EM:produtor_rural',
//     ],
//   },
//   {
//     nome_socio: 'GRAZIELLA VICENTE BISQUOLO PENTEADO',
//     tipo: 'persona',
//     id_socio: '***690498**',
//     id_socio_carbono: 'BR0374PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0029EM:socio'],
//   },
//   {
//     nome_socio: 'ARTHUR CHIAROTTO PENTEADO',
//     tipo: 'persona',
//     id_socio: '***456578**',
//     id_socio_carbono: 'BR0268PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: [
//       'BR0029EM:socio_adm',
//       ' BR0028EM:socio_adm',
//       ' BR0027EM:socio_adm',
//     ],
//   },
//   {
//     nome_socio: 'JORGE FRANCISCO HENRIQUES',
//     tipo: 'persona',
//     id_socio: '***806808**',
//     id_socio_carbono: 'BR0432PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0031EM:director', 'BR0044EM:director'],
//   },
//   {
//     nome_socio: 'SERGIO ANTONIO GARCIA AMOROSO',
//     tipo: 'persona',
//     id_socio: '***086608**',
//     id_socio_carbono: 'BR0097PER',
//     relacao_com_empresa: 'Presidente',
//     id_rol: 'presidente',
//     relacion_empresas_rol: [
//       'BR0031EM:presidente',
//       'BR0044EM:presidente',
//       'BR0030EM:presidente',
//     ],
//   },
//   {
//     nome_socio: 'BATISTA & CIA LTDA',
//     tipo: 'empresa',
//     id_socio: '2.28398E+13',
//     id_socio_carbono: 'BR0118EM',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0032EM:socio'],
//   },
//   {
//     nome_socio: 'GUILHERME GALVANE BATISTA',
//     tipo: 'persona',
//     id_socio: '***391002**',
//     id_socio_carbono: 'BR0240PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0032EM:socio'],
//   },
//   {
//     nome_socio: 'JUNIOR GALVANE BATISTA',
//     tipo: 'persona',
//     id_socio: '***211559**',
//     id_socio_carbono: 'BR0154PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0032EM:socio_adm'],
//   },
//   {
//     nome_socio: 'JOAO DA CRUZ RODRIGUES',
//     tipo: 'persona',
//     id_socio: '***512723**',
//     id_socio_carbono: 'BR0296PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0033EM:administrador'],
//   },
//   {
//     nome_socio: 'RUDIBERT RUECKERT',
//     tipo: 'persona',
//     id_socio: '***428319**',
//     id_socio_carbono: 'BR0254PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0033EM:administrador'],
//   },
//   {
//     nome_socio: 'PRECIOUS WOODS HOLDING LTD.',
//     tipo: 'empresa',
//     id_socio: '5.56985E+12',
//     id_socio_carbono: 'XX0007EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0033EM:socio'],
//   },
//   {
//     nome_socio: 'BRENO PINTO FIGUEIREDO',
//     tipo: 'persona',
//     id_socio: '***316027**',
//     id_socio_carbono: 'BR0210PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0034EM:administrador'],
//   },
//   {
//     nome_socio: 'JULIANA DIAS FIGUEIREDO',
//     tipo: 'persona',
//     id_socio: '***150267**',
//     id_socio_carbono: 'BR0122PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0034EM:administrador'],
//   },
//   {
//     nome_socio: 'MARCO ANTONIO FUJIHARA',
//     tipo: 'persona',
//     id_socio: '***916318**',
//     id_socio_carbono: 'BR0488PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0034EM:administrador'],
//   },
//   {
//     nome_socio: 'MARIANA NAOUM MENDONCA COROA',
//     tipo: 'persona',
//     id_socio: '***654587**',
//     id_socio_carbono: 'BR0355PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0034EM:administrador'],
//   },
//   {
//     nome_socio: 'VICTOR NAOUM MENDONCA COROA',
//     tipo: 'persona',
//     id_socio: '***655237**',
//     id_socio_carbono: 'BR0356PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0034EM:administrador'],
//   },
//   {
//     nome_socio: 'IVISIX VENTURES, CONSULTORIA, PROJETOS E PARTICIPACOES LTDA',
//     tipo: 'empresa',
//     id_socio: '1.8546E+13',
//     id_socio_carbono: 'XX0027EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0034EM:socio'],
//   },
//   {
//     nome_socio: 'MN CONSULTORIA E PARTICIPACOES LTDA',
//     tipo: 'empresa',
//     id_socio: '4.88904E+13',
//     id_socio_carbono: 'XX0051EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0034EM:socio'],
//   },
//   {
//     nome_socio: 'NAOUM AMBIENTAL LTDA',
//     tipo: 'empresa',
//     id_socio: '4.411E+13',
//     id_socio_carbono: 'XX0047EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0034EM:socio'],
//   },
//   {
//     nome_socio: 'RADCE CONSULTORIA E PARTICIPACOES LTDA',
//     tipo: 'empresa',
//     id_socio: '2.42714E+13',
//     id_socio_carbono: 'XX0034EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0034EM:socio'],
//   },
//   {
//     nome_socio: 'CARLOS ROBERTO CANABARRO GOMES',
//     tipo: 'persona',
//     id_socio: '***553600**',
//     id_socio_carbono: 'BR0315PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0035EM:director'],
//   },
//   {
//     nome_socio: 'RICARDO LUIZ LUDKE',
//     tipo: 'persona',
//     id_socio: '***479461**',
//     id_socio_carbono: 'BR0281PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0035EM:director'],
//   },
//   {
//     nome_socio: 'GIUSEPPE PINELLI',
//     tipo: 'persona',
//     id_socio: '***594661**',
//     id_socio_carbono: 'BR0327PER',
//     relacao_com_empresa: 'Presidente',
//     id_rol: 'presidente',
//     relacion_empresas_rol: ['BR0035EM:presidente'],
//   },
//   {
//     nome_socio: 'JOSE AUGUSTO DE SOUSA JUNIOR',
//     tipo: 'persona',
//     id_socio: '***261198**',
//     id_socio_carbono: 'BR0183PER',
//     relacao_com_empresa: 'Conselheiro de Administração',
//     id_rol: 'consejo_adm',
//     relacion_empresas_rol: ['BR0036EM:consejo_admBR0038EM:consejo_adm'],
//   },
//   {
//     nome_socio: 'ERLON SILVA HONORATO',
//     tipo: 'persona',
//     id_socio: '***866508**',
//     id_socio_carbono: 'BR0461PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0036EM:socio'],
//   },
//   {
//     nome_socio: 'JEFFERSON LUIZ MATIOLI',
//     tipo: 'persona',
//     id_socio: '***390338**',
//     id_socio_carbono: 'BR0238PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0036EM:socio'],
//   },
//   {
//     nome_socio: 'RICARDO METZNER GOMES',
//     tipo: 'persona',
//     id_socio: '***859658**',
//     id_socio_carbono: 'BR0455PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0036EM:socio'],
//   },
//   {
//     nome_socio: 'ANDREZA KELLY DELBON DE SOUSA',
//     tipo: 'persona',
//     id_socio: '***788628**',
//     id_socio_carbono: 'BR0418PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0036EM:socio_adm'],
//   },
//   {
//     nome_socio: 'EDISON TICLE DE ANDRADE MELO E SOUZA FILHO',
//     tipo: 'persona',
//     id_socio: '***300688**',
//     id_socio_carbono: 'BR0202PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0037EM:administrador'],
//   },
//   {
//     nome_socio: 'FERNANDO GALLETTI DE QUEIROZ',
//     tipo: 'persona',
//     id_socio: '***418418**',
//     id_socio_carbono: 'BR0249PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0037EM:administrador'],
//   },
//   {
//     nome_socio: 'JOAO DE ALMEIDA SAMPAIO FILHO',
//     tipo: 'persona',
//     id_socio: '***526218**',
//     id_socio_carbono: 'BR0303PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0037EM:administrador'],
//   },
//   {
//     nome_socio: 'NATHAN DE MELLO FORTUNATO FREIRE',
//     tipo: 'persona',
//     id_socio: '***421118**',
//     id_socio_carbono: 'BR0252PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0037EM:administrador'],
//   },
//   {
//     nome_socio: 'MINERVA DAWN FARMS INDUSTRIA E COMERCIO DE PROTEINAS S/A',
//     tipo: 'empresa',
//     id_socio: '9.10418E+12',
//     id_socio_carbono: 'XX0014EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0037EM:socio'],
//   },
//   {
//     nome_socio: 'MINERVA S.A.',
//     tipo: 'empresa',
//     id_socio: '6.76204E+13',
//     id_socio_carbono: 'XX0054EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0037EM:socio'],
//   },
//   {
//     nome_socio: 'FERNANDO FERREIRA MEIRELLES',
//     tipo: 'persona',
//     id_socio: '***890178**',
//     id_socio_carbono: 'BR0475PER',
//     relacao_com_empresa: 'Conselheiro de Administração',
//     id_rol: 'consejo_adm',
//     relacion_empresas_rol: ['BR0038EM:consejo_adm'],
//   },
//   {
//     nome_socio: 'LUIZ HENRIQUE GREIN MONIZ DE ARAGAO',
//     tipo: 'persona',
//     id_socio: '***379229**',
//     id_socio_carbono: 'BR0233PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0038EM:director'],
//   },
//   {
//     nome_socio: 'NICOLAS GUTIERREZ LONDONO',
//     tipo: 'persona',
//     id_socio: '***246717**',
//     id_socio_carbono: 'BR0172PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0038EM:director'],
//   },
//   {
//     nome_socio: 'RODRIGO BRANDAO DE ALMEIDA',
//     tipo: 'persona',
//     id_socio: '***671237**',
//     id_socio_carbono: 'BR0366PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0038EM:director'],
//   },
//   {
//     nome_socio: 'GUILHERME ROSSETTO NUNES DE OLIVEIRA',
//     tipo: 'persona',
//     id_socio: '***141088**',
//     id_socio_carbono: 'BR0115PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0039EM:administrador'],
//   },
//   {
//     nome_socio: 'LIRDES S.A.',
//     tipo: 'empresa',
//     id_socio: '4.00542E+13',
//     id_socio_carbono: 'XX0044EM2',
//     relacao_com_empresa: 'Sócio Pessoa Jurídica Domiciliado no Exterior',
//     id_rol: 'socio_pj_dom_ex',
//     relacion_empresas_rol: ['BR0039EM:socio_pj_dom_ex'],
//   },
//   {
//     nome_socio: 'ERNANDO PEREIRA DA SILVA',
//     tipo: 'persona',
//     id_socio: '***794918**',
//     id_socio_carbono: 'BR0421PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0040EM:socio'],
//   },
//   {
//     nome_socio: 'JEFFERSON RUBENS FERREIRA',
//     tipo: 'persona',
//     id_socio: '***859788**',
//     id_socio_carbono: 'BR0456PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0040EM:socio'],
//   },
//   {
//     nome_socio: 'JOSE CARLOS KALIL',
//     tipo: 'persona',
//     id_socio: '***504478**',
//     id_socio_carbono: 'BR0289PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0040EM:socio'],
//   },
//   {
//     nome_socio: 'UBIRACI BENUTE JAIME',
//     tipo: 'persona',
//     id_socio: '***651398**',
//     id_socio_carbono: 'BR0352PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0040EM:socio_adm'],
//   },
//   {
//     nome_socio: 'CRASSO PAULO BOSCO BREVIGLIERI',
//     tipo: 'persona',
//     id_socio: '***511618**',
//     id_socio_carbono: 'BR0295PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0041EM:socio_adm'],
//   },
//   {
//     nome_socio: 'MARIANO COLINI CENAMO',
//     tipo: 'persona',
//     id_socio: '***318518**',
//     id_socio_carbono: 'BR0211PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0042EM:socio'],
//   },
//   {
//     nome_socio: 'JONATAS MACHADO IBERNON',
//     tipo: 'persona',
//     id_socio: '***143122**',
//     id_socio_carbono: 'BR0116PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0042EM:socio_adm'],
//   },
//   {
//     nome_socio: 'PAOLA PACHECO BLEICKER',
//     tipo: 'persona',
//     id_socio: '***769900**',
//     id_socio_carbono: 'BR0410PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0043EM:administrador'],
//   },
//   {
//     nome_socio: 'NELITON MARQUES DA SILVA',
//     tipo: 'persona',
//     id_socio: '***830862**',
//     id_socio_carbono: 'BR0443PER',
//     relacao_com_empresa: 'Presidente',
//     id_rol: 'presidente',
//     relacion_empresas_rol: ['BR0043EM:presidente'],
//   },
//   {
//     nome_socio: 'AMINTAS DE OLIVEIRA BRANDAO JUNIOR',
//     tipo: 'persona',
//     id_socio: '***647222**',
//     id_socio_carbono: 'BR0350PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0045EM:socio_adm'],
//   },
//   {
//     nome_socio: 'MARY LUCY DA COSTA SANTANA',
//     tipo: 'persona',
//     id_socio: '***290448**',
//     id_socio_carbono: 'BR0197PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0047EM:socio'],
//   },
//   {
//     nome_socio: 'NICIA DE ALMEIDA COUTINHO',
//     tipo: 'persona',
//     id_socio: '***607842**',
//     id_socio_carbono: 'BR0336PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0047EM:socio_adm'],
//   },
//   {
//     nome_socio: 'ARLEI RODRIGUES FONTOURA',
//     tipo: 'persona',
//     id_socio: '***997180**',
//     id_socio_carbono: 'BR0533PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0048EM:administrador'],
//   },
//   {
//     nome_socio: 'BERNARD GUSTAVE PIERRE CASSAGNE',
//     tipo: 'persona',
//     id_socio: '***543362**',
//     id_socio_carbono: 'BR0311PER',
//     relacao_com_empresa: 'Sócio Pessoa Física Residente no Exterior',
//     id_rol: 'socio_pf_res_ex',
//     relacion_empresas_rol: ['BR0048EM:socio_pf_res_ex'],
//   },
//   {
//     nome_socio: 'JEAN FRANCOIS PAUL FERNAND CHEVALIER',
//     tipo: 'persona',
//     id_socio: '***543102**',
//     id_socio_carbono: 'BR0308PER',
//     relacao_com_empresa: 'Sócio Pessoa Física Residente no Exterior',
//     id_rol: 'socio_pf_res_ex',
//     relacion_empresas_rol: ['BR0048EM:socio_pf_res_ex'],
//   },
//   {
//     nome_socio: 'NICOLAS PIERRE BAYOL',
//     tipo: 'persona',
//     id_socio: '***543282**',
//     id_socio_carbono: 'BR0310PER',
//     relacao_com_empresa: 'Sócio Pessoa Física Residente no Exterior',
//     id_rol: 'socio_pf_res_ex',
//     relacion_empresas_rol: ['BR0048EM:socio_pf_res_ex'],
//   },
//   {
//     nome_socio: 'FORET RESSOURCES MANAGEMENT',
//     tipo: 'empresa',
//     id_socio: '9.31217E+12',
//     id_socio_carbono: 'XX0016EM2',
//     relacao_com_empresa: 'Sócio Pessoa Jurídica Domiciliado no Exterior',
//     id_rol: 'socio_pj_dom_ex',
//     relacion_empresas_rol: ['BR0048EM:socio_pj_dom_ex'],
//   },
//   {
//     nome_socio: 'JOSE SALVADOR DA SILVA FILHO',
//     tipo: 'persona',
//     id_socio: '***608528**',
//     id_socio_carbono: 'BR0337PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0049EM:administrador'],
//   },
//   {
//     nome_socio: 'NATAL FERREIRA VASCONCELOS',
//     tipo: 'persona',
//     id_socio: '***680196**',
//     id_socio_carbono: 'BR0370PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0049EM:administrador'],
//   },
//   {
//     nome_socio: 'RINA INTERNATIONAL BV',
//     tipo: 'empresa',
//     id_socio: '1.1391E+13',
//     id_socio_carbono: 'XX0022EM2',
//     relacao_com_empresa: 'Sócio Pessoa Jurídica Domiciliado no Exterior',
//     id_rol: 'socio_pj_dom_ex',
//     relacion_empresas_rol: ['BR0049EM:socio_pj_dom_ex'],
//   },
//   {
//     nome_socio: 'RINA SERVICES S.P.A.',
//     tipo: 'empresa',
//     id_socio: '9.24323E+12',
//     id_socio_carbono: 'XX0015EM2',
//     relacao_com_empresa: 'Sócio Pessoa Jurídica Domiciliado no Exterior',
//     id_rol: 'socio_pj_dom_ex',
//     relacion_empresas_rol: ['BR0049EM:socio_pj_dom_ex'],
//   },
//   {
//     nome_socio: 'BRAZIL AGFOR, LLC',
//     tipo: 'empresa',
//     id_socio: '2.53147E+13',
//     id_socio_carbono: 'XX0056EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0050EM:socio'],
//   },
//   {
//     nome_socio: 'MICHAEL EDWARD GREENE',
//     tipo: 'persona',
//     id_socio: '***159561**',
//     id_socio_carbono: 'BR0125PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0050EM:socio_adm', 'BR0113EM:socio_adm'],
//   },
//   {
//     nome_socio: 'ANELIZE LENZI RUAS DE ALMEIDA',
//     tipo: 'persona',
//     id_socio: '***195641**',
//     id_socio_carbono: 'BR0140PER',
//     relacao_com_empresa: 'Conselheiro de Administração',
//     id_rol: 'consejo_adm',
//     relacion_empresas_rol: ['BR0051EM:consejo_adm'],
//   },
//   {
//     nome_socio: 'DARIO CARNEVALLI DURIGAN',
//     tipo: 'persona',
//     id_socio: '***672408**',
//     id_socio_carbono: 'BR0367PER',
//     relacao_com_empresa: 'Conselheiro de Administração',
//     id_rol: 'consejo_adm',
//     relacion_empresas_rol: ['BR0051EM:consejo_adm'],
//   },
//   {
//     nome_socio: 'ELISA VIEIRA LEONEL',
//     tipo: 'persona',
//     id_socio: '***460676**',
//     id_socio_carbono: 'BR0273PER',
//     relacao_com_empresa: 'Conselheiro de Administração',
//     id_rol: 'consejo_adm',
//     relacion_empresas_rol: ['BR0051EM:consejo_adm'],
//   },
//   {
//     nome_socio: 'GABRIEL MURICCA GALIPOLO',
//     tipo: 'persona',
//     id_socio: '***827438**',
//     id_socio_carbono: 'BR0440PER',
//     relacao_com_empresa: 'Conselheiro de Administração',
//     id_rol: 'consejo_adm',
//     relacion_empresas_rol: ['BR0051EM:consejo_adm'],
//   },
//   {
//     nome_socio: 'KELLY TATIANE MARTINS QUIRINO',
//     tipo: 'persona',
//     id_socio: '***783438**',
//     id_socio_carbono: 'BR0415PER',
//     relacao_com_empresa: 'Conselheiro de Administração',
//     id_rol: 'consejo_adm',
//     relacion_empresas_rol: ['BR0051EM:consejo_adm'],
//   },
//   {
//     nome_socio: 'MARCELO GASPARINO DA SILVA',
//     tipo: 'persona',
//     id_socio: '***383469**',
//     id_socio_carbono: 'BR0235PER',
//     relacao_com_empresa: 'Conselheiro de Administração',
//     id_rol: 'consejo_adm',
//     relacion_empresas_rol: ['BR0051EM:consejo_adm'],
//   },
//   {
//     nome_socio: 'PAULO ROBERTO SIMAO BIJOS',
//     tipo: 'persona',
//     id_socio: '***914748**',
//     id_socio_carbono: 'BR0487PER',
//     relacao_com_empresa: 'Conselheiro de Administração',
//     id_rol: 'consejo_adm',
//     relacion_empresas_rol: ['BR0051EM:consejo_adm'],
//   },
//   {
//     nome_socio: 'ROBERT JUENEMANN',
//     tipo: 'persona',
//     id_socio: '***077100**',
//     id_socio_carbono: 'BR0094PER',
//     relacao_com_empresa: 'Conselheiro de Administração',
//     id_rol: 'consejo_adm',
//     relacion_empresas_rol: ['BR0051EM:consejo_adm'],
//   },
//   {
//     nome_socio: 'ALAN CARLOS GUEDES DE OLIVEIRA',
//     tipo: 'persona',
//     id_socio: '***550179**',
//     id_socio_carbono: 'BR0313PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0051EM:director'],
//   },
//   {
//     nome_socio: 'ALBERTO MARTINHAGO VIEIRA',
//     tipo: 'persona',
//     id_socio: '***842999**',
//     id_socio_carbono: 'BR0449PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0051EM:director'],
//   },
//   {
//     nome_socio: 'ANA CRISTINA ROSA GARCIA',
//     tipo: 'persona',
//     id_socio: '***443671**',
//     id_socio_carbono: 'BR0263PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0051EM:director'],
//   },
//   {
//     nome_socio: 'ANTONIO CARLOS WAGNER CHIARELLO',
//     tipo: 'persona',
//     id_socio: '***263100**',
//     id_socio_carbono: 'BR0184PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0051EM:director'],
//   },
//   {
//     nome_socio: 'CARLA NESI',
//     tipo: 'persona',
//     id_socio: '***295868**',
//     id_socio_carbono: 'BR0200PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0051EM:director'],
//   },
//   {
//     nome_socio: 'CARLOS EDUARDO GUEDES PINTO',
//     tipo: 'persona',
//     id_socio: '***464088**',
//     id_socio_carbono: 'BR0275PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0051EM:director'],
//   },
//   {
//     nome_socio: 'EDUARDO CESAR PASA',
//     tipo: 'persona',
//     id_socio: '***035920**',
//     id_socio_carbono: 'BR0066PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0051EM:director'],
//   },
//   {
//     nome_socio: 'EULER ANTONIO LUZ MATHIAS',
//     tipo: 'persona',
//     id_socio: '***344088**',
//     id_socio_carbono: 'BR0220PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0051EM:director'],
//   },
//   {
//     nome_socio: 'EVERTON LUIS KAPFENBERGER',
//     tipo: 'persona',
//     id_socio: '***224319**',
//     id_socio_carbono: 'BR0160PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0051EM:director'],
//   },
//   {
//     nome_socio: 'FELIPE GUIMARAES GEISSLER PRINCE',
//     tipo: 'persona',
//     id_socio: '***345856**',
//     id_socio_carbono: 'BR0221PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0051EM:director'],
//   },
//   {
//     nome_socio: 'FRANCISCO AUGUSTO LASSALVIA',
//     tipo: 'persona',
//     id_socio: '***355918**',
//     id_socio_carbono: 'BR0226PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0051EM:director'],
//   },
//   {
//     nome_socio: 'JOAO FRANCISCO FRUET JUNIOR',
//     tipo: 'persona',
//     id_socio: '***344060**',
//     id_socio_carbono: 'BR0219PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0051EM:director'],
//   },
//   {
//     nome_socio: 'JOAO VAGNES DE MOURA SILVA',
//     tipo: 'persona',
//     id_socio: '***043411**',
//     id_socio_carbono: 'BR0069PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0051EM:director'],
//   },
//   {
//     nome_socio: 'JOSE RICARDO SASSERON',
//     tipo: 'persona',
//     id_socio: '***404558**',
//     id_socio_carbono: 'BR0242PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0051EM:director'],
//   },
//   {
//     nome_socio: 'JULIO CESAR VEZZARO',
//     tipo: 'persona',
//     id_socio: '***058029**',
//     id_socio_carbono: 'BR0080PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0051EM:director'],
//   },
//   {
//     nome_socio: 'KAMILLO TONONI OLIVEIRA SILVA',
//     tipo: 'persona',
//     id_socio: '***027514**',
//     id_socio_carbono: 'BR0060PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0051EM:director'],
//   },
//   {
//     nome_socio: 'LARISSA DA SILVA NOVAIS VIEIRA',
//     tipo: 'persona',
//     id_socio: '***038787**',
//     id_socio_carbono: 'BR0067PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0051EM:director'],
//   },
//   {
//     nome_socio: 'LUCIANO MATARAZZO REGNO',
//     tipo: 'persona',
//     id_socio: '***210718**',
//     id_socio_carbono: 'BR0152PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0051EM:director'],
//   },
//   {
//     nome_socio: 'LUCINEIA POSSAR',
//     tipo: 'persona',
//     id_socio: '***309199**',
//     id_socio_carbono: 'BR0206PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0051EM:director'],
//   },
//   {
//     nome_socio: 'LUIZ GUSTAVO BRAZ LAGE',
//     tipo: 'persona',
//     id_socio: '***132426**',
//     id_socio_carbono: 'BR0109PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0051EM:director'],
//   },
//   {
//     nome_socio: 'MARCO GEOVANNE TOBIAS DA SILVA',
//     tipo: 'persona',
//     id_socio: '***225791**',
//     id_socio_carbono: 'BR0161PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0051EM:director'],
//   },
//   {
//     nome_socio: 'MARIANA PIRES DIAS',
//     tipo: 'persona',
//     id_socio: '***147908**',
//     id_socio_carbono: 'BR0118PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0051EM:director'],
//   },
//   {
//     nome_socio: 'MARISA REGHINI FERREIRA MATTOS',
//     tipo: 'persona',
//     id_socio: '***301948**',
//     id_socio_carbono: 'BR0203PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0051EM:director'],
//   },
//   {
//     nome_socio: 'NEUDSON PERES DE FREITAS',
//     tipo: 'persona',
//     id_socio: '***631536**',
//     id_socio_carbono: 'BR0344PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0051EM:director'],
//   },
//   {
//     nome_socio: 'PAULA SAYAO CARVALHO ARAUJO',
//     tipo: 'persona',
//     id_socio: '***989951**',
//     id_socio_carbono: 'BR0531PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0051EM:director'],
//   },
//   {
//     nome_socio: 'PEDRO BRAMONT',
//     tipo: 'persona',
//     id_socio: '***472469**',
//     id_socio_carbono: 'BR0279PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0051EM:director'],
//   },
//   {
//     nome_socio: 'RAFAEL MACHADO GIOVANELLA',
//     tipo: 'persona',
//     id_socio: '***211719**',
//     id_socio_carbono: 'BR0155PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0051EM:director'],
//   },
//   {
//     nome_socio: 'RODRIGO COSTA VASCONCELOS',
//     tipo: 'persona',
//     id_socio: '***561061**',
//     id_socio_carbono: 'BR0316PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0051EM:director'],
//   },
//   {
//     nome_socio: 'RODRIGO MULINARI',
//     tipo: 'persona',
//     id_socio: '***599070**',
//     id_socio_carbono: 'BR0329PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0051EM:director'],
//   },
//   {
//     nome_socio: 'ROSIANE BARBOSA LAVIOLA',
//     tipo: 'persona',
//     id_socio: '***181471**',
//     id_socio_carbono: 'BR0135PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0051EM:director'],
//   },
//   {
//     nome_socio: 'THIAGO AFFONSO BORSARI',
//     tipo: 'persona',
//     id_socio: '***759718**',
//     id_socio_carbono: 'BR0408PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0051EM:director'],
//   },
//   {
//     nome_socio: 'TARCIANA PAULA GOMES MEDEIROS',
//     tipo: 'persona',
//     id_socio: '***128734**',
//     id_socio_carbono: 'BR0108PER',
//     relacao_com_empresa: 'Presidente',
//     id_rol: 'presidente',
//     relacion_empresas_rol: ['BR0051EM:presidente'],
//   },
//   {
//     nome_socio: 'FABIO GALINDO SILVESTRE',
//     tipo: 'persona',
//     id_socio: '***417038**',
//     id_socio_carbono: 'BR0248PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0052EM:director'],
//   },
//   {
//     nome_socio: 'MARCIO ARTIN ARAKELIAN',
//     tipo: 'persona',
//     id_socio: '***883488**',
//     id_socio_carbono: 'BR0471PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0052EM:director', 'BR0085EM:director'],
//   },
//   {
//     nome_socio: 'BERNARDO PARNES',
//     tipo: 'persona',
//     id_socio: '***102448**',
//     id_socio_carbono: 'BR0101PER',
//     relacao_com_empresa: 'Conselheiro de Administração',
//     id_rol: 'consejo_adm',
//     relacion_empresas_rol: ['BR0053EM:consejo_adm'],
//   },
//   {
//     nome_socio: 'JACYR DA SILVA COSTA FILHO',
//     tipo: 'persona',
//     id_socio: '***252758**',
//     id_socio_carbono: 'BR0174PER',
//     relacao_com_empresa: 'Conselheiro de Administração',
//     id_rol: 'consejo_adm',
//     relacion_empresas_rol: ['BR0053EM:consejo_adm'],
//   },
//   {
//     nome_socio: 'JOSE ARIMATEA DE ANGELO CALSAVERINI',
//     tipo: 'persona',
//     id_socio: '***264808**',
//     id_socio_carbono: 'BR0186PER',
//     relacao_com_empresa: 'Conselheiro de Administração',
//     id_rol: 'consejo_adm',
//     relacion_empresas_rol: ['BR0053EM:consejo_adm'],
//   },
//   {
//     nome_socio: 'JOSE ROBERTO MENDONCA DE BARROS',
//     tipo: 'persona',
//     id_socio: '***761408**',
//     id_socio_carbono: 'BR0409PER',
//     relacao_com_empresa: 'Conselheiro de Administração',
//     id_rol: 'consejo_adm',
//     relacion_empresas_rol: ['BR0053EM:consejo_adm'],
//   },
//   {
//     nome_socio: 'MARCELO RESCHINI ABUD',
//     tipo: 'persona',
//     id_socio: '***694888**',
//     id_socio_carbono: 'BR0376PER',
//     relacao_com_empresa: 'Conselheiro de Administração',
//     id_rol: 'consejo_adm',
//     relacion_empresas_rol: ['BR0053EM:consejo_adm'],
//   },
//   {
//     nome_socio: 'PAULO PIRATINY ABBOTT CALDEIRA',
//     tipo: 'persona',
//     id_socio: '***795780**',
//     id_socio_carbono: 'BR0423PER',
//     relacao_com_empresa: 'Conselheiro de Administração',
//     id_rol: 'consejo_adm',
//     relacion_empresas_rol: ['BR0053EM:consejo_adm'],
//   },
//   {
//     nome_socio: 'SERGIO SPINELLI SILVA JUNIOR',
//     tipo: 'persona',
//     id_socio: '***888088**',
//     id_socio_carbono: 'BR0472PER',
//     relacao_com_empresa: 'Conselheiro de Administração',
//     id_rol: 'consejo_adm',
//     relacion_empresas_rol: ['BR0053EM:consejo_adm'],
//   },
//   {
//     nome_socio: 'VITOR MONTENEGRO WANDERLEY JUNIOR',
//     tipo: 'persona',
//     id_socio: '***955054**',
//     id_socio_carbono: 'BR0517PER',
//     relacao_com_empresa: 'Conselheiro de Administração',
//     id_rol: 'consejo_adm',
//     relacion_empresas_rol: ['BR0053EM:consejo_adm'],
//   },
//   {
//     nome_socio: 'ANDERSON ANGELO DE SOUZA',
//     tipo: 'persona',
//     id_socio: '***177605**',
//     id_socio_carbono: 'BR0133PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0053EM:director'],
//   },
//   {
//     nome_socio: 'JARI DE SOUZA',
//     tipo: 'persona',
//     id_socio: '***167991**',
//     id_socio_carbono: 'BR0129PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0053EM:director'],
//   },
//   {
//     nome_socio: 'MARCO AURELIO MENDONCA SERAPHIM',
//     tipo: 'persona',
//     id_socio: '***242506**',
//     id_socio_carbono: 'BR0167PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0053EM:director'],
//   },
//   {
//     nome_socio: 'PAULO CESAR LEITE',
//     tipo: 'persona',
//     id_socio: '***827888**',
//     id_socio_carbono: 'BR0441PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0053EM:director'],
//   },
//   {
//     nome_socio: 'RODRIGO RIBEIRO GONCALVES',
//     tipo: 'persona',
//     id_socio: '***871628**',
//     id_socio_carbono: 'BR0465PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0053EM:director'],
//   },
//   {
//     nome_socio: 'JOSE FERNANDO MAZUCA FILHO',
//     tipo: 'persona',
//     id_socio: '***051488**',
//     id_socio_carbono: 'BR0073PER',
//     relacao_com_empresa: 'Presidente',
//     id_rol: 'presidente',
//     relacion_empresas_rol: ['BR0053EM:presidente'],
//   },
//   {
//     nome_socio: 'MARCELO MUZZI DE QUEIROZ',
//     tipo: 'persona',
//     id_socio: '***209306**',
//     id_socio_carbono: 'BR0150PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0057EM:administrador', 'BR0058EM:administrador'],
//   },
//   {
//     nome_socio: 'ANA BEATRIZ RIBEIRO DE QUEIROZ',
//     tipo: 'persona',
//     id_socio: '***739806**',
//     id_socio_carbono: 'BR0399PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0057EM:socio', ' BR0058EM:socio'],
//   },
//   {
//     nome_socio: 'CAIO MARIO CALDEIRA BRANT RIBEIRO',
//     tipo: 'persona',
//     id_socio: '***735306**',
//     id_socio_carbono: 'BR0398PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0057EM:socio', ' BR0058EM:socio'],
//   },
//   {
//     nome_socio: 'FLAVIA CALDEIRA BRANT RIBEIRO DE FIGUEIREDO',
//     tipo: 'persona',
//     id_socio: '***245466**',
//     id_socio_carbono: 'BR0169PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0057EM:socio'],
//   },
//   {
//     nome_socio: 'HELENA CALDEIRA BRANT RIBEIRO',
//     tipo: 'persona',
//     id_socio: '***739996**',
//     id_socio_carbono: 'BR0400PER',
//     relacao_com_empresa: 'Conselheiro de Administração',
//     id_rol: 'consejo_adm',
//     relacion_empresas_rol: ['BR0058EM:consejo_adm'],
//   },
//   {
//     nome_socio: 'MARIO ALVES RIBEIRO',
//     tipo: 'persona',
//     id_socio: '***411456**',
//     id_socio_carbono: 'BR0245PER',
//     relacao_com_empresa: 'Presidente',
//     id_rol: 'presidente',
//     relacion_empresas_rol: ['BR0058EM:presidente'],
//   },
//   {
//     nome_socio: 'FERNANDO MONTANARI',
//     tipo: 'persona',
//     id_socio: '***231909**',
//     id_socio_carbono: 'BR0164PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0059EM:socio_adm'],
//   },
//   {
//     nome_socio: 'MARCELO DE CASTRO CHAVES STABILE',
//     tipo: 'persona',
//     id_socio: '***210858**',
//     id_socio_carbono: 'BR0153PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0059EM:socio_adm'],
//   },
//   {
//     nome_socio: 'MARIA CECILIA FIORDOLIVA FERRONATO',
//     tipo: 'persona',
//     id_socio: '***928328**',
//     id_socio_carbono: 'BR0496PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0059EM:socio_adm'],
//   },
//   {
//     nome_socio: 'YURI RUGAI MARINHO',
//     tipo: 'persona',
//     id_socio: '***980998**',
//     id_socio_carbono: 'BR0527PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0059EM:socio_adm'],
//   },
//   {
//     nome_socio: 'CELIA REGINA DANCIERI MARTINELLI',
//     tipo: 'persona',
//     id_socio: '***620648**',
//     id_socio_carbono: 'BR0340PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0060EM:socio'],
//   },
//   {
//     nome_socio: 'DANIELA DE CAMPOS DANSIERI E ALMEIDA PRADO',
//     tipo: 'persona',
//     id_socio: '***064708**',
//     id_socio_carbono: 'BR0086PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0060EM:socio'],
//   },
//   {
//     nome_socio: 'FATIMA PERFEITO CAMPOS DANSIERI',
//     tipo: 'persona',
//     id_socio: '***437858**',
//     id_socio_carbono: 'BR0259PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0060EM:socio'],
//   },
//   {
//     nome_socio: 'ISABEL CRISTINA DANCIERI SILVEIRA',
//     tipo: 'persona',
//     id_socio: '***078958**',
//     id_socio_carbono: 'BR0095PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0060EM:socio'],
//   },
//   {
//     nome_socio: 'MARIA SANTINA DANSIERI',
//     tipo: 'persona',
//     id_socio: '***412308**',
//     id_socio_carbono: 'BR0246PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0060EM:socio'],
//   },
//   {
//     nome_socio: 'LUIZ CARLOS DANSIERI',
//     tipo: 'persona',
//     id_socio: '***455318**',
//     id_socio_carbono: 'BR0267PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0060EM:socio_adm'],
//   },
//   {
//     nome_socio: 'PAULO CESAR DANCIERI',
//     tipo: 'persona',
//     id_socio: '***469618**',
//     id_socio_carbono: 'BR0278PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0060EM:socio_adm'],
//   },
//   {
//     nome_socio: 'ADRIANO SARACENI BANDEIRA',
//     tipo: 'persona',
//     id_socio: '***487208**',
//     id_socio_carbono: 'BR0283PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0061EM:administrador'],
//   },
//   {
//     nome_socio: 'LUIZ APARECIDO CARUSO NETO',
//     tipo: 'persona',
//     id_socio: '***667778**',
//     id_socio_carbono: 'BR0363PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0061EM:administrador'],
//   },
//   {
//     nome_socio: 'MAURO RIBEIRO NETO',
//     tipo: 'persona',
//     id_socio: '***002066**',
//     id_socio_carbono: 'BR0045PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0061EM:administrador'],
//   },
//   {
//     nome_socio: 'SERGIO AUGUSTO MALACRIDA JUNIOR',
//     tipo: 'persona',
//     id_socio: '***532868**',
//     id_socio_carbono: 'BR0305PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0061EM:administrador'],
//   },
//   {
//     nome_socio: 'VOTORANTIM S.A.',
//     tipo: 'empresa',
//     id_socio: '3.40705E+12',
//     id_socio_carbono: 'XX0004EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0061EM:socio'],
//   },
//   {
//     nome_socio: 'VP GESTAO LTDA.',
//     tipo: 'empresa',
//     id_socio: '2.65473E+13',
//     id_socio_carbono: 'XX0035EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0061EM:socio'],
//   },
//   {
//     nome_socio: 'KLAUS DUARTE BARRETTO',
//     tipo: 'persona',
//     id_socio: '***601978**',
//     id_socio_carbono: 'BR0331PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0061EM:socio_adm', 'BR0046EM:socio_adm'],
//   },
//   {
//     nome_socio: 'MONICA CRISTINA CABELLO DE BRITO',
//     tipo: 'persona',
//     id_socio: '***877464**',
//     id_socio_carbono: 'BR0466PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0061EM:socio_adm', 'BR0046EM:socio_adm'],
//   },
//   {
//     nome_socio: 'CARLOS SERGIO THOMAZI',
//     tipo: 'persona',
//     id_socio: '***535769**',
//     id_socio_carbono: 'BR0306PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0062EM:administrador'],
//   },
//   {
//     nome_socio: 'JAIR ROVER',
//     tipo: 'persona',
//     id_socio: '***921912**',
//     id_socio_carbono: 'BR0492PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0062EM:administrador'],
//   },
//   {
//     nome_socio: 'JORGE LUIS URIARTE',
//     tipo: 'persona',
//     id_socio: '***056260**',
//     id_socio_carbono: 'BR0077PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0062EM:administrador'],
//   },
//   {
//     nome_socio: 'JUCELINO ANTONIO SALLA',
//     tipo: 'persona',
//     id_socio: '***902900**',
//     id_socio_carbono: 'BR0480PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0062EM:administrador'],
//   },
//   {
//     nome_socio: 'CJC PARTICIPACOES LTDA',
//     tipo: 'empresa',
//     id_socio: '5.04865E+13',
//     id_socio_carbono: 'XX0053EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0062EM:socio'],
//   },
//   {
//     nome_socio: 'DN PARTICIPACOES LTDA',
//     tipo: 'empresa',
//     id_socio: '1.74166E+13',
//     id_socio_carbono: 'XX0026EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0062EM:socio'],
//   },
//   {
//     nome_socio: 'EJV PARTICIPACAO SOCIETARIA LTDA',
//     tipo: 'empresa',
//     id_socio: '3.41003E+13',
//     id_socio_carbono: 'XX0040EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0062EM:socio'],
//   },
//   {
//     nome_socio: 'JJ ADMINISTRADORA DE BENS LTDA',
//     tipo: 'empresa',
//     id_socio: '3.05703E+13',
//     id_socio_carbono: 'XX0038EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0062EM:socio'],
//   },
//   {
//     nome_socio: 'HUMBERTO ANTONIO ROVER',
//     tipo: 'persona',
//     id_socio: '***788449**',
//     id_socio_carbono: 'BR0417PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0062EM:socio_adm'],
//   },
//   {
//     nome_socio: 'JORGE LUIZ PORTO MUNARI',
//     tipo: 'persona',
//     id_socio: '***822859**',
//     id_socio_carbono: 'BR0439PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0062EM:socio_adm'],
//   },
//   {
//     nome_socio: 'SILMAR LAGEMANN',
//     tipo: 'persona',
//     id_socio: '***591460**',
//     id_socio_carbono: 'BR0325PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0062EM:socio_adm'],
//   },
//   {
//     nome_socio: 'SILVANO D AGNOLUZZO',
//     tipo: 'persona',
//     id_socio: '***196092**',
//     id_socio_carbono: 'BR0142PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: [
//       'BR0063EM:socio',
//       'BR0064EM:socio',
//       'BR0066EM:socio',
//       'BR0065EM:socio',
//     ],
//   },
//   {
//     nome_socio: 'ADRIANO D AGNOLUZZO',
//     tipo: 'persona',
//     id_socio: '***215749**',
//     id_socio_carbono: 'BR0158PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: [
//       'BR0063EM:socio_adm',
//       'BR0064EM:socio_adm',
//       'BR0066EM:socio_adm',
//       'BR0065EM:socio_adm',
//     ],
//   },
//   {
//     nome_socio: 'VITORIO SUFREDINI NETO',
//     tipo: 'persona',
//     id_socio: '***133913**',
//     id_socio_carbono: 'BR0110PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: [
//       'BR0063EM:socio_adm',
//       'BR0064EM:socio_adm',
//       'BR0066EM:socio_adm',
//       'BR0065EM:socio_adm',
//       'BR0065EM:socio_adm',
//     ],
//   },
//   {
//     nome_socio: 'ANDRE NOGUEIRA BORBA',
//     tipo: 'persona',
//     id_socio: '***681646**',
//     id_socio_carbono: 'BR0371PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0067EM:director'],
//   },
//   {
//     nome_socio: 'BENY FITERMAN',
//     tipo: 'persona',
//     id_socio: '***861438**',
//     id_socio_carbono: 'BR0459PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0067EM:director'],
//   },
//   {
//     nome_socio: 'LUIZ HENRIQUE OLIVEIRA MARQUES',
//     tipo: 'persona',
//     id_socio: '***347041**',
//     id_socio_carbono: 'BR0223PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0067EM:director'],
//   },
//   {
//     nome_socio: 'MARCELLA CATARINA NOVAES DE ARAUJO',
//     tipo: 'persona',
//     id_socio: '***350162**',
//     id_socio_carbono: 'BR0224PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0067EM:director'],
//   },
//   {
//     nome_socio: 'MARCOS FRANCISCO DE LA CRUZ COSTA',
//     tipo: 'persona',
//     id_socio: '***390358**',
//     id_socio_carbono: 'BR0239PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0067EM:director'],
//   },
//   {
//     nome_socio: 'TULIO DIAS BRITO',
//     tipo: 'persona',
//     id_socio: '***945538**',
//     id_socio_carbono: 'BR0511PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0067EM:director'],
//   },
//   {
//     nome_socio: 'TIAGO GONCALVES DE OLIVEIRA RICCI',
//     tipo: 'persona',
//     id_socio: '***802751**',
//     id_socio_carbono: 'BR0429PER',
//     relacao_com_empresa: 'Conselheiro de Administração',
//     id_rol: 'consejo_adm',
//     relacion_empresas_rol: ['BR0068EM:consejo_adm', 'BR0069EM:consejo_adm'],
//   },
//   {
//     nome_socio: 'MUNIR YOUNES SOARES',
//     tipo: 'persona',
//     id_socio: '***894178**',
//     id_socio_carbono: 'BR0477PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0068EM:director'],
//   },
//   {
//     nome_socio: 'DANIEL DAYEH ROCHA',
//     tipo: 'persona',
//     id_socio: '***932718**',
//     id_socio_carbono: 'BR0501PER',
//     relacao_com_empresa: 'Sócio sem Capital',
//     id_rol: 'socio_s_capital',
//     relacion_empresas_rol: ['BR0069EM:socio_s_capital'],
//   },
//   {
//     nome_socio: 'FELIPE GOMES DORNELAS ALVARES',
//     tipo: 'persona',
//     id_socio: '***602898**',
//     id_socio_carbono: 'BR0333PER',
//     relacao_com_empresa: 'Sócio sem Capital',
//     id_rol: 'socio_s_capital',
//     relacion_empresas_rol: ['BR0069EM:socio_s_capital'],
//   },
//   {
//     nome_socio: 'KARINE TAVARES DA CRUZ',
//     tipo: 'persona',
//     id_socio: '***028818**',
//     id_socio_carbono: 'BR0061PER',
//     relacao_com_empresa: 'Sócio sem Capital',
//     id_rol: 'socio_s_capital',
//     relacion_empresas_rol: ['BR0069EM:socio_s_capital'],
//   },
//   {
//     nome_socio: 'MATEUS LEMOS FRANCO DA SILVA',
//     tipo: 'persona',
//     id_socio: '***568086**',
//     id_socio_carbono: 'BR0319PER',
//     relacao_com_empresa: 'Sócio sem Capital',
//     id_rol: 'socio_s_capital',
//     relacion_empresas_rol: ['BR0069EM:socio_s_capital'],
//   },
//   {
//     nome_socio: 'SIMONE POLINI DE MARCHI',
//     tipo: 'persona',
//     id_socio: '***820511**',
//     id_socio_carbono: 'BR0437PER',
//     relacao_com_empresa: 'Sócio sem Capital',
//     id_rol: 'socio_s_capital',
//     relacion_empresas_rol: ['BR0069EM:socio_s_capital'],
//   },
//   {
//     nome_socio: 'RODOLPHO OLIVEIRA SANTOS',
//     tipo: 'persona',
//     id_socio: '***909928**',
//     id_socio_carbono: 'BR0485PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0069EM:socio_adm'],
//   },
//   {
//     nome_socio: 'RENAN CUNHA FANTINI',
//     tipo: 'persona',
//     id_socio: '***564918**',
//     id_socio_carbono: 'BR0318PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0070EM:socio'],
//   },
//   {
//     nome_socio: 'FERNANDO FROSINI DE BARROS FERRAZ',
//     tipo: 'persona',
//     id_socio: '***903948**',
//     id_socio_carbono: 'BR0481PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0070EM:socio_adm'],
//   },
//   {
//     nome_socio: 'RAFAEL BEMERGUY SEFER',
//     tipo: 'persona',
//     id_socio: '***017792**',
//     id_socio_carbono: 'BR0052PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0072EM:socio_adm', 'BR0071EM:socio_adm'],
//   },
//   {
//     nome_socio: 'GUANABARA AMBIENTAL LTDA',
//     tipo: 'empresa',
//     id_socio: '4.54249E+13',
//     id_socio_carbono: 'BR0077EM',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0073EM:socio'],
//   },
//   {
//     nome_socio: 'ROMA PARTICIPACOES S/S LTDA',
//     tipo: 'empresa',
//     id_socio: '4.60147E+13',
//     id_socio_carbono: 'XX0048EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0073EM:socio'],
//   },
//   {
//     nome_socio: 'FELIPE RIBEIRO BITTENCOURT',
//     tipo: 'persona',
//     id_socio: '***385576**',
//     id_socio_carbono: 'BR0237PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0074EM:director'],
//   },
//   {
//     nome_socio: 'HENRIQUE DE ALMEIDA PEREIRA',
//     tipo: 'persona',
//     id_socio: '***238646**',
//     id_socio_carbono: 'BR0166PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0074EM:director'],
//   },
//   {
//     nome_socio: 'PAULO MACHADO DE CARVALHO',
//     tipo: 'persona',
//     id_socio: '***868448**',
//     id_socio_carbono: 'BR0462PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0074EM:director'],
//   },
//   {
//     nome_socio: 'RAIR DE SOUSA VERDE',
//     tipo: 'persona',
//     id_socio: '***950202**',
//     id_socio_carbono: 'BR0514PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0075EM:socio_adm'],
//   },
//   {
//     nome_socio: 'RODRIGO DE SOUZA GOMES',
//     tipo: 'persona',
//     id_socio: '***820842**',
//     id_socio_carbono: 'BR0438PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0075EM:socio_adm'],
//   },
//   {
//     nome_socio: 'RODRIGO GOMES DE OLIVEIRA',
//     tipo: 'persona',
//     id_socio: '***451969**',
//     id_socio_carbono: 'BR0264PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0076EM:administrador'],
//   },
//   {
//     nome_socio: 'RG CLINICA MEDICA SS LTDA',
//     tipo: 'empresa',
//     id_socio: '3.9876E+13',
//     id_socio_carbono: 'XX0043EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0076EM:socio'],
//   },
//   {
//     nome_socio: 'FERNANDA HOEBEL MUNHOZ BUENO',
//     tipo: 'persona',
//     id_socio: '***138879**',
//     id_socio_carbono: 'BR0114PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0077EM:socio'],
//   },
//   {
//     nome_socio: 'IANA HOEBEL MUNHOZ',
//     tipo: 'persona',
//     id_socio: '***138859**',
//     id_socio_carbono: 'BR0113PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0077EM:socio'],
//   },
//   {
//     nome_socio: 'ROSANA MARIA HOEBEL',
//     tipo: 'persona',
//     id_socio: '***543249**',
//     id_socio_carbono: 'BR0309PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0077EM:socio'],
//   },
//   {
//     nome_socio: 'DIEGO HOEBEL MUNHOZ',
//     tipo: 'persona',
//     id_socio: '***072969**',
//     id_socio_carbono: 'BR0090PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0077EM:socio_adm', 'BR0073EM:socio_adm'],
//   },
//   {
//     nome_socio: 'JOSE GILVAN DE OLIVEIRA MATOGROSSO COSTA',
//     tipo: 'persona',
//     id_socio: '***053122**',
//     id_socio_carbono: 'BR0074PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0079EM:socio'],
//   },
//   {
//     nome_socio: 'JOSMAR GILSON DE OLIVEIRA MATOGROSSO COSTA',
//     tipo: 'persona',
//     id_socio: '***110512**',
//     id_socio_carbono: 'BR0104PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0079EM:socio_adm'],
//   },
//   {
//     nome_socio: 'LUIZ ANTONIO MEDEIROS TAVARES',
//     tipo: 'persona',
//     id_socio: '***959912**',
//     id_socio_carbono: 'BR0519PER',
//     relacao_com_empresa: 'Presidente',
//     id_rol: 'presidente',
//     relacion_empresas_rol: ['BR0080EM:presidente'],
//   },
//   {
//     nome_socio: 'VALESSA FERNANDES JANUARIO DA SILVEIRA',
//     tipo: 'persona',
//     id_socio: '***841349**',
//     id_socio_carbono: 'BR0447PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0081EM:socio_adm'],
//   },
//   {
//     nome_socio: 'AVENOR TEIXEIRA DE CARVALHO NETO',
//     tipo: 'persona',
//     id_socio: '***146346**',
//     id_socio_carbono: 'BR0117PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0082EM:director'],
//   },
//   {
//     nome_socio: 'MARCO ANTONIO VILELA TANNUS FILHO',
//     tipo: 'persona',
//     id_socio: '***628546**',
//     id_socio_carbono: 'BR0343PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0082EM:director'],
//   },
//   {
//     nome_socio: 'RUBENS BATISTA JUNIOR',
//     tipo: 'persona',
//     id_socio: '***518796**',
//     id_socio_carbono: 'BR0299PER',
//     relacao_com_empresa: 'Representante Legal',
//     id_rol: 'rep_legal',
//     relacion_empresas_rol: ['BR0082EM:rep_legal'],
//   },
//   {
//     nome_socio: 'VERONICA OKI IGACIHALAGUTI',
//     tipo: 'persona',
//     id_socio: '***177712**',
//     id_socio_carbono: 'BR0134PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0084EM:director'],
//   },
//   {
//     nome_socio: 'PEDRO IVO GALINDO SILVESTRE',
//     tipo: 'persona',
//     id_socio: '***807498**',
//     id_socio_carbono: 'BR0433PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0085EM:administrador'],
//   },
//   {
//     nome_socio: 'FUTURE CARBON HOLDING S.A.',
//     tipo: 'empresa',
//     id_socio: '4.36883E+13',
//     id_socio_carbono: 'BR0052EM',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0085EM:socio'],
//   },
//   {
//     nome_socio: 'JAMES CASTRO CAMELI',
//     tipo: 'persona',
//     id_socio: '***942272**',
//     id_socio_carbono: 'BR0509PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0087EM:socio_adm'],
//   },
//   {
//     nome_socio: 'MARIA DO SOCORRO COSTA DE ARAUJO',
//     tipo: 'persona',
//     id_socio: '***182292**',
//     id_socio_carbono: 'BR0136PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0088EM:socio'],
//   },
//   {
//     nome_socio: 'GUSTAVO COSTA DE ARAUJO',
//     tipo: 'persona',
//     id_socio: '***339352**',
//     id_socio_carbono: 'BR0215PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0088EM:socio_adm'],
//   },
//   {
//     nome_socio: 'FABIO IZIDORO DE FARIAS',
//     tipo: 'persona',
//     id_socio: '***979372**',
//     id_socio_carbono: 'BR0525PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0089EM:socio_adm'],
//   },
//   {
//     nome_socio: 'MANUELA CARVALHO FARIAS',
//     tipo: 'persona',
//     id_socio: '***503702**',
//     id_socio_carbono: 'BR0288PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0089EM:socio_adm'],
//   },
//   {
//     nome_socio: 'MAOLA MONIQUE FARIA',
//     tipo: 'persona',
//     id_socio: '***744176**',
//     id_socio_carbono: 'BR0402PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0089EM:socio_adm'],
//   },
//   {
//     nome_socio: 'GILBERTO DO CARMO LOPES SIQUEIRA',
//     tipo: 'persona',
//     id_socio: '***749801**',
//     id_socio_carbono: 'BR0404PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0090EM:socio_adm'],
//   },
//   {
//     nome_socio: 'RENAN OLIVEIRA SILVA',
//     tipo: 'persona',
//     id_socio: '***045233**',
//     id_socio_carbono: 'BR0070PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0090EM:socio_adm'],
//   },
//   {
//     nome_socio: 'ANTONIO JOSE LUDOVINO LOPES',
//     tipo: 'persona',
//     id_socio: '***734848**',
//     id_socio_carbono: 'BR0397PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0091EM:socio_adm'],
//   },
//   {
//     nome_socio: 'BRUNO TAVARES DA SILVA',
//     tipo: 'persona',
//     id_socio: '***073528**',
//     id_socio_carbono: 'BR0091PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0092EM:administrador', 'EX0018EM:rep_legal'],
//   },
//   {
//     nome_socio: 'PARA REDD PROJECTS LIMITED',
//     tipo: 'empresa',
//     id_socio: '4.35006E+13',
//     id_socio_carbono: 'EX0018EM',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0092EM:socio'],
//   },
//   {
//     nome_socio: 'TAV COMPANY PARTICIPACOES  SOCIEDADE UNIPESSOAL LIMITADA',
//     tipo: 'empresa',
//     id_socio: '4.28343E+13',
//     id_socio_carbono: 'XX0046EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0092EM:socio'],
//   },
//   {
//     nome_socio: 'FRANCISCO RODRIGUES CALIXTO NETO',
//     tipo: 'persona',
//     id_socio: '***430722**',
//     id_socio_carbono: 'BR0257PER',
//     relacao_com_empresa: 'Presidente',
//     id_rol: 'presidente',
//     relacion_empresas_rol: ['BR0093EM:presidente'],
//   },
//   {
//     nome_socio: 'FRANCISCO RODRIGUES DE MELO',
//     tipo: 'persona',
//     id_socio: '***932952**',
//     id_socio_carbono: 'BR0502PER',
//     relacao_com_empresa: 'Presidente',
//     id_rol: 'presidente',
//     relacion_empresas_rol: ['BR0094EM:presidente'],
//   },
//   {
//     nome_socio: 'MARIA SANTANA FERREIRA GONCALVES',
//     tipo: 'persona',
//     id_socio: '***157202**',
//     id_socio_carbono: 'BR0124PER',
//     relacao_com_empresa: 'Presidente',
//     id_rol: 'presidente',
//     relacion_empresas_rol: ['BR0095EM:presidente'],
//   },
//   {
//     nome_socio: 'ADILSON DO NASCIMENTO ANDRADE',
//     tipo: 'persona',
//     id_socio: '***772442**',
//     id_socio_carbono: 'BR0411PER',
//     relacao_com_empresa: 'Presidente',
//     id_rol: 'presidente',
//     relacion_empresas_rol: ['BR0096EM:presidente'],
//   },
//   {
//     nome_socio: 'MARCOS PASTORE DAVID',
//     tipo: 'persona',
//     id_socio: '***729608**',
//     id_socio_carbono: 'BR0394PER',
//     relacao_com_empresa: 'Conselheiro de Administração',
//     id_rol: 'consejo_adm',
//     relacion_empresas_rol: ['BR0097EM:consejo_adm'],
//   },
//   {
//     nome_socio: 'MARCELO TAIAR ARBEX',
//     tipo: 'persona',
//     id_socio: '***643338**',
//     id_socio_carbono: 'BR0348PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0097EM:director'],
//   },
//   {
//     nome_socio: 'ROBERTO TAIAR ARBEX',
//     tipo: 'persona',
//     id_socio: '***100548**',
//     id_socio_carbono: 'BR0100PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0097EM:director'],
//   },
//   {
//     nome_socio: 'CRISTIANI SILVESTRE',
//     tipo: 'persona',
//     id_socio: '***150228**',
//     id_socio_carbono: 'BR0121PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0098EM:socio_adm'],
//   },
//   {
//     nome_socio: 'MARCOS GUILHERME ALVES PRETO',
//     tipo: 'persona',
//     id_socio: '***830858**',
//     id_socio_carbono: 'BR0442PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0098EM:socio_adm', 'BR0121EM:socio_adm'],
//   },
//   {
//     nome_socio: 'DIVALDO JOSE DA COSTA REZENDE',
//     tipo: 'persona',
//     id_socio: '***539846**',
//     id_socio_carbono: 'BR0307PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0099EM:socio'],
//   },
//   {
//     nome_socio: 'STEFANO MERLIN',
//     tipo: 'persona',
//     id_socio: '***121341**',
//     id_socio_carbono: 'BR0107PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0099EM:socio_adm', 'BR0111EM:socio_adm'],
//   },
//   {
//     nome_socio: 'FERNANDO GUSTAVO JACOB',
//     tipo: 'persona',
//     id_socio: '***929509**',
//     id_socio_carbono: 'BR0498PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0100EM:administrador'],
//   },
//   {
//     nome_socio: 'FRANCILENE COLFERAI JACOB',
//     tipo: 'persona',
//     id_socio: '***714829**',
//     id_socio_carbono: 'BR0388PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0100EM:administrador'],
//   },
//   {
//     nome_socio: 'JAMIL COLFERAI JACOB',
//     tipo: 'persona',
//     id_socio: '***259339**',
//     id_socio_carbono: 'BR0180PER',
//     relacao_com_empresa: 'Sócio Menor (Assistido/Representado)',
//     id_rol: 'socio_menor',
//     relacion_empresas_rol: ['BR0100EM:socio_menor'],
//   },
//   {
//     nome_socio: 'VICENTE COLFERAI JACOB',
//     tipo: 'persona',
//     id_socio: '***269459**',
//     id_socio_carbono: 'BR0190PER',
//     relacao_com_empresa: 'Sócio Menor (Assistido/Representado)',
//     id_rol: 'socio_menor',
//     relacion_empresas_rol: ['BR0100EM:socio_menor'],
//   },
//   {
//     nome_socio: 'EDSON KELLER',
//     tipo: 'persona',
//     id_socio: '***975608**',
//     id_socio_carbono: 'BR0522PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0101EM:administrador'],
//   },
//   {
//     nome_socio: 'IARA NUNES DE OLIVEIRA',
//     tipo: 'persona',
//     id_socio: '***664001**',
//     id_socio_carbono: 'BR0360PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0101EM:administrador'],
//   },
//   {
//     nome_socio: 'LUIZ PICCININ',
//     tipo: 'persona',
//     id_socio: '***215738**',
//     id_socio_carbono: 'BR0157PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0101EM:administrador'],
//   },
//   {
//     nome_socio: 'ROBERTO MOTTA',
//     tipo: 'persona',
//     id_socio: '***684718**',
//     id_socio_carbono: 'BR0372PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0101EM:administrador'],
//   },
//   {
//     nome_socio: 'MORRO AZUL EMPREENDIMENTOS E PARTICIPACOES S/A',
//     tipo: 'empresa',
//     id_socio: '7.69723E+12',
//     id_socio_carbono: 'XX0011EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0101EM:socio'],
//   },
//   {
//     nome_socio: 'NOSSA SENHORA APARECIDA EMPREENDIMENTOS E PARTICIPACOES S/A',
//     tipo: 'empresa',
//     id_socio: '1.3611E+13',
//     id_socio_carbono: 'XX0025EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0101EM:socio'],
//   },
//   {
//     nome_socio: 'RIO XINGU PARTICIPACOES LTDA',
//     tipo: 'empresa',
//     id_socio: '7.82618E+12',
//     id_socio_carbono: 'XX0013EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0101EM:socio'],
//   },
//   {
//     nome_socio: 'SANTA ADELIA EMPREENDIMENTOS E PARTICIPACOES S/A',
//     tipo: 'empresa',
//     id_socio: '2.41182E+13',
//     id_socio_carbono: 'XX0033EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0101EM:socio'],
//   },
//   {
//     nome_socio: 'SATURNO INVESTIMENTOS E PARTICIPACOES S/A',
//     tipo: 'empresa',
//     id_socio: '7.64012E+12',
//     id_socio_carbono: 'XX0010EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0101EM:socio'],
//   },
//   {
//     nome_socio: 'JOSE LUIZ FELIX DE ANDRADE FILHO',
//     tipo: 'persona',
//     id_socio: '***882133**',
//     id_socio_carbono: 'BR0469PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0103EM:socio_adm'],
//   },
//   {
//     nome_socio: 'PATRICIA DE LUCA LIMA GREFF',
//     tipo: 'persona',
//     id_socio: '***751649**',
//     id_socio_carbono: 'BR0405PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0104EM:socio_adm'],
//   },
//   {
//     nome_socio: 'ADALVA MARIA GALINDO',
//     tipo: 'persona',
//     id_socio: '***024608**',
//     id_socio_carbono: 'BR0057PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0105EM:director'],
//   },
//   {
//     nome_socio: 'FLAVIA GALINDO SILVESTRE SILVA',
//     tipo: 'persona',
//     id_socio: '***934628**',
//     id_socio_carbono: 'BR0504PER',
//     relacao_com_empresa: 'Presidente',
//     id_rol: 'presidente',
//     relacion_empresas_rol: ['BR0105EM:presidente'],
//   },
//   {
//     nome_socio: 'FABIO LEVI VIDIGAL',
//     tipo: 'persona',
//     id_socio: '***062838**',
//     id_socio_carbono: 'BR0085PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0106EM:administrador'],
//   },
//   {
//     nome_socio: 'AMPLEWELL HOLDINGS LIMITED',
//     tipo: 'empresa',
//     id_socio: '1.07932E+13',
//     id_socio_carbono: 'XX0020EM2',
//     relacao_com_empresa: 'Sócio Pessoa Jurídica Domiciliado no Exterior',
//     id_rol: 'socio_pj_dom_ex',
//     relacion_empresas_rol: ['BR0106EM:socio_pj_dom_ex'],
//   },
//   {
//     nome_socio: 'GREAT PATH LIMITED',
//     tipo: 'empresa',
//     id_socio: '1.28229E+13',
//     id_socio_carbono: 'XX0023EM2',
//     relacao_com_empresa: 'Sócio Pessoa Jurídica Domiciliado no Exterior',
//     id_rol: 'socio_pj_dom_ex',
//     relacion_empresas_rol: ['BR0106EM:socio_pj_dom_ex'],
//   },
//   {
//     nome_socio: 'CLAUDIO UEZU',
//     tipo: 'persona',
//     id_socio: '***574778**',
//     id_socio_carbono: 'BR0321PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0107EM:socio'],
//   },
//   {
//     nome_socio: 'ALEXANDRE UEZU',
//     tipo: 'persona',
//     id_socio: '***977958**',
//     id_socio_carbono: 'BR0523PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0107EM:socio_adm'],
//   },
//   {
//     nome_socio: 'CRISTIANE BLEY KESTERKE CLAUSEN',
//     tipo: 'persona',
//     id_socio: '***408519**',
//     id_socio_carbono: 'BR0244PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0108EM:director'],
//   },
//   {
//     nome_socio: 'JORGE CRISTIANO MELLO',
//     tipo: 'persona',
//     id_socio: '***846328**',
//     id_socio_carbono: 'BR0452PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0108EM:director'],
//   },
//   {
//     nome_socio: 'CESAR EDUARDO ISAACSON BUFFARA',
//     tipo: 'persona',
//     id_socio: '***017689**',
//     id_socio_carbono: 'BR0051PER',
//     relacao_com_empresa: 'Presidente',
//     id_rol: 'presidente',
//     relacion_empresas_rol: ['BR0108EM:presidente'],
//   },
//   {
//     nome_socio: 'LEDIANA GHEDIN LOPES',
//     tipo: 'persona',
//     id_socio: '***265402**',
//     id_socio_carbono: 'BR0188PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0109EM:director'],
//   },
//   {
//     nome_socio: 'GILVAN GUIDIN',
//     tipo: 'persona',
//     id_socio: '***783861**',
//     id_socio_carbono: 'BR0416PER',
//     relacao_com_empresa: 'Presidente',
//     id_rol: 'presidente',
//     relacion_empresas_rol: ['BR0109EM:presidente'],
//   },
//   {
//     nome_socio: 'AGRO MARIPA - PARTICIPACOES, EMPREENDIMENTOS E ADMINISTRACAO LTDA',
//     tipo: 'empresa',
//     id_socio: '1.24065E+12',
//     id_socio_carbono: 'XX0001EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0110EM:socio'],
//   },
//   {
//     nome_socio: 'MARCELO BAPTISTA DE OLIVEIRA',
//     tipo: 'persona',
//     id_socio: '***801626**',
//     id_socio_carbono: 'BR0427PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0110EM:socio_adm'],
//   },
//   {
//     nome_socio: 'PAULO CESAR BITTENCOURT DE CARVALHO',
//     tipo: 'persona',
//     id_socio: '***699067**',
//     id_socio_carbono: 'BR0380PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0112EM:director'],
//   },
//   {
//     nome_socio: 'SEBASTIAO ERNANES RANGEL',
//     tipo: 'persona',
//     id_socio: '***626417**',
//     id_socio_carbono: 'BR0342PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0112EM:director'],
//   },
//   {
//     nome_socio: 'FELIPE BITTENCOURT DE CARVALHO',
//     tipo: 'persona',
//     id_socio: '***799467**',
//     id_socio_carbono: 'BR0425PER',
//     relacao_com_empresa: 'Presidente',
//     id_rol: 'presidente',
//     relacion_empresas_rol: ['BR0112EM:presidente'],
//   },
//   {
//     nome_socio: 'ROBERTO FIGUEIREDO STRUMPF',
//     tipo: 'persona',
//     id_socio: '***860408**',
//     id_socio_carbono: 'BR0458PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0114EM:administrador'],
//   },
//   {
//     nome_socio: 'CARBON CREDIT SOLUTIONS INC',
//     tipo: 'empresa',
//     id_socio: '3.44908E+13',
//     id_socio_carbono: 'XX0041EM2',
//     relacao_com_empresa: 'Sócio Pessoa Jurídica Domiciliado no Exterior',
//     id_rol: 'socio_pj_dom_ex',
//     relacion_empresas_rol: ['BR0114EM:socio_pj_dom_ex'],
//   },
//   {
//     nome_socio: 'ANGELO PACCELLI CIPRIANO RABELO',
//     tipo: 'persona',
//     id_socio: '***644391**',
//     id_socio_carbono: 'BR0349PER',
//     relacao_com_empresa: 'Presidente',
//     id_rol: 'presidente',
//     relacion_empresas_rol: ['BR0115EM:presidente'],
//   },
//   {
//     nome_socio: 'ILVANIO MARTINS',
//     tipo: 'persona',
//     id_socio: '***666196**',
//     id_socio_carbono: 'BR0362PER',
//     relacao_com_empresa: 'Presidente',
//     id_rol: 'presidente',
//     relacion_empresas_rol: ['BR0116EM:presidente'],
//   },
//   {
//     nome_socio: 'ANDRE LUIS DOS SANTOS RIBEIRO',
//     tipo: 'persona',
//     id_socio: '***424298**',
//     id_socio_carbono: 'BR0253PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0117EM:director'],
//   },
//   {
//     nome_socio: 'MAXIMIR DIAS DE FRANCA',
//     tipo: 'persona',
//     id_socio: '***916941**',
//     id_socio_carbono: 'BR0489PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0117EM:director'],
//   },
//   {
//     nome_socio: 'MARLOS FERREIRA ALVES',
//     tipo: 'persona',
//     id_socio: '***163976**',
//     id_socio_carbono: 'BR0126PER',
//     relacao_com_empresa: 'Presidente',
//     id_rol: 'presidente',
//     relacion_empresas_rol: ['BR0117EM:presidente'],
//   },
//   {
//     nome_socio: 'IRACI GALVANE BATISTA',
//     tipo: 'persona',
//     id_socio: '***509359**',
//     id_socio_carbono: 'BR0293PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0118EM:socio'],
//   },
//   {
//     nome_socio: 'MOACIR ELOY CROCETTA BATISTA',
//     tipo: 'persona',
//     id_socio: '***705129**',
//     id_socio_carbono: 'BR0383PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0118EM:socio_adm', 'BR0032EM:socio_adm'],
//   },
//   {
//     nome_socio: 'ANDRE ROBERTO DOS SANTOS MANFREDINI',
//     tipo: 'persona',
//     id_socio: '***357479**',
//     id_socio_carbono: 'BR0228PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0119EM:administrador'],
//   },
//   {
//     nome_socio: 'VALDEMAR CANDIDO DA SILVA',
//     tipo: 'persona',
//     id_socio: '***898379**',
//     id_socio_carbono: 'BR0479PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0119EM:administrador'],
//   },
//   {
//     nome_socio:
//       'MANFREDINI PARTICIPACOES, INCORPORACOES & ADMINISTRACAO DE BENS LTDA',
//     tipo: 'empresa',
//     id_socio: '1.08075E+13',
//     id_socio_carbono: 'XX0021EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0119EM:socio'],
//   },
//   {
//     nome_socio: 'NATURAL RESOURCES DEVELOPMENT AG',
//     tipo: 'empresa',
//     id_socio: '1.30769E+13',
//     id_socio_carbono: 'XX0024EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0119EM:socio'],
//   },
//   {
//     nome_socio:
//       'STADIE & FISCHA PARTICIPACOES, INCORPORACOES E ADMINISTRACAO DE BENS LTDA',
//     tipo: 'empresa',
//     id_socio: '1.94427E+13',
//     id_socio_carbono: 'XX0029EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0119EM:socio'],
//   },
//   {
//     nome_socio: 'VCS PARTICIPACOES LTDA',
//     tipo: 'empresa',
//     id_socio: '4.61763E+13',
//     id_socio_carbono: 'XX0049EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0119EM:socio'],
//   },
//   {
//     nome_socio: 'ALCIMAR DACKO',
//     tipo: 'persona',
//     id_socio: '***168880**',
//     id_socio_carbono: 'BR0130PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0120EM:socio_adm'],
//   },
//   {
//     nome_socio: 'MARLI BERTOTTI DACKO',
//     tipo: 'persona',
//     id_socio: '***260000**',
//     id_socio_carbono: 'BR0181PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0120EM:socio_adm'],
//   },
//   {
//     nome_socio: 'MARIA CRISTINA RODRIGUEZ RODRIGUEZ',
//     tipo: 'persona',
//     id_socio: '***340996**',
//     id_socio_carbono: 'BR0216PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0121EM:administrador'],
//   },
//   {
//     nome_socio: 'AGROCORTEX FLORESTAS DO BRASIL PARTICIPACOES S.A.',
//     tipo: 'empresa',
//     id_socio: '1.93744E+13',
//     id_socio_carbono: 'XX0028EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0121EM:socio'],
//   },
//   {
//     nome_socio: 'AGROCORTEX FLORESTAS TROPICAIS PARTICIPACOES LTDA.',
//     tipo: 'empresa',
//     id_socio: '1.98469E+13',
//     id_socio_carbono: 'XX0031EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0121EM:socio'],
//   },
//   {
//     nome_socio: 'GUILHERME LUCAS MEDEIROS PRADO',
//     tipo: 'persona',
//     id_socio: '***904058**',
//     id_socio_carbono: 'BR0482PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0122EM:socio_adm'],
//   },
//   {
//     nome_socio: 'MARCELO HECTOR SABBAGH HADDAD',
//     tipo: 'persona',
//     id_socio: '***713058**',
//     id_socio_carbono: 'BR0386PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0122EM:socio_adm'],
//   },
//   {
//     nome_socio: 'THIAGO DE AVILA OTHERO',
//     tipo: 'persona',
//     id_socio: '***251260**',
//     id_socio_carbono: 'BR0173PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0122EM:socio_adm'],
//   },
//   {
//     nome_socio: 'RAFAEL NORA TANNUS',
//     tipo: 'persona',
//     id_socio: '***020798**',
//     id_socio_carbono: 'BR0055PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0123EM:socio_adm'],
//   },
//   {
//     nome_socio: 'GUSTAVO HENRIQUE BATISTA',
//     tipo: 'persona',
//     id_socio: '***623546**',
//     id_socio_carbono: 'BR0341PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0124EM:socio_adm'],
//   },
//   {
//     nome_socio: 'AMAZONIA SOLUCOES PARA A SUSTENTABILIDADE LTDA.',
//     tipo: 'empresa',
//     id_socio: '1.05775E+13',
//     id_socio_carbono: 'XX0019EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0125EM:socio'],
//   },
//   {
//     nome_socio: 'ROSANA DELLA MEA SUTTON',
//     tipo: 'persona',
//     id_socio: '***889270**',
//     id_socio_carbono: 'BR0474PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0125EM:socio_adm'],
//   },
//   {
//     nome_socio: 'EDUARDO O REILLY CABRAL COVAS BARRIONUEVO',
//     tipo: 'persona',
//     id_socio: '***055259**',
//     id_socio_carbono: 'BR0076PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0126EM:director'],
//   },
//   {
//     nome_socio: 'FERNANDO O REILLY CABRAL BARRIONUEVO',
//     tipo: 'persona',
//     id_socio: '***732119**',
//     id_socio_carbono: 'BR0395PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0126EM:director'],
//   },
//   {
//     nome_socio: 'VALDENOR CAMPOS DA COSTA JUNIOR',
//     tipo: 'persona',
//     id_socio: '***429112**',
//     id_socio_carbono: 'BR0256PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0126EM:director'],
//   },
//   {
//     nome_socio: 'LEONARDO O REILLY CABRAL BARRIONUEVO',
//     tipo: 'persona',
//     id_socio: '***859059**',
//     id_socio_carbono: 'BR0454PER',
//     relacao_com_empresa: 'Presidente',
//     id_rol: 'presidente',
//     relacion_empresas_rol: ['BR0126EM:presidente'],
//   },
//   {
//     nome_socio: 'YURI NOGUEIRA FERES',
//     tipo: 'persona',
//     id_socio: '***597308**',
//     id_socio_carbono: 'BR0328PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0127EM:director'],
//   },
//   {
//     nome_socio: 'ALMIR NARAYAMOGA SURUI',
//     tipo: 'persona',
//     id_socio: '***366972**',
//     id_socio_carbono: 'BR0229PER',
//     relacao_com_empresa: 'Presidente',
//     id_rol: 'presidente',
//     relacion_empresas_rol: ['BR0128EM:presidente'],
//   },
//   {
//     nome_socio: 'MARIA DO SOCORRO CORDEIRO SIQUEIRA',
//     tipo: 'persona',
//     id_socio: '***065552**',
//     id_socio_carbono: 'BR0087PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0129EM:director'],
//   },
//   {
//     nome_socio: 'VIRGILIO MAURICIO VIANA',
//     tipo: 'persona',
//     id_socio: '***280696**',
//     id_socio_carbono: 'BR0194PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0129EM:director'],
//   },
//   {
//     nome_socio: 'PAULA MARIA BIRAL',
//     tipo: 'persona',
//     id_socio: '***909298**',
//     id_socio_carbono: 'BR0484PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0131EM:socio'],
//   },
//   {
//     nome_socio: 'CARLOS ALBERTO BARBOSA PORSCH',
//     tipo: 'persona',
//     id_socio: '***439179**',
//     id_socio_carbono: 'BR0261PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0132EM:administrador'],
//   },
//   {
//     nome_socio: 'DOUGLAS ANTONIO GRANEMANN DE SOUZA',
//     tipo: 'persona',
//     id_socio: '***464009**',
//     id_socio_carbono: 'BR0274PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0132EM:administrador'],
//   },
//   {
//     nome_socio: 'REALE LTDA',
//     tipo: 'empresa',
//     id_socio: '3.39044E+13',
//     id_socio_carbono: 'XX0039EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0132EM:socio'],
//   },
//   {
//     nome_socio: 'IRENE ELIZABETH LENCI',
//     tipo: 'persona',
//     id_socio: '***194608**',
//     id_socio_carbono: 'BR0139PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0134EM:administrador'],
//   },
//   {
//     nome_socio: 'FSM PARTICIPACOES LTDA',
//     tipo: 'empresa',
//     id_socio: '7.80414E+12',
//     id_socio_carbono: 'XX0012EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0134EM:socio'],
//   },
//   {
//     nome_socio: 'RUBENS FORBES ALVES DE LIMA',
//     tipo: 'persona',
//     id_socio: '***508538**',
//     id_socio_carbono: 'BR0292PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0134EM:socio_adm'],
//   },
//   {
//     nome_socio: 'WARWICK DO AMARAL MANFRINATO',
//     tipo: 'persona',
//     id_socio: '***267028**',
//     id_socio_carbono: 'BR0189PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0135EM:socio_adm'],
//   },
//   {
//     nome_socio: 'HILDEGARD GUTZ HORTA',
//     tipo: 'persona',
//     id_socio: '***642258**',
//     id_socio_carbono: 'BR0346PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0136EM:administrador'],
//   },
//   {
//     nome_socio: 'BUNGE BRASIL HOLDINGS BV',
//     tipo: 'empresa',
//     id_socio: '6.05162E+12',
//     id_socio_carbono: 'XX0008EM2',
//     relacao_com_empresa: 'Sócio Pessoa Jurídica Domiciliado no Exterior',
//     id_rol: 'socio_pj_dom_ex',
//     relacion_empresas_rol: ['BR0136EM:socio_pj_dom_ex'],
//   },
//   {
//     nome_socio: 'BUNGE HOLDINGS B.V.',
//     tipo: 'empresa',
//     id_socio: '6.05162E+12',
//     id_socio_carbono: 'XX0009EM2',
//     relacao_com_empresa: 'Sócio Pessoa Jurídica Domiciliado no Exterior',
//     id_rol: 'socio_pj_dom_ex',
//     relacion_empresas_rol: ['BR0136EM:socio_pj_dom_ex'],
//   },
//   {
//     nome_socio: 'ALEXANDRE BERTOLDI',
//     tipo: 'persona',
//     id_socio: '***031318**',
//     id_socio_carbono: 'BR0062PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'ALEXANDRE OUTEDA JORGE',
//     tipo: 'persona',
//     id_socio: '***356338**',
//     id_socio_carbono: 'BR0227PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'ALVARO SILAS ULIANI MARTINS DOS SANTOS',
//     tipo: 'persona',
//     id_socio: '***170258**',
//     id_socio_carbono: 'BR0131PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'ANA CAROLINA FERNANDES CARPINETTI',
//     tipo: 'persona',
//     id_socio: '***593738**',
//     id_socio_carbono: 'BR0326PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'ANDRE MORAES MARQUES',
//     tipo: 'persona',
//     id_socio: '***811118**',
//     id_socio_carbono: 'BR0435PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'ANDRE VERTULLO BERNINI',
//     tipo: 'persona',
//     id_socio: '***789178**',
//     id_socio_carbono: 'BR0419PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'ANDRE VIVAN DE SOUZA',
//     tipo: 'persona',
//     id_socio: '***419238**',
//     id_socio_carbono: 'BR0250PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'ANDRE ZONARO GIACCHETTA',
//     tipo: 'persona',
//     id_socio: '***805378**',
//     id_socio_carbono: 'BR0430PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'ANDREA MASCITTO',
//     tipo: 'persona',
//     id_socio: '***882918**',
//     id_socio_carbono: 'BR0470PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'ANGELA FAN CHI KUNG',
//     tipo: 'persona',
//     id_socio: '***524188**',
//     id_socio_carbono: 'BR0301PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'ANTONIO JOSE MATTOS MORELLO',
//     tipo: 'persona',
//     id_socio: '***258138**',
//     id_socio_carbono: 'BR0177PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'BIANCA PUMAR COELHO',
//     tipo: 'persona',
//     id_socio: '***009287**',
//     id_socio_carbono: 'BR0048PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'BRUNO BALDUCCINI',
//     tipo: 'persona',
//     id_socio: '***438088**',
//     id_socio_carbono: 'BR0260PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'CAIO CARLOS CRUZ FERREIRA SILVA',
//     tipo: 'persona',
//     id_socio: '***213297**',
//     id_socio_carbono: 'BR0156PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'CAMILA CARVALHO GOMES',
//     tipo: 'persona',
//     id_socio: '***061068**',
//     id_socio_carbono: 'BR0082PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'CAMILA MARTINO PARISE',
//     tipo: 'persona',
//     id_socio: '***695058**',
//     id_socio_carbono: 'BR0377PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'CARLOS ALBERTO MOREIRA LIMA JUNIOR',
//     tipo: 'persona',
//     id_socio: '***383938**',
//     id_socio_carbono: 'BR0236PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'CARLOS AUGUSTO VILHENA DE MAGALHAES CUNHA FILHO',
//     tipo: 'persona',
//     id_socio: '***758741**',
//     id_socio_carbono: 'BR0406PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'CARLOS EDUARDO GAZINEU DE AZEVEDO',
//     tipo: 'persona',
//     id_socio: '***727048**',
//     id_socio_carbono: 'BR0393PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'CARLOS HENRIQUE TRANJAN BECHARA',
//     tipo: 'persona',
//     id_socio: '***076297**',
//     id_socio_carbono: 'BR0093PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'CAROLINE GUAZZELLI QUEIROZ GOMES',
//     tipo: 'persona',
//     id_socio: '***342228**',
//     id_socio_carbono: 'BR0218PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'CAUE REZENDE MYANAKI',
//     tipo: 'persona',
//     id_socio: '***498738**',
//     id_socio_carbono: 'BR0286PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'CELSO CINTRA MORI',
//     tipo: 'persona',
//     id_socio: '***295228**',
//     id_socio_carbono: 'BR0198PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'CIRO TORRES FREITAS',
//     tipo: 'persona',
//     id_socio: '***855898**',
//     id_socio_carbono: 'BR0453PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'CRISTIANE IANAGUI MATSUMOTO',
//     tipo: 'persona',
//     id_socio: '***050458**',
//     id_socio_carbono: 'BR0072PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'CRISTIANNE SACCAB ZARZUR CHACCUR',
//     tipo: 'persona',
//     id_socio: '***458478**',
//     id_socio_carbono: 'BR0270PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'DANIEL COSTA REBELLO',
//     tipo: 'persona',
//     id_socio: '***585701**',
//     id_socio_carbono: 'BR0323PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'DIEGO CALDAS RIVAS DE SIMONE',
//     tipo: 'persona',
//     id_socio: '***607578**',
//     id_socio_carbono: 'BR0335PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'DIOGENES MENDES GONCALVES NETO',
//     tipo: 'persona',
//     id_socio: '***515128**',
//     id_socio_carbono: 'BR0298PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'EDUARDO CARVALHO CAIUBY',
//     tipo: 'persona',
//     id_socio: '***773268**',
//     id_socio_carbono: 'BR0412PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'EDUARDO HENRIQUE PAOLIELLO JUNIOR',
//     tipo: 'persona',
//     id_socio: '***937038**',
//     id_socio_carbono: 'BR0506PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'EIDER AVELINO SILVA',
//     tipo: 'persona',
//     id_socio: '***308926**',
//     id_socio_carbono: 'BR0205PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'EMIR NUNES DE OLIVEIRA NETO',
//     tipo: 'persona',
//     id_socio: '***459167**',
//     id_socio_carbono: 'BR0272PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'ENRICO JUCA BENTIVEGNA',
//     tipo: 'persona',
//     id_socio: '***115788**',
//     id_socio_carbono: 'BR0106PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'FABIO ROCHA PINTO E SILVA',
//     tipo: 'persona',
//     id_socio: '***296518**',
//     id_socio_carbono: 'BR0201PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'FERNANDO JOSE PRADO FERREIRA',
//     tipo: 'persona',
//     id_socio: '***642888**',
//     id_socio_carbono: 'BR0347PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'FERNANDO MIRANDEZ DEL NERO GOMES',
//     tipo: 'persona',
//     id_socio: '***507648**',
//     id_socio_carbono: 'BR0291PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'FERNANDO RUIZ DE ALMEIDA PRADO',
//     tipo: 'persona',
//     id_socio: '***258028**',
//     id_socio_carbono: 'BR0176PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'FERNANDO SANTIAGO DOS SANTOS ZORZO',
//     tipo: 'persona',
//     id_socio: '***245988**',
//     id_socio_carbono: 'BR0170PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'FLAVIO VEITZMAN',
//     tipo: 'persona',
//     id_socio: '***562208**',
//     id_socio_carbono: 'BR0317PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'FRANCISCO WERNECK DE ALBUQUERQUE MARANHAO',
//     tipo: 'persona',
//     id_socio: '***945917**',
//     id_socio_carbono: 'BR0512PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'FRANCO MUSETTI GROTTI',
//     tipo: 'persona',
//     id_socio: '***951138**',
//     id_socio_carbono: 'BR0515PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'GIANCARLO CHAMMA MATARAZZO',
//     tipo: 'persona',
//     id_socio: '***715628**',
//     id_socio_carbono: 'BR0389PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'GILBERTO GIUSTI',
//     tipo: 'persona',
//     id_socio: '***888338**',
//     id_socio_carbono: 'BR0473PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'GIULIANO COLOMBO',
//     tipo: 'persona',
//     id_socio: '***926648**',
//     id_socio_carbono: 'BR0495PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'GUILHERME FELICISSIMO DE ALMEIDA LEITE',
//     tipo: 'persona',
//     id_socio: '***370848**',
//     id_socio_carbono: 'BR0232PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'GUILHERME SAMPAIO MONTEIRO',
//     tipo: 'persona',
//     id_socio: '***312198**',
//     id_socio_carbono: 'BR0207PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'HENRIQUE DA SILVA GORDO LANG',
//     tipo: 'persona',
//     id_socio: '***206158**',
//     id_socio_carbono: 'BR0147PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'HENRY SERGIO SZTUTMAN',
//     tipo: 'persona',
//     id_socio: '***313888**',
//     id_socio_carbono: 'BR0209PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'JOAMIR MULLER ROMITI ALVES',
//     tipo: 'persona',
//     id_socio: '***176128**',
//     id_socio_carbono: 'BR0132PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'JOAO MARCELO GONCALVES PACHECO',
//     tipo: 'persona',
//     id_socio: '***031608**',
//     id_socio_carbono: 'BR0064PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'JOAO RAFAEL LAVANDEIRA GANDARA DE CARVALHO',
//     tipo: 'persona',
//     id_socio: '***031487**',
//     id_socio_carbono: 'BR0063PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'JORGE NEY DE FIGUEIREDO LOPES JUNIOR',
//     tipo: 'persona',
//     id_socio: '***732628**',
//     id_socio_carbono: 'BR0396PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'JOSE ALEXANDRE BUAIZ NETO',
//     tipo: 'persona',
//     id_socio: '***583201**',
//     id_socio_carbono: 'BR0322PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'JOSE CARLOS JUNQUEIRA SAMPAIO MEIRELLES',
//     tipo: 'persona',
//     id_socio: '***330768**',
//     id_socio_carbono: 'BR0213PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'JOSE LUIZ HOMEM DE MELLO',
//     tipo: 'persona',
//     id_socio: '***791188**',
//     id_socio_carbono: 'BR0420PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'JOSE MAURO DECOUSSAU MACHADO',
//     tipo: 'persona',
//     id_socio: '***254588**',
//     id_socio_carbono: 'BR0175PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'JOSE ROBERTO OLIVA JUNIOR',
//     tipo: 'persona',
//     id_socio: '***947796**',
//     id_socio_carbono: 'BR0513PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'JULIO CESAR BUENO',
//     tipo: 'persona',
//     id_socio: '***433706**',
//     id_socio_carbono: 'BR0258PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'LARISSA MARIA GALIMBERTI AFONSO',
//     tipo: 'persona',
//     id_socio: '***491558**',
//     id_socio_carbono: 'BR0284PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'LEONARDO BAPTISTA RODRIGUES CRUZ',
//     tipo: 'persona',
//     id_socio: '***657518**',
//     id_socio_carbono: 'BR0358PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'LEONARDO PERES DA ROCHA E SILVA',
//     tipo: 'persona',
//     id_socio: '***696421**',
//     id_socio_carbono: 'BR0379PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'LUCAS PINTO SIMAO',
//     tipo: 'persona',
//     id_socio: '***002508**',
//     id_socio_carbono: 'BR0046PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'LUCIANA ROSANOVA GALHARDO',
//     tipo: 'persona',
//     id_socio: '***112088**',
//     id_socio_carbono: 'BR0105PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'LUCIANO GARCIA ROSSI',
//     tipo: 'persona',
//     id_socio: '***150638**',
//     id_socio_carbono: 'BR0123PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'LUIS ANTONIO FERRAZ MENDES',
//     tipo: 'persona',
//     id_socio: '***801798**',
//     id_socio_carbono: 'BR0428PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'LUIS CELSO CECILIO LEITE RIBEIRO',
//     tipo: 'persona',
//     id_socio: '***226498**',
//     id_socio_carbono: 'BR0162PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'LUIS CLAUDIO FURTADO FARIA',
//     tipo: 'persona',
//     id_socio: '***528997**',
//     id_socio_carbono: 'BR0304PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'LUIZ FERNANDO VALENTE DE PAIVA',
//     tipo: 'persona',
//     id_socio: '***497278**',
//     id_socio_carbono: 'BR0285PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'LUIZ ROBERTO PEROBA BARBOSA',
//     tipo: 'persona',
//     id_socio: '***276118**',
//     id_socio_carbono: 'BR0191PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'MARCELLO ALFREDO BERNARDES',
//     tipo: 'persona',
//     id_socio: '***778207**',
//     id_socio_carbono: 'BR0413PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'MARCELLO PORTES DA SILVEIRA LOBO',
//     tipo: 'persona',
//     id_socio: '***439427**',
//     id_socio_carbono: 'BR0262PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'MARCELO MARQUES RONCAGLIA',
//     tipo: 'persona',
//     id_socio: '***369218**',
//     id_socio_carbono: 'BR0231PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'MARCELO VIVEIROS DE MOURA',
//     tipo: 'persona',
//     id_socio: '***026677**',
//     id_socio_carbono: 'BR0059PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'MARCOS CHAVES LADEIRA',
//     tipo: 'persona',
//     id_socio: '***289588**',
//     id_socio_carbono: 'BR0196PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'MARCOS DE VICQ DE CUMPTICH',
//     tipo: 'persona',
//     id_socio: '***933297**',
//     id_socio_carbono: 'BR0503PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'MARIANA MONTE ALEGRE DE PAIVA',
//     tipo: 'persona',
//     id_socio: '***345928**',
//     id_socio_carbono: 'BR0222PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'MARIO PANSERI FERREIRA',
//     tipo: 'persona',
//     id_socio: '***951998**',
//     id_socio_carbono: 'BR0516PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'MAURICIO JOSE GUILHERME FROES GUIDI CELINI GIUBILEI',
//     tipo: 'persona',
//     id_socio: '***974146**',
//     id_socio_carbono: 'BR0521PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'MAURO BERENHOLC',
//     tipo: 'persona',
//     id_socio: '***546858**',
//     id_socio_carbono: 'BR0312PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'MAXIMILIAN FIERRO PASCHOAL',
//     tipo: 'persona',
//     id_socio: '***936358**',
//     id_socio_carbono: 'BR0505PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'MIGUEL TORNOVSKY',
//     tipo: 'persona',
//     id_socio: '***842227**',
//     id_socio_carbono: 'BR0448PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'NATALIA GENINA LUGERO DE ALMEIDA',
//     tipo: 'persona',
//     id_socio: '***865938**',
//     id_socio_carbono: 'BR0460PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'PAULA SUSANNA AMARAL MELLO',
//     tipo: 'persona',
//     id_socio: '***664108**',
//     id_socio_carbono: 'BR0361PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'PEDRO PAULO BARRADAS BARATA',
//     tipo: 'persona',
//     id_socio: '***295378**',
//     id_socio_carbono: 'BR0199PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'PYTHAGORAS LOPES DE CARVALHO NETO',
//     tipo: 'persona',
//     id_socio: '***472768**',
//     id_socio_carbono: 'BR0280PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'RAFAEL JOSE LOPES GASPAR',
//     tipo: 'persona',
//     id_socio: '***725098**',
//     id_socio_carbono: 'BR0392PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'RAPHAEL DE CUNTO',
//     tipo: 'persona',
//     id_socio: '***312668**',
//     id_socio_carbono: 'BR0208PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'RAPHAEL MORAES PACIELLO',
//     tipo: 'persona',
//     id_socio: '***657307**',
//     id_socio_carbono: 'BR0357PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'RAPHAEL PALMIERI SALOMAO',
//     tipo: 'persona',
//     id_socio: '***056298**',
//     id_socio_carbono: 'BR0078PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'RENATO HENRIQUE CAUMO',
//     tipo: 'persona',
//     id_socio: '***879538**',
//     id_socio_carbono: 'BR0467PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'RENATO STEPHAN GRION',
//     tipo: 'persona',
//     id_socio: '***457108**',
//     id_socio_carbono: 'BR0269PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'RENE GUILHERME DA SILVA MEDRADO',
//     tipo: 'persona',
//     id_socio: '***196028**',
//     id_socio_carbono: 'BR0141PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'RICARDO EMMANUEL VIEIRA COELHO',
//     tipo: 'persona',
//     id_socio: '***066017**',
//     id_socio_carbono: 'BR0088PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'RICARDO GLAESSNER BINNIE',
//     tipo: 'persona',
//     id_socio: '***396548**',
//     id_socio_carbono: 'BR0241PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'RICARDO PAGLIARI LEVY',
//     tipo: 'persona',
//     id_socio: '***906228**',
//     id_socio_carbono: 'BR0483PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'RICARDO SIMOES RUSSO',
//     tipo: 'persona',
//     id_socio: '***379308**',
//     id_socio_carbono: 'BR0234PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'ROBERTA STETTINGER ROSSI BILOTTI DEMANGE',
//     tipo: 'persona',
//     id_socio: '***100458**',
//     id_socio_carbono: 'BR0099PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'RODRIGO CORREA MARTONE',
//     tipo: 'persona',
//     id_socio: '***879558**',
//     id_socio_carbono: 'BR0468PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'RODRIGO DE MAGALHAES CARNEIRO DE OLIVEIRA',
//     tipo: 'persona',
//     id_socio: '***455118**',
//     id_socio_carbono: 'BR0266PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'RODRIGO PERSONE PRESTES DE CAMARGO',
//     tipo: 'persona',
//     id_socio: '***167198**',
//     id_socio_carbono: 'BR0128PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'SERGIO PINHEIRO MARCAL',
//     tipo: 'persona',
//     id_socio: '***062448**',
//     id_socio_carbono: 'BR0084PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'TATIANA MELLO GUAZZELLI',
//     tipo: 'persona',
//     id_socio: '***075438**',
//     id_socio_carbono: 'BR0092PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'TERCIO CHIAVASSA',
//     tipo: 'persona',
//     id_socio: '***210278**',
//     id_socio_carbono: 'BR0151PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'THAIS GALO',
//     tipo: 'persona',
//     id_socio: '***940708**',
//     id_socio_carbono: 'BR0507PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'THERA VAN SWAAY DE MARCHI',
//     tipo: 'persona',
//     id_socio: '***979808**',
//     id_socio_carbono: 'BR0526PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'THIAGO BRAGA JUNQUEIRA',
//     tipo: 'persona',
//     id_socio: '***137676**',
//     id_socio_carbono: 'BR0111PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'THIAGO JOSE DA SILVA',
//     tipo: 'persona',
//     id_socio: '***260578**',
//     id_socio_carbono: 'BR0182PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'TIAGO ARAUJO DIAS THEMUDO LESSA',
//     tipo: 'persona',
//     id_socio: '***521399**',
//     id_socio_carbono: 'BR0300PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'TIAGO ELER SILVA',
//     tipo: 'persona',
//     id_socio: '***017886**',
//     id_socio_carbono: 'BR0053PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'TIAGO MOREIRA VIEIRA ROCHA',
//     tipo: 'persona',
//     id_socio: '***696248**',
//     id_socio_carbono: 'BR0378PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'VANIA MARQUES RIBEIRO',
//     tipo: 'persona',
//     id_socio: '***956416**',
//     id_socio_carbono: 'BR0518PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'VINICIUS PIMENTA SEIXAS PEREIRA',
//     tipo: 'persona',
//     id_socio: '***258908**',
//     id_socio_carbono: 'BR0178PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'WERNER GRAU NETO',
//     tipo: 'persona',
//     id_socio: '***415998**',
//     id_socio_carbono: 'BR0247PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'YUKA ONO',
//     tipo: 'persona',
//     id_socio: '***513848**',
//     id_socio_carbono: 'BR0297PER',
//     relacao_com_empresa: 'Sócio com Capital',
//     id_rol: 'socio_c_capital',
//     relacion_empresas_rol: ['BR0137EM:socio_c_capital'],
//   },
//   {
//     nome_socio: 'FERNANDO ALVES MEIRA',
//     tipo: 'persona',
//     id_socio: '***166928**',
//     id_socio_carbono: 'BR0127PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0137EM:socio_adm'],
//   },
//   {
//     nome_socio: 'VICENTE COELHO ARAUJO',
//     tipo: 'persona',
//     id_socio: '***485621**',
//     id_socio_carbono: 'BR0282PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0137EM:socio_adm'],
//   },
//   {
//     nome_socio: 'BIO ASSETS ATIVOS AMBIENTAIS LTDA',
//     tipo: 'empresa',
//     id_socio: '3.55746E+12',
//     id_socio_carbono: 'XX0006EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0138EM:socio'],
//   },
//   {
//     nome_socio: 'CHAN LAP TAK',
//     tipo: 'persona',
//     id_socio: '***201238**',
//     id_socio_carbono: 'BR0145PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0138EM:socio_adm'],
//   },
//   {
//     nome_socio: 'DENISE VIANA BORGES',
//     tipo: 'persona',
//     id_socio: '***200532**',
//     id_socio_carbono: 'BR0144PER',
//     relacao_com_empresa: 'Presidente',
//     id_rol: 'presidente',
//     relacion_empresas_rol: ['BR0139EM:presidente'],
//   },
//   {
//     nome_socio: 'FABIANA BARBOSA GOMES',
//     tipo: 'persona',
//     id_socio: '***321292**',
//     id_socio_carbono: 'BR0212PER',
//     relacao_com_empresa: 'Presidente',
//     id_rol: 'presidente',
//     relacion_empresas_rol: ['BR0140EM:presidente'],
//   },
//   {
//     nome_socio: 'FELIPE MOURA SALES',
//     tipo: 'persona',
//     id_socio: '***586582**',
//     id_socio_carbono: 'BR0324PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0141EM:socio_adm'],
//   },
//   {
//     nome_socio: 'PAULO SILVA CESARIO ROSA',
//     tipo: 'persona',
//     id_socio: '***351442**',
//     id_socio_carbono: 'BR0225PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0141EM:socio_adm'],
//   },
//   {
//     nome_socio: 'FABIO THAINES',
//     tipo: 'persona',
//     id_socio: '***602511**',
//     id_socio_carbono: 'BR0332PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0142EM:socio'],
//   },
//   {
//     nome_socio: 'IGOR AGAPEJEV DE ANDRADE',
//     tipo: 'persona',
//     id_socio: '***979048**',
//     id_socio_carbono: 'BR0524PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0142EM:socio_adm'],
//   },
//   {
//     nome_socio: 'ALDERI EMIDIO DE ARAUJO',
//     tipo: 'persona',
//     id_socio: '***860108**',
//     id_socio_carbono: 'BR0457PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0144EM:director'],
//   },
//   {
//     nome_socio: 'ANA MARGARIDA CASTRO EULER',
//     tipo: 'persona',
//     id_socio: '***716557**',
//     id_socio_carbono: 'BR0390PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0144EM:director'],
//   },
//   {
//     nome_socio: 'CLENIO NAILTO PILLON',
//     tipo: 'persona',
//     id_socio: '***639420**',
//     id_socio_carbono: 'BR0345PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0144EM:director'],
//   },
//   {
//     nome_socio: 'SELMA LUCIA LIRA BELTRAO',
//     tipo: 'persona',
//     id_socio: '***945164**',
//     id_socio_carbono: 'BR0510PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0144EM:director'],
//   },
//   {
//     nome_socio: 'SILVIA MARIA FONSECA SILVEIRA MASSRUHA',
//     tipo: 'persona',
//     id_socio: '***083228**',
//     id_socio_carbono: 'BR0096PER',
//     relacao_com_empresa: 'Presidente',
//     id_rol: 'presidente',
//     relacion_empresas_rol: ['BR0144EM:presidente'],
//   },
//   {
//     nome_socio: 'ELENIRA GADELHA BEZERRA MENDES',
//     tipo: 'persona',
//     id_socio: '***467282**',
//     id_socio_carbono: 'BR0276PER',
//     relacao_com_empresa: 'Presidente',
//     id_rol: 'presidente',
//     relacion_empresas_rol: ['BR0145EM:presidente'],
//   },
//   {
//     nome_socio: 'CELIA MARIA MARINHO DE ARAUJO MELO',
//     tipo: 'persona',
//     id_socio: '***306553**',
//     id_socio_carbono: 'BR0204PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0147EM:administrador'],
//   },
//   {
//     nome_socio: 'MARIA LUCILENE FERREIRA',
//     tipo: 'persona',
//     id_socio: '***743652**',
//     id_socio_carbono: 'BR0401PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0147EM:administrador'],
//   },
//   {
//     nome_socio: 'CILL CONSULTORIA E ASSESSORIA EMPRESARIAL LTDA',
//     tipo: 'empresa',
//     id_socio: '3.54267E+12',
//     id_socio_carbono: 'XX0005EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0147EM:socio'],
//   },
//   {
//     nome_socio: 'PIQUIA HOLDING LTDA',
//     tipo: 'empresa',
//     id_socio: '3.02523E+12',
//     id_socio_carbono: 'XX0003EM2',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0147EM:socio'],
//   },
//   {
//     nome_socio: 'FRANCISCO UMBERTO PRADO COUTO',
//     tipo: 'persona',
//     id_socio: '***797238**',
//     id_socio_carbono: 'BR0424PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0148EM:socio_adm'],
//   },
//   {
//     nome_socio: 'MARCIO ROBERTO PINTO LISBOA PINHEIRO',
//     tipo: 'persona',
//     id_socio: '***099482**',
//     id_socio_carbono: 'BR0098PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0149EM:director', 'BR0150EM:director'],
//   },
//   {
//     nome_socio: 'ANDRE LUIZ PINTO LISBOA PINHEIRO',
//     tipo: 'persona',
//     id_socio: '***759702**',
//     id_socio_carbono: 'BR0407PER',
//     relacao_com_empresa: 'Presidente',
//     id_rol: 'presidente',
//     relacion_empresas_rol: ['BR0149EM:presidente', 'BR0150EM:presidente'],
//   },
//   {
//     nome_socio: 'OKRYT KUANTORO',
//     tipo: 'persona',
//     id_socio: '***035802**',
//     id_socio_carbono: 'BR0002PER',
//     relacao_com_empresa: 'Presidente',
//     id_rol: 'presidente',
//     relacion_empresas_rol: ['BR0151EM:presidente'],
//   },
//   {
//     nome_socio: 'ELIMARA PARINTINTIN',
//     tipo: 'persona',
//     id_socio: '***220952**',
//     id_socio_carbono: 'BR0017PER',
//     relacao_com_empresa: 'Presidente',
//     id_rol: 'presidente',
//     relacion_empresas_rol: ['BR0152EM:presidente'],
//   },
//   {
//     nome_socio: 'JUAREZ CINTA LARGA',
//     tipo: 'persona',
//     id_socio: '***390511**',
//     id_socio_carbono: 'BR0028PER',
//     relacao_com_empresa: 'Presidente',
//     id_rol: 'presidente',
//     relacion_empresas_rol: ['BR0153EM:presidente'],
//   },
//   {
//     nome_socio: 'OITA MATINA CINTA LARGA FILHO SEMANI',
//     tipo: 'persona',
//     id_socio: '***986872**',
//     id_socio_carbono: 'BR0043PER',
//     relacao_com_empresa: 'Presidente',
//     id_rol: 'presidente',
//     relacion_empresas_rol: ['BR0154EM:presidente'],
//   },
//   {
//     nome_socio: 'FRANCINILDO COSME KABA MUNDURUKU',
//     tipo: 'persona',
//     id_socio: '***599952**',
//     id_socio_carbono: 'BR0032PER',
//     relacao_com_empresa: 'Presidente',
//     id_rol: 'presidente',
//     relacion_empresas_rol: ['BR0155EM:presidente'],
//   },
//   {
//     nome_socio: 'EUMARIA ASSIRI MAKURAP',
//     tipo: 'persona',
//     id_socio: '***200812**',
//     id_socio_carbono: 'BR0016PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0156EM:director'],
//   },
//   {
//     nome_socio: 'MARIA SILVA CABRAL',
//     tipo: 'persona',
//     id_socio: '***344522**',
//     id_socio_carbono: 'BR0024PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0156EM:director'],
//   },
//   {
//     nome_socio: 'THALIA ASSIRY CINTA LARGA',
//     tipo: 'persona',
//     id_socio: '***091582**',
//     id_socio_carbono: 'BR0009PER',
//     relacao_com_empresa: 'Presidente',
//     id_rol: 'presidente',
//     relacion_empresas_rol: ['BR0156EM:presidente'],
//   },
//   {
//     nome_socio: 'ALEXIS DE MORAES CANTAUX',
//     tipo: 'persona',
//     id_socio: '***813938**',
//     id_socio_carbono: 'BR0039PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0157EM:director'],
//   },
//   {
//     nome_socio: 'JEAN PIERRE PAUL CANTAUX',
//     tipo: 'persona',
//     id_socio: '***271438**',
//     id_socio_carbono: 'BR0021PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0157EM:director', 'BR0159EM:socio_adm'],
//   },
//   {
//     nome_socio: 'SERVIO TULIO PRADO JUNIOR',
//     tipo: 'persona',
//     id_socio: '***875808**',
//     id_socio_carbono: 'BR0042PER',
//     relacao_com_empresa: 'Representante Legal',
//     id_rol: 'rep_legal',
//     relacion_empresas_rol: ['BR0158EM:rep_legal'],
//   },
//   {
//     nome_socio: 'CESAR EDUARDO BECHARA ARB CAMARDO',
//     tipo: 'persona',
//     id_socio: '***123998**',
//     id_socio_carbono: 'BR0011PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0158EM:socio'],
//   },
//   {
//     nome_socio: 'DAIL DAE IL SONG',
//     tipo: 'persona',
//     id_socio: '***225678**',
//     id_socio_carbono: 'BR0018PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0158EM:socio'],
//   },
//   {
//     nome_socio: 'FERNANDO LOPES ALBERTO',
//     tipo: 'persona',
//     id_socio: '***603498**',
//     id_socio_carbono: 'BR0033PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0158EM:socio'],
//   },
//   {
//     nome_socio: 'GABRIEL KIM',
//     tipo: 'persona',
//     id_socio: '***049508**',
//     id_socio_carbono: 'BR0003PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0158EM:socio'],
//   },
//   {
//     nome_socio: 'LUCIANO DA SILVEIRA ARAUJO',
//     tipo: 'persona',
//     id_socio: '***656508**',
//     id_socio_carbono: 'BR0035PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0158EM:socio'],
//   },
//   {
//     nome_socio: 'MARCELO PEREIRA BINDER',
//     tipo: 'persona',
//     id_socio: '***845488**',
//     id_socio_carbono: 'BR0040PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0158EM:socio'],
//   },
//   {
//     nome_socio: 'RUI PEDRO DE ALMEIDA RIBEIRO',
//     tipo: 'persona',
//     id_socio: '***262658**',
//     id_socio_carbono: 'BR0020PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0158EM:socio'],
//   },
//   {
//     nome_socio: 'SEOK YEON CHANG',
//     tipo: 'persona',
//     id_socio: '***189278**',
//     id_socio_carbono: 'BR0015PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0158EM:socio'],
//   },
//   {
//     nome_socio: 'YIM KYU LEE',
//     tipo: 'persona',
//     id_socio: '***154388**',
//     id_socio_carbono: 'BR0012PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0158EM:socio'],
//   },
//   {
//     nome_socio: 'JEAN CLAUDE PINTO BARRETO',
//     tipo: 'persona',
//     id_socio: '***795057**',
//     id_socio_carbono: 'BR0038PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0159EM:socio'],
//   },
//   {
//     nome_socio: 'PAULO BRAGA',
//     tipo: 'persona',
//     id_socio: '***583338**',
//     id_socio_carbono: 'BR0031PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0159EM:socio'],
//   },
//   {
//     nome_socio: 'ANDREIA DE QUEIROZ FREIRE',
//     tipo: 'persona',
//     id_socio: '***027062**',
//     id_socio_carbono: 'BR0001PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0160EM:socio'],
//   },
//   {
//     nome_socio: 'SAID ELIAS VASCONCELOS NOGUEIRA',
//     tipo: 'persona',
//     id_socio: '***084582**',
//     id_socio_carbono: 'BR0008PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0160EM:socio_adm'],
//   },
//   {
//     nome_socio: 'CEZAR DA CUNHA MELO SENA',
//     tipo: 'persona',
//     id_socio: '***288556**',
//     id_socio_carbono: 'BR0022PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0162EM:director'],
//   },
//   {
//     nome_socio: 'FABRICIO PERES MAZAIA',
//     tipo: 'persona',
//     id_socio: '***382038**',
//     id_socio_carbono: 'BR0027PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0162EM:director'],
//   },
//   {
//     nome_socio: 'NEY NELSON MACHADO DE SOUSA',
//     tipo: 'persona',
//     id_socio: '***174078**',
//     id_socio_carbono: 'BR0014PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0162EM:director'],
//   },
//   {
//     nome_socio: 'SHIGEHARU KATO',
//     tipo: 'persona',
//     id_socio: '***123811**',
//     id_socio_carbono: 'BR0010PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0162EM:director'],
//   },
//   {
//     nome_socio: 'SHOHEI NODA',
//     tipo: 'persona',
//     id_socio: '***363348**',
//     id_socio_carbono: 'BR0025PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0162EM:director'],
//   },
//   {
//     nome_socio: 'TAKANOBU KODAMA',
//     tipo: 'persona',
//     id_socio: '***859728**',
//     id_socio_carbono: 'BR0041PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0162EM:director'],
//   },
//   {
//     nome_socio: 'THIAGO LUIZ GOERCK',
//     tipo: 'persona',
//     id_socio: '***490328**',
//     id_socio_carbono: 'BR0029PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0162EM:director'],
//   },
//   {
//     nome_socio: 'YASUYUKI HIDAKA',
//     tipo: 'persona',
//     id_socio: '***774078**',
//     id_socio_carbono: 'BR0037PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0162EM:director'],
//   },
//   {
//     nome_socio: 'MAURO DONISETI SILVERIO RODRIGUES',
//     tipo: 'persona',
//     id_socio: '***051909**',
//     id_socio_carbono: 'BR0004PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0163EM:socio_adm'],
//   },
//   {
//     nome_socio: 'REMY DENECHEAU',
//     tipo: 'persona',
//     id_socio: '***082547**',
//     id_socio_carbono: 'BR0007PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0164EM:socio_adm', 'BR0165EM:socio_adm'],
//   },
//   {
//     nome_socio: 'ANA MARIA GOMES MATA',
//     tipo: 'persona',
//     id_socio: '***158087**',
//     id_socio_carbono: 'BR0013PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0165EM:socio'],
//   },
//   {
//     nome_socio: 'ADAMOR MACEDO PINTO',
//     tipo: 'persona',
//     id_socio: '***062202**',
//     id_socio_carbono: 'BR0005PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0166EM:director'],
//   },
//   {
//     nome_socio: 'MANOEL PEDRO BRAGA PAES',
//     tipo: 'persona',
//     id_socio: '***643672**',
//     id_socio_carbono: 'BR0034PER',
//     relacao_com_empresa: 'Diretor',
//     id_rol: 'director',
//     relacion_empresas_rol: ['BR0166EM:director'],
//   },
//   {
//     nome_socio: 'ANTONIO CARLOS MONTEIRO FONSECA',
//     tipo: 'persona',
//     id_socio: '***369302**',
//     id_socio_carbono: 'BR0026PER',
//     relacao_com_empresa: 'Presidente',
//     id_rol: 'presidente',
//     relacion_empresas_rol: ['BR0166EM:presidente'],
//   },
//   {
//     nome_socio: 'ALLAN MORGADO GUERRA',
//     tipo: 'persona',
//     id_socio: '***677107**',
//     id_socio_carbono: 'BR0369PER',
//     relacao_com_empresa: 'Administrador',
//     id_rol: 'administrador',
//     relacion_empresas_rol: ['BR0168EM:administrador'],
//   },
//   {
//     nome_socio: 'PINNACLE GLOBAL PARTNERS',
//     tipo: 'empresa',
//     id_socio: '2.75064E+13',
//     id_socio_carbono: 'XX0036EM2',
//     relacao_com_empresa: 'Sócio Pessoa Jurídica Domiciliado no Exterior',
//     id_rol: 'socio_pj_dom_ex',
//     relacion_empresas_rol: ['BR0168EM:socio_pj_dom_ex'],
//   },
//   {
//     nome_socio: 'RAFAELLA FERRAZ SOUZA',
//     tipo: 'persona',
//     id_socio: '***752797**',
//     id_socio_carbono: 'BR0036PER',
//     relacao_com_empresa: 'Representante Legal',
//     id_rol: 'rep_legal',
//     relacion_empresas_rol: ['BR0169EM:rep_legal'],
//   },
//   {
//     nome_socio: 'PEDRO RUHS DA SILVA',
//     tipo: 'persona',
//     id_socio: '***339947**',
//     id_socio_carbono: 'BR0023PER',
//     relacao_com_empresa: 'Representante Legal',
//     id_rol: 'rep_legal',
//     relacion_empresas_rol: ['BR0170EM:rep_legal'],
//   },
//   {
//     nome_socio: 'ALEXANDRE DA ROSA',
//     tipo: 'persona',
//     id_socio: '***060148**',
//     id_socio_carbono: 'BR0081PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['BR0170EM:socio_adm'],
//   },
//   {
//     nome_socio: 'MARIA ALICE',
//     tipo: 'persona',
//     id_socio: '***572288**',
//     id_socio_carbono: 'BR0030PER',
//     relacao_com_empresa: 'Representante Legal',
//     id_rol: 'rep_legal',
//     relacion_empresas_rol: ['EX0002EM:rep_legal'],
//   },
//   {
//     nome_socio: 'Maurício Moura Costa',
//     tipo: 'persona',
//     id_socio: 'No disponible',
//     id_socio_carbono: 'BR0534PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['EX0017EM:socio_adm', 'EX0015EM:director'],
//   },
//   {
//     nome_socio: 'Pedro Henrique Moura Costa',
//     tipo: 'persona',
//     id_socio: 'No disponible',
//     id_socio_carbono: 'BR0535PER',
//     relacao_com_empresa: 'Sócio-Administrador',
//     id_rol: 'socio_adm',
//     relacion_empresas_rol: ['EX0017EM:socio_adm', 'EX0015EM:director'],
//   },
//   {
//     nome_socio: 'MARIA MATOGROSSO COSTA',
//     tipo: 'persona',
//     id_socio: '***526042**',
//     id_socio_carbono: 'BR0302PER',
//     relacao_com_empresa: 'Sócio',
//     id_rol: 'socio',
//     relacion_empresas_rol: ['BR0078EM:socio'],
//   },
// ]

const PersonasBR: IPersonas[] = [
  {
    nome_socio:
      'A A Cavalca Administracao De Bens Proprios E Participacoes Ltda.',
    id_socio: '01.569.232/0001-28',
    id_socio_carbono: 'SO0001ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0123EM:socio'],
  },
  {
    nome_socio: 'Ack Participacoes Societarias Ltda',
    id_socio: '29.122.221/0001-14',
    id_socio_carbono: 'SO0002ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0123EM:socio'],
  },
  {
    nome_socio: 'Adalva Maria Galindo',
    id_socio: '***024608**',
    id_socio_carbono: 'SO0003PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0132EM:director'],
  },
  {
    nome_socio: 'Adamor Macedo Pinto',
    id_socio: '***062202**',
    id_socio_carbono: 'SO0004PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0032EM:director'],
  },
  {
    nome_socio: 'Aderval Jose Dalmaso',
    id_socio: '***831842**',
    id_socio_carbono: 'SO0005PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0186EM:director'],
  },
  {
    nome_socio: 'Adilson Do Nascimento Andrade',
    id_socio: '***772442**',
    id_socio_carbono: 'SO0006PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0106EM:presidente'],
  },
  {
    nome_socio: 'Adnan Demachki',
    id_socio: '***781292**',
    id_socio_carbono: 'SO0007PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0155EM:soccio_diretor'],
  },
  {
    nome_socio: 'Adriano D Agnoluzzo',
    id_socio: '***215749**',
    id_socio_carbono: 'SO0008PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: [
      'BRA0029EM:socio',
      'BRA0062EM:soccio_diretor',
      'BRA0139EM:soccio_diretor',
      'BRA0193EM:soccio_diretor',
    ],
  },
  {
    nome_socio: 'Adriano Saraceni Bandeira',
    id_socio: '***487208**',
    id_socio_carbono: 'SO0009PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0008EM:administrador'],
  },
  {
    nome_socio: 'Afar Participacoes Societarias Ltda',
    id_socio: '21.974.561/0001-61',
    id_socio_carbono: 'SO0010ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0123EM:socio'],
  },
  {
    nome_socio:
      'Agro Maripa - Participacoes, Empreendimentos E Administracao Ltda',
    id_socio: '01.240.653/0001-00',
    id_socio_carbono: 'SO0011ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0039EM:socio'],
  },
  {
    nome_socio: 'Agrocortex Florestas Do Brasil Participacoes S.A.',
    id_socio: '19.374.422/0001-55',
    id_socio_carbono: 'SO0012ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0104EM:socio'],
  },
  {
    nome_socio: 'Agrocortex Florestas Tropicais Participacoes Ltda.',
    id_socio: '19.846.881/0001-94',
    id_socio_carbono: 'SO0013ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0059EM:socio', 'BRA0104EM:socio'],
  },
  {
    nome_socio: 'Aigle Cavalca Knack',
    id_socio: '***138519**',
    id_socio_carbono: 'SO0014PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0123EM:administrador'],
  },
  {
    nome_socio: 'Alain Juan Pablo Belda Fernandez',
    id_socio: '***686058**',
    id_socio_carbono: 'SO0015PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0158EM:director'],
  },
  {
    nome_socio: 'Alan Carlos Guedes De Oliveira',
    id_socio: '***550179**',
    id_socio_carbono: 'SO0016PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0001EM:director'],
  },
  {
    nome_socio: 'Alberto Martinhago Vieira',
    id_socio: '***842999**',
    id_socio_carbono: 'SO0017PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0001EM:director'],
  },
  {
    nome_socio: 'Alcides Cavalca Neto',
    id_socio: '***708829**',
    id_socio_carbono: 'SO0018PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0123EM:administrador'],
  },
  {
    nome_socio: 'Alcimar Dacko',
    id_socio: '***168880**',
    id_socio_carbono: 'SO0019PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0012EM:soccio_diretor'],
  },
  {
    nome_socio: 'Alderi Emidio De Araujo',
    id_socio: '***860108**',
    id_socio_carbono: 'SO0020PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0003EM:director'],
  },
  {
    nome_socio: 'Aldo Roberto Tisott',
    id_socio: '***009870**',
    id_socio_carbono: 'SO0021PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0103EM:administrador'],
  },
  {
    nome_socio: 'Alessandra Bessa Alves De Melo',
    id_socio: '***259048**',
    id_socio_carbono: 'SO0022PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0068EM:miembro_junta'],
  },
  {
    nome_socio: 'Alex Sandro Da Silva',
    id_socio: '***605588**',
    id_socio_carbono: 'SO0023PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0072EM:socio_ccapital'],
  },
  {
    nome_socio: 'Alexandre Bertoldi',
    id_socio: '***031318**',
    id_socio_carbono: 'SO0024PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Alexandre Da Rosa',
    id_socio: '***060148**',
    id_socio_carbono: 'SO0025PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0113EM:soccio_diretor'],
  },
  {
    nome_socio: 'Alexandre Enrico Silva Figliolino',
    id_socio: '***668698**',
    id_socio_carbono: 'SO0026PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0158EM:director'],
  },
  {
    nome_socio: 'Alexandre Ferreira Bossi',
    id_socio: '***553038**',
    id_socio_carbono: 'SO0626PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0121EM:presidente', 'BRA0171EM:director'],
  },
  {
    nome_socio: 'Alexandre Outeda Jorge',
    id_socio: '***356338**',
    id_socio_carbono: 'SO0027PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Alexandre Uezu',
    id_socio: '***977958**',
    id_socio_carbono: 'SO0028PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0111EM:soccio_diretor'],
  },
  {
    nome_socio: 'Alexis De Moraes Cantaux',
    id_socio: '***813938**',
    id_socio_carbono: 'SO0029PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0143EM:director'],
  },
  {
    nome_socio: 'Allan Morgado Guerra',
    id_socio: '***677107**',
    id_socio_carbono: 'SO0030PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0101EM:administrador'],
  },
  {
    nome_socio: 'Almir Narayamoga Surui',
    id_socio: '***366972**',
    id_socio_carbono: 'SO0031PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0196EM:presidente'],
  },
  {
    nome_socio: 'Alvaro Luiz Dilli Goncalves',
    id_socio: '***062441**',
    id_socio_carbono: 'SO0032PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0086EM:director'],
  },
  {
    nome_socio: 'Alvaro Silas Uliani Martins Dos Santos',
    id_socio: '***170258**',
    id_socio_carbono: 'SO0033PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Amazon Climate Exchangr',
    id_socio: '11.085.975/0001-86',
    id_socio_carbono: 'SO0681ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['CAN0004EM:socio'],
  },
  {
    nome_socio: 'Amazonia Solucoes Para A Sustentabilidade Ltda.',
    id_socio: '10.577.464/0001-19',
    id_socio_carbono: 'SO0034ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0090EM:socio'],
  },
  {
    nome_socio: 'Amintas De Oliveira Brandao Junior',
    id_socio: '***647222**',
    id_socio_carbono: 'SO0035PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0125EM:soccio_diretor'],
  },
  {
    nome_socio: 'Amplewell Holdings Limited',
    id_socio: '10.793.175/0001-57',
    id_socio_carbono: 'SO0036ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0069EM:socio'],
  },
  {
    nome_socio: 'Ana Beatriz Ribeiro De Queiroz',
    id_socio: '***739806**',
    id_socio_carbono: 'SO0037PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0038EM:socio', 'BRA0060EM:socio'],
  },
  {
    nome_socio: 'Ana Carolina Fernandes Carpinetti',
    id_socio: '***593738**',
    id_socio_carbono: 'SO0038PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Ana Carolina Ribeiro Valadares Gontijo Couto',
    id_socio: '***444816**',
    id_socio_carbono: 'SO0632PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: [
      'BRA0046EM:soccio_diretor',
      'BRA0085EM:soccio_diretor',
    ],
  },
  {
    nome_socio: 'Ana Cristina Rosa Garcia',
    id_socio: '***443671**',
    id_socio_carbono: 'SO0039PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0001EM:director'],
  },
  {
    nome_socio: 'Ana Lucia Ribeiro Valadares Gontijo',
    id_socio: '***370276**',
    id_socio_carbono: 'SO0661PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0085EM:soccio_diretor'],
  },
  {
    nome_socio: 'Ana Margarida Castro Euler',
    id_socio: '***716557**',
    id_socio_carbono: 'SO0040PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0003EM:director'],
  },
  {
    nome_socio: 'Ana Maria Gomes Mata',
    id_socio: '***158087**',
    id_socio_carbono: 'SO0041PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0166EM:socio'],
  },
  {
    nome_socio: 'Ana Valeria Clausen Chaves',
    id_socio: '***944339**',
    id_socio_carbono: 'SO0673PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0089EM:soccio_diretor'],
  },
  {
    nome_socio: 'Anderson Angelo De Souza',
    id_socio: '***177605**',
    id_socio_carbono: 'SO0042PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0091EM:director'],
  },
  {
    nome_socio: 'Anderson De Oliveira Alexandre',
    id_socio: '***679561**',
    id_socio_carbono: 'SO0662PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0087EM:soccio_diretor'],
  },
  {
    nome_socio: 'Andre Cinta Larga',
    id_socio: '***813112**',
    id_socio_carbono: 'SO0645PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0180EM:director'],
  },
  {
    nome_socio: 'Andre Luis Cavalcanti De Albuquerque',
    id_socio: '***897999**',
    id_socio_carbono: 'SO0671PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: [
      'BRA0089EM:administrador',
      'BRA0089EM:representante_legal',
    ],
  },
  {
    nome_socio: 'Andre Luis Dos Santos Ribeiro',
    id_socio: '***424298**',
    id_socio_carbono: 'SO0043PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0110EM:director'],
  },
  {
    nome_socio: 'Andre Luiz Pinto Lisboa Pinheiro',
    id_socio: '***759702**',
    id_socio_carbono: 'SO0044PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0025EM:presidente', 'BRA0030EM:presidente'],
  },
  {
    nome_socio: 'Andre Moraes Marques',
    id_socio: '***811118**',
    id_socio_carbono: 'SO0045PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Andre Nogueira Borba',
    id_socio: '***681646**',
    id_socio_carbono: 'SO0046PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0023EM:director'],
  },
  {
    nome_socio: 'Andre Roberto Dos Santos Manfredini',
    id_socio: '***357479**',
    id_socio_carbono: 'SO0047PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0105EM:administrador'],
  },
  {
    nome_socio: 'Andre Vertullo Bernini',
    id_socio: '***789178**',
    id_socio_carbono: 'SO0048PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Andre Vivan De Souza',
    id_socio: '***419238**',
    id_socio_carbono: 'SO0049PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Andre Zonaro Giacchetta',
    id_socio: '***805378**',
    id_socio_carbono: 'SO0050PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Andrea Mascitto',
    id_socio: '***882918**',
    id_socio_carbono: 'SO0051PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Andreia De Queiroz Freire',
    id_socio: '***027062**',
    id_socio_carbono: 'SO0052PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0119EM:socio'],
  },
  {
    nome_socio: 'Andreza Kelly Delbon De Sousa',
    id_socio: '***788628**',
    id_socio_carbono: 'SO0053PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0076EM:soccio_diretor'],
  },
  {
    nome_socio: 'Anelize Lenzi Ruas De Almeida',
    id_socio: '***195641**',
    id_socio_carbono: 'SO0054PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0001EM:miembro_junta'],
  },
  {
    nome_socio: 'Angela Fan Chi Kung',
    id_socio: '***524188**',
    id_socio_carbono: 'SO0055PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Angelo Paccelli Cipriano Rabelo',
    id_socio: '***644391**',
    id_socio_carbono: 'SO0056PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0094EM:presidente'],
  },
  {
    nome_socio: 'Antonio Carlos Monteiro Fonseca',
    id_socio: '***369302**',
    id_socio_carbono: 'SO0057PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0032EM:presidente'],
  },
  {
    nome_socio: 'Antonio Carlos Wagner Chiarello',
    id_socio: '***263100**',
    id_socio_carbono: 'SO0058PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0001EM:director'],
  },
  {
    nome_socio: 'Antonio Fernando De Gaspari',
    id_socio: '***264308**',
    id_socio_carbono: 'SO0059PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0007EM:soccio_diretor'],
  },
  {
    nome_socio: 'Antonio Jose Ludovino Lopes',
    id_socio: '***734848**',
    id_socio_carbono: 'SO0060PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0052EM:soccio_diretor'],
  },
  {
    nome_socio: 'Antonio Jose Mattos Morello',
    id_socio: '***258138**',
    id_socio_carbono: 'SO0061PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Apsis Carbon Intermediacao Ltda.',
    id_socio: '48.999.869/0001-18',
    id_socio_carbono: 'SO0668ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0185EM:socio'],
  },
  {
    nome_socio: 'Ari Zugman',
    id_socio: '***806279**',
    id_socio_carbono: 'SO0062PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0035EM:presidente'],
  },
  {
    nome_socio: 'Arlei Rodrigues Fontoura',
    id_socio: '***997180**',
    id_socio_carbono: 'SO0063PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0066EM:administrador'],
  },
  {
    nome_socio: 'Arlindo De Azevedo Moura',
    id_socio: '***459100**',
    id_socio_carbono: 'SO0064PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0047EM:miembro_junta'],
  },
  {
    nome_socio: 'Arthur Chiarotto Penteado',
    id_socio: '***456578**',
    id_socio_carbono: 'SO0065PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: [
      'BRA0056EM:soccio_diretor',
      'BRA0070EM:soccio_diretor',
      'BRA0167EM:soccio_diretor',
    ],
  },
  {
    nome_socio: 'Arthur Junqueira Ferreira Penteado',
    id_socio: '***150158**',
    id_socio_carbono: 'SO0066PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0056EM:produtor_rural'],
  },
  {
    nome_socio: 'Aurelio Pavinato',
    id_socio: '***973590**',
    id_socio_carbono: 'SO0067PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0086EM:administrador', 'BRA0103EM:administrador'],
  },
  {
    nome_socio: 'Avenor Teixeira De Carvalho Neto',
    id_socio: '***146346**',
    id_socio_carbono: 'SO0068PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0160EM:director'],
  },
  {
    nome_socio: 'Aweakynga Parakana',
    id_socio: '***385672**',
    id_socio_carbono: 'SO0630PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0129EM:presidente'],
  },
  {
    nome_socio: 'Barbara Rege Palomo Pavan',
    id_socio: '***209098**',
    id_socio_carbono: 'SO0069PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0072EM:socio_scapital'],
  },
  {
    nome_socio: 'Batista & Cia Ltda',
    id_socio: '22839815/0001-00',
    id_socio_carbono: 'SO0070ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0176EM:socio'],
  },
  {
    nome_socio: 'Beny Fiterman',
    id_socio: '***861438**',
    id_socio_carbono: 'SO0071PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0023EM:director'],
  },
  {
    nome_socio: 'Bernard Gustave Pierre Cassagne',
    id_socio: '***543362**',
    id_socio_carbono: 'SO0072PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0066EM:socio'],
  },
  {
    nome_socio: 'Bernardo Parnes',
    id_socio: '***102448**',
    id_socio_carbono: 'SO0073PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0091EM:miembro_junta'],
  },
  {
    nome_socio: 'Bianca Pumar Coelho',
    id_socio: '***009287**',
    id_socio_carbono: 'SO0074PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Bio Assets Ativos Ambientais Ltda',
    id_socio: '03.557.460/0001-03',
    id_socio_carbono: 'SO0075ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0040EM:socio'],
  },
  {
    nome_socio: 'Biocarbon Corp',
    id_socio: '45.683.558/0001-57',
    id_socio_carbono: 'SO0636ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0173EM:socio'],
  },
  {
    nome_socio: 'Blackbridge Corp.',
    id_socio: '19.444.940/0001-06',
    id_socio_carbono: 'SO0686ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0198EM:empresa_socia_ext'],
  },
  {
    nome_socio: 'Brazil Agfor, Llc',
    id_socio: '25.314.742/0001-12',
    id_socio_carbono: 'SO0076ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0127EM:socio'],
  },
  {
    nome_socio: 'Breno Pinto Figueiredo',
    id_socio: '***316027**',
    id_socio_carbono: 'SO0077PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0178EM:administrador'],
  },
  {
    nome_socio: 'Bruno Balduccini',
    id_socio: '***438088**',
    id_socio_carbono: 'SO0078PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Bruno Brazil De Souza',
    id_socio: '***986868**',
    id_socio_carbono: 'SO0079PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0147EM:soccio_diretor'],
  },
  {
    nome_socio: 'Bruno Melo Da Matta',
    id_socio: '***369088**',
    id_socio_carbono: 'SO0080PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0147EM:socio'],
  },
  {
    nome_socio: 'Bruno Tavares Da Silva',
    id_socio: '***073528**',
    id_socio_carbono: 'SO0082PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: [
      'BRA0159EM:administrador',
      'EMI0001EM:representante_legal',
    ],
  },
  {
    nome_socio: 'Bruno Tavares Da Silva',
    id_socio: '***073528**',
    id_socio_carbono: 'SO0081PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0159EM:administrador'],
  },
  {
    nome_socio: 'Bunge Brasil Holdings Bv',
    id_socio: '06051618/0001-67',
    id_socio_carbono: 'SO0083ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0051EM:socio'],
  },
  {
    nome_socio: 'Bunge Holdings B.V.',
    id_socio: '06.051.621/0001-80',
    id_socio_carbono: 'SO0084ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0051EM:socio'],
  },
  {
    nome_socio: 'Bvrio',
    id_socio: '17.573.498/0001-84',
    id_socio_carbono: 'SO0683ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['REI0002EM:socio'],
  },
  {
    nome_socio: 'Caio Carlos Cruz Ferreira Silva',
    id_socio: '***213297**',
    id_socio_carbono: 'SO0085PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Caio Mario Caldeira Brant Ribeiro',
    id_socio: '***735306**',
    id_socio_carbono: 'SO0086PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0038EM:socio', 'BRA0060EM:socio'],
  },
  {
    nome_socio: 'Caio Morales Depra',
    id_socio: '***932452**',
    id_socio_carbono: 'SO0087PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0186EM:director'],
  },
  {
    nome_socio: 'Camila Carvalho Gomes',
    id_socio: '***061068**',
    id_socio_carbono: 'SO0088PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Camila Martino Parise',
    id_socio: '***695058**',
    id_socio_carbono: 'SO0089PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Camilla Schindler',
    id_socio: '***693189**',
    id_socio_carbono: 'SO0090PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0187EM:presidente'],
  },
  {
    nome_socio: 'Carbon Credit Solutions Inc',
    id_socio: '34.490.801/0001-02',
    id_socio_carbono: 'SO0091ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0079EM:socio'],
  },
  {
    nome_socio: 'Carbon Credits Consulting S.R.L',
    id_socio: '42.905.382/0001-42',
    id_socio_carbono: 'SO0092ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0165EM:socio'],
  },
  {
    nome_socio: 'Carbonext Holding S.A',
    id_socio: '41.643.197/0001-64',
    id_socio_carbono: 'SO0093ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0082EM:socio'],
  },
  {
    nome_socio: 'Carla Nesi',
    id_socio: '***295868**',
    id_socio_carbono: 'SO0094PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0001EM:director'],
  },
  {
    nome_socio: 'Carlos Alberto Barbosa Porsch',
    id_socio: '***439179**',
    id_socio_carbono: 'SO0678PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0192EM:soccio_diretor'],
  },
  {
    nome_socio: 'Carlos Alberto Barbosa Porsch',
    id_socio: '***439179**',
    id_socio_carbono: 'SO0095PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0194EM:administrador'],
  },
  {
    nome_socio: 'Carlos Alberto Bernardo Mesquita',
    id_socio: '***425677**',
    id_socio_carbono: 'SO0101PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['REI0002EM:director'],
  },
  {
    nome_socio: 'Carlos Alberto Moreira Lima Junior',
    id_socio: '***383938**',
    id_socio_carbono: 'SO0096PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Carlos Augusto Vilhena De Magalhaes Cunha Filho',
    id_socio: '***758741**',
    id_socio_carbono: 'SO0097PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Carlos Eduardo Gazineu De Azevedo',
    id_socio: '***727048**',
    id_socio_carbono: 'SO0098PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Carlos Eduardo Guedes Pinto',
    id_socio: '***464088**',
    id_socio_carbono: 'SO0099PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0001EM:director'],
  },
  {
    nome_socio: 'Carlos Henrique Tranjan Bechara',
    id_socio: '***076297**',
    id_socio_carbono: 'SO0100PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Carlos Roberto Canabarro Gomes',
    id_socio: '***553600**',
    id_socio_carbono: 'SO0102PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0028EM:director'],
  },
  {
    nome_socio: 'Carlos Sergio Thomazi',
    id_socio: '***535769**',
    id_socio_carbono: 'SO0103PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0050EM:administrador'],
  },
  {
    nome_socio: 'Carolina Maria Rocha Freitas',
    id_socio: '***556577**',
    id_socio_carbono: 'SO0625PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0171EM:presidente'],
  },
  {
    nome_socio: 'Caroline Guazzelli Queiroz Gomes',
    id_socio: '***342228**',
    id_socio_carbono: 'SO0104PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Catarina Villares Stoppe',
    id_socio: '***184868**',
    id_socio_carbono: 'SO0105PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0120EM:soccio_diretor'],
  },
  {
    nome_socio: 'Caue Rezende Myanaki',
    id_socio: '***498738**',
    id_socio_carbono: 'SO0106PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Cavalcanti De Albuquerque Consultores Associados Ltda',
    id_socio: '11.465.692/0001-60',
    id_socio_carbono: 'SO0672ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0089EM:socio'],
  },
  {
    nome_socio: 'Celia Maria Marinho De Araujo Melo',
    id_socio: '***306553**',
    id_socio_carbono: 'SO0107PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0017EM:administrador'],
  },
  {
    nome_socio: 'Celia Regina Dancieri Martinelli',
    id_socio: '***620648**',
    id_socio_carbono: 'SO0108PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0168EM:socio'],
  },
  {
    nome_socio: 'Celso Cintra Mori',
    id_socio: '***295228**',
    id_socio_carbono: 'SO0109PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Cesar Eduardo Bechara Arb Camardo',
    id_socio: '***123998**',
    id_socio_carbono: 'SO0110PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0118EM:socio'],
  },
  {
    nome_socio: 'Cesar Eduardo Isaacson Buffara',
    id_socio: '***017689**',
    id_socio_carbono: 'SO0111PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0191EM:presidente'],
  },
  {
    nome_socio: 'Cezar Da Cunha Melo Sena',
    id_socio: '***288556**',
    id_socio_carbono: 'SO0112PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0061EM:director'],
  },
  {
    nome_socio: 'Chan Lap Tak',
    id_socio: '***201238**',
    id_socio_carbono: 'SO0114PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0040EM:soccio_diretor'],
  },
  {
    nome_socio: 'Christiana Soares Cabral Flecha',
    id_socio: '***148736**',
    id_socio_carbono: 'SO0116PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0082EM:administrador'],
  },
  {
    nome_socio: 'Cill Consultoria E Assessoria Empresarial Ltda',
    id_socio: '03.542.670/0001-28',
    id_socio_carbono: 'SO0117ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0017EM:socio'],
  },
  {
    nome_socio: 'Ciro Torres Freitas',
    id_socio: '***855898**',
    id_socio_carbono: 'SO0118PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Cjc Participacoes Ltda',
    id_socio: '50.486.543/0001-39',
    id_socio_carbono: 'SO0119ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0050EM:socio'],
  },
  {
    nome_socio: 'Claudio Uezu',
    id_socio: '***574778**',
    id_socio_carbono: 'SO0120PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0111EM:socio'],
  },
  {
    nome_socio: 'Clemente Soares Hamoy',
    id_socio: '***928602**',
    id_socio_carbono: 'SO0121PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0035EM:director'],
  },
  {
    nome_socio: 'Clenio Nailto Pillon',
    id_socio: '***639420**',
    id_socio_carbono: 'SO0122PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0003EM:director'],
  },
  {
    nome_socio: 'Cornelio Adriano Sanders',
    id_socio: '***095320**',
    id_socio_carbono: 'SO0648PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['NAN0005EM:soccio_diretor'],
  },
  {
    nome_socio: 'Crasso Paulo Bosco Breviglieri',
    id_socio: '***511618**',
    id_socio_carbono: 'SO0123PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0140EM:soccio_diretor'],
  },
  {
    nome_socio: 'Cristiane Bley Kesterke Clausen',
    id_socio: '***408519**',
    id_socio_carbono: 'SO0124PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0191EM:director'],
  },
  {
    nome_socio: 'Cristiane Ianagui Matsumoto',
    id_socio: '***050458**',
    id_socio_carbono: 'SO0125PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Cristiane Vancine Leme',
    id_socio: '***364948**',
    id_socio_carbono: 'SO0635PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0173EM:administrador'],
  },
  {
    nome_socio: 'Cristiani Silvestre',
    id_socio: '***150228**',
    id_socio_carbono: 'SO0126PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0122EM:soccio_diretor'],
  },
  {
    nome_socio: 'Cristianne Saccab Zarzur Chaccur',
    id_socio: '***458478**',
    id_socio_carbono: 'SO0127PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Cristiano Soares Rodrigues',
    id_socio: '***919117**',
    id_socio_carbono: 'SO0128PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: [
      'BRA0018EM:presidente',
      'BRA0019EM:director',
      'BRA0047EM:presidente',
    ],
  },
  {
    nome_socio: 'Cvl Participacoes Societarias Ltda.',
    id_socio: '09.474.443/0001-99',
    id_socio_carbono: 'SO0129ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0123EM:socio'],
  },
  {
    nome_socio: 'Dail Dae Il Song',
    id_socio: '***225678**',
    id_socio_carbono: 'SO0130PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0118EM:socio'],
  },
  {
    nome_socio: 'Daniel Costa Rebello',
    id_socio: '***585701**',
    id_socio_carbono: 'SO0131PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Daniel Dayeh Rocha',
    id_socio: '***932718**',
    id_socio_carbono: 'SO0132PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0134EM:socio'],
  },
  {
    nome_socio: 'Daniel Frank Cavalcante De Almeida',
    id_socio: '***821473**',
    id_socio_carbono: 'SO0663PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0169EM:soccio_diretor'],
  },
  {
    nome_socio: 'Daniel Moreira Florence',
    id_socio: '***499317**',
    id_socio_carbono: 'SO0133PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0047EM:director'],
  },
  {
    nome_socio: 'Daniel Yoshio Shinohara',
    id_socio: '***237928**',
    id_socio_carbono: 'SO0627PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0171EM:director'],
  },
  {
    nome_socio: 'Daniela De Campos Dansieri E Almeida Prado',
    id_socio: '***064708**',
    id_socio_carbono: 'SO0134PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0168EM:socio'],
  },
  {
    nome_socio: 'Dario Carnevalli Durigan',
    id_socio: '***672408**',
    id_socio_carbono: 'SO0135PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0001EM:miembro_junta'],
  },
  {
    nome_socio: 'David Escaquete',
    id_socio: '***023018**',
    id_socio_carbono: 'SO0136PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0147EM:soccio_diretor'],
  },
  {
    nome_socio: 'Denise Viana Borges',
    id_socio: '***200532**',
    id_socio_carbono: 'SO0137PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0034EM:presidente'],
  },
  {
    nome_socio: 'Dennis Souza Russelakis De Oliveira',
    id_socio: '***212382**',
    id_socio_carbono: 'SO0638PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0156EM:soccio_diretor'],
  },
  {
    nome_socio: 'Deryck Pantoja Martins',
    id_socio: '***869052**',
    id_socio_carbono: 'SO0138PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0074EM:soccio_diretor'],
  },
  {
    nome_socio: 'Diego Caldas Rivas De Simone',
    id_socio: '***607578**',
    id_socio_carbono: 'SO0139PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Diego Da Costa E Silva',
    id_socio: '***848702**',
    id_socio_carbono: 'SO0639PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0156EM:soccio_diretor'],
  },
  {
    nome_socio: 'Diego Hoebel Munhoz',
    id_socio: '***072969**',
    id_socio_carbono: 'SO0140PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: [
      'BRA0170EM:soccio_diretor',
      'BRA0174EM:soccio_diretor',
    ],
  },
  {
    nome_socio: 'Diego Machado Carrion Serrano',
    id_socio: '***277458**',
    id_socio_carbono: 'SO0141PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0080EM:socio', 'BRA0147EM:socio'],
  },
  {
    nome_socio: 'Diogenes Mendes Goncalves Neto',
    id_socio: '***515128**',
    id_socio_carbono: 'SO0142PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Divaldo Jose Da Costa Rezende',
    id_socio: '***539846**',
    id_socio_carbono: 'SO0143PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0011EM:socio'],
  },
  {
    nome_socio: 'Dn Participacoes Ltda',
    id_socio: '17.416.571/0001-04',
    id_socio_carbono: 'SO0144ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0050EM:socio'],
  },
  {
    nome_socio: 'Dorivaldo Ixati Javae',
    id_socio: '***364711**',
    id_socio_carbono: 'SO0654PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0149EM:presidente'],
  },
  {
    nome_socio: 'Douglas Antonio Granemann De Souza',
    id_socio: '***464009**',
    id_socio_carbono: 'SO0677PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: [
      'BRA0192EM:representante_legal',
      'BRA0192EM:soccio_diretor',
    ],
  },
  {
    nome_socio: 'Douglas Antonio Granemann De Souza',
    id_socio: '***464009**',
    id_socio_carbono: 'SO0145PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0194EM:administrador'],
  },
  {
    nome_socio: 'Edgard Mario De Medeiros Junior',
    id_socio: '***986482**',
    id_socio_carbono: 'SO0146PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0155EM:soccio_diretor'],
  },
  {
    nome_socio: 'Edison Ticle De Andrade Melo E Souza Filho',
    id_socio: '***300688**',
    id_socio_carbono: 'SO0147PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0157EM:administrador'],
  },
  {
    nome_socio: 'Edson Anastacio Filho',
    id_socio: '***834308**',
    id_socio_carbono: 'SO0148PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0072EM:socio'],
  },
  {
    nome_socio: 'Edson Julio Martins Paris',
    id_socio: '***443758**',
    id_socio_carbono: 'SO0676PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0081EM:soccio_diretor'],
  },
  {
    nome_socio: 'Edson Keller',
    id_socio: '***975608**',
    id_socio_carbono: 'SO0149PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0002EM:administrador'],
  },
  {
    nome_socio: 'Eduardo Carvalho Caiuby',
    id_socio: '***773268**',
    id_socio_carbono: 'SO0150PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Eduardo Cesar Pasa',
    id_socio: '***035920**',
    id_socio_carbono: 'SO0151PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0001EM:director'],
  },
  {
    nome_socio: 'Eduardo De Britto Pereira Azevedo',
    id_socio: '***208487**',
    id_socio_carbono: 'SO0152PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0019EM:director', 'BRA0047EM:miembro_junta'],
  },
  {
    nome_socio: 'Eduardo Gomes De Almeida',
    id_socio: '***930137**',
    id_socio_carbono: 'SO0153PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0068EM:miembro_junta'],
  },
  {
    nome_socio: 'Eduardo Gusson',
    id_socio: '***909988**',
    id_socio_carbono: 'SO0154PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0020EM:soccio_diretor'],
  },
  {
    nome_socio: 'Eduardo Henrique Paoliello Junior',
    id_socio: '***937038**',
    id_socio_carbono: 'SO0155PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Eduardo Martins De Oliveira',
    id_socio: '***225908**',
    id_socio_carbono: 'SO0687PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0198EM:socio'],
  },
  {
    nome_socio: 'Eduardo O Reilly Cabral Covas Barrionuevo',
    id_socio: '***055259**',
    id_socio_carbono: 'SO0156PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0084EM:director'],
  },
  {
    nome_socio: 'Eduardo Silva Logemann',
    id_socio: '***844760**',
    id_socio_carbono: 'SO0157PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0086EM:miembro_junta'],
  },
  {
    nome_socio: 'Eider Avelino Silva',
    id_socio: '***308926**',
    id_socio_carbono: 'SO0158PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Ejv Participacao Societaria Ltda',
    id_socio: '34.100.287/0001-43',
    id_socio_carbono: 'SO0159ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0050EM:socio'],
  },
  {
    nome_socio: 'Elimara Parintintin',
    id_socio: '***220952**',
    id_socio_carbono: 'SO0160PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0006EM:presidente'],
  },
  {
    nome_socio: 'Elisa Vieira Leonel',
    id_socio: '***460676**',
    id_socio_carbono: 'SO0161PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0001EM:miembro_junta'],
  },
  {
    nome_socio: 'Elliott Sassoon',
    id_socio: '***444238**',
    id_socio_carbono: 'SO0666PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0009EM:director'],
  },
  {
    nome_socio: 'Emir Nunes De Oliveira Neto',
    id_socio: '***459167**',
    id_socio_carbono: 'SO0162PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Enrico Juca Bentivegna',
    id_socio: '***115788**',
    id_socio_carbono: 'SO0163PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Erlon Silva Honorato',
    id_socio: '***866508**',
    id_socio_carbono: 'SO0164PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0076EM:socio'],
  },
  {
    nome_socio: 'Ernando Pereira Da Silva',
    id_socio: '***794918**',
    id_socio_carbono: 'SO0165PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0182EM:socio'],
  },
  {
    nome_socio: 'Ernani Maldaner',
    id_socio: '***953629**',
    id_socio_carbono: 'SO0640PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0092EM:soccio_diretor'],
  },
  {
    nome_socio: 'Estela Neves De Souza Albuquerque',
    id_socio: '***995382**',
    id_socio_carbono: 'SO0166PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0155EM:socio'],
  },
  {
    nome_socio: 'Euler Antonio Luz Mathias',
    id_socio: '***344088**',
    id_socio_carbono: 'SO0167PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0001EM:director'],
  },
  {
    nome_socio: 'Eumaria Assiri Makurap',
    id_socio: '***200812**',
    id_socio_carbono: 'SO0168PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0135EM:director'],
  },
  {
    nome_socio: 'Everton Luis Kapfenberger',
    id_socio: '***224319**',
    id_socio_carbono: 'SO0169PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0001EM:director'],
  },
  {
    nome_socio: 'Fabiana Barbosa Gomes',
    id_socio: '***321292**',
    id_socio_carbono: 'SO0170PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0021EM:presidente'],
  },
  {
    nome_socio: 'Fabiana Maciel Da Costa',
    id_socio: '***699973**',
    id_socio_carbono: 'SO0171PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0072EM:socio'],
  },
  {
    nome_socio: 'Fabio Galindo Silvestre',
    id_socio: '***417038**',
    id_socio_carbono: 'SO0172PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0162EM:director'],
  },
  {
    nome_socio: 'Fabio Inacio De Sousa',
    id_socio: '***796748**',
    id_socio_carbono: 'SO0675PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0081EM:soccio_diretor'],
  },
  {
    nome_socio: 'Fabio Izidoro De Farias',
    id_socio: '***979372**',
    id_socio_carbono: 'SO0173PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0145EM:soccio_diretor'],
  },
  {
    nome_socio: 'Fabio Levi Vidigal',
    id_socio: '***062838**',
    id_socio_carbono: 'SO0174PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0069EM:administrador'],
  },
  {
    nome_socio: 'Fabio Roberto Niedermeier',
    id_socio: '***104560**',
    id_socio_carbono: 'SO0175PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: [
      'BRA0116EM:soccio_diretor',
      'BRA0155EM:soccio_diretor',
    ],
  },
  {
    nome_socio: 'Fabio Rocha Pinto E Silva',
    id_socio: '***296518**',
    id_socio_carbono: 'SO0176PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Fabio Thaines',
    id_socio: '***602511**',
    id_socio_carbono: 'SO0177PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0027EM:socio'],
  },
  {
    nome_socio: 'Fabricio Peres Mazaia',
    id_socio: '***382038**',
    id_socio_carbono: 'SO0178PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0061EM:director'],
  },
  {
    nome_socio: 'Fabricio Resende Fonseca',
    id_socio: '***870167**',
    id_socio_carbono: 'SO0179PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0068EM:miembro_junta'],
  },
  {
    nome_socio: 'Farmacia Do Consumidor',
    id_socio: '04.521.258/0001-94',
    id_socio_carbono: 'SO0658ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['NAN0001EM:socio'],
  },
  {
    nome_socio: 'Fatima Perfeito Campos Dansieri',
    id_socio: '***437858**',
    id_socio_carbono: 'SO0180PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0168EM:socio'],
  },
  {
    nome_socio: 'Fausto Scapini',
    id_socio: '***285639**',
    id_socio_carbono: 'SO0181PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0116EM:socio'],
  },
  {
    nome_socio: 'Felipe Bittencourt De Carvalho',
    id_socio: '***799467**',
    id_socio_carbono: 'SO0182PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0005EM:presidente'],
  },
  {
    nome_socio: 'Felipe Gomes Dornelas Alvares',
    id_socio: '***602898**',
    id_socio_carbono: 'SO0183PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0134EM:socio'],
  },
  {
    nome_socio: 'Felipe Guimaraes Geissler Prince',
    id_socio: '***345856**',
    id_socio_carbono: 'SO0184PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0001EM:director'],
  },
  {
    nome_socio: 'Felipe Moura Sales',
    id_socio: '***586582**',
    id_socio_carbono: 'SO0185PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0075EM:soccio_diretor'],
  },
  {
    nome_socio: 'Felipe Ribeiro Bittencourt',
    id_socio: '***385576**',
    id_socio_carbono: 'SO0186PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0054EM:director'],
  },
  {
    nome_socio: 'Felipe Viana Lima',
    id_socio: '***925228**',
    id_socio_carbono: 'SO0187PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0082EM:administrador'],
  },
  {
    nome_socio: 'Fernanda Hoebel Munhoz Bueno',
    id_socio: '***138879**',
    id_socio_carbono: 'SO0188PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0170EM:socio'],
  },
  {
    nome_socio: 'Fernando Alves Meira',
    id_socio: '***166928**',
    id_socio_carbono: 'SO0189PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:soccio_diretor'],
  },
  {
    nome_socio: 'Fernando Ferreira Meirelles',
    id_socio: '***890178**',
    id_socio_carbono: 'SO0190PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0151EM:miembro_junta'],
  },
  {
    nome_socio: 'Fernando Frosini De Barros Ferraz',
    id_socio: '***903948**',
    id_socio_carbono: 'SO0191PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0093EM:soccio_diretor'],
  },
  {
    nome_socio: 'Fernando Galletti De Queiroz',
    id_socio: '***418418**',
    id_socio_carbono: 'SO0192PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0157EM:administrador'],
  },
  {
    nome_socio: 'Fernando Gustavo Jacob',
    id_socio: '***929509**',
    id_socio_carbono: 'SO0193PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0136EM:administrador'],
  },
  {
    nome_socio: 'Fernando Jose Prado Ferreira',
    id_socio: '***642888**',
    id_socio_carbono: 'SO0194PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Fernando Lopes Alberto',
    id_socio: '***603498**',
    id_socio_carbono: 'SO0195PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0118EM:socio'],
  },
  {
    nome_socio: 'Fernando Mirandez Del Nero Gomes',
    id_socio: '***507648**',
    id_socio_carbono: 'SO0196PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Fernando Montanari',
    id_socio: '***231909**',
    id_socio_carbono: 'SO0197PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0109EM:soccio_diretor'],
  },
  {
    nome_socio: 'Fernando O Reilly Cabral Barrionuevo',
    id_socio: '***732119**',
    id_socio_carbono: 'SO0198PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0084EM:director'],
  },
  {
    nome_socio: 'Fernando Ruiz De Almeida Prado',
    id_socio: '***258028**',
    id_socio_carbono: 'SO0199PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Fernando Santiago Dos Santos Zorzo',
    id_socio: '***245988**',
    id_socio_carbono: 'SO0200PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Flavia Caldeira Brant Ribeiro De Figueiredo',
    id_socio: '***245466**',
    id_socio_carbono: 'SO0201PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0060EM:socio'],
  },
  {
    nome_socio: 'Flavia Chiarotto Penteado',
    id_socio: '***651418**',
    id_socio_carbono: 'SO0202PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0056EM:socio', 'BRA0070EM:socio'],
  },
  {
    nome_socio: 'Flavia Galindo Silvestre Silva',
    id_socio: '***934628**',
    id_socio_carbono: 'SO0203PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0132EM:presidente'],
  },
  {
    nome_socio: 'Flavio Veitzman',
    id_socio: '***562208**',
    id_socio_carbono: 'SO0204PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Foret Ressources Management',
    id_socio: '09.312.168/0001-07',
    id_socio_carbono: 'SO0205ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0066EM:socio'],
  },
  {
    nome_socio: 'Franciele Salvador',
    id_socio: '***648179**',
    id_socio_carbono: 'SO0206PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0082EM:administrador'],
  },
  {
    nome_socio: 'Francilene Colferai Jacob',
    id_socio: '***714829**',
    id_socio_carbono: 'SO0207PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0136EM:administrador'],
  },
  {
    nome_socio: 'Francinildo Cosme Kaba Munduruku',
    id_socio: '***599952**',
    id_socio_carbono: 'SO0208PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0071EM:presidente'],
  },
  {
    nome_socio: 'Francisca Eliane De Melo Cameli',
    id_socio: '***628302**',
    id_socio_carbono: 'SO0680PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0042EM:socio'],
  },
  {
    nome_socio: 'Francisca Maria Freitas',
    id_socio: 'Não disponível',
    id_socio_carbono: 'SO0209PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['USA0016EM:director'],
  },
  {
    nome_socio: 'Francisco Augusto Lassalvia',
    id_socio: '***355918**',
    id_socio_carbono: 'SO0210PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0001EM:director'],
  },
  {
    nome_socio: 'Francisco Gasparetto Higuchi',
    id_socio: '***966852**',
    id_socio_carbono: 'SO0650PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0077EM:soccio_diretor'],
  },
  {
    nome_socio: 'Francisco Ramos Muniz',
    id_socio: '***224252**',
    id_socio_carbono: 'SO0211PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0015EM:presidente'],
  },
  {
    nome_socio: 'Francisco Rodrigues Calixto Neto',
    id_socio: '***430722**',
    id_socio_carbono: 'SO0212PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0049EM:presidente'],
  },
  {
    nome_socio: 'Francisco Rodrigues De Melo',
    id_socio: '***932952**',
    id_socio_carbono: 'SO0213PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0057EM:presidente'],
  },
  {
    nome_socio: 'Francisco Umberto Prado Couto',
    id_socio: '***797238**',
    id_socio_carbono: 'SO0214PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0078EM:soccio_diretor'],
  },
  {
    nome_socio: 'Francisco Werneck De Albuquerque Maranhao',
    id_socio: '***945917**',
    id_socio_carbono: 'SO0215PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Franco Musetti Grotti',
    id_socio: '***951138**',
    id_socio_carbono: 'SO0216PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Frederico Tomas De Souza E Miranda',
    id_socio: '***716718**',
    id_socio_carbono: 'SO0217PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0020EM:soccio_diretor'],
  },
  {
    nome_socio: 'Fsm Participacoes Ltda',
    id_socio: '07.804.142/0001-50',
    id_socio_carbono: 'SO0218ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0043EM:socio'],
  },
  {
    nome_socio: 'Future Carbon Holding S.A.',
    id_socio: '43.688.286/0001-52',
    id_socio_carbono: 'SO0219ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0163EM:socio'],
  },
  {
    nome_socio: 'Gabriel Bertoni Sebastiao',
    id_socio: '***926188**',
    id_socio_carbono: 'SO0220PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0175EM:socio'],
  },
  {
    nome_socio: 'Gabriel Kim',
    id_socio: '***049508**',
    id_socio_carbono: 'SO0221PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0118EM:socio'],
  },
  {
    nome_socio: 'Gabriel Muricca Galipolo',
    id_socio: '***827438**',
    id_socio_carbono: 'SO0222PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0001EM:miembro_junta'],
  },
  {
    nome_socio: 'Giancarlo Chamma Matarazzo',
    id_socio: '***715628**',
    id_socio_carbono: 'SO0223PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Gilberto Do Carmo Lopes Siqueira',
    id_socio: '***749801**',
    id_socio_carbono: 'SO0224PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0088EM:soccio_diretor'],
  },
  {
    nome_socio: 'Gilberto Giusti',
    id_socio: '***888338**',
    id_socio_carbono: 'SO0225PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Gilmar Cinta Larga',
    id_socio: '***772702**',
    id_socio_carbono: 'SO0644PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0180EM:presidente'],
  },
  {
    nome_socio: 'Gilvan Guidin',
    id_socio: '***783861**',
    id_socio_carbono: 'SO0226PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0098EM:presidente'],
  },
  {
    nome_socio: 'Girlei Costa Da Cunha',
    id_socio: '***054540**',
    id_socio_carbono: 'SO0227PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0020EM:soccio_diretor'],
  },
  {
    nome_socio: 'Giuliano Colombo',
    id_socio: '***926648**',
    id_socio_carbono: 'SO0228PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Giuseppe Pinelli',
    id_socio: '***594661**',
    id_socio_carbono: 'SO0229PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0028EM:presidente'],
  },
  {
    nome_socio: 'Graziella Vicente Bisquolo Penteado',
    id_socio: '***690498**',
    id_socio_carbono: 'SO0230PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0167EM:socio'],
  },
  {
    nome_socio: 'Great Path Limited',
    id_socio: '12.822.908/0001-60',
    id_socio_carbono: 'SO0231ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0069EM:socio'],
  },
  {
    nome_socio: 'Green Musk B.V',
    id_socio: '52.741.408/0001-18',
    id_socio_carbono: 'SO0669ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0185EM:socio'],
  },
  {
    nome_socio: 'Guanabara Ambiental Ltda',
    id_socio: '45.424.948/0001-02',
    id_socio_carbono: 'SO0232ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0174EM:socio'],
  },
  {
    nome_socio: 'Guilherme Berwerth Stucchi',
    id_socio: '***735568**',
    id_socio_carbono: 'SO0649PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0124EM:soccio_diretor'],
  },
  {
    nome_socio: 'Guilherme Felicissimo De Almeida Leite',
    id_socio: '***370848**',
    id_socio_carbono: 'SO0233PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Guilherme Galvane Batista',
    id_socio: '***391002**',
    id_socio_carbono: 'SO0234PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0176EM:socio'],
  },
  {
    nome_socio: 'Guilherme Galvane Batista',
    id_socio: '***391002**',
    id_socio_carbono: 'SO0507PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0176EM:socio'],
  },
  {
    nome_socio: 'Guilherme Lucas Medeiros Prado',
    id_socio: '***904058**',
    id_socio_carbono: 'SO0235PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0083EM:soccio_diretor'],
  },
  {
    nome_socio: 'Guilherme Patini Borlenghi',
    id_socio: '***104768**',
    id_socio_carbono: 'SO0236PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0068EM:director'],
  },
  {
    nome_socio: 'Guilherme Rossetto Nunes De Oliveira',
    id_socio: '***141088**',
    id_socio_carbono: 'SO0237PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0097EM:administrador'],
  },
  {
    nome_socio: 'Guilherme Sampaio Monteiro',
    id_socio: '***312198**',
    id_socio_carbono: 'SO0238PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Gustavo Costa De Araujo',
    id_socio: '***339352**',
    id_socio_carbono: 'SO0239PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0114EM:soccio_diretor'],
  },
  {
    nome_socio: 'Gustavo Galante Streiff',
    id_socio: '***830708**',
    id_socio_carbono: 'SO0685PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0198EM:socio'],
  },
  {
    nome_socio: 'Gustavo Henrique Batista',
    id_socio: '***623546**',
    id_socio_carbono: 'SO0240PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0183EM:soccio_diretor'],
  },
  {
    nome_socio: 'Gustavo Macedo Lunardi',
    id_socio: '***748920**',
    id_socio_carbono: 'SO0241PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0103EM:administrador'],
  },
  {
    nome_socio: 'Harvey Scholl',
    id_socio: 'Não disponível',
    id_socio_carbono: 'SO0242PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['USA0015EM:director'],
  },
  {
    nome_socio: 'Heberton Henrique Dimas De Barros',
    id_socio: '***200468**',
    id_socio_carbono: 'SO0243PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0147EM:socio'],
  },
  {
    nome_socio: 'Helena Caldeira Brant Ribeiro',
    id_socio: '***739996**',
    id_socio_carbono: 'SO0244PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0038EM:miembro_junta'],
  },
  {
    nome_socio: 'Henrique Da Silva Gordo Lang',
    id_socio: '***206158**',
    id_socio_carbono: 'SO0245PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Henrique De Almeida Pereira',
    id_socio: '***238646**',
    id_socio_carbono: 'SO0246PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0054EM:director'],
  },
  {
    nome_socio: 'Henry Sergio Sztutman',
    id_socio: '***313888**',
    id_socio_carbono: 'SO0247PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Hildegard Gutz Horta',
    id_socio: '***642258**',
    id_socio_carbono: 'SO0248PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0051EM:administrador'],
  },
  {
    nome_socio: 'Hileia Participacoes E Investimentos S/A',
    id_socio: '48.950.782/0001-56',
    id_socio_carbono: 'SO0249ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0102EM:socio'],
  },
  {
    nome_socio: 'Hugo Souza Dos Santos',
    id_socio: '***050378**',
    id_socio_carbono: 'SO0250PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0082EM:administrador'],
  },
  {
    nome_socio: 'Huh Gyou Bum',
    id_socio: 'Não disponível',
    id_socio_carbono: 'SO0615PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['SUI0001EM:director'],
  },
  {
    nome_socio: 'Humberto Antonio Rover',
    id_socio: '***788449**',
    id_socio_carbono: 'SO0251PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0050EM:soccio_diretor'],
  },
  {
    nome_socio: 'Iana Hoebel Munhoz',
    id_socio: '***138859**',
    id_socio_carbono: 'SO0252PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0170EM:socio'],
  },
  {
    nome_socio: 'Iara Musse Felix',
    id_socio: '***628747**',
    id_socio_carbono: 'SO0684PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0198EM:socio_repres_legal'],
  },
  {
    nome_socio: 'Iara Nunes De Oliveira',
    id_socio: '***664001**',
    id_socio_carbono: 'SO0253PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0002EM:administrador'],
  },
  {
    nome_socio: 'Igor Agapejev De Andrade',
    id_socio: '***979048**',
    id_socio_carbono: 'SO0254PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0027EM:soccio_diretor'],
  },
  {
    nome_socio: 'Ilderlei Souza Rodrigues Cordeiro',
    id_socio: '***486902**',
    id_socio_carbono: 'SO0652PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0045EM:soccio_diretor'],
  },
  {
    nome_socio: 'Ilvanio Martins',
    id_socio: '***666196**',
    id_socio_carbono: 'SO0255PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0137EM:presidente'],
  },
  {
    nome_socio: 'Iraci Galvane Batista',
    id_socio: '***509359**',
    id_socio_carbono: 'SO0256PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0117EM:socio'],
  },
  {
    nome_socio: 'Irene Elizabeth Lenci',
    id_socio: '***194608**',
    id_socio_carbono: 'SO0257PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0043EM:administrador'],
  },
  {
    nome_socio: 'Isabel Cristina Dancieri Silveira',
    id_socio: '***078958**',
    id_socio_carbono: 'SO0258PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0168EM:socio'],
  },
  {
    nome_socio: 'Iury Tercas Rodrigues',
    id_socio: '***863901**',
    id_socio_carbono: 'SO0653PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0045EM:socio'],
  },
  {
    nome_socio: 'Ivisix Ventures, Consultoria, Projetos E Participacoes Ltda',
    id_socio: '18.546.015/0001-15',
    id_socio_carbono: 'SO0259ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0178EM:socio'],
  },
  {
    nome_socio: 'Ivo Marcon Brum',
    id_socio: '***420770**',
    id_socio_carbono: 'SO0260PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0103EM:administrador'],
  },
  {
    nome_socio: 'Ivone Maldaner',
    id_socio: '***044151**',
    id_socio_carbono: 'SO0641PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0092EM:socio'],
  },
  {
    nome_socio: 'Jacyr Da Silva Costa Filho',
    id_socio: '***252758**',
    id_socio_carbono: 'SO0261PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0091EM:miembro_junta'],
  },
  {
    nome_socio: 'Jaime Francisco Henriques Filho',
    id_socio: '***440708**',
    id_socio_carbono: 'SO0660PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0004EM:director'],
  },
  {
    nome_socio: 'Jair Rover',
    id_socio: '***921912**',
    id_socio_carbono: 'SO0262PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0050EM:administrador'],
  },
  {
    nome_socio: 'James Castro Cameli',
    id_socio: '***942272**',
    id_socio_carbono: 'SO0679PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0042EM:soccio_diretor'],
  },
  {
    nome_socio: 'James Castro Cameli',
    id_socio: '***942272**',
    id_socio_carbono: 'SO0263PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0010EM:soccio_diretor'],
  },
  {
    nome_socio: 'Jamil Colferai Jacob',
    id_socio: '***259339**',
    id_socio_carbono: 'SO0264PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0136EM:socio'],
  },
  {
    nome_socio: 'Jan Mark Angele Pensaert',
    id_socio: '***342010**',
    id_socio_carbono: 'SO0265PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0086EM:miembro_junta'],
  },
  {
    nome_socio: 'Janaina Correa Da Fonseca Dallan',
    id_socio: '***713338**',
    id_socio_carbono: 'SO0266PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0082EM:administrador'],
  },
  {
    nome_socio: 'Jari De Souza',
    id_socio: '***167991**',
    id_socio_carbono: 'SO0267PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0091EM:director'],
  },
  {
    nome_socio: 'Jean Claude Pinto Barreto',
    id_socio: '***795057**',
    id_socio_carbono: 'SO0268PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0044EM:socio'],
  },
  {
    nome_socio: 'Jean Francois Paul Fernand Chevalier',
    id_socio: '***543102**',
    id_socio_carbono: 'SO0269PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0066EM:socio'],
  },
  {
    nome_socio: 'Jean Pierre Paul Cantaux',
    id_socio: '***271438**',
    id_socio_carbono: 'SO0270PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0044EM:soccio_diretor', 'BRA0143EM:director'],
  },
  {
    nome_socio: 'Jefferson Luiz Matioli',
    id_socio: '***390338**',
    id_socio_carbono: 'SO0271PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0076EM:socio'],
  },
  {
    nome_socio: 'Jefferson Rubens Ferreira',
    id_socio: '***859788**',
    id_socio_carbono: 'SO0272PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0182EM:socio'],
  },
  {
    nome_socio: 'Jj Administradora De Bens Ltda',
    id_socio: '3.05703E+13',
    id_socio_carbono: 'SO0273ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0050EM:socio'],
  },
  {
    nome_socio: 'Joamir Muller Romiti Alves',
    id_socio: '***176128**',
    id_socio_carbono: 'SO0274PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Joao Antonio Villares Stoppe',
    id_socio: '***619068**',
    id_socio_carbono: 'SO0275PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0120EM:soccio_diretor'],
  },
  {
    nome_socio: 'Joao Bosco Gabriel',
    id_socio: '***620187**',
    id_socio_carbono: 'SO0276PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0186EM:presidente'],
  },
  {
    nome_socio: 'Joao Carlos De Souza Meirelles Filho',
    id_socio: '***833748**',
    id_socio_carbono: 'SO0277PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0013EM:presidente'],
  },
  {
    nome_socio: 'Joao Da Cruz Rodrigues',
    id_socio: '***512723**',
    id_socio_carbono: 'SO0278PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0026EM:administrador'],
  },
  {
    nome_socio: 'Joao De Almeida Sampaio Filho',
    id_socio: '***526218**',
    id_socio_carbono: 'SO0279PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0157EM:administrador'],
  },
  {
    nome_socio: 'Joao Francisco Fruet Junior',
    id_socio: '***344060**',
    id_socio_carbono: 'SO0280PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0001EM:director'],
  },
  {
    nome_socio: 'Joao Manoel Stefani Rodrigues Siqueira',
    id_socio: '***223588**',
    id_socio_carbono: 'SO0624PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0171EM:director'],
  },
  {
    nome_socio: 'Joao Marcelo Goncalves Pacheco',
    id_socio: '***031608**',
    id_socio_carbono: 'SO0281PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Joao Rafael Lavandeira Gandara De Carvalho',
    id_socio: '***031487**',
    id_socio_carbono: 'SO0282PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Joao Vagnes De Moura Silva',
    id_socio: '***043411**',
    id_socio_carbono: 'SO0283PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0001EM:director'],
  },
  {
    nome_socio: 'Joao Villela De Andrade',
    id_socio: '***845878**',
    id_socio_carbono: 'SO0284PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0014EM:director'],
  },
  {
    nome_socio: 'Joel Francisco Henriques',
    id_socio: '***492178**',
    id_socio_carbono: 'SO0659PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0004EM:presidente'],
  },
  {
    nome_socio: 'Joercio Paulino Da Costa',
    id_socio: '***070922**',
    id_socio_carbono: 'SO0285PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0175EM:administrador'],
  },
  {
    nome_socio: 'Jonatan Augusto Ville Lubian',
    id_socio: '***398329**',
    id_socio_carbono: 'SO0674PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0179EM:soccio_diretor'],
  },
  {
    nome_socio: 'Jonatas Machado Ibernon',
    id_socio: '***143122**',
    id_socio_carbono: 'SO0286PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0138EM:soccio_diretor'],
  },
  {
    nome_socio: 'Jorge Cristiano Mello',
    id_socio: '***846328**',
    id_socio_carbono: 'SO0287PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0191EM:director'],
  },
  {
    nome_socio: 'Jorge Francisco Henriques',
    id_socio: '***806808**',
    id_socio_carbono: 'SO0646PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0099EM:director'],
  },
  {
    nome_socio: 'Jorge Francisco Henriques',
    id_socio: '***806808**',
    id_socio_carbono: 'SO0288PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0036EM:director', 'BRA0099EM:director'],
  },
  {
    nome_socio: 'Jorge Luis Uriarte',
    id_socio: '***056260**',
    id_socio_carbono: 'SO0289PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0050EM:administrador'],
  },
  {
    nome_socio: 'Jorge Luiz Porto Munari',
    id_socio: '***822859**',
    id_socio_carbono: 'SO0290PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0050EM:soccio_diretor'],
  },
  {
    nome_socio: 'Jorge Ney De Figueiredo Lopes Junior',
    id_socio: '***732628**',
    id_socio_carbono: 'SO0291PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Jose Alexandre Buaiz Neto',
    id_socio: '***583201**',
    id_socio_carbono: 'SO0292PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Jose Arimatea De Angelo Calsaverini',
    id_socio: '***264808**',
    id_socio_carbono: 'SO0293PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0091EM:miembro_junta'],
  },
  {
    nome_socio: 'Jose Augusto De Sousa Junior',
    id_socio: '***261198**',
    id_socio_carbono: 'SO0294PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0076EM:miembro_junta', 'BRA0151EM:miembro_junta'],
  },
  {
    nome_socio: 'Jose Carlos Junqueira Sampaio Meirelles',
    id_socio: '***330768**',
    id_socio_carbono: 'SO0295PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Jose Carlos Kalil',
    id_socio: '***504478**',
    id_socio_carbono: 'SO0296PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0182EM:socio'],
  },
  {
    nome_socio: 'Jose De Oliveira Cruz',
    id_socio: '***695612**',
    id_socio_carbono: 'SO0656PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['NAN0001EM:soccio_diretor'],
  },
  {
    nome_socio: 'Jose Fernando Mazuca Filho',
    id_socio: '***051488**',
    id_socio_carbono: 'SO0297PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0091EM:presidente'],
  },
  {
    nome_socio: 'Jose Gilvan De Oliveira Matogrosso Costa',
    id_socio: '***053122**',
    id_socio_carbono: 'SO0298PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0100EM:socio', 'BRA0197EM:socio'],
  },
  {
    nome_socio: 'Jose Luciano Clemente Guajajara',
    id_socio: '***742253**',
    id_socio_carbono: 'SO0643PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0142EM:presidente'],
  },
  {
    nome_socio: 'Jose Luiz Felix De Andrade Filho',
    id_socio: '***882133**',
    id_socio_carbono: 'SO0299PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0153EM:soccio_diretor'],
  },
  {
    nome_socio: 'Jose Luiz Homem De Mello',
    id_socio: '***791188**',
    id_socio_carbono: 'SO0300PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Jose Mauro Decoussau Machado',
    id_socio: '***254588**',
    id_socio_carbono: 'SO0301PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Jose Ricardo Sasseron',
    id_socio: '***404558**',
    id_socio_carbono: 'SO0302PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0001EM:director'],
  },
  {
    nome_socio: 'Jose Roberto Mendonca De Barros',
    id_socio: '***761408**',
    id_socio_carbono: 'SO0303PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0091EM:miembro_junta'],
  },
  {
    nome_socio: 'Jose Roberto Oliva Junior',
    id_socio: '***947796**',
    id_socio_carbono: 'SO0304PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Jose Tumkaya',
    id_socio: 'Não disponível',
    id_socio_carbono: 'SO0616PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['SUI0001EM:director'],
  },
  {
    nome_socio: 'Jose Ulpiano Pinto De Souza Filho',
    id_socio: '***205518**',
    id_socio_carbono: 'SO0306PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0014EM:director'],
  },
  {
    nome_socio: 'Jose Villela De Andrade Neto',
    id_socio: '***809518**',
    id_socio_carbono: 'SO0307PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0014EM:presidente'],
  },
  {
    nome_socio: 'Josmar Gilson De Oliveira Matogrosso Costa',
    id_socio: '***110512**',
    id_socio_carbono: 'SO0308PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: [
      'BRA0100EM:soccio_diretor',
      'BRA0197EM:soccio_diretor',
    ],
  },
  {
    nome_socio: 'Juarez Cinta Larga',
    id_socio: '***390511**',
    id_socio_carbono: 'SO0309PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0058EM:presidente'],
  },
  {
    nome_socio: 'Jucelino Antonio Salla',
    id_socio: '***902900**',
    id_socio_carbono: 'SO0310PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0050EM:administrador'],
  },
  {
    nome_socio: 'Juliana Dias Figueiredo',
    id_socio: '***150267**',
    id_socio_carbono: 'SO0311PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0178EM:administrador'],
  },
  {
    nome_socio: 'Juliana Perez Alonso Correa',
    id_socio: '***701207**',
    id_socio_carbono: 'SO0312PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0018EM:director', 'BRA0047EM:director'],
  },
  {
    nome_socio: 'Julio Cesar Bueno',
    id_socio: '***433706**',
    id_socio_carbono: 'SO0313PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Julio Cesar Vezzaro',
    id_socio: '***058029**',
    id_socio_carbono: 'SO0314PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0001EM:director'],
  },
  {
    nome_socio: 'Junior Galvane Batista',
    id_socio: '***211559**',
    id_socio_carbono: 'SO0315PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0176EM:soccio_diretor'],
  },
  {
    nome_socio: 'Juscelino Fernandes Martins',
    id_socio: '***406806**',
    id_socio_carbono: 'SO0316PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0068EM:miembro_junta'],
  },
  {
    nome_socio: 'Justiniano De Queiroz Netto',
    id_socio: '***230652**',
    id_socio_carbono: 'SO0317PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0155EM:socio'],
  },
  {
    nome_socio: 'Kamillo Tononi Oliveira Silva',
    id_socio: '***027514**',
    id_socio_carbono: 'SO0318PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0001EM:director'],
  },
  {
    nome_socio: 'Kamutaja Silva Awa',
    id_socio: '***157621**',
    id_socio_carbono: 'SO0629PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0129EM:presidente'],
  },
  {
    nome_socio: 'Karine Tavares Da Cruz',
    id_socio: '***028818**',
    id_socio_carbono: 'SO0319PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0134EM:socio'],
  },
  {
    nome_socio: 'Kelly Tatiane Martins Quirino',
    id_socio: '***783438**',
    id_socio_carbono: 'SO0320PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0001EM:miembro_junta'],
  },
  {
    nome_socio: 'Klaus Duarte Barretto',
    id_socio: '***601978**',
    id_socio_carbono: 'SO0321PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: [
      'BRA0016EM:soccio_diretor',
      'BRA0133EM:soccio_diretor',
    ],
  },
  {
    nome_socio: 'Larissa Da Silva Novais Vieira',
    id_socio: '***038787**',
    id_socio_carbono: 'SO0322PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0001EM:director'],
  },
  {
    nome_socio: 'Larissa Maria Galimberti Afonso',
    id_socio: '***491558**',
    id_socio_carbono: 'SO0323PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Lediana Ghedin Lopes',
    id_socio: '***265402**',
    id_socio_carbono: 'SO0325PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0098EM:director'],
  },
  {
    nome_socio: 'Leonardo Baptista Rodrigues Cruz',
    id_socio: '***657518**',
    id_socio_carbono: 'SO0326PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Leonardo O Reilly Cabral Barrionuevo',
    id_socio: '***859059**',
    id_socio_carbono: 'SO0327PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0084EM:presidente'],
  },
  {
    nome_socio: 'Leonardo Peres Da Rocha E Silva',
    id_socio: '***696421**',
    id_socio_carbono: 'SO0328PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Leticia Koutchin Dos Reis',
    id_socio: '***507441**',
    id_socio_carbono: 'SO0329PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0164EM:soccio_diretor'],
  },
  {
    nome_socio: 'Lilian Keiko Motooka',
    id_socio: '***890308**',
    id_socio_carbono: 'SO0330PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0072EM:socio_ccapital'],
  },
  {
    nome_socio: 'Lilian Marques Esteves',
    id_socio: '***941527**',
    id_socio_carbono: 'SO0331PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0187EM:director'],
  },
  {
    nome_socio: 'Liliana Madrigal',
    id_socio: 'Não disponível',
    id_socio_carbono: 'SO0619PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0196EM:director'],
  },
  {
    nome_socio: 'Lirdes S.A.',
    id_socio: '4.00542E+13',
    id_socio_carbono: 'SO0324ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0097EM:empresa_socia_ext'],
  },
  {
    nome_socio: 'Lucas Pinto Simao',
    id_socio: '***002508**',
    id_socio_carbono: 'SO0332PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Luciana Freire Barca Nascimento',
    id_socio: '***428758**',
    id_socio_carbono: 'SO0333PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0068EM:director'],
  },
  {
    nome_socio: 'Luciana Rosanova Galhardo',
    id_socio: '***112088**',
    id_socio_carbono: 'SO0334PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Luciano Da Silveira Araujo',
    id_socio: '***656508**',
    id_socio_carbono: 'SO0335PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0118EM:socio'],
  },
  {
    nome_socio: 'Luciano Garcia Rossi',
    id_socio: '***150638**',
    id_socio_carbono: 'SO0336PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Luciano Matarazzo Regno',
    id_socio: '***210718**',
    id_socio_carbono: 'SO0337PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0001EM:director'],
  },
  {
    nome_socio: 'Luciano Roberto Correa Da Fonseca Filho',
    id_socio: '***039828**',
    id_socio_carbono: 'SO0338PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0082EM:administrador'],
  },
  {
    nome_socio: 'Lucinara Camargo Araujo Souza Russelakis',
    id_socio: '***818782**',
    id_socio_carbono: 'SO0637PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0156EM:socio'],
  },
  {
    nome_socio: 'Lucineia Possar',
    id_socio: '***309199**',
    id_socio_carbono: 'SO0339PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0001EM:director'],
  },
  {
    nome_socio: 'Luis Antonio Ferraz Mendes',
    id_socio: '***801798**',
    id_socio_carbono: 'SO0340PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Luis Celso Cecilio Leite Ribeiro',
    id_socio: '***226498**',
    id_socio_carbono: 'SO0341PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Luis Claudio Furtado Faria',
    id_socio: '***528997**',
    id_socio_carbono: 'SO0342PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Luiz Antonio Medeiros Tavares',
    id_socio: '***959912**',
    id_socio_carbono: 'SO0343PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0112EM:presidente'],
  },
  {
    nome_socio: 'Luiz Aparecido Caruso Neto',
    id_socio: '***667778**',
    id_socio_carbono: 'SO0344PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0008EM:administrador'],
  },
  {
    nome_socio: 'Luiz Carlos Dansieri',
    id_socio: '***455318**',
    id_socio_carbono: 'SO0345PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0168EM:soccio_diretor'],
  },
  {
    nome_socio: 'Luiz Fernando De Moura',
    id_socio: '***671088**',
    id_socio_carbono: 'SO0346PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0082EM:administrador'],
  },
  {
    nome_socio: 'Luiz Fernando Valente De Paiva',
    id_socio: '***497278**',
    id_socio_carbono: 'SO0347PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Luiz Gustavo Braz Lage',
    id_socio: '***132426**',
    id_socio_carbono: 'SO0348PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0001EM:director'],
  },
  {
    nome_socio: 'Luiz Henrique Grein Moniz De Aragao',
    id_socio: '***379229**',
    id_socio_carbono: 'SO0349PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0151EM:director'],
  },
  {
    nome_socio: 'Luiz Henrique Oliveira Marques',
    id_socio: '***347041**',
    id_socio_carbono: 'SO0350PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0023EM:director'],
  },
  {
    nome_socio: 'Luiz Piccinin',
    id_socio: '***215738**',
    id_socio_carbono: 'SO0351PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0002EM:administrador'],
  },
  {
    nome_socio: 'Luiz Roberto Peroba Barbosa',
    id_socio: '***276118**',
    id_socio_carbono: 'SO0352PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Luiz Rogerio De Oliveira',
    id_socio: '***232952**',
    id_socio_carbono: 'SO0353PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0175EM:administrador'],
  },
  {
    nome_socio:
      'Manfredini Participacoes, Incorporacoes & Administracao De Bens Ltda',
    id_socio: '10.807.509/0001-02',
    id_socio_carbono: 'SO0354ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0105EM:socio'],
  },
  {
    nome_socio: 'Manoel Pedro Braga Paes',
    id_socio: '***643672**',
    id_socio_carbono: 'SO0355PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0032EM:director'],
  },
  {
    nome_socio: 'Manuela Carvalho Farias',
    id_socio: '***503702**',
    id_socio_carbono: 'SO0356PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0145EM:soccio_diretor'],
  },
  {
    nome_socio: 'Maola Monique Faria',
    id_socio: '***744176**',
    id_socio_carbono: 'SO0357PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0145EM:soccio_diretor'],
  },
  {
    nome_socio: 'Marcella Catarina Novaes De Araujo',
    id_socio: '***350162**',
    id_socio_carbono: 'SO0359PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0023EM:director'],
  },
  {
    nome_socio: 'Marcello Alfredo Bernardes',
    id_socio: '***778207**',
    id_socio_carbono: 'SO0360PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Marcello Portes Da Silveira Lobo',
    id_socio: '***439427**',
    id_socio_carbono: 'SO0361PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Marcelo Baptista De Oliveira',
    id_socio: '***801626**',
    id_socio_carbono: 'SO0362PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0039EM:soccio_diretor'],
  },
  {
    nome_socio: 'Marcelo Corsini Afonso',
    id_socio: '***467978**',
    id_socio_carbono: 'SO0363PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0102EM:soccio_diretor'],
  },
  {
    nome_socio: 'Marcelo De Castro Chaves Stabile',
    id_socio: '***210858**',
    id_socio_carbono: 'SO0364PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0109EM:soccio_diretor'],
  },
  {
    nome_socio: 'Marcelo Gasparino Da Silva',
    id_socio: '***383469**',
    id_socio_carbono: 'SO0365PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0001EM:miembro_junta'],
  },
  {
    nome_socio: 'Marcelo Hector Sabbagh Haddad',
    id_socio: '***713058**',
    id_socio_carbono: 'SO0366PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0083EM:soccio_diretor'],
  },
  {
    nome_socio: 'Marcelo Marques Roncaglia',
    id_socio: '***369218**',
    id_socio_carbono: 'SO0367PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Marcelo Muzzi De Queiroz',
    id_socio: '***209306**',
    id_socio_carbono: 'SO0368PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0038EM:administrador', 'BRA0060EM:administrador'],
  },
  {
    nome_socio: 'Marcelo Pereira Binder',
    id_socio: '***845488**',
    id_socio_carbono: 'SO0369PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0118EM:socio'],
  },
  {
    nome_socio: 'Marcelo Reschini Abud',
    id_socio: '***694888**',
    id_socio_carbono: 'SO0370PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0091EM:miembro_junta'],
  },
  {
    nome_socio: 'Marcelo Taiar Arbex',
    id_socio: '***643338**',
    id_socio_carbono: 'SO0371PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0065EM:director'],
  },
  {
    nome_socio: 'Marcelo Viveiros De Moura',
    id_socio: '***026677**',
    id_socio_carbono: 'SO0372PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Marcio Artin Arakelian',
    id_socio: '***883488**',
    id_socio_carbono: 'SO0373PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0162EM:director', 'BRA0163EM:director'],
  },
  {
    nome_socio: 'Marcio Jose Ferreira',
    id_socio: '***569628**',
    id_socio_carbono: 'SO0374PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0047EM:director'],
  },
  {
    nome_socio: 'Marcio Roberto Pinto Lisboa Pinheiro',
    id_socio: '***099482**',
    id_socio_carbono: 'SO0375PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0025EM:director', 'BRA0030EM:director'],
  },
  {
    nome_socio: 'Marco Antonio Fujihara',
    id_socio: '***916318**',
    id_socio_carbono: 'SO0376PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0178EM:administrador'],
  },
  {
    nome_socio: 'Marco Antonio Vilela Tannus Filho',
    id_socio: '***628546**',
    id_socio_carbono: 'SO0377PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0160EM:director'],
  },
  {
    nome_socio: 'Marco Aurelio Mendonca Seraphim',
    id_socio: '***242506**',
    id_socio_carbono: 'SO0378PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0091EM:director'],
  },
  {
    nome_socio: 'Marco Geovanne Tobias Da Silva',
    id_socio: '***225791**',
    id_socio_carbono: 'SO0379PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0001EM:director'],
  },
  {
    nome_socio: 'Marcos Chaves Ladeira',
    id_socio: '***289588**',
    id_socio_carbono: 'SO0380PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Marcos De Vicq De Cumptich',
    id_socio: '***933297**',
    id_socio_carbono: 'SO0381PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Marcos Francisco De La Cruz Costa',
    id_socio: '***390358**',
    id_socio_carbono: 'SO0382PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0023EM:director'],
  },
  {
    nome_socio: 'Marcos Guilherme Alves Preto',
    id_socio: '***830858**',
    id_socio_carbono: 'SO0383PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: [
      'BRA0104EM:soccio_diretor',
      'BRA0122EM:soccio_diretor',
    ],
  },
  {
    nome_socio: 'Marcos Pastore David',
    id_socio: '***729608**',
    id_socio_carbono: 'SO0384PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0065EM:miembro_junta'],
  },
  {
    nome_socio: 'Maria Cecilia Fiordoliva Ferronato',
    id_socio: '***928328**',
    id_socio_carbono: 'SO0386PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0109EM:soccio_diretor'],
  },
  {
    nome_socio: 'Maria Cristina De Oliveira Bittencourt',
    id_socio: '***087242**',
    id_socio_carbono: 'SO0665PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0009EM:director'],
  },
  {
    nome_socio: 'Maria Cristina Rodriguez Rodriguez',
    id_socio: '***340996**',
    id_socio_carbono: 'SO0387PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0104EM:administrador'],
  },
  {
    nome_socio: 'Maria Do Socorro Cordeiro Siqueira',
    id_socio: '***065552**',
    id_socio_carbono: 'SO0388PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0064EM:director'],
  },
  {
    nome_socio: 'Maria Do Socorro Costa De Araujo',
    id_socio: '***182292**',
    id_socio_carbono: 'SO0389PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0114EM:socio'],
  },
  {
    nome_socio: 'Maria Jose De Santana Dias Gutierrez',
    id_socio: '***035078**',
    id_socio_carbono: 'SO0390PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0165EM:administrador'],
  },
  {
    nome_socio: 'Maria Lucilene Ferreira',
    id_socio: '***743652**',
    id_socio_carbono: 'SO0391PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0017EM:administrador'],
  },
  {
    nome_socio: 'Maria Matogrosso Costa',
    id_socio: '***526042**',
    id_socio_carbono: 'SO0392PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0197EM:socio'],
  },
  {
    nome_socio: 'Maria Santana Ferreira Goncalves',
    id_socio: '***157202**',
    id_socio_carbono: 'SO0393PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0126EM:presidente'],
  },
  {
    nome_socio: 'Maria Santina Dansieri',
    id_socio: '***412308**',
    id_socio_carbono: 'SO0394PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0168EM:socio'],
  },
  {
    nome_socio: 'Maria Silva Cabral',
    id_socio: '***344522**',
    id_socio_carbono: 'SO0395PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0135EM:director'],
  },
  {
    nome_socio: 'Mariana Monte Alegre De Paiva',
    id_socio: '***345928**',
    id_socio_carbono: 'SO0396PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Mariana Naoum Mendonca Coroa',
    id_socio: '***654587**',
    id_socio_carbono: 'SO0397PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0178EM:administrador'],
  },
  {
    nome_socio: 'Mariana Pires Dias',
    id_socio: '***147908**',
    id_socio_carbono: 'SO0398PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0001EM:director'],
  },
  {
    nome_socio: 'Mariano Colini Cenamo',
    id_socio: '***318518**',
    id_socio_carbono: 'SO0399PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0138EM:socio'],
  },
  {
    nome_socio: 'Mario Alves Ribeiro',
    id_socio: '***411456**',
    id_socio_carbono: 'SO0400PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0038EM:presidente'],
  },
  {
    nome_socio: 'Mario Panseri Ferreira',
    id_socio: '***951998**',
    id_socio_carbono: 'SO0401PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Marisa Reghini Ferreira Mattos',
    id_socio: '***301948**',
    id_socio_carbono: 'SO0402PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0001EM:director'],
  },
  {
    nome_socio: 'Mark J Plotkin',
    id_socio: 'Não disponível',
    id_socio_carbono: 'SO0618PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0196EM:director'],
  },
  {
    nome_socio: 'Marli Bertotti Dacko',
    id_socio: '***260000**',
    id_socio_carbono: 'SO0403PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0012EM:soccio_diretor'],
  },
  {
    nome_socio: 'Marlos Ferreira Alves',
    id_socio: '***163976**',
    id_socio_carbono: 'SO0404PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0110EM:presidente'],
  },
  {
    nome_socio: 'Mary Lucy Da Costa Santana',
    id_socio: '***290448**',
    id_socio_carbono: 'SO0405PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0108EM:socio'],
  },
  {
    nome_socio: 'Mateus Bonadiman',
    id_socio: '***983900**',
    id_socio_carbono: 'SO0651PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0077EM:soccio_diretor'],
  },
  {
    nome_socio: 'Mateus Lemos Franco Da Silva',
    id_socio: '***568086**',
    id_socio_carbono: 'SO0406PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0134EM:socio'],
  },
  {
    nome_socio: 'Mauricio De Moura Costa',
    id_socio: '***656077**',
    id_socio_carbono: 'SO0682PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['REI0002EM:administrador'],
  },
  {
    nome_socio: 'Mauricio Jose Guilherme Froes Guidi Celini Giubilei',
    id_socio: '***974146**',
    id_socio_carbono: 'SO0407PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Mauricio Moura Costa',
    id_socio: '***656077**',
    id_socio_carbono: 'SO0408PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['REI0001EM:socio', 'REI0003EM:director'],
  },
  {
    nome_socio: 'Mauro Berenholc',
    id_socio: '***546858**',
    id_socio_carbono: 'SO0409PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Mauro Doniseti Silverio Rodrigues',
    id_socio: '***051909**',
    id_socio_carbono: 'SO0410PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0181EM:soccio_diretor'],
  },
  {
    nome_socio: 'Mauro Ribeiro Neto',
    id_socio: '***002066**',
    id_socio_carbono: 'SO0411PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0008EM:administrador'],
  },
  {
    nome_socio: 'Maximilian Fierro Paschoal',
    id_socio: '***936358**',
    id_socio_carbono: 'SO0412PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Maximir Dias De Franca',
    id_socio: '***916941**',
    id_socio_carbono: 'SO0413PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0110EM:director'],
  },
  {
    nome_socio: 'Medio Norte Participacoes Societarias Ltda.',
    id_socio: '10.466.676/0001-29',
    id_socio_carbono: 'SO0414ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0123EM:socio'],
  },
  {
    nome_socio: 'Michael E Brown',
    id_socio: 'Não disponível',
    id_socio_carbono: 'SO0609PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['USA0015EM:director'],
  },
  {
    nome_socio: 'Michael Edward Greene',
    id_socio: '***159561**',
    id_socio_carbono: 'SO0415PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: [
      'BRA0127EM:soccio_diretor',
      'BRA0148EM:soccio_diretor',
    ],
  },
  {
    nome_socio: 'Michael Jenkins',
    id_socio: 'Não disponível',
    id_socio_carbono: 'SO0617PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['USA0001EM:director'],
  },
  {
    nome_socio: 'Michel Alexandre Roy',
    id_socio: '***895478**',
    id_socio_carbono: 'SO0416PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0187EM:director'],
  },
  {
    nome_socio: 'Miguel Tornovsky',
    id_socio: '***842227**',
    id_socio_carbono: 'SO0417PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Minerva Dawn Farms Industria E Comercio De Proteinas S/A',
    id_socio: '09.104.182/0001-15',
    id_socio_carbono: 'SO0418ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0157EM:socio'],
  },
  {
    nome_socio: 'Minerva S.A.',
    id_socio: '67.620.377/0001-14',
    id_socio_carbono: 'SO0419ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0157EM:socio'],
  },
  {
    nome_socio: 'Mitchel Pasin',
    id_socio: 'Não disponível',
    id_socio_carbono: 'SO0611PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['USA0015EM:director'],
  },
  {
    nome_socio: 'Mn Consultoria E Participacoes Ltda',
    id_socio: '48.890.355/0001-20',
    id_socio_carbono: 'SO0420ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0178EM:socio'],
  },
  {
    nome_socio: 'Moacir Eloy Crocetta Batista Junior',
    id_socio: '***211559**',
    id_socio_carbono: 'SO0506PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0176EM:socio'],
  },
  {
    nome_socio: 'Moacir Eloy Crocetta Batista',
    id_socio: '***705129**',
    id_socio_carbono: 'SO0631PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0059EM:soccio_diretor'],
  },
  {
    nome_socio: 'Moacir Eloy Crocetta Batista',
    id_socio: '***705129**',
    id_socio_carbono: 'SO0421PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: [
      'BRA0117EM:soccio_diretor',
      'BRA0176EM:soccio_diretor',
    ],
  },
  {
    nome_socio: 'Monica Cristina Cabello De Brito',
    id_socio: '***877464**',
    id_socio_carbono: 'SO0422PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: [
      'BRA0016EM:soccio_diretor',
      'BRA0133EM:soccio_diretor',
    ],
  },
  {
    nome_socio: 'Morro Azul Empreendimentos E Participacoes S/A',
    id_socio: '07.697.230/0001-09\n',
    id_socio_carbono: 'SO0423ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0002EM:socio'],
  },
  {
    nome_socio: 'Muireann Mageras Gibbons-Neff',
    id_socio: 'Não disponível',
    id_socio_carbono: 'SO0614PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['SUI0001EM:director'],
  },
  {
    nome_socio: 'Munir Younes Soares',
    id_socio: '***894178**',
    id_socio_carbono: 'SO0424PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0115EM:director'],
  },
  {
    nome_socio: 'Murilo Augusto De Oliveira',
    id_socio: '***749506**',
    id_socio_carbono: 'SO0688PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0198EM:soccio_diretor'],
  },
  {
    nome_socio: 'Nadia De Souza Bancoff',
    id_socio: '***243128**',
    id_socio_carbono: 'SO0425PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0072EM:socio'],
  },
  {
    nome_socio: 'Naoum Ambiental Ltda',
    id_socio: '4.411E+13',
    id_socio_carbono: 'SO0426ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0178EM:socio'],
  },
  {
    nome_socio: 'Natalia Genina Lugero De Almeida',
    id_socio: '***865938**',
    id_socio_carbono: 'SO0428PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Nathan De Mello Fortunato Freire',
    id_socio: '***421118**',
    id_socio_carbono: 'SO0429PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0157EM:administrador'],
  },
  {
    nome_socio: 'Natural Resources Development Ag',
    id_socio: '13.076.885/0001-54',
    id_socio_carbono: 'SO0430ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0105EM:socio'],
  },
  {
    nome_socio: 'Neliton Marques Da Silva',
    id_socio: '***830862**',
    id_socio_carbono: 'SO0431PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0048EM:presidente'],
  },
  {
    nome_socio: 'Neudson Peres De Freitas',
    id_socio: '***631536**',
    id_socio_carbono: 'SO0432PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0001EM:director'],
  },
  {
    nome_socio: 'Ney Nelson Machado De Sousa',
    id_socio: '***174078**',
    id_socio_carbono: 'SO0433PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0061EM:director'],
  },
  {
    nome_socio: 'Nicia De Almeida Coutinho',
    id_socio: '***607842**',
    id_socio_carbono: 'SO0434PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0108EM:soccio_diretor'],
  },
  {
    nome_socio: 'Nicolas Gutierrez Londono',
    id_socio: '***246717**',
    id_socio_carbono: 'SO0435PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0151EM:director'],
  },
  {
    nome_socio: 'Nicolas Pierre Bayol',
    id_socio: '***543282**',
    id_socio_carbono: 'SO0436PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0066EM:socio'],
  },
  {
    nome_socio: 'Nossa Senhora Aparecida Empreendimentos E Participacoes S/A',
    id_socio: '13.610.970/0001-50',
    id_socio_carbono: 'SO0437ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0002EM:socio'],
  },
  {
    nome_socio: 'Oita Matina Cinta Larga Filho Semani',
    id_socio: '***986872**',
    id_socio_carbono: 'SO0438PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0063EM:presidente'],
  },
  {
    nome_socio: 'Okryt Kuantoro',
    id_socio: '***035802**',
    id_socio_carbono: 'SO0439PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0144EM:presidente'],
  },
  {
    nome_socio: 'Oscar Luiz Cervi',
    id_socio: '***628030**',
    id_socio_carbono: 'SO0623PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0018EM:presidente'],
  },
  {
    nome_socio: 'Osmar Jose Ruschel',
    id_socio: '***577479**',
    id_socio_carbono: 'SO0622PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0022EM:administrador'],
  },
  {
    nome_socio: 'Osmar Scaramussa',
    id_socio: '***917247**',
    id_socio_carbono: 'SO0440PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0155EM:soccio_diretor'],
  },
  {
    nome_socio: 'Otileia Brito De Oliveira',
    id_socio: '***088382**',
    id_socio_carbono: 'SO0657PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['NAN0001EM:soccio_diretor'],
  },
  {
    nome_socio: 'Pablo Fernandez De Mello E Souza',
    id_socio: 'Não disponível',
    id_socio_carbono: 'SO0612PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['SUI0001EM:presidente'],
  },
  {
    nome_socio: 'Paola Pacheco Bleicker',
    id_socio: '***769900**',
    id_socio_carbono: 'SO0441PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0048EM:administrador'],
  },
  {
    nome_socio: 'Paolo Ardenghi Di Cicco',
    id_socio: '***000788**',
    id_socio_carbono: 'SO0442PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0072EM:socio'],
  },
  {
    nome_socio: 'Para Redd Projects Limited',
    id_socio: '43.500.617/0001-89',
    id_socio_carbono: 'SO0443ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0159EM:socio'],
  },
  {
    nome_socio: 'Para Redd',
    id_socio: '43.500.617/0001-89',
    id_socio_carbono: 'SO0670ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0159EM:socio'],
  },
  {
    nome_socio: 'Patricia De Luca Lima Greff',
    id_socio: '***751649**',
    id_socio_carbono: 'SO0444PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0107EM:soccio_diretor'],
  },
  {
    nome_socio: 'Paula De Lara E Silva',
    id_socio: '***511028**',
    id_socio_carbono: 'SO0445PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0072EM:soccio_diretor'],
  },
  {
    nome_socio: 'Paula Isla Martins',
    id_socio: '***705191**',
    id_socio_carbono: 'SO0446PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0164EM:socio'],
  },
  {
    nome_socio: 'Paula Maria Biral',
    id_socio: '***909298**',
    id_socio_carbono: 'SO0447PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0080EM:socio'],
  },
  {
    nome_socio: 'Paula Sayao Carvalho Araujo',
    id_socio: '***989951**',
    id_socio_carbono: 'SO0448PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0001EM:director'],
  },
  {
    nome_socio: 'Paula Susanna Amaral Mello',
    id_socio: '***664108**',
    id_socio_carbono: 'SO0449PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Paulo Braga',
    id_socio: '***583338**',
    id_socio_carbono: 'SO0450PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0044EM:socio'],
  },
  {
    nome_socio: 'Paulo Cesar Bittencourt De Carvalho',
    id_socio: '***699067**',
    id_socio_carbono: 'SO0451PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0005EM:director'],
  },
  {
    nome_socio: 'Paulo Cesar Dancieri',
    id_socio: '***469618**',
    id_socio_carbono: 'SO0452PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0168EM:soccio_diretor'],
  },
  {
    nome_socio: 'Paulo Cesar Leite',
    id_socio: '***827888**',
    id_socio_carbono: 'SO0453PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0091EM:director'],
  },
  {
    nome_socio: 'Paulo Machado De Carvalho',
    id_socio: '***868448**',
    id_socio_carbono: 'SO0454PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0054EM:director'],
  },
  {
    nome_socio: 'Paulo Piratiny Abbott Caldeira',
    id_socio: '***795780**',
    id_socio_carbono: 'SO0455PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0091EM:miembro_junta'],
  },
  {
    nome_socio: 'Paulo Roberto Bellotti',
    id_socio: '***013908**',
    id_socio_carbono: 'SO0456PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0068EM:miembro_junta'],
  },
  {
    nome_socio: 'Paulo Roberto Simao Bijos',
    id_socio: '***914748**',
    id_socio_carbono: 'SO0457PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0001EM:miembro_junta'],
  },
  {
    nome_socio: 'Paulo Silva Cesario Rosa',
    id_socio: '***351442**',
    id_socio_carbono: 'SO0458PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0075EM:soccio_diretor'],
  },
  {
    nome_socio: 'Pedro Bramont',
    id_socio: '***472469**',
    id_socio_carbono: 'SO0459PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0001EM:director'],
  },
  {
    nome_socio: 'Pedro Freitas',
    id_socio: 'Não disponível',
    id_socio_carbono: 'SO0460PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['USA0016EM:gerente'],
  },
  {
    nome_socio: 'Pedro Henrique De Moura Costa',
    id_socio: '***672427**',
    id_socio_carbono: 'SO0613PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['REI0002EM:director', 'SUI0001EM:director'],
  },
  {
    nome_socio: 'Pedro Henrique Moura Costa',
    id_socio: '***672427**',
    id_socio_carbono: 'SO0462PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['REI0002EM:representante_legal'],
  },
  {
    nome_socio: 'Pedro Henrique Moura Costa',
    id_socio: 'Não disponível',
    id_socio_carbono: 'SO0461PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['REI0001EM:socio', 'REI0003EM:director'],
  },
  {
    nome_socio: 'Pedro Ivo Galindo Silvestre',
    id_socio: '***807498**',
    id_socio_carbono: 'SO0463PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0163EM:administrador'],
  },
  {
    nome_socio: 'Pedro Paulo Barradas Barata',
    id_socio: '***295378**',
    id_socio_carbono: 'SO0464PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Pedro Ruhs Da Silva',
    id_socio: '***339947**',
    id_socio_carbono: 'SO0465PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['REI0004EM:representante_legal'],
  },
  {
    nome_socio: 'Pinnacle Global Partners',
    id_socio: '27.506.365/0001-49',
    id_socio_carbono: 'SO0466ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0101EM:socio'],
  },
  {
    nome_socio: 'Piquia Holding Ltda',
    id_socio: '03.025.229/0001-79',
    id_socio_carbono: 'SO0467ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0017EM:socio'],
  },
  {
    nome_socio: 'Plinio Pagnoncelli Aguiar Ribeiro',
    id_socio: '***333201**',
    id_socio_carbono: 'SO0468PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0068EM:presidente'],
  },
  {
    nome_socio: 'Pre-Cortados Da Amazonia',
    id_socio: '14.413.082/0001-00',
    id_socio_carbono: 'SO0664ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0009EM:socio'],
  },
  {
    nome_socio: 'Precious Woods Holding Ltd.',
    id_socio: '05.569.852/0001-18',
    id_socio_carbono: 'SO0469ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0026EM:socio'],
  },
  {
    nome_socio: 'Pythagoras Lopes De Carvalho Neto',
    id_socio: '***472768**',
    id_socio_carbono: 'SO0470PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Radce Consultoria E Participacoes Ltda',
    id_socio: '24.271.394/0001-80',
    id_socio_carbono: 'SO0471ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0178EM:socio'],
  },
  {
    nome_socio: 'Rafael Bemerguy Sefer',
    id_socio: '***017792**',
    id_socio_carbono: 'SO0472PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: [
      'BRA0161EM:soccio_diretor',
      'BRA0177EM:soccio_diretor',
    ],
  },
  {
    nome_socio: 'Rafael Jose Lopes Gaspar',
    id_socio: '***725098**',
    id_socio_carbono: 'SO0473PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Rafael Machado Giovanella',
    id_socio: '***211719**',
    id_socio_carbono: 'SO0474PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0001EM:director'],
  },
  {
    nome_socio: 'Rafael Nora Tannus',
    id_socio: '***020798**',
    id_socio_carbono: 'SO0475PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0073EM:soccio_diretor'],
  },
  {
    nome_socio: 'Rafaella Ferraz Souza',
    id_socio: '***752797**',
    id_socio_carbono: 'SO0476PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0002EM:representante_legal'],
  },
  {
    nome_socio: 'Rair De Sousa Verde',
    id_socio: '***950202**',
    id_socio_carbono: 'SO0477PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0146EM:soccio_diretor'],
  },
  {
    nome_socio: 'Raniery Vale Neri Branco',
    id_socio: '***987262**',
    id_socio_carbono: 'SO0478PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0074EM:soccio_diretor'],
  },
  {
    nome_socio: 'Raphael De Cunto',
    id_socio: '***312668**',
    id_socio_carbono: 'SO0479PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Raphael Moraes Paciello',
    id_socio: '***657307**',
    id_socio_carbono: 'SO0480PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Raphael Palmieri Salomao',
    id_socio: '***056298**',
    id_socio_carbono: 'SO0481PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Raphaella Maria Chagas Fernandes Goncalves',
    id_socio: '***600328**',
    id_socio_carbono: 'SO0482PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0072EM:socio'],
  },
  {
    nome_socio: 'Reale Ltda',
    id_socio: '33.904.379/0001-13',
    id_socio_carbono: 'SO0483ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0194EM:socio'],
  },
  {
    nome_socio: 'Reginaldo Bispo De Souza',
    id_socio: '***025532**',
    id_socio_carbono: 'SO0484PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0175EM:socio'],
  },
  {
    nome_socio: 'Remy Denecheau',
    id_socio: '***082547**',
    id_socio_carbono: 'SO0486PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: [
      'BRA0130EM:soccio_diretor',
      'BRA0166EM:soccio_diretor',
    ],
  },
  {
    nome_socio: 'Renan Akio Kamimura',
    id_socio: '***056616**',
    id_socio_carbono: 'SO0487PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0147EM:socio'],
  },
  {
    nome_socio: 'Renan Cunha Fantini',
    id_socio: '***564918**',
    id_socio_carbono: 'SO0488PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0093EM:socio'],
  },
  {
    nome_socio: 'Renan Oliveira Silva',
    id_socio: '***045233**',
    id_socio_carbono: 'SO0489PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0088EM:soccio_diretor'],
  },
  {
    nome_socio: 'Renata Pozzato Carneiro Monteiro',
    id_socio: '***284707**',
    id_socio_carbono: 'SO0667PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0185EM:administrador'],
  },
  {
    nome_socio: 'Renato Cassim Cavalini',
    id_socio: '***658628**',
    id_socio_carbono: 'SO0490PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0086EM:miembro_junta'],
  },
  {
    nome_socio: 'Renato Henrique Caumo',
    id_socio: '***879538**',
    id_socio_carbono: 'SO0491PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Renato Stephan Grion',
    id_socio: '***457108**',
    id_socio_carbono: 'SO0492PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Rene Guilherme Da Silva Medrado',
    id_socio: '***196028**',
    id_socio_carbono: 'SO0493PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Rg Clinica Medica Ss Ltda',
    id_socio: '39.876.042/0001-26',
    id_socio_carbono: 'SO0494ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0150EM:socio'],
  },
  {
    nome_socio: 'Ricardo Emmanuel Vieira Coelho',
    id_socio: '***066017**',
    id_socio_carbono: 'SO0495PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Ricardo Glaessner Binnie',
    id_socio: '***396548**',
    id_socio_carbono: 'SO0496PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Ricardo Luiz Ludke',
    id_socio: '***479461**',
    id_socio_carbono: 'SO0497PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0028EM:director'],
  },
  {
    nome_socio: 'Ricardo Metzner Gomes',
    id_socio: '***859658**',
    id_socio_carbono: 'SO0498PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0076EM:socio'],
  },
  {
    nome_socio: 'Ricardo Pagliari Levy',
    id_socio: '***906228**',
    id_socio_carbono: 'SO0499PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Ricardo Ribeiro Valadares Gontijo',
    id_socio: '***843996**',
    id_socio_carbono: 'SO0634PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: [
      'BRA0046EM:soccio_diretor',
      'BRA0085EM:soccio_diretor',
    ],
  },
  {
    nome_socio: 'Ricardo Simoes Russo',
    id_socio: '***379308**',
    id_socio_carbono: 'SO0500PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Ricardo Valadares Gontijo',
    id_socio: '***017286**',
    id_socio_carbono: 'SO0633PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: [
      'BRA0046EM:soccio_diretor',
      'BRA0085EM:soccio_diretor',
    ],
  },
  {
    nome_socio: 'Ricardo Villares Lot Stoppe',
    id_socio: '***184878**',
    id_socio_carbono: 'SO0501PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0120EM:soccio_diretor'],
  },
  {
    nome_socio: 'Rio Xingu Participacoes Ltda',
    id_socio: '07.826.181/0001-59',
    id_socio_carbono: 'SO0504ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0002EM:socio'],
  },
  {
    nome_socio: 'Rjc2 Assets Administration Participacoes Ltda',
    id_socio: '48.064.917/0001-86',
    id_socio_carbono: 'SO0505ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0175EM:socio', 'BRA0176EM:socio'],
  },
  {
    nome_socio: 'Robert Juenemann',
    id_socio: '***077100**',
    id_socio_carbono: 'SO0508PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0001EM:miembro_junta'],
  },
  {
    nome_socio: 'Roberta Stettinger Rossi Bilotti Demange',
    id_socio: '***100458**',
    id_socio_carbono: 'SO0509PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Roberto Figueiredo Strumpf',
    id_socio: '***860408**',
    id_socio_carbono: 'SO0510PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0079EM:administrador'],
  },
  {
    nome_socio: 'Roberto Motta',
    id_socio: '***684718**',
    id_socio_carbono: 'SO0511PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0002EM:administrador'],
  },
  {
    nome_socio: 'Roberto Salom Perez',
    id_socio: '110370***',
    id_socio_carbono: 'SO0512PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0033EM:representante_legal'],
  },
  {
    nome_socio: 'Roberto Taiar Arbex',
    id_socio: '***100548**',
    id_socio_carbono: 'SO0513PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0065EM:director'],
  },
  {
    nome_socio: 'Rodolpho Oliveira Santos',
    id_socio: '***909928**',
    id_socio_carbono: 'SO0514PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0134EM:soccio_diretor'],
  },
  {
    nome_socio: 'Rodrigo Brandao De Almeida',
    id_socio: '***671237**',
    id_socio_carbono: 'SO0515PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0151EM:director'],
  },
  {
    nome_socio: 'Rodrigo Correa Martone',
    id_socio: '***879558**',
    id_socio_carbono: 'SO0516PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Rodrigo Costa Vasconcelos',
    id_socio: '***561061**',
    id_socio_carbono: 'SO0517PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0001EM:director'],
  },
  {
    nome_socio: 'Rodrigo Da Rocha Ruschel',
    id_socio: '***624032**\n',
    id_socio_carbono: 'SO0620PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0022EM:socio'],
  },
  {
    nome_socio: 'Rodrigo De Magalhaes Carneiro De Oliveira',
    id_socio: '***455118**',
    id_socio_carbono: 'SO0518PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Rodrigo De Souza Gomes',
    id_socio: '***820842**',
    id_socio_carbono: 'SO0519PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0146EM:soccio_diretor'],
  },
  {
    nome_socio: 'Rodrigo Gomes De Oliveira',
    id_socio: '***451969**',
    id_socio_carbono: 'SO0520PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0150EM:administrador'],
  },
  {
    nome_socio: 'Rodrigo Mulinari',
    id_socio: '***599070**',
    id_socio_carbono: 'SO0521PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0001EM:director'],
  },
  {
    nome_socio: 'Rodrigo Persone Prestes De Camargo',
    id_socio: '***167198**',
    id_socio_carbono: 'SO0522PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Rodrigo Ribeiro Goncalves',
    id_socio: '***871628**',
    id_socio_carbono: 'SO0523PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0091EM:director'],
  },
  {
    nome_socio: 'Rodrigo Sousa Pereira',
    id_socio: '***817048**',
    id_socio_carbono: 'SO0524PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0072EM:socio_ccapital'],
  },
  {
    nome_socio: 'Roma Participacoes S/S Ltda',
    id_socio: '46.014.709/0001-47',
    id_socio_carbono: 'SO0525ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0174EM:socio'],
  },
  {
    nome_socio: 'Romulo Pereira Da Silva Arantes',
    id_socio: '***675098**',
    id_socio_carbono: 'SO0526PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0172EM:soccio_diretor'],
  },
  {
    nome_socio: 'Roque Lazaro De Gaspari Junior',
    id_socio: '***264808**',
    id_socio_carbono: 'SO0527PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0007EM:miembro_junta'],
  },
  {
    nome_socio: 'Rosana Della Mea Sutton',
    id_socio: '***889270**',
    id_socio_carbono: 'SO0528PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0090EM:soccio_diretor'],
  },
  {
    nome_socio: 'Rosana Maria Hoebel',
    id_socio: '***543249**',
    id_socio_carbono: 'SO0529PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0170EM:socio'],
  },
  {
    nome_socio: 'Rosiane Barbosa Laviola',
    id_socio: '***181471**',
    id_socio_carbono: 'SO0530PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0001EM:director'],
  },
  {
    nome_socio: 'Rosivaldo Campos Gois',
    id_socio: '***088112**',
    id_socio_carbono: 'SO0628PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0053EM:presidente'],
  },
  {
    nome_socio: 'Roy Schwartz',
    id_socio: 'Não disponível',
    id_socio_carbono: 'SO0610PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['USA0015EM:director'],
  },
  {
    nome_socio: 'Rubens Batista Junior',
    id_socio: '***518796**',
    id_socio_carbono: 'SO0531PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0160EM:representante_legal'],
  },
  {
    nome_socio: 'Rubens Forbes Alves De Lima',
    id_socio: '***508538**',
    id_socio_carbono: 'SO0532PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0043EM:soccio_diretor'],
  },
  {
    nome_socio: 'Rudibert Rueckert',
    id_socio: '***428319**',
    id_socio_carbono: 'SO0533PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0026EM:administrador'],
  },
  {
    nome_socio: 'Rui Pedro De Almeida Ribeiro',
    id_socio: '***262658**',
    id_socio_carbono: 'SO0534PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0118EM:socio'],
  },
  {
    nome_socio: 'Said Elias Vasconcelos Nogueira',
    id_socio: '***084582**',
    id_socio_carbono: 'SO0535PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0119EM:soccio_diretor'],
  },
  {
    nome_socio: 'Santa Adelia Empreendimentos E Participacoes S/A',
    id_socio: '24.118.220/0001-82',
    id_socio_carbono: 'SO0536ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0002EM:socio'],
  },
  {
    nome_socio: 'Saturno Investimentos E Participacoes S/A',
    id_socio: '07.640.115/0001-90',
    id_socio_carbono: 'SO0537ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0002EM:socio'],
  },
  {
    nome_socio: 'Sebastiao Ernanes Rangel',
    id_socio: '***626417**',
    id_socio_carbono: 'SO0538PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0005EM:director'],
  },
  {
    nome_socio: 'Selma Lucia Lira Beltrao',
    id_socio: '***945164**',
    id_socio_carbono: 'SO0539PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0003EM:director'],
  },
  {
    nome_socio: 'Seok Yeon Chang',
    id_socio: '***189278**',
    id_socio_carbono: 'SO0540PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0118EM:socio'],
  },
  {
    nome_socio: 'Sergio Antonio Garcia Amoroso',
    id_socio: '***086608**',
    id_socio_carbono: 'SO0647PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0099EM:presidente'],
  },
  {
    nome_socio: 'Sergio Antonio Garcia Amoroso',
    id_socio: '***086608**',
    id_socio_carbono: 'SO0541PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: [
      'BRA0036EM:presidente',
      'BRA0099EM:presidente',
      'BRA0190EM:presidente',
    ],
  },
  {
    nome_socio: 'Sergio Augusto Malacrida Junior',
    id_socio: '***532868**',
    id_socio_carbono: 'SO0542PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0008EM:administrador'],
  },
  {
    nome_socio: 'Sergio Pinheiro Marcal',
    id_socio: '***062448**',
    id_socio_carbono: 'SO0543PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Sergio Spinelli Silva Junior',
    id_socio: '***888088**',
    id_socio_carbono: 'SO0544PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0091EM:miembro_junta'],
  },
  {
    nome_socio: 'Servio Tulio Prado Junior',
    id_socio: '***875808**',
    id_socio_carbono: 'SO0545PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0118EM:representante_legal'],
  },
  {
    nome_socio: 'Shigeharu Kato',
    id_socio: '***123811**',
    id_socio_carbono: 'SO0546PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0061EM:director'],
  },
  {
    nome_socio: 'Shohei Noda',
    id_socio: '***363348**',
    id_socio_carbono: 'SO0547PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0061EM:director'],
  },
  {
    nome_socio: 'Silmar Lagemann',
    id_socio: '***591460**',
    id_socio_carbono: 'SO0548PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0050EM:soccio_diretor'],
  },
  {
    nome_socio: 'Silvano D Agnoluzzo',
    id_socio: '***196092**',
    id_socio_carbono: 'SO0549PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: [
      'BRA0029EM:socio',
      'BRA0062EM:socio',
      'BRA0139EM:socio',
      'BRA0193EM:socio',
    ],
  },
  {
    nome_socio: 'Silvia Maria Fonseca Silveira Massruha',
    id_socio: '***083228**',
    id_socio_carbono: 'SO0550PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0003EM:presidente'],
  },
  {
    nome_socio: 'Simone Polini De Marchi',
    id_socio: '***820511**',
    id_socio_carbono: 'SO0551PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0134EM:socio'],
  },
  {
    nome_socio: 'Slc Agricola S.A.',
    id_socio: '89.096.457/0001-55',
    id_socio_carbono: 'SO0552ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0103EM:socio'],
  },
  {
    nome_socio: 'Slc Investimentos Agricolas Ltda',
    id_socio: '19.765.592/0001-60',
    id_socio_carbono: 'SO0553ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0103EM:socio'],
  },
  {
    nome_socio: 'Soraia De Souza Pires',
    id_socio: '***019978**',
    id_socio_carbono: 'SO0554PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0072EM:socio'],
  },
  {
    nome_socio:
      'Stadie & Fischa Participacoes, Incorporacoes E Administracao De Bens Ltda',
    id_socio: '19.442.704/0001-42',
    id_socio_carbono: 'SO0555ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0105EM:socio'],
  },
  {
    nome_socio: 'Stefano Merlin',
    id_socio: '***121341**',
    id_socio_carbono: 'SO0556PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: [
      'BRA0011EM:soccio_diretor',
      'BRA0067EM:soccio_diretor',
    ],
  },
  {
    nome_socio: 'Sustainable Investment Management Limited (Sim)',
    id_socio: '11263566',
    id_socio_carbono: 'SO0557ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['REI0003EM:socio'],
  },
  {
    nome_socio: 'Takanobu Kodama',
    id_socio: '***859728**',
    id_socio_carbono: 'SO0558PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0061EM:director'],
  },
  {
    nome_socio: 'Tarana Parakana',
    id_socio: '***339412**',
    id_socio_carbono: 'SO0655PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0152EM:presidente'],
  },
  {
    nome_socio: 'Tarciana Paula Gomes Medeiros',
    id_socio: '***128734**',
    id_socio_carbono: 'SO0559PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0001EM:presidente'],
  },
  {
    nome_socio: 'Tatiana Mello Guazzelli',
    id_socio: '***075438**',
    id_socio_carbono: 'SO0560PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Tatiane Ruschel Figarella',
    id_socio: '***813452**',
    id_socio_carbono: 'SO0621PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0022EM:socio'],
  },
  {
    nome_socio: 'Tav Company Participacoes Sociedade Unipessoal Limitada',
    id_socio: '42.834.280/0001-83',
    id_socio_carbono: 'SO0561ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0159EM:socio'],
  },
  {
    nome_socio: 'Tercio Chiavassa',
    id_socio: '***210278**',
    id_socio_carbono: 'SO0562PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Teresa Cristina Corpa Vendramini',
    id_socio: '***801538**',
    id_socio_carbono: 'SO0563PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0158EM:director'],
  },
  {
    nome_socio: 'Teresa Cristina Ribeiro Ralston Botelho Bracher',
    id_socio: '***246628**',
    id_socio_carbono: 'SO0564PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0158EM:presidente'],
  },
  {
    nome_socio: 'Thais Galo',
    id_socio: '***940708**',
    id_socio_carbono: 'SO0565PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Thalia Assiry Cinta Larga',
    id_socio: '***091582**',
    id_socio_carbono: 'SO0566PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0135EM:presidente'],
  },
  {
    nome_socio: 'Theotonio Mauricio Monteiro De Barros',
    id_socio: '***551938**',
    id_socio_carbono: 'SO0567PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0072EM:soccio_diretor'],
  },
  {
    nome_socio: 'Thera Van Swaay De Marchi',
    id_socio: '***979808**',
    id_socio_carbono: 'SO0568PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Thiago Affonso Borsari',
    id_socio: '***759718**',
    id_socio_carbono: 'SO0569PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0001EM:director'],
  },
  {
    nome_socio: 'Thiago Armando Spina',
    id_socio: '***454938**',
    id_socio_carbono: 'SO0570PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0072EM:socio'],
  },
  {
    nome_socio: 'Thiago Braga Junqueira',
    id_socio: '***137676**',
    id_socio_carbono: 'SO0571PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Thiago Da Costa Silva',
    id_socio: '***653698**',
    id_socio_carbono: 'SO0572PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0068EM:director'],
  },
  {
    nome_socio: 'Thiago De Avila Othero',
    id_socio: '***251260**',
    id_socio_carbono: 'SO0573PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0083EM:soccio_diretor'],
  },
  {
    nome_socio: 'Thiago Jose Da Silva',
    id_socio: '***260578**',
    id_socio_carbono: 'SO0574PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Thiago Luiz Goerck',
    id_socio: '***490328**',
    id_socio_carbono: 'SO0575PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0061EM:director'],
  },
  {
    nome_socio: 'Tiago Araujo Dias Themudo Lessa',
    id_socio: '***521399**',
    id_socio_carbono: 'SO0576PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Tiago Eler Silva',
    id_socio: '***017886**',
    id_socio_carbono: 'SO0577PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Tiago Goncalves De Oliveira Ricci',
    id_socio: '***802751**',
    id_socio_carbono: 'SO0578PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0115EM:miembro_junta', 'BRA0134EM:miembro_junta'],
  },
  {
    nome_socio: 'Tiago Moreira Vieira Rocha',
    id_socio: '***696248**',
    id_socio_carbono: 'SO0579PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Tmnh Participacoes S.A',
    id_socio: '35.725.203/0001-20',
    id_socio_carbono: 'SO0580ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0147EM:socio'],
  },
  {
    nome_socio: 'Tulio Dias Brito',
    id_socio: '***945538**',
    id_socio_carbono: 'SO0581PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0023EM:director'],
  },
  {
    nome_socio: 'Ubiraci Benute Jaime',
    id_socio: '***651398**',
    id_socio_carbono: 'SO0582PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0182EM:soccio_diretor'],
  },
  {
    nome_socio: 'Valdemar Candido Da Silva',
    id_socio: '***898379**',
    id_socio_carbono: 'SO0583PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0105EM:administrador'],
  },
  {
    nome_socio: 'Valdenor Campos Da Costa Junior',
    id_socio: '***429112**',
    id_socio_carbono: 'SO0584PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0084EM:director'],
  },
  {
    nome_socio: 'Valessa Fernandes Januario Da Silveira',
    id_socio: '***841349**',
    id_socio_carbono: 'SO0585PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0154EM:soccio_diretor'],
  },
  {
    nome_socio: 'Vania Marques Ribeiro',
    id_socio: '***956416**',
    id_socio_carbono: 'SO0586PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Vantuires Oliveira Martins Javae',
    id_socio: '***891531**',
    id_socio_carbono: 'SO0642PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0037EM:presidente'],
  },
  {
    nome_socio: 'Vcs Participacoes Ltda',
    id_socio: '46.176.324/0001-86',
    id_socio_carbono: 'SO0587ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0105EM:socio'],
  },
  {
    nome_socio: 'Verner Tiede',
    id_socio: '***795000**',
    id_socio_carbono: 'SO0588PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0086EM:miembro_junta'],
  },
  {
    nome_socio: 'Veronica Oki Igacihalaguti',
    id_socio: '***177712**',
    id_socio_carbono: 'SO0589PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0141EM:director'],
  },
  {
    nome_socio: 'Vicente Coelho Araujo',
    id_socio: '***485621**',
    id_socio_carbono: 'SO0590PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:soccio_diretor'],
  },
  {
    nome_socio: 'Vicente Colferai Jacob',
    id_socio: '***269459**',
    id_socio_carbono: 'SO0591PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0136EM:socio'],
  },
  {
    nome_socio: 'Victor Davi Patini Borlenghi',
    id_socio: '***276578**',
    id_socio_carbono: 'SO0592PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0068EM:miembro_junta'],
  },
  {
    nome_socio: 'Victor Naoum Mendonca Coroa',
    id_socio: '***655237**',
    id_socio_carbono: 'SO0593PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0178EM:administrador'],
  },
  {
    nome_socio: 'Victor Souza De Mattos',
    id_socio: '***005528**',
    id_socio_carbono: 'SO0594PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0082EM:administrador'],
  },
  {
    nome_socio: 'Vinicius Ceron Rissoli',
    id_socio: '***694708**',
    id_socio_carbono: 'SO0689PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0198EM:soccio_diretor'],
  },
  {
    nome_socio: 'Vinicius Pimenta Seixas Pereira',
    id_socio: '***258908**',
    id_socio_carbono: 'SO0595PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Virgilio Mauricio Viana',
    id_socio: '***280696**',
    id_socio_carbono: 'SO0596PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0064EM:director'],
  },
  {
    nome_socio: 'Vitor Montenegro Wanderley Junior',
    id_socio: '***955054**',
    id_socio_carbono: 'SO0597PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0091EM:miembro_junta'],
  },
  {
    nome_socio: 'Vitorio Sufredini Neto',
    id_socio: '***133913**',
    id_socio_carbono: 'SO0598PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: [
      'BRA0029EM:soccio_diretor',
      'BRA0062EM:soccio_diretor',
      'BRA0139EM:soccio_diretor',
      'BRA0193EM:soccio_diretor',
    ],
  },
  {
    nome_socio: 'Votorantim S.A.',
    id_socio: '03.407.049/0001-51',
    id_socio_carbono: 'SO0599ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0008EM:socio'],
  },
  {
    nome_socio: 'Vp Gestao Ltda.',
    id_socio: '26.547.288/0001-02',
    id_socio_carbono: 'SO0600ENBR',
    tipo: 'entidade',
    relacao_empresa_rol: ['BRA0008EM:socio'],
  },
  {
    nome_socio: 'Warwick Do Amaral Manfrinato',
    id_socio: '***267028**',
    id_socio_carbono: 'SO0601PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0041EM:soccio_diretor'],
  },
  {
    nome_socio: 'Werner Grau Neto',
    id_socio: '***415998**',
    id_socio_carbono: 'SO0602PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Yaacov Vaknin',
    id_socio: 'Não disponível',
    id_socio_carbono: 'SO0607PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['USA0015EM:director'],
  },
  {
    nome_socio: 'Yasuyuki Hidaka',
    id_socio: '***774078**',
    id_socio_carbono: 'SO0603PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0061EM:director'],
  },
  {
    nome_socio: 'Yim Kyu Lee',
    id_socio: '***154388**',
    id_socio_carbono: 'SO0604PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0118EM:socio'],
  },
  {
    nome_socio: 'Yuka Ono',
    id_socio: '***513848**',
    id_socio_carbono: 'SO0605PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0188EM:socio_ccapital'],
  },
  {
    nome_socio: 'Yuri Rugai Marinho',
    id_socio: '***980998**',
    id_socio_carbono: 'SO0608PEBR',
    tipo: 'pessoa',
    relacao_empresa_rol: ['BRA0109EM:soccio_diretor'],
  },
]

const PersonasCO: IPersonas[] = [
  {
    nome_socio: 'Adela Roa Varón',
    id_socio: '52030***',
    id_socio_carbono: 'SO0002PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0024EM:socio'],
  },
  {
    nome_socio: 'Adolfo León Martínez Astudillo',
    id_socio: 'No disponible',
    id_socio_carbono: 'SO0003PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0025EM:socio'],
  },
  {
    nome_socio: 'Adriana Guadalupe De Bedout Guerra',
    id_socio: 'No disponible',
    id_socio_carbono: 'SO0005PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0019EM:socio'],
  },
  {
    nome_socio: 'Adrián Mauricio Zapata Zabala',
    id_socio: '15271***',
    id_socio_carbono: 'SO0004PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0062EM:miembro_junta'],
  },
  {
    nome_socio: 'Alba Lucía Morales Jiménez',
    id_socio: '52197***',
    id_socio_carbono: 'SO0010PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0024EM:socio'],
  },
  {
    nome_socio: 'Alcaldía De El Carmen De Viboral',
    id_socio: '890982616-9',
    id_socio_carbono: 'SO0011ENCO',
    tipo: 'entidade',
    relacao_empresa_rol: ['COL0008EM:socio'],
  },
  {
    nome_socio: 'Alcaldía De El Retiro',
    id_socio: '890903938-8',
    id_socio_carbono: 'SO0012ENCO',
    tipo: 'entidade',
    relacao_empresa_rol: ['COL0008EM:socio'],
  },
  {
    nome_socio: 'Alcaldía De El Santuario',
    id_socio: '890983813-8',
    id_socio_carbono: 'SO0013ENCO',
    tipo: 'entidade',
    relacao_empresa_rol: ['COL0008EM:socio'],
  },
  {
    nome_socio: 'Alcaldía De Guarne',
    id_socio: '890982055-7',
    id_socio_carbono: 'SO0014ENCO',
    tipo: 'entidade',
    relacao_empresa_rol: ['COL0008EM:socio'],
  },
  {
    nome_socio: 'Alcaldía De La Ceja',
    id_socio: '890981207-5',
    id_socio_carbono: 'SO0120ENCO',
    tipo: 'entidade',
    relacao_empresa_rol: ['COL0008EM:socio'],
  },
  {
    nome_socio: 'Alcaldía De La Unión',
    id_socio: '890981995-0',
    id_socio_carbono: 'SO0121ENCO',
    tipo: 'entidade',
    relacao_empresa_rol: ['COL0008EM:socio'],
  },
  {
    nome_socio: 'Alcaldía De Marinilla',
    id_socio: '890983716-1',
    id_socio_carbono: 'SO0122ENCO',
    tipo: 'entidade',
    relacao_empresa_rol: ['COL0008EM:socio'],
  },
  {
    nome_socio: 'Alcaldía De Rionegro',
    id_socio: '890907317-2',
    id_socio_carbono: 'SO0123ENCO',
    tipo: 'entidade',
    relacao_empresa_rol: ['COL0008EM:socio'],
  },
  {
    nome_socio: 'Alcaldía De San Vicente',
    id_socio: '890982506-7',
    id_socio_carbono: 'SO0124ENCO',
    tipo: 'entidade',
    relacao_empresa_rol: ['COL0008EM:socio'],
  },
  {
    nome_socio: 'Alexis Ludwig Leroy',
    id_socio: '17FD31***',
    id_socio_carbono: 'SO0030PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0055EM:representante_legal'],
  },
  {
    nome_socio: 'Alicia Micolta Cabrera',
    id_socio: '31530***',
    id_socio_carbono: 'SO0103PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0030EM:socio_ccapital'],
  },
  {
    nome_socio: 'Allcot Ag',
    id_socio: 'CH-020-3901396-9',
    id_socio_carbono: 'SO0031ENCO',
    tipo: 'entidade',
    relacao_empresa_rol: ['COL0055EM:socio_ccapital'],
  },
  {
    nome_socio: 'Alvaro Alberto Silva Casallas',
    id_socio: '79424***',
    id_socio_carbono: 'SO0273PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0036EM:representante_legal_suplente'],
  },
  {
    nome_socio: 'Alvaro Cogollo Pacheco',
    id_socio: '6874***',
    id_socio_carbono: 'SO0026PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0047EM:socio'],
  },
  {
    nome_socio: 'Amalia María Cano Castaño',
    id_socio: '32255***',
    id_socio_carbono: 'SO0027PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0047EM:socio'],
  },
  {
    nome_socio: 'Amparo Gavito Pineda',
    id_socio: '52113***',
    id_socio_carbono: 'SO0294PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0059EM:socio_ccapital_repres_legal_suplente'],
  },
  {
    nome_socio: 'Ana Gabriela De Luna Uribe',
    id_socio: '52386***',
    id_socio_carbono: 'SO0029PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0034EM:socio_repres_legal_suplente'],
  },
  {
    nome_socio: 'Ana Milena Plata Fajardo',
    id_socio: '1098620***',
    id_socio_carbono: 'SO0073PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0052EM:representante_legal_suplente'],
  },
  {
    nome_socio: 'Andrea Fernanda Rodríguez Wilches',
    id_socio: '1019142***',
    id_socio_carbono: 'SO0213PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0040EM:socio'],
  },
  {
    nome_socio: 'Andrea Polanco',
    id_socio: '52087***',
    id_socio_carbono: 'SO0034PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0024EM:socio'],
  },
  {
    nome_socio: 'Andrei Stoica',
    id_socio: '1029***',
    id_socio_carbono: 'SO0035PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0081EM:representante_legal'],
  },
  {
    nome_socio: 'Andrés Felipe Aponte Gutiérrez',
    id_socio: 'No disponible',
    id_socio_carbono: 'SO0038PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0024EM:socio'],
  },
  {
    nome_socio: 'Andrés Fernando Almonacid Sánchez',
    id_socio: '79867***',
    id_socio_carbono: 'SO0040PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0024EM:socio_repres_legal_suplente'],
  },
  {
    nome_socio: 'Andrés Guillermo Molina Liévano',
    id_socio: '80875***',
    id_socio_carbono: 'SO0296PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0075EM:representante_legal'],
  },
  {
    nome_socio: 'Andrés Leonardo Cornejo Escallón',
    id_socio: '94545***',
    id_socio_carbono: 'SO0043PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0056EM:socio'],
  },
  {
    nome_socio: 'Andrés Link Ospina',
    id_socio: '79780***',
    id_socio_carbono: 'SO0044PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0034EM:socio_repres_legal'],
  },
  {
    nome_socio: 'Andrés Oswaldo Bernal Ruiz',
    id_socio: '79953***',
    id_socio_carbono: 'SO0046PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0042EM:representante_legal'],
  },
  {
    nome_socio: 'Angel Munera S.A.S.',
    id_socio: '9006947278',
    id_socio_carbono: 'SO0271ENCO',
    tipo: 'entidade',
    relacao_empresa_rol: ['COL0071EM:derente_repres_legal'],
  },
  {
    nome_socio: 'Angie Ferleidy Sanabria Peñaloza',
    id_socio: '1118549***',
    id_socio_carbono: 'SO0214PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0040EM:socio'],
  },
  {
    nome_socio: 'Angie Leydie Hernández',
    id_socio: '29120***',
    id_socio_carbono: 'SO0228PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0051EM:socio'],
  },
  {
    nome_socio: 'Angélica Díaz Pulido',
    id_socio: 'No disponible',
    id_socio_carbono: 'SO0137PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0047EM:socio'],
  },
  {
    nome_socio: 'Antoine Escalas',
    id_socio: '130975S00***',
    id_socio_carbono: 'SO0194PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0024EM:socio'],
  },
  {
    nome_socio: 'Antonio Zambrano Delgadillo',
    id_socio: '2927***',
    id_socio_carbono: 'SO0220PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0058EM:socio'],
  },
  {
    nome_socio: 'Applied Ecology For Tropical Resources Programs Inc.',
    id_socio: 'EIN 38-3751536',
    id_socio_carbono: 'SO0221ENCO',
    tipo: 'entidade',
    relacao_empresa_rol: ['COL0058EM:socio'],
  },
  {
    nome_socio: 'Ariel Klop',
    id_socio: '310***',
    id_socio_carbono: 'SO0057PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0082EM:socio'],
  },
  {
    nome_socio: 'Armando García García',
    id_socio: '79524***',
    id_socio_carbono: 'SO0050PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0032EM:socio_ccapital'],
  },
  {
    nome_socio:
      'Asociación Colombiana De Exportadores De Flores (Asocolflores)',
    id_socio: '860037665-8',
    id_socio_carbono: 'SO0125ENCO',
    tipo: 'entidade',
    relacao_empresa_rol: ['COL0008EM:socio'],
  },
  {
    nome_socio:
      'Asociación De Municipios Del Altiplano Del Oriente Antioqueño (Masora)',
    id_socio: '800183770-1',
    id_socio_carbono: 'SO0126ENCO',
    tipo: 'entidade',
    relacao_empresa_rol: ['COL0008EM:socio'],
  },
  {
    nome_socio:
      'Asociación De Organizaciones Ambientales Del Oriente Antioqueño (Avanso)',
    id_socio: '811038106-9',
    id_socio_carbono: 'SO0127ENCO',
    tipo: 'entidade',
    relacao_empresa_rol: ['COL0008EM:socio'],
  },
  {
    nome_socio:
      'Asociación Municipal De Juntas De Acción Comunal De El Retiro (Asocomunal El Retiro)',
    id_socio: '900162317-9',
    id_socio_carbono: 'SO0128ENCO',
    tipo: 'entidade',
    relacao_empresa_rol: ['COL0008EM:socio'],
  },
  {
    nome_socio:
      'Asociación Municipal De Juntas De Acción Comunal De Marinilla (Asocomunal Marinilla)',
    id_socio: '89088455-2',
    id_socio_carbono: 'SO0129ENCO',
    tipo: 'entidade',
    relacao_empresa_rol: ['COL0008EM:socio'],
  },
  {
    nome_socio:
      'Asociación Municipal De Juntas De Acción Comunal De Rionegro (Asocomunal Rionegro)',
    id_socio: '800056980-6',
    id_socio_carbono: 'SO0130ENCO',
    tipo: 'entidade',
    relacao_empresa_rol: ['COL0008EM:socio'],
  },
  {
    nome_socio:
      'Asociación Municipal De Juntas De Acción Comunal De San Vicente (Asocomunal San Vicente)',
    id_socio: ' 800206948-4',
    id_socio_carbono: 'SO0131ENCO',
    tipo: 'entidade',
    relacao_empresa_rol: ['COL0008EM:socio'],
  },
  {
    nome_socio: 'Aída Marcela Vasco Palacios',
    id_socio: '52381***',
    id_socio_carbono: 'SO0009PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0024EM:socio'],
  },
  {
    nome_socio: 'Biofix Group S.A.S.',
    id_socio: '901659896-1',
    id_socio_carbono: 'SO0074ENCO',
    tipo: 'entidade',
    relacao_empresa_rol: ['COL0052EM:socio_ccapital'],
  },
  {
    nome_socio: 'Biomax Biocombustibles S.A.',
    id_socio: '830136799-1',
    id_socio_carbono: 'SO0104ENCO',
    tipo: 'entidade',
    relacao_empresa_rol: ['COL0030EM:socio_ccapital'],
  },
  {
    nome_socio: 'Blanca Nubia Sánchez De Montoya',
    id_socio: '42963***',
    id_socio_carbono: 'SO0226PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0029EM:representante_legal_suplente'],
  },
  {
    nome_socio: 'Brodie David Ferguson',
    id_socio: '347***',
    id_socio_carbono: 'SO0051PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0032EM:socio_repres_legal'],
  },
  {
    nome_socio: 'Bárbara Lara Escoto',
    id_socio: '993***',
    id_socio_carbono: 'SO0068PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: [
      'COL0072EM:representante_legal',
      'MEX0001EM:director',
    ],
  },
  {
    nome_socio: 'Camilo Gutiérrez Patiño',
    id_socio: '1010219***',
    id_socio_carbono: 'SO0266PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0044EM:socio'],
  },
  {
    nome_socio: 'Carbo Holding S.A.S.',
    id_socio: '901662087-9',
    id_socio_carbono: 'SO0087ENCO',
    tipo: 'entidade',
    relacao_empresa_rol: ['COL0046EM:socio_ccapital'],
  },
  {
    nome_socio: 'Carlos Andrés Méndez Oliveros',
    id_socio: '1018452***',
    id_socio_carbono: 'SO0075PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0052EM:representante_legal'],
  },
  {
    nome_socio: 'Carlos Cuesta Díaz',
    id_socio: '2892***',
    id_socio_carbono: 'SO0159PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0003EM:representante_legal_suplente'],
  },
  {
    nome_socio: 'Carlos Demetrio Arias Alfaro',
    id_socio: '253***',
    id_socio_carbono: 'SO0105PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0030EM:socio_ccapital_repres_legal_suplente'],
  },
  {
    nome_socio: 'Carlos Eduardo Abondano Leal',
    id_socio: '3066***',
    id_socio_carbono: 'SO0265PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0086EM:derente_repres_legal'],
  },
  {
    nome_socio: 'Carlos Julio Benavides Sabogal',
    id_socio: '73121***',
    id_socio_carbono: 'SO0015PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0078EM:socio_ccapital_repres_legal_suplente'],
  },
  {
    nome_socio: 'Carlos Mauricio Mazo',
    id_socio: '15273***',
    id_socio_carbono: 'SO0138PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0047EM:representante_legal_suplente'],
  },
  {
    nome_socio: 'Carlos Orlando Díaz Albarán',
    id_socio: '1110447***',
    id_socio_carbono: 'SO0063PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0082EM:socio'],
  },
  {
    nome_socio: 'Carlos Sebastián Vieira Uribe',
    id_socio: '98539***',
    id_socio_carbono: 'SO0139PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0047EM:representante_legal'],
  },
  {
    nome_socio: 'Carolina Jaramillo Aguirrezábal',
    id_socio: '52389***',
    id_socio_carbono: 'SO0274PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0036EM:representante_legal_suplente'],
  },
  {
    nome_socio: 'Catalina Arias Agudelo',
    id_socio: '52352***',
    id_socio_carbono: 'SO0195PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0024EM:socio'],
  },
  {
    nome_socio: 'Catherine Bridget Cushnan',
    id_socio: '',
    id_socio_carbono: 'SO0280PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0031EM:socio_ccapital'],
  },
  {
    nome_socio: 'Clara Ligia Solano Gutiérrez',
    id_socio: '51873***',
    id_socio_carbono: 'SO0229PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0017EM:derente_repres_legal'],
  },
  {
    nome_socio: 'Claudia Liliana Torres Azuero',
    id_socio: '52498***',
    id_socio_carbono: 'SO0081PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0027EM:representante_legal_suplente'],
  },
  {
    nome_socio:
      'Corporación Autónoma Regional De Las Cuencas De Los Ríos Negro Y Nare (Cornare)',
    id_socio: '890985138-3',
    id_socio_carbono: 'SO0132ENCO',
    tipo: 'entidade',
    relacao_empresa_rol: ['COL0008EM:socio'],
  },
  {
    nome_socio: 'Corporación Bioesferas',
    id_socio: '9007699934',
    id_socio_carbono: 'SO0064ENCO',
    tipo: 'entidade',
    relacao_empresa_rol: ['COL0082EM:socio'],
  },
  {
    nome_socio:
      'Corporación De Estudios, Educación E Investigación Ambiental (Ceam)',
    id_socio: '811037176-1',
    id_socio_carbono: 'SO0133ENCO',
    tipo: 'entidade',
    relacao_empresa_rol: ['COL0008EM:socio'],
  },
  {
    nome_socio: 'Corporación Empresarial Del Oriente Antioqueño (Ceo)',
    id_socio: '890985350-9',
    id_socio_carbono: 'SO0134ENCO',
    tipo: 'entidade',
    relacao_empresa_rol: ['COL0008EM:socio'],
  },
  {
    nome_socio: 'César Andrés Paz Suárez',
    id_socio: '16919***',
    id_socio_carbono: 'SO0155PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0025EM:socio_repres_legal'],
  },
  {
    nome_socio: 'Dafna Camila Ángel',
    id_socio: '52085***',
    id_socio_carbono: 'SO0196PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0024EM:socio'],
  },
  {
    nome_socio: 'Daniel Esteban Aguirre Cornejo',
    id_socio: '1192760***',
    id_socio_carbono: 'SO0183PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0056EM:socio'],
  },
  {
    nome_socio: 'Daniel Gutiérrez Patiño',
    id_socio: '1018462***',
    id_socio_carbono: 'SO0267PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0044EM:socio'],
  },
  {
    nome_socio: 'Daniel Job Van Der Post',
    id_socio: '639***',
    id_socio_carbono: 'SO0197PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0024EM:socio'],
  },
  {
    nome_socio: 'Daniel Sebastián Bernal Linares',
    id_socio: '',
    id_socio_carbono: 'SO0106PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0030EM:socio_ccapital'],
  },
  {
    nome_socio: 'Danna Gabriela Aguirre Cornejo',
    id_socio: '1006071***',
    id_socio_carbono: 'SO0184PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0056EM:socio_repres_legal'],
  },
  {
    nome_socio: 'David Fernando Paz Lozada',
    id_socio: '1130611***',
    id_socio_carbono: 'SO0032PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0055EM:representante_legal_suplente'],
  },
  {
    nome_socio: 'David Ricardo Duarte Castilla',
    id_socio: '80040***',
    id_socio_carbono: 'SO0304PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0061EM:representante_legal_suplente'],
  },
  {
    nome_socio: 'Dayana Chaves Roa',
    id_socio: '1018487***',
    id_socio_carbono: 'SO0278PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0072EM:representante_legal_suplente'],
  },
  {
    nome_socio: 'Diana Susana Rodríguez Buriticá',
    id_socio: '52265***',
    id_socio_carbono: 'SO0198PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0024EM:socio'],
  },
  {
    nome_socio: 'Didier Enrique Guevara Cárdenas',
    id_socio: '479***',
    id_socio_carbono: 'SO0033PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0063EM:socio_ccapital'],
  },
  {
    nome_socio: 'Diego Armando Núñez Guevara',
    id_socio: '1118538***',
    id_socio_carbono: 'SO0036PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0063EM:socio_ccapital'],
  },
  {
    nome_socio: 'Ecologic S.A.S.',
    id_socio: '900440679-2',
    id_socio_carbono: 'SO0095ENCO',
    tipo: 'entidade',
    relacao_empresa_rol: ['COL0060EM:socio_ccapital'],
  },
  {
    nome_socio: 'Edgar De Jesús Correa López',
    id_socio: '15327***',
    id_socio_carbono: 'SO0189PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: [
      'COL0062EM:derente_repres_legal',
      'COL0062EM:representante_legal',
    ],
  },
  {
    nome_socio: 'Edgar Mauricio Rodríguez Castro',
    id_socio: '79786***',
    id_socio_carbono: 'SO0096PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0060EM:representante_legal'],
  },
  {
    nome_socio: 'Eduwin Antonio Hincapié Peñaloza',
    id_socio: '1118536***',
    id_socio_carbono: 'SO0215PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0040EM:socio'],
  },
  {
    nome_socio: 'Edward William Rumsey',
    id_socio: '510539***',
    id_socio_carbono: 'SO0259PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0035EM:derente_repres_legal'],
  },
  {
    nome_socio: 'Edwin Arango Muñoz',
    id_socio: 'No disponible',
    id_socio_carbono: 'SO0156PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0025EM:socio'],
  },
  {
    nome_socio: 'Efraín Eduardo Peña Moreno',
    id_socio: '79785***',
    id_socio_carbono: 'SO0260PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0035EM:representante_legal_suplente'],
  },
  {
    nome_socio: 'Emerson Edilberto Jaimes',
    id_socio: '74377***',
    id_socio_carbono: 'SO0172PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0009EM:representante_legal_suplente'],
  },
  {
    nome_socio: 'Emerson Leonardo Durán Vargas',
    id_socio: '74379***',
    id_socio_carbono: 'SO0264PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0074EM:socio_ccapital_repres_legal'],
  },
  {
    nome_socio: 'Emily Roynestad',
    id_socio: '',
    id_socio_carbono: 'SO0052PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0032EM:socio_ccapital'],
  },
  {
    nome_socio: 'Enq S.A.S.',
    id_socio: '900560359-5',
    id_socio_carbono: 'SO0179ENCO',
    tipo: 'entidade',
    relacao_empresa_rol: ['COL0073EM:socio_ccapital'],
  },
  {
    nome_socio: 'Enrique Díaz González',
    id_socio: '79780***',
    id_socio_carbono: 'SO0298PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0054EM:representante_legal'],
  },
  {
    nome_socio: 'Eric Jussef Cardozo Matta',
    id_socio: '79641***',
    id_socio_carbono: 'SO0222PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0058EM:socio_repres_legal'],
  },
  {
    nome_socio: 'Ernesto Moisés Amaya Campos',
    id_socio: '17326***',
    id_socio_carbono: 'SO0039PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0063EM:socio_ccapital'],
  },
  {
    nome_socio: 'Eunice Santos',
    id_socio: '28494***',
    id_socio_carbono: 'SO0199PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0024EM:socio'],
  },
  {
    nome_socio: 'Eva Yaneth Araque Delgado',
    id_socio: '63352***',
    id_socio_carbono: 'SO0041PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0063EM:socio_ccapital'],
  },
  {
    nome_socio: 'Fabio Alberto Arjona Hincapié',
    id_socio: '6876***',
    id_socio_carbono: 'SO0118PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0011EM:representante_legal'],
  },
  {
    nome_socio: 'Fabio Alexis García',
    id_socio: '18256***',
    id_socio_carbono: 'SO0180PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0073EM:representante_legal_suplente'],
  },
  {
    nome_socio: 'Federico José Ortiz Mejía',
    id_socio: '19498***',
    id_socio_carbono: 'SO0281PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0031EM:socio_ccapital_repres_legal'],
  },
  {
    nome_socio: 'Ferley Arroyo Rosero',
    id_socio: '82384***',
    id_socio_carbono: 'SO0185PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0056EM:socio'],
  },
  {
    nome_socio: 'Fernando Arbeláez Escalante',
    id_socio: '79780***',
    id_socio_carbono: 'SO0200PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0024EM:socio_repres_legal'],
  },
  {
    nome_socio: 'Flores Silvestres S.A.',
    id_socio: '800023622-2',
    id_socio_carbono: 'SO0098ENCO',
    tipo: 'entidade',
    relacao_empresa_rol: ['COL0019EM:socio'],
  },
  {
    nome_socio: 'Francia Emilia De Fátima Gallego Sánchez',
    id_socio: '51582***',
    id_socio_carbono: 'SO0232PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0043EM:representante_legal_suplente'],
  },
  {
    nome_socio: 'Francis Elena Cornejo Naranjo',
    id_socio: '66982***',
    id_socio_carbono: 'SO0186PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0056EM:socio_repres_legal_suplente'],
  },
  {
    nome_socio: 'Francisco Alberto Galán Sarmiento',
    id_socio: '19260***',
    id_socio_carbono: 'SO0257PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0026EM:derente_repres_legal'],
  },
  {
    nome_socio: 'Francisco Javier Botero Pineda',
    id_socio: '71604***',
    id_socio_carbono: 'SO0023PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0021EM:socio_repres_legal_suplente'],
  },
  {
    nome_socio: 'Francisco Quiroga Zea',
    id_socio: '14196***',
    id_socio_carbono: 'SO0238PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0006EM:socio'],
  },
  {
    nome_socio: 'Freeland Construcciones S.A.S.',
    id_socio: '900402175-0',
    id_socio_carbono: 'SO0107ENCO',
    tipo: 'entidade',
    relacao_empresa_rol: ['COL0030EM:socio_ccapital'],
  },
  {
    nome_socio: 'Germán Bernal Gutiérrez',
    id_socio: '19199***',
    id_socio_carbono: 'SO0108PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0030EM:socio_ccapital_repres_legal'],
  },
  {
    nome_socio: 'Germán Javier Díaz Gutiérrez',
    id_socio: '80056***',
    id_socio_carbono: 'SO0042PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0063EM:socio_ccapital'],
  },
  {
    nome_socio: 'Gil Y Cía Sociedad En Comandita',
    id_socio: 'No disponible',
    id_socio_carbono: 'SO0109ENCO',
    tipo: 'entidade',
    relacao_empresa_rol: ['COL0030EM:socio_ccapital'],
  },
  {
    nome_socio: 'Global Consulting And Assessment Services S.A. De C.V.',
    id_socio: '559094',
    id_socio_carbono: 'SO0279ENCO',
    tipo: 'entidade',
    relacao_empresa_rol: ['COL0072EM:socio_ccapital'],
  },
  {
    nome_socio: 'Gloria Astrid Moreno Gómez',
    id_socio: '43061***',
    id_socio_carbono: 'SO0140PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0047EM:socio'],
  },
  {
    nome_socio: 'Gloria Liliana Pérez Londoño',
    id_socio: '32554***',
    id_socio_carbono: 'SO0190PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0062EM:miembro_junta'],
  },
  {
    nome_socio: 'Gustavo Andrés Albarán Perdomo',
    id_socio: '1020843***',
    id_socio_carbono: 'SO0065PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0082EM:socio'],
  },
  {
    nome_socio: 'Heidy Daniela Colmenares Oviedo',
    id_socio: '1006532***',
    id_socio_carbono: 'SO0250PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0049EM:socio_ccapital'],
  },
  {
    nome_socio: 'Helmuth Mauricio Gallego Sánchez',
    id_socio: '79367***',
    id_socio_carbono: 'SO0233PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0043EM:representante_legal'],
  },
  {
    nome_socio: 'Henry Alejandro Silva Pérez',
    id_socio: '1015468***',
    id_socio_carbono: 'SO0253PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0076EM:socio_ccapital'],
  },
  {
    nome_socio: 'Henry Rodríguez García',
    id_socio: 'No disponible',
    id_socio_carbono: 'SO0157PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0025EM:socio'],
  },
  {
    nome_socio: 'Henry Silva Meche',
    id_socio: '74815***',
    id_socio_carbono: 'SO0254PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0076EM:derente_repres_legal'],
  },
  {
    nome_socio: 'Hernán Javier Díaz Perdomo',
    id_socio: '93392***',
    id_socio_carbono: 'SO0201PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0024EM:socio'],
  },
  {
    nome_socio: 'Inés Cavelier Franco',
    id_socio: '41705***',
    id_socio_carbono: 'SO0258PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0026EM:director_repres_legal_suplente'],
  },
  {
    nome_socio: 'Isabel Cristina Montoya Sánchez',
    id_socio: '43628***',
    id_socio_carbono: 'SO0227PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0029EM:representante_legal'],
  },
  {
    nome_socio: 'Isabel Cristina Ramírez Gómez',
    id_socio: '43515***',
    id_socio_carbono: 'SO0024PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0021EM:socio_repres_legal'],
  },
  {
    nome_socio: 'Jaime Andrés García Urrea',
    id_socio: '15443***',
    id_socio_carbono: 'SO0135PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0008EM:derente_repres_legal'],
  },
  {
    nome_socio: 'Jaime Oswaldo Ortiz Vanegas',
    id_socio: '79051***',
    id_socio_carbono: 'SO0053PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0032EM:representante_legal_suplente'],
  },
  {
    nome_socio: 'Jairo Alfonso Viña Patiño',
    id_socio: '14210***',
    id_socio_carbono: 'SO0066PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0082EM:socio'],
  },
  {
    nome_socio: 'Jairo Leonardo Gómez Quinche',
    id_socio: '1110561***',
    id_socio_carbono: 'SO0275PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0036EM:representante_legal_suplente'],
  },
  {
    nome_socio: 'Javier Arturo Ruiz Naranjo',
    id_socio: '15318***',
    id_socio_carbono: 'SO0191PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0062EM:miembro_junta'],
  },
  {
    nome_socio: 'Jayma Holdings S.A.S.',
    id_socio: '901650081-3 ',
    id_socio_carbono: 'SO0305ENCO',
    tipo: 'entidade',
    relacao_empresa_rol: ['COL0061EM:socio_ccapital'],
  },
  {
    nome_socio: 'Jeffrey William Hayward',
    id_socio: '529554***',
    id_socio_carbono: 'SO0299PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0054EM:miembro_junta'],
  },
  {
    nome_socio: 'Jimmy Alexander Ruiz Vásquez',
    id_socio: '79790***',
    id_socio_carbono: 'SO0016PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0078EM:socio_ccapital_repres_legal'],
  },
  {
    nome_socio: 'Jmbg Green Investing S.A.S.',
    id_socio: '901102676-5',
    id_socio_carbono: 'SO0110ENCO',
    tipo: 'entidade',
    relacao_empresa_rol: ['COL0030EM:socio_ccapital'],
  },
  {
    nome_socio: 'Jonathan Gildardo Núñez Guevara',
    id_socio: '86085***',
    id_socio_carbono: 'SO0045PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0063EM:socio_ccapital_repres_legal'],
  },
  {
    nome_socio: 'Jorge Eduardo Girón Leuro',
    id_socio: '79447***',
    id_socio_carbono: 'SO0295PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0059EM:socio_ccapital_repres_legal'],
  },
  {
    nome_socio: 'Jorge Humberto Arango Herrera',
    id_socio: '10103***',
    id_socio_carbono: 'SO0076PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0014EM:director'],
  },
  {
    nome_socio: 'Jorge Mario Ochoa',
    id_socio: '71654***',
    id_socio_carbono: 'SO0025PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0021EM:representante_legal_suplente'],
  },
  {
    nome_socio: 'Jorjany Maritza Botero Orrego',
    id_socio: '44003***',
    id_socio_carbono: 'SO0202PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0024EM:socio'],
  },
  {
    nome_socio: 'José Arturo Restrepo Aristizábal',
    id_socio: '79964***',
    id_socio_carbono: 'SO0223PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0058EM:socio_repres_legal_suplente'],
  },
  {
    nome_socio: 'José Libardo Henao Tejada',
    id_socio: '8394***',
    id_socio_carbono: 'SO0099PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0019EM:representante_legal_suplente'],
  },
  {
    nome_socio: 'José Luis Rivera Mican',
    id_socio: '80036***',
    id_socio_carbono: 'SO0097PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0060EM:representante_legal_suplente'],
  },
  {
    nome_socio: 'José Micolta Cabrera',
    id_socio: 'No disponible',
    id_socio_carbono: 'SO0111PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0030EM:socio_ccapital'],
  },
  {
    nome_socio: 'José Miguel Correa Salazar',
    id_socio: '79940***',
    id_socio_carbono: 'SO0088PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0046EM:socio_ccapital_repres_legal'],
  },
  {
    nome_socio: 'Juan Andrés López Silva',
    id_socio: '80407***',
    id_socio_carbono: 'SO0089PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0046EM:director'],
  },
  {
    nome_socio: 'Juan Camilo Clavijo López',
    id_socio: 'No disponible',
    id_socio_carbono: 'SO0141PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0047EM:socio'],
  },
  {
    nome_socio: 'Juan Camilo Colmenares Oviedo',
    id_socio: '1006532***',
    id_socio_carbono: 'SO0251PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0049EM:socio_ccapital'],
  },
  {
    nome_socio: 'Juan Carlos Cuesta Quintero',
    id_socio: '79339***',
    id_socio_carbono: 'SO0160PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0003EM:derente_repres_legal'],
  },
  {
    nome_socio: 'Juan David Sánchez Londoño',
    id_socio: '70420***',
    id_socio_carbono: 'SO0203PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0024EM:socio'],
  },
  {
    nome_socio: 'Juan Eduardo García Trejos',
    id_socio: '18250***',
    id_socio_carbono: 'SO0255PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0076EM:socio_ccapital'],
  },
  {
    nome_socio: 'Juan Fernando Millán',
    id_socio: '1020715***',
    id_socio_carbono: 'SO0204PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0024EM:socio'],
  },
  {
    nome_socio: 'Juan Fernando Phillips Bernal',
    id_socio: '79942***',
    id_socio_carbono: 'SO0205PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0024EM:socio'],
  },
  {
    nome_socio: 'Juan Luis Mejía Sánchez',
    id_socio: '70084***',
    id_socio_carbono: 'SO0100PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0019EM:representante_legal_suplente'],
  },
  {
    nome_socio: 'Juan Lázaro Toro',
    id_socio: '71671***',
    id_socio_carbono: 'SO0142PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0047EM:socio'],
  },
  {
    nome_socio: 'Juan Pablo Muriel Rojas',
    id_socio: '16735***',
    id_socio_carbono: 'SO0239PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0006EM:representante_legal'],
  },
  {
    nome_socio: 'Juan Sebastián Bernal García',
    id_socio: 'No disponible',
    id_socio_carbono: 'SO0112PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0030EM:socio_ccapital'],
  },
  {
    nome_socio: 'Laura Camila Calderón Moreno',
    id_socio: '1006856***',
    id_socio_carbono: 'SO0047PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0063EM:socio_ccapital'],
  },
  {
    nome_socio: 'Laura Dyann Albarán Zamora',
    id_socio: '1110560***',
    id_socio_carbono: 'SO0067PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0082EM:socio'],
  },
  {
    nome_socio: 'Laura Marcela Cornejo Escallón',
    id_socio: '1130677***',
    id_socio_carbono: 'SO0187PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0056EM:socio'],
  },
  {
    nome_socio: 'Laura Oliva Sánchez Nupan',
    id_socio: '1061763***',
    id_socio_carbono: 'SO0158PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0025EM:socio_repres_legal_suplente'],
  },
  {
    nome_socio: 'Lauro Rodrigo Álvarez Torres',
    id_socio: '1216***',
    id_socio_carbono: 'SO0022PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0081EM:representante_legal_suplente'],
  },
  {
    nome_socio: 'Leandro Valentín Buenaventura Ibargüen',
    id_socio: '4816***',
    id_socio_carbono: 'SO0188PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0056EM:socio'],
  },
  {
    nome_socio: 'Leidy Marcela Jojoa Unigarro',
    id_socio: '59310***',
    id_socio_carbono: 'SO0143PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0047EM:socio'],
  },
  {
    nome_socio: 'Lenin Lider Sucre Garay',
    id_socio: 'PA0264***',
    id_socio_carbono: 'SO0300PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0054EM:miembro_junta'],
  },
  {
    nome_socio: 'Leonel Bohórquez Bohórquez',
    id_socio: '9658***',
    id_socio_carbono: 'SO0048PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0063EM:socio_ccapital'],
  },
  {
    nome_socio: 'Leslie L. Durschinger',
    id_socio: 'No disponible',
    id_socio_carbono: 'SO0284PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0001EM:derente_repres_legal'],
  },
  {
    nome_socio: 'Lina Maria Betancur Garnica',
    id_socio: '43155***',
    id_socio_carbono: 'SO0144PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0047EM:socio'],
  },
  {
    nome_socio: 'Luisa Fernanda Mejía Duque',
    id_socio: '43999***',
    id_socio_carbono: 'SO0145PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0047EM:socio'],
  },
  {
    nome_socio: 'Luz Adriana Velasco Dorado',
    id_socio: '31580***',
    id_socio_carbono: 'SO0276PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0036EM:representante_legal_suplente'],
  },
  {
    nome_socio: 'Luz Marina Campuzano Jaramillo',
    id_socio: '38234***',
    id_socio_carbono: 'SO0094PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: [
      'COL0048EM:representante_legal_suplente',
      'COL0085EM:representante_legal_suplente',
    ],
  },
  {
    nome_socio: 'Luz Stella Restrepo Martínez',
    id_socio: '43411***',
    id_socio_carbono: 'SO0224PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0058EM:socio'],
  },
  {
    nome_socio: 'Luz Ángela Palacios Campuzano',
    id_socio: '1032405***',
    id_socio_carbono: 'SO0093PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: [
      'COL0048EM:director',
      'COL0085EM:derente_repres_legal',
    ],
  },
  {
    nome_socio: 'Mariano Esteban Taborda Retrepo',
    id_socio: '15273***',
    id_socio_carbono: 'SO0192PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0062EM:miembro_junta'],
  },
  {
    nome_socio: 'Mario Vargas Ramírez',
    id_socio: '79781***',
    id_socio_carbono: 'SO0208PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0024EM:socio'],
  },
  {
    nome_socio: 'Martín Antonio De Bedout Guerra',
    id_socio: '117000885***',
    id_socio_carbono: 'SO0102PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0019EM:socio'],
  },
  {
    nome_socio: 'María Adelaida De Bedout De Mejía',
    id_socio: '32336***',
    id_socio_carbono: 'SO0101PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0019EM:socio_repres_legal'],
  },
  {
    nome_socio: 'María Camila Durán Chacón',
    id_socio: '52250***',
    id_socio_carbono: 'SO0301PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0054EM:representante_legal_suplente'],
  },
  {
    nome_socio: 'María Catalina Becerra Leal',
    id_socio: '1013622***',
    id_socio_carbono: 'SO0090PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0069EM:representante_legal'],
  },
  {
    nome_socio: 'María Catalina Giraldo Pastrana',
    id_socio: '52151***',
    id_socio_carbono: 'SO0206PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0024EM:socio'],
  },
  {
    nome_socio: 'María Fernanda Wilches Fonseca',
    id_socio: '52862***',
    id_socio_carbono: 'SO0216PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0040EM:representante_legal'],
  },
  {
    nome_socio: 'María Jimena Patiño Ocampo',
    id_socio: '31294***',
    id_socio_carbono: 'SO0268PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0044EM:representante_legal'],
  },
  {
    nome_socio: 'María Luisa Ortiz Mejía',
    id_socio: '39778***',
    id_socio_carbono: 'SO0282PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0031EM:representante_legal_suplente'],
  },
  {
    nome_socio: 'María Paula Alonso Gamboa',
    id_socio: '52386***',
    id_socio_carbono: 'SO0256PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0076EM:socio_ccapital_repres_legal'],
  },
  {
    nome_socio: 'María Teresa Gámez Pardo',
    id_socio: '52904***',
    id_socio_carbono: 'SO0207PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0024EM:socio'],
  },
  {
    nome_socio: 'Mauricio Fernández Posada',
    id_socio: '1128264***',
    id_socio_carbono: 'SO0272PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0071EM:socio_ccapital'],
  },
  {
    nome_socio: 'Mauricio Rivera Correa',
    id_socio: '71782***',
    id_socio_carbono: 'SO0146PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0047EM:socio'],
  },
  {
    nome_socio: 'Michael Andrew Korchinsky',
    id_socio: 'HM451***',
    id_socio_carbono: 'SO0302PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0054EM:miembro_junta'],
  },
  {
    nome_socio: 'Miguel Andrés Wilches Fonseca',
    id_socio: '1118544***',
    id_socio_carbono: 'SO0217PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0040EM:socio'],
  },
  {
    nome_socio: 'Miguel Esteban Oviedo Acosta',
    id_socio: '14271***',
    id_socio_carbono: 'SO0069PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0082EM:socio'],
  },
  {
    nome_socio: 'Miguel Ángel Colmenares Oviedo',
    id_socio: '1006532***',
    id_socio_carbono: 'SO0252PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0049EM:socio_ccapital_repres_legal'],
  },
  {
    nome_socio: 'Mónica Barragán Salas',
    id_socio: '66859***',
    id_socio_carbono: 'SO0240PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0006EM:socio'],
  },
  {
    nome_socio: 'Mónica Lara Escoto',
    id_socio: 'LAEM830830***',
    id_socio_carbono: 'SO0230PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['MEX0001EM:socio_ccapital'],
  },
  {
    nome_socio: 'Mónica Paola Saldarriaga Escobar',
    id_socio: '43158***',
    id_socio_carbono: 'SO0173PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0009EM:representante_legal'],
  },
  {
    nome_socio: 'Natalia Arango Vélez',
    id_socio: '31970***',
    id_socio_carbono: 'SO0178PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0012EM:derente_repres_legal'],
  },
  {
    nome_socio: 'Natalia Góngora',
    id_socio: '43255***',
    id_socio_carbono: 'SO0209PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0024EM:socio'],
  },
  {
    nome_socio: 'Natalia Norden',
    id_socio: '52704***',
    id_socio_carbono: 'SO0210PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0024EM:socio'],
  },
  {
    nome_socio: 'Natalia Uribe Macías',
    id_socio: '43974***',
    id_socio_carbono: 'SO0147PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0047EM:socio'],
  },
  {
    nome_socio: 'Natasha Avendaño García',
    id_socio: '43200***',
    id_socio_carbono: 'SO0171PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0022EM:gerente_repres_legal'],
  },
  {
    nome_socio: 'Nelson Enrique Cabaneiro Urbano',
    id_socio: '86067***',
    id_socio_carbono: 'SO0049PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0063EM:socio_ccapital'],
  },
  {
    nome_socio: 'Nelson Javier Albarán Castro',
    id_socio: '14240***',
    id_socio_carbono: 'SO0070PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0082EM:socio'],
  },
  {
    nome_socio: 'Nora Elena Londoño Fernández',
    id_socio: '42866***',
    id_socio_carbono: 'SO0148PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0047EM:socio'],
  },
  {
    nome_socio: 'Norberto López Alvarez',
    id_socio: '70562***',
    id_socio_carbono: 'SO0149PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0047EM:socio'],
  },
  {
    nome_socio: 'Olbany Fernando Muñoz Delgado',
    id_socio: '79672***',
    id_socio_carbono: 'SO0181PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0073EM:representante_legal'],
  },
  {
    nome_socio: 'Omar Alberto Rodríguez Bernal',
    id_socio: '73113***',
    id_socio_carbono: 'SO0113PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0030EM:socio_ccapital'],
  },
  {
    nome_socio: 'Omar Eduardo Hernández Páez',
    id_socio: '1020761***',
    id_socio_carbono: 'SO0077PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0014EM:representante_legal'],
  },
  {
    nome_socio: 'Oscar Yesid Florián Caro',
    id_socio: '7309***',
    id_socio_carbono: 'SO0017PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0078EM:socio_ccapital'],
  },
  {
    nome_socio: 'Pablo César Barragán Salas',
    id_socio: '94458***',
    id_socio_carbono: 'SO0241PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0006EM:representante_legal_suplente'],
  },
  {
    nome_socio: 'Paola Jiménez',
    id_socio: '46383***',
    id_socio_carbono: 'SO0211PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0024EM:socio'],
  },
  {
    nome_socio: 'Patricia Del Carmen Albarán Castro',
    id_socio: '38264***',
    id_socio_carbono: 'SO0072PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0082EM:socio_repres_legal'],
  },
  {
    nome_socio: 'Paula Caicedo Rosales',
    id_socio: '52089***',
    id_socio_carbono: 'SO0212PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0024EM:socio'],
  },
  {
    nome_socio: 'Paula Mercedes Zapata Arias',
    id_socio: '52263***',
    id_socio_carbono: 'SO0079PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0014EM:director'],
  },
  {
    nome_socio: 'Pedro Jahaziel Amaya Medina',
    id_socio: '80768***',
    id_socio_carbono: 'SO0193PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0048EM:representante_legal'],
  },
  {
    nome_socio: 'Pedro Santiago Posada Arango',
    id_socio: '70569***',
    id_socio_carbono: 'SO0306PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0061EM:director'],
  },
  {
    nome_socio: 'Permian Global Holdings S.A.R.L.',
    id_socio: 'B211555',
    id_socio_carbono: 'SO0261ENCO',
    tipo: 'entidade',
    relacao_empresa_rol: ['COL0035EM:socio_ccapital'],
  },
  {
    nome_socio: 'Permian Global Research Limited',
    id_socio: '6040296',
    id_socio_carbono: 'SO0262ENCO',
    tipo: 'entidade',
    relacao_empresa_rol: ['COL0035EM:socio_ccapital'],
  },
  {
    nome_socio: 'Planeta Limpio S.A.',
    id_socio: 'No disponible',
    id_socio_carbono: 'SO0114ENCO',
    tipo: 'entidade',
    relacao_empresa_rol: ['COL0030EM:socio_ccapital'],
  },
  {
    nome_socio: 'Q&Q Legal S.A.S.',
    id_socio: '900620873-8',
    id_socio_carbono: 'SO0018ENCO',
    tipo: 'entidade',
    relacao_empresa_rol: ['COL0078EM:socio_ccapital'],
  },
  {
    nome_socio: 'Ruby Acosta Bastidas',
    id_socio: '52387***',
    id_socio_carbono: 'SO0082PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0027EM:socio_ccapital_repres_legal'],
  },
  {
    nome_socio: 'Samuel Monsalve Correa',
    id_socio: '1152437***',
    id_socio_carbono: 'SO0150PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0047EM:socio'],
  },
  {
    nome_socio: 'Sandra Yuribel Duarte Chaparro',
    id_socio: '1118***',
    id_socio_carbono: 'SO0218PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0040EM:socio'],
  },
  {
    nome_socio: 'Saúl Ernesto Hoyos Gómez',
    id_socio: '88222***',
    id_socio_carbono: 'SO0151PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0047EM:socio'],
  },
  {
    nome_socio: 'Sheilla Marlenny Namen Chavarro',
    id_socio: '49770***',
    id_socio_carbono: 'SO0080PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0014EM:representante_legal_suplente'],
  },
  {
    nome_socio: 'Shirley Yeraldin Rojas Molano ',
    id_socio: '1118553***',
    id_socio_carbono: 'SO0219PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0040EM:socio'],
  },
  {
    nome_socio: 'South Pole Holding Ag',
    id_socio: 'CH-020-3030094-1',
    id_socio_carbono: 'SO0277ENCO',
    tipo: 'entidade',
    relacao_empresa_rol: ['COL0036EM:socio_ccapital'],
  },
  {
    nome_socio: 'Stags Business S.A.S.',
    id_socio: '901878806-6',
    id_socio_carbono: 'SO0182ENCO',
    tipo: 'entidade',
    relacao_empresa_rol: ['COL0073EM:socio_ccapital'],
  },
  {
    nome_socio: 'Terra Commodities S.A.',
    id_socio: '634903',
    id_socio_carbono: 'SO0283ENCO',
    tipo: 'entidade',
    relacao_empresa_rol: ['COL0031EM:socio_ccapital'],
  },
  {
    nome_socio: 'Tomás Hinestroza Koppel',
    id_socio: '80322***',
    id_socio_carbono: 'SO0152PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0047EM:socio'],
  },
  {
    nome_socio: 'Universidad Católica De Oriente',
    id_socio: '890984746-7',
    id_socio_carbono: 'SO0136ENCO',
    tipo: 'entidade',
    relacao_empresa_rol: ['COL0008EM:socio'],
  },
  {
    nome_socio: 'Valentina Hoyos Ramírez',
    id_socio: '43608***',
    id_socio_carbono: 'SO0153PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0047EM:socio'],
  },
  {
    nome_socio: 'Verónica Liliana Uribe Uribe',
    id_socio: '43264***',
    id_socio_carbono: 'SO0225PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0058EM:socio'],
  },
  {
    nome_socio: 'Weact Pty Ltd.',
    id_socio: '28140558818',
    id_socio_carbono: 'SO0297ENCO',
    tipo: 'entidade',
    relacao_empresa_rol: ['COL0075EM:socio_ccapital'],
  },
  {
    nome_socio: 'Wildlife Works Carbon Llc',
    id_socio: '25-1719093',
    id_socio_carbono: 'SO0303ENCO',
    tipo: 'entidade',
    relacao_empresa_rol: ['COL0054EM:socio_ccapital'],
  },
  {
    nome_socio: 'Yolanda Escoto Torales',
    id_socio: 'EOTY510916***',
    id_socio_carbono: 'SO0231PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['MEX0001EM:socio_ccapital'],
  },
  {
    nome_socio: 'Yovany Ochoa',
    id_socio: 'No disponible',
    id_socio_carbono: 'SO0154PECO',
    tipo: 'pessoa',
    relacao_empresa_rol: ['COL0047EM:socio'],
  },
  {
    nome_socio: 'Águia Holdings S.A.S.',
    id_socio: '901661709-7',
    id_socio_carbono: 'SO0008ENCO',
    tipo: 'entidade',
    relacao_empresa_rol: ['COL0061EM:socio_ccapital'],
  },
]

const PersonasPE: IPersonas[] = [
  {
    nome_socio: 'Alan Schipper Guerovich',
    id_socio: 'No disponible',
    id_socio_carbono: 'SO0002PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0011EM:representante_legal'],
  },
  {
    nome_socio: 'Alexandre Schouler',
    id_socio: 'No disponible',
    id_socio_carbono: 'SO0003PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['FRA0001EM:director'],
  },
  {
    nome_socio: 'Alfredo Enrique Ferreyros Gildemeister',
    id_socio: 'No disponible',
    id_socio_carbono: 'SO0004PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0004EM:representante_legal'],
  },
  {
    nome_socio: 'Alvaro Benitez Kongfook ',
    id_socio: '09875***',
    id_socio_carbono: 'SO0006PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0008EM:representante_legal'],
  },
  {
    nome_socio: 'Alvaro Benitez Kongfook',
    id_socio: '09875***',
    id_socio_carbono: 'SO0005PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0009EM:representante_legal'],
  },
  {
    nome_socio: 'Alvaro Torres Enriquez',
    id_socio: 'No disponible',
    id_socio_carbono: 'SO0007PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0003EM:miembro_junta'],
  },
  {
    nome_socio: 'Angelli Varinia Vasquez Moreno',
    id_socio: '70505***',
    id_socio_carbono: 'SO0008PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0009EM:representante_legal'],
  },
  {
    nome_socio: 'Antonio Palacios Tejada',
    id_socio: '07269***',
    id_socio_carbono: 'SO0009PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0008EM:representante_legal'],
  },
  {
    nome_socio: 'Arturo Ramiro Rivera Linares',
    id_socio: '29563***',
    id_socio_carbono: 'SO0011PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0009EM:representante_legal'],
  },
  {
    nome_socio: 'Augusto Santiago Chiong Yep',
    id_socio: '07848***',
    id_socio_carbono: 'SO0012PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0009EM:representante_legal'],
  },
  {
    nome_socio: 'Aurora Karina Santana Moran De Desmarais',
    id_socio: 'No disponible',
    id_socio_carbono: 'SO0013PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['CAN0002EM:director', 'CAN0003EM:director'],
  },
  {
    nome_socio: 'Bernard Gauvin',
    id_socio: 'No disponible',
    id_socio_carbono: 'SO0014PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['CAN0002EM:socio'],
  },
  {
    nome_socio: 'Branko Bozovich Seminario       ',
    id_socio: '43029***',
    id_socio_carbono: 'SO0015PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0001EM:representante_legal'],
  },
  {
    nome_socio: 'Bs Climate Lt Bidco Uk Limited',
    id_socio: '14302825',
    id_socio_carbono: 'SO0016ENPE',
    tipo: 'entidade',
    relacao_empresa_rol: ['FRA0001EM:socio'],
  },
  {
    nome_socio: 'Cesar Augusto Ipenza Peralta',
    id_socio: 'No disponible',
    id_socio_carbono: 'SO0017PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0007EM:director'],
  },
  {
    nome_socio: 'Cesar Eduardo Seminario Rodríguez       ',
    id_socio: '06663***',
    id_socio_carbono: 'SO0018PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0018EM:director'],
  },
  {
    nome_socio: 'Claudio Albert Schneider Negib',
    id_socio: '09750***',
    id_socio_carbono: 'SO0019PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0004EM:representante_legal'],
  },
  {
    nome_socio: 'Dave Pogois Loayza',
    id_socio: 'No disponible',
    id_socio_carbono: 'SO0020PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0003EM:miembro_junta'],
  },
  {
    nome_socio: 'David Martin Saettone Watmough',
    id_socio: '09336***',
    id_socio_carbono: 'SO0021PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0005EM:representante_legal'],
  },
  {
    nome_socio: 'Desjardins - Innovatech S.E.C.',
    id_socio: '3363082135',
    id_socio_carbono: 'SO0022ENPE',
    tipo: 'entidade',
    relacao_empresa_rol: ['CAN0002EM:socio'],
  },
  {
    nome_socio: 'Earl Walters Norman       ',
    id_socio: 'CE 710095***',
    id_socio_carbono: 'SO0023PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0002EM:gerente'],
  },
  {
    nome_socio: 'Eleazar Zavala Flores       ',
    id_socio: '41582***',
    id_socio_carbono: 'SO0024PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0014EM:director'],
  },
  {
    nome_socio: 'Enrique Erwin Albengrin Garcia',
    id_socio: 'No disponible',
    id_socio_carbono: 'SO0025PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0011EM:representante_legal'],
  },
  {
    nome_socio: 'Erasmo Jesús Wong Lu Vega',
    id_socio: '08255***',
    id_socio_carbono: 'SO0026PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0008EM:director', 'PER0009EM:director_gerente'],
  },
  {
    nome_socio: 'Erasmo Martin Wong Kongfook',
    id_socio: '44508***',
    id_socio_carbono: 'SO0027PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0009EM:gerente_repres_legal'],
  },
  {
    nome_socio: 'Erick Samuel Pajares Garay',
    id_socio: '07974***',
    id_socio_carbono: 'SO0028PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0007EM:director'],
  },
  {
    nome_socio: 'Etienne Desmarais',
    id_socio: 'No disponible',
    id_socio_carbono: 'SO0029PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['CAN0002EM:director', 'CAN0003EM:director'],
  },
  {
    nome_socio: 'Evelyn Consuelo Chang Gonzales       ',
    id_socio: '15727***',
    id_socio_carbono: 'SO0030PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0001EM:representante_legal'],
  },
  {
    nome_socio: 'Evert Thomas',
    id_socio: 'No disponible',
    id_socio_carbono: 'SO0031PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0007EM:director'],
  },
  {
    nome_socio: 'Gestion Yaties Inc.',
    id_socio: '1173146227',
    id_socio_carbono: 'SO0036ENPE',
    tipo: 'entidade',
    relacao_empresa_rol: ['CAN0002EM:socio'],
  },
  {
    nome_socio: 'Glenn Rod Schipper Guerovich',
    id_socio: 'No disponible',
    id_socio_carbono: 'SO0037PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0011EM:gerente'],
  },
  {
    nome_socio: 'Gloria Jacqueline Tello Torres De Rojas',
    id_socio: '05351***',
    id_socio_carbono: 'SO0038PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0002EM:representante_legal'],
  },
  {
    nome_socio: 'Gonzalo Jose Cristobal Varillas Cueto',
    id_socio: 'No disponible',
    id_socio_carbono: 'SO0039PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0007EM:director'],
  },
  {
    nome_socio: 'Greta Rosario Castillo Mendoza',
    id_socio: 'No disponible',
    id_socio_carbono: 'SO0040PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0010EM:gerente'],
  },
  {
    nome_socio: 'Hector Orlando Salas Luritta',
    id_socio: '07912***',
    id_socio_carbono: 'SO0041PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0011EM:representante_legal'],
  },
  {
    nome_socio: 'Ignacio Romulo Lombardi Indacochea',
    id_socio: 'No disponible',
    id_socio_carbono: 'SO0043PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0003EM:miembro_junta'],
  },
  {
    nome_socio: 'Ivo Bozovich Noriega       ',
    id_socio: '40120***',
    id_socio_carbono: 'SO0045PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0001EM:director'],
  },
  {
    nome_socio: 'Ivo Bozovich Noriega',
    id_socio: '40120***',
    id_socio_carbono: 'SO0044PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0011EM:representante_legal'],
  },
  {
    nome_socio: 'Jaime Guillermo Nalvarte Armas',
    id_socio: 'No disponible',
    id_socio_carbono: 'SO0046PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0003EM:miembro_junta'],
  },
  {
    nome_socio: 'Javier Hector Rivera Pinzas',
    id_socio: 'No disponible',
    id_socio_carbono: 'SO0048PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0011EM:representante_legal'],
  },
  {
    nome_socio: 'Jorge Gil Cantuarias Falconi',
    id_socio: '08796***',
    id_socio_carbono: 'SO0050PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0005EM:director'],
  },
  {
    nome_socio: 'Jorge Luis Aliaga Arauco',
    id_socio: '49012***',
    id_socio_carbono: 'SO0051PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0007EM:director'],
  },
  {
    nome_socio: 'Jorge Mario Palomares De Los Santos',
    id_socio: '08461***',
    id_socio_carbono: 'SO0052PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0003EM:director_m_junta'],
  },
  {
    nome_socio: 'Jose Abrahan Cardozo Mouzully',
    id_socio: 'No disponible',
    id_socio_carbono: 'SO0053PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0009EM:gerente', 'PER0010EM:gerente'],
  },
  {
    nome_socio: 'Jose Alfredo Biasevich Barreto',
    id_socio: '08248***',
    id_socio_carbono: 'SO0054PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0011EM:representante_legal'],
  },
  {
    nome_socio: 'Jose Luis Canchaya Toledo',
    id_socio: 'No disponible',
    id_socio_carbono: 'SO0055PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0009EM:gerente'],
  },
  {
    nome_socio: 'Juan Carlos Gonzalez Aybar',
    id_socio: '42457***',
    id_socio_carbono: 'SO0056PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['FRA0002EM:director', 'PER0019EM:director'],
  },
  {
    nome_socio: 'Lily Olga Rodriguez Bayona',
    id_socio: 'No disponible',
    id_socio_carbono: 'SO0059PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0007EM:fundador'],
  },
  {
    nome_socio: 'Luis Fernando Palomino Miranda',
    id_socio: '09075***',
    id_socio_carbono: 'SO0060PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: [
      'PER0008EM:representante_legal',
      'PER0009EM:representante_legal',
    ],
  },
  {
    nome_socio: 'Luis Gerardo Espinel Cuba',
    id_socio: '09643***',
    id_socio_carbono: 'SO0061PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0004EM:representante_legal'],
  },
  {
    nome_socio: 'Manuel Augusto Glave Testino',
    id_socio: 'No disponible',
    id_socio_carbono: 'SO0064PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0007EM:director'],
  },
  {
    nome_socio: 'Manuel Augusto Mujica Freundt       ',
    id_socio: '10610***',
    id_socio_carbono: 'SO0065PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0001EM:representante_legal'],
  },
  {
    nome_socio: 'Manuel Kooyip Chong',
    id_socio: '49012***',
    id_socio_carbono: 'SO0066PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0010EM:director_gerente'],
  },
  {
    nome_socio: 'Maria Alejandra Ofelia Agurto Bustamante',
    id_socio: '10494***',
    id_socio_carbono: 'SO0067PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0005EM:representante_legal'],
  },
  {
    nome_socio: 'Maria De Nazareth Cardozo Mouzully',
    id_socio: 'No disponible',
    id_socio_carbono: 'SO0068PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0009EM:fundador'],
  },
  {
    nome_socio: 'Marleni Ramirez Figueroa',
    id_socio: 'No disponible',
    id_socio_carbono: 'SO0070PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0007EM:fundador'],
  },
  {
    nome_socio: 'Marny Graciela Barreros Arostegui      ',
    id_socio: '05071***',
    id_socio_carbono: 'SO0072PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0011EM:representante_legal'],
  },
  {
    nome_socio: 'Marny Graciela Barreros Arostegui',
    id_socio: '05071***',
    id_socio_carbono: 'SO0071PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0011EM:representante_legal'],
  },
  {
    nome_socio: 'Mikel David Manrique Rivero',
    id_socio: 'No disponible',
    id_socio_carbono: 'SO0073PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0011EM:representante_legal'],
  },
  {
    nome_socio: 'Nelson Leopoldo Melendez Ascaño',
    id_socio: 'No disponible',
    id_socio_carbono: 'SO0075PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0011EM:representante_legal'],
  },
  {
    nome_socio: 'Nelson Nilton Kroll Kohel',
    id_socio: '10687***',
    id_socio_carbono: 'SO0076PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0009EM:representante_legal'],
  },
  {
    nome_socio: 'Oswaldo Elar Frech Loechle       ',
    id_socio: '21010***',
    id_socio_carbono: 'SO0078PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0011EM:representante_legal'],
  },
  {
    nome_socio: 'Oswaldo Elar Frech Loechle',
    id_socio: '21010***',
    id_socio_carbono: 'SO0077PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0011EM:representante_legal'],
  },
  {
    nome_socio: 'Oswaldo Elard Frech Loechle',
    id_socio: 'No disponible',
    id_socio_carbono: 'SO0079PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0011EM:representante_legal'],
  },
  {
    nome_socio: 'Patricia Ivonne Fernandez-Davila Messum',
    id_socio: 'No disponible',
    id_socio_carbono: 'SO0080PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0007EM:director'],
  },
  {
    nome_socio: 'Patrick Mitchel Cuya Vallejo      ',
    id_socio: '41554***',
    id_socio_carbono: 'SO0081PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0015EM:director'],
  },
  {
    nome_socio: 'Presentacion Yony Picchotito Haquehua',
    id_socio: '09276***',
    id_socio_carbono: 'SO0083PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0011EM:representante_legal'],
  },
  {
    nome_socio: 'Rafael Bardalez Ruiz       ',
    id_socio: '09851***',
    id_socio_carbono: 'SO0084PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0020EM:director'],
  },
  {
    nome_socio: 'Rita Vilca Lucana',
    id_socio: '41439***',
    id_socio_carbono: 'SO0086PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0013EM:director'],
  },
  {
    nome_socio: 'Roberto Germán Velez Salinas       ',
    id_socio: '09151***',
    id_socio_carbono: 'SO0087PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0011EM:representante_legal'],
  },
  {
    nome_socio: 'Sylvia Patricia Breña Toranzo',
    id_socio: '09867***',
    id_socio_carbono: 'SO0089PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0011EM:representante_legal'],
  },
  {
    nome_socio: 'Transition Cafe Selva Norte S.E.C.',
    id_socio: '3374463548',
    id_socio_carbono: 'SO0090ENPE',
    tipo: 'entidade',
    relacao_empresa_rol: ['CAN0003EM:socio'],
  },
  {
    nome_socio: 'Usmila Torres Valdez       ',
    id_socio: '06987***',
    id_socio_carbono: 'SO0092PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0011EM:representante_legal'],
  },
  {
    nome_socio: 'Usmila Torres Valdez',
    id_socio: '06987***',
    id_socio_carbono: 'SO0091PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0011EM:representante_legal'],
  },
  {
    nome_socio: 'Vittorio De Dea Peña       ',
    id_socio: '21010***',
    id_socio_carbono: 'SO0082PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0011EM:derente_repres_legal'],
  },
  {
    nome_socio: 'Xiaodong Ji Wu',
    id_socio: 'No disponible',
    id_socio_carbono: 'SO0094PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0010EM:gerente'],
  },
  {
    nome_socio: 'Yan Carlos Cruzado Cruz       ',
    id_socio: '80305***',
    id_socio_carbono: 'SO0095PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0017EM:director'],
  },
  {
    nome_socio: 'Yolanda Ramirez Villacorta',
    id_socio: 'No disponible',
    id_socio_carbono: 'SO0096PEPE',
    tipo: 'pessoa',
    relacao_empresa_rol: ['PER0003EM:miembro_junta'],
  },
]
export const Personas: IPersonas[] = [
  ...PersonasBR,
  ...PersonasCO,
  ...PersonasPE,
]
